// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hRrWd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureGroupStateContext", ()=>DisclosureGroupStateContext);
parcelHelpers.export(exports, "DisclosureGroup", ()=>DisclosureGroup);
parcelHelpers.export(exports, "DisclosureContext", ()=>DisclosureContext);
parcelHelpers.export(exports, "DisclosureStateContext", ()=>DisclosureStateContext);
parcelHelpers.export(exports, "Disclosure", ()=>Disclosure);
parcelHelpers.export(exports, "DisclosurePanel", ()=>DisclosurePanel);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DisclosureGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DisclosureGroup = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosureGroup(props, ref) {
    let state = (0, _reactStately.useDisclosureGroupState)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-DisclosureGroup',
        values: {
            isDisabled: state.isDisabled,
            state
        }
    });
    let domProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...domProps,
        ...renderProps,
        ref: ref,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DisclosureGroupStateContext.Provider, {
        value: state
    }, renderProps.children));
});
const DisclosureContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DisclosureStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalDisclosureContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Disclosure = /*#__PURE__*/ (0, _react.forwardRef)(function Disclosure(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DisclosureContext);
    let groupState = (0, _react.useContext)(DisclosureGroupStateContext);
    let { id, ...otherProps } = props;
    // Generate an id if one wasn't provided.
    // (can't pass id into useId since it can also be a number)
    let defaultId = (0, _utils1.useId)();
    id ||= defaultId;
    let isExpanded = groupState ? groupState.expandedKeys.has(id) : props.isExpanded;
    let state = (0, _reactStately.useDisclosureState)({
        ...props,
        isExpanded,
        onExpandedChange (isExpanded) {
            if (groupState) groupState.toggleKey(id);
            props.onExpandedChange?.(isExpanded);
        }
    });
    let panelRef = (0, _reactDefault.default).useRef(null);
    let isDisabled = props.isDisabled || groupState?.isDisabled || false;
    let { buttonProps, panelProps } = (0, _reactAria.useDisclosure)({
        ...props,
        isExpanded,
        isDisabled
    }, state, panelRef);
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        defaultClassName: 'react-aria-Disclosure',
        values: {
            isExpanded: state.isExpanded,
            isDisabled,
            isFocusVisibleWithin,
            state
        }
    });
    let domProps = (0, _utils1.filterDOMProps)(otherProps, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        trigger: buttonProps
                    }
                }
            ],
            [
                InternalDisclosureContext,
                {
                    panelProps,
                    panelRef
                }
            ],
            [
                DisclosureStateContext,
                state
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(domProps, renderProps, focusWithinProps),
        ref: ref,
        "data-expanded": state.isExpanded || undefined,
        "data-disabled": isDisabled || undefined,
        "data-focus-visible-within": isFocusVisibleWithin || undefined
    }, renderProps.children));
});
const DisclosurePanel = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosurePanel(props, ref) {
    let { role = 'group' } = props;
    let { panelProps, panelRef } = (0, _react.useContext)(InternalDisclosureContext);
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, _reactAria.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-DisclosurePanel',
        values: {
            isFocusVisibleWithin
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(DOMProps, renderProps, panelProps, focusWithinProps),
        ref: (0, _utils1.mergeRefs)(ref, panelRef),
        role: role,
        "data-focus-visible-within": isFocusVisibleWithin || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                null
            ]
        ]
    }, props.children));
});

},{"react-aria":[["useDisclosure","fRMYk"],["useFocusRing","6TXyU"]],"./Button":"9G5XO","./utils":"bA6Cz","react-stately":[["useDisclosureGroupState","2ckh1"],["useDisclosureState","djrKJ"]],"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["mergeRefs","1vHgg"],["useId","jbI4Y"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fRMYk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a disclosure component.
 * @param props - Props for the disclosure.
 * @param state - State for the disclosure, as returned by `useDisclosureState`.
 * @param ref - A ref for the disclosure panel.
 */ parcelHelpers.export(exports, "useDisclosure", ()=>useDisclosure);
var _reactDom = require("react-dom");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _ssr = require("@react-aria/ssr");
function useDisclosure(props, state, ref) {
    let { isDisabled } = props;
    let triggerId = (0, _utils.useId)();
    let panelId = (0, _utils.useId)();
    let isSSR = (0, _ssr.useIsSSR)();
    let raf = (0, _react.useRef)(null);
    let handleBeforeMatch = (0, _react.useCallback)(()=>{
        // Wait a frame to revert browser's removal of hidden attribute
        raf.current = requestAnimationFrame(()=>{
            if (ref.current) ref.current.setAttribute('hidden', 'until-found');
        });
        // Force sync state update
        (0, _reactDom.flushSync)(()=>{
            state.toggle();
        });
    }, [
        ref,
        state
    ]);
    // @ts-ignore https://github.com/facebook/react/pull/24741
    (0, _utils.useEvent)(ref, 'beforematch', handleBeforeMatch);
    let isExpandedRef = (0, _react.useRef)(null);
    (0, _utils.useLayoutEffect)(()=>{
        // Cancel any pending RAF to prevent stale updates
        if (raf.current) cancelAnimationFrame(raf.current);
        if (ref.current && !isSSR) {
            let panel = ref.current;
            if (isExpandedRef.current == null || typeof panel.getAnimations !== 'function') {
                // On initial render (and in tests), set attributes without animation.
                if (state.isExpanded) {
                    panel.removeAttribute('hidden');
                    panel.style.setProperty('--disclosure-panel-width', 'auto');
                    panel.style.setProperty('--disclosure-panel-height', 'auto');
                } else {
                    panel.setAttribute('hidden', 'until-found');
                    panel.style.setProperty('--disclosure-panel-width', '0px');
                    panel.style.setProperty('--disclosure-panel-height', '0px');
                }
            } else if (state.isExpanded !== isExpandedRef.current) {
                if (state.isExpanded) {
                    panel.removeAttribute('hidden');
                    // Set the width and height as pixels so they can be animated.
                    panel.style.setProperty('--disclosure-panel-width', panel.scrollWidth + 'px');
                    panel.style.setProperty('--disclosure-panel-height', panel.scrollHeight + 'px');
                    Promise.all(panel.getAnimations().map((a)=>a.finished)).then(()=>{
                        // After the animations complete, switch back to auto so the content can resize.
                        panel.style.setProperty('--disclosure-panel-width', 'auto');
                        panel.style.setProperty('--disclosure-panel-height', 'auto');
                    }).catch(()=>{});
                } else {
                    panel.style.setProperty('--disclosure-panel-width', panel.scrollWidth + 'px');
                    panel.style.setProperty('--disclosure-panel-height', panel.scrollHeight + 'px');
                    // Force style re-calculation to trigger animations.
                    window.getComputedStyle(panel).height;
                    // Animate to zero size.
                    panel.style.setProperty('--disclosure-panel-width', '0px');
                    panel.style.setProperty('--disclosure-panel-height', '0px');
                    // Wait for animations to apply the hidden attribute.
                    Promise.all(panel.getAnimations().map((a)=>a.finished)).then(()=>panel.setAttribute('hidden', 'until-found')).catch(()=>{});
                }
            }
            isExpandedRef.current = state.isExpanded;
        }
    }, [
        isDisabled,
        ref,
        state.isExpanded,
        isSSR
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    return {
        buttonProps: {
            id: triggerId,
            'aria-expanded': state.isExpanded,
            'aria-controls': panelId,
            onPress: (e)=>{
                if (!isDisabled && e.pointerType !== 'keyboard') state.toggle();
            },
            isDisabled,
            onPressStart (e) {
                if (e.pointerType === 'keyboard' && !isDisabled) state.toggle();
            }
        },
        panelProps: {
            id: panelId,
            // This can be overridden at the panel element level.
            role: 'group',
            'aria-labelledby': triggerId,
            'aria-hidden': !state.isExpanded,
            hidden: isSSR ? !state.isExpanded : undefined
        }
    };
}

},{"react-dom":"gC2PC","react":"a1TxN","@react-aria/utils":[["useEvent","c8GoD"],["useId","jbI4Y"],["useLayoutEffect","2ViQu"]],"@react-aria/ssr":"ictJr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"2ckh1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a group of disclosures, e.g. an accordion.
 * It supports both single and multiple expanded items.
 */ parcelHelpers.export(exports, "useDisclosureGroupState", ()=>useDisclosureGroupState);
var _utils = require("@react-stately/utils");
var _react = require("react");
function useDisclosureGroupState(props) {
    let { allowsMultipleExpanded = false, isDisabled = false } = props;
    let [expandedKeys, setExpandedKeys] = (0, _utils.useControlledState)((0, _react.useMemo)(()=>props.expandedKeys ? new Set(props.expandedKeys) : undefined, [
        props.expandedKeys
    ]), (0, _react.useMemo)(()=>props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), [
        props.defaultExpandedKeys
    ]), props.onExpandedChange);
    (0, _react.useEffect)(()=>{
        // Ensure only one item is expanded if allowsMultipleExpanded is false.
        if (!allowsMultipleExpanded && expandedKeys.size > 1) {
            let firstKey = expandedKeys.values().next().value;
            if (firstKey != null) setExpandedKeys(new Set([
                firstKey
            ]));
        }
    });
    return {
        allowsMultipleExpanded,
        isDisabled,
        expandedKeys,
        setExpandedKeys,
        toggleKey (key) {
            let keys;
            if (allowsMultipleExpanded) {
                keys = new Set(expandedKeys);
                if (keys.has(key)) keys.delete(key);
                else keys.add(key);
            } else keys = new Set(expandedKeys.has(key) ? [] : [
                key
            ]);
            setExpandedKeys(keys);
        }
    };
}

},{"@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"djrKJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a disclosure widget. Tracks whether the disclosure is expanded, and provides
 * methods to toggle this state.
 */ parcelHelpers.export(exports, "useDisclosureState", ()=>useDisclosureState);
var _react = require("react");
var _utils = require("@react-stately/utils");
function useDisclosureState(props) {
    let [isExpanded, setExpanded] = (0, _utils.useControlledState)(props.isExpanded, props.defaultExpanded || false, props.onExpandedChange);
    const expand = (0, _react.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    const collapse = (0, _react.useCallback)(()=>{
        setExpanded(false);
    }, [
        setExpanded
    ]);
    const toggle = (0, _react.useCallback)(()=>{
        setExpanded(!isExpanded);
    }, [
        setExpanded,
        isExpanded
    ]);
    return {
        isExpanded,
        setExpanded,
        expand,
        collapse,
        toggle
    };
}

},{"react":"a1TxN","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"akpch":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerContext", ()=>PickerContext);
parcelHelpers.export(exports, "menu", ()=>menu);
parcelHelpers.export(exports, "Picker", ()=>Picker);
parcelHelpers.export(exports, "PickerItem", ()=>PickerItem);
parcelHelpers.export(exports, "PickerSection", ()=>PickerSection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _avatar = require("./Avatar");
var _checkbox = require("./Checkbox");
var _centerBaseline = require("./CenterBaseline");
var _menu = require("./Menu");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _collections = require("@react-aria/collections");
var _comboBox = require("./ComboBox");
var _field = require("./Field");
var _form = require("./Form");
var _content = require("./Content");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _runtime = require("../style/runtime");
var _popover = require("./Popover");
var _interactions = require("@react-aria/interactions");
var _pressScale = require("./pressScale");
var _progressCircle = require("./ProgressCircle");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _utils2 = require("./utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const PickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isQuiet) rules += ' _Le12';
    else if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' sd12';
    rules += ' eb12';
    rules += ' _oa12';
    rules += ' SMBFGYc12';
    rules += ' RfBFGYc12';
    if (props.size === "XL") rules += ' Nl12';
    else if (props.size === "L") rules += ' Nj12';
    else if (props.size === "S") rules += ' Nf12';
    else if (props.size === "XS") rules += ' Ne12';
    else rules += ' Nk12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' qc12';
    rules += ' qsd12';
    rules += ' -Qg41Lb-IAxCW0c12';
    rules += ' -Qg41Lb-gLWx3bIy12';
    rules += ' FRuFGYc12';
    rules += ' zXcEWr12';
    rules += ' yXcEWr12';
    rules += ' BXcEWr12';
    rules += ' AXcEWr12';
    if (props.isQuiet) rules += ' _qd12';
    else rules += ' _qtb12';
    if (props.size === "XL") rules += ' -Anxdcc-Zt12';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne12';
    else if (props.size === "S") rules += ' -Anxdcc-Zr12';
    else rules += ' -Anxdcc-Z3fn9H12';
    rules += ' __v6TNLWb12';
    rules += ' _Pc12';
    rules += ' _Wd12';
    rules += ' _je12';
    rules += ' _jlf12';
    if (props.isDisabled) rules += ' ilc12';
    else rules += ' ilb12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isQuiet) rules += ' g912';
    else if (props.isDisabled) rules += ' gH12';
    else if (props.isOpen) rules += ' gF12';
    else {
        if (props.isPressed) rules += ' gF12';
        else if (props.isFocusVisible) rules += ' gF12';
        else if (props.isHovered) rules += ' gF12';
        else rules += ' gH12';
    }
    if (props.isQuiet) rules += ' Ln12';
    rules += ' __ca12';
    if (props.size === "XL") rules += ' -F_-Fz12';
    else if (props.size === "L") rules += ' -F_-Fv12';
    else if (props.size === "S") rules += ' -F_-Fp12';
    else if (props.size === "XS") rules += ' -F_-Fn12';
    else rules += ' -F_-Fx12';
    if (props.isQuiet) rules += ' -S_-Sd12';
    else rules += ' -S_-Sv12';
    if (props.isQuiet) rules += ' -R_-Rd12';
    else rules += ' -R_-Rv12';
    return rules;
};
const quietFocusLine = " Za12 FLvNfn12 _Pa12 _lr12 og12 ng12 kg12 jg12 g_h12 gle12";
let menu = function anonymous(props) {
    let rules = " ";
    rules += ' _Le12';
    rules += ' se12';
    rules += ' Za12';
    if (props.size === "XL") rules += ' Dk92HIe12';
    else if (props.size === "L") rules += ' DyaX9Fb12';
    else if (props.size === "M") rules += ' Deb5jcb12';
    else if (props.size === "S") rules += ' DGTLJAe12';
    rules += ' _oa12';
    rules += ' K40ub4c12';
    rules += ' _Na12';
    rules += ' Pa12';
    rules += ' Tt12';
    rules += ' Qt12';
    rules += ' St12';
    rules += ' Rt12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' __ya12';
    return rules;
};
const invalidBorder = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' _Pa12';
    rules += ' Wr12';
    rules += ' _Er12';
    rules += ' _lr12';
    rules += ' _Rr12';
    rules += ' _Ob12';
    rules += ' _jf12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    if (props.isPressed) rules += ' im12';
    else if (props.isFocusVisible) rules += ' im12';
    else if (props.isHovered) rules += ' im12';
    else rules += ' ip12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " ";
    if (props.isQuiet) rules += ' _ua12';
    else rules += ' _ub12';
    rules += ' _Nc12';
    rules += ' Pc12';
    rules += ' _Yb12';
    rules += ' _7c12';
    rules += ' sd12';
    rules += ' eb12';
    return rules;
};
const iconStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _va12';
    rules += ' _Sd12';
    rules += ' -_8sjo0b-t5ZbAob12';
    if (props.isLoading) rules += ' pp12';
    return rules;
};
const avatar = " z2U5Crc12 y2U5Crc12 B2U5Crc12 A2U5Crc12 Ht12 Hsu12";
const loadingWrapperStyles = " z2mU12 yzZKy12 sd12 eb12 _Ca12 Jv12 Gv12";
const progressCircleStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' Zp12';
    else if (props.size === "L") rules += ' Zn12';
    else if (props.size === "M") rules += ' Zm12';
    else if (props.size === "S") rules += ' Zu12';
    if (props.size === "XL") rules += ' Fq12';
    else if (props.size === "L") rules += ' Fo12';
    else if (props.size === "M") rules += ' Fn12';
    else if (props.size === "S") rules += ' Ft12';
    return rules;
};
let InternalPickerContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M'
});
let InsideSelectValueContext = /*#__PURE__*/ (0, _react.createContext)(false);
const Picker = /*#__PURE__*/ (0, _react.forwardRef)(function Picker(props1, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, PickerContext);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { direction = 'bottom', align = 'start', shouldFlip = true, menuWidth, label, description: descriptionMessage, errorMessage, children, items, size = 'M', labelPosition = 'top', labelAlign = 'start', necessityIndicator, UNSAFE_className = '', UNSAFE_style, placeholder = stringFormatter.format('picker.placeholder'), isQuiet, loadingState, onLoadMore, ...pickerProps } = props1;
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    let renderer;
    let showButtonSpinner = (0, _react.useMemo)(()=>loadingState === 'loading', [
        loadingState
    ]);
    let spinnerId = (0, _utils1.useSlotId)([
        showButtonSpinner
    ]);
    let listBoxLoadingCircle = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxLoadMoreItem), {
        className: loadingWrapperStyles,
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerProgressCircle, {
            size: size,
            "aria-label": stringFormatter.format('table.loadingMore')
        })
    });
    if (typeof children === 'function' && items) renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: items,
                dependencies: props1.dependencies,
                children: children
            }),
            listBoxLoadingCircle
        ]
    });
    else renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            listBoxLoadingCircle
        ]
    });
    let scale = (0, _utils2.useScale)();
    let { direction: dir } = (0, _i18N.useLocale)();
    let RTLFlipOffset = dir === 'rtl' ? -1 : 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Select), {
        ...pickerProps,
        "aria-describedby": spinnerId,
        placeholder: placeholder,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                }
            }
            if (props.isInForm) rules += ' DLwlgod12';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb12';
                else if (props.labelPosition === "top") rules += ' DM8Mfn12';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb12';
            else if (props.labelPosition === "top") rules += ' E4w1sLc12';
            if (props.labelPosition === "side") rules += ' CbRM95c12';
            else if (props.labelPosition === "top") rules += ' Cxaocre12';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                rules += ' vx12';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                rules += ' vx12';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                rules += ' vx12';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                rules += ' vx12';
            } else {
                rules += ' -_6BNtrc-c12';
                rules += ' vx12';
            }
            rules += ' ea12';
            rules += ' _Fd12';
            rules += ' _FnuYUweb12';
            if (props.size === "XL") rules += ' -BhX7R-Fz12';
            else if (props.size === "L") rules += ' -BhX7R-Fv12';
            else if (props.size === "S") rules += ' -BhX7R-Fp12';
            else if (props.size === "XS") rules += ' -BhX7R-Fn12';
            else rules += ' -BhX7R-Fx12';
            rules += ' -AJjOLd-UVkF0Db12';
            rules += ' qg12';
            rules += ' __ca12';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isOpen, isFocusVisible, isInvalid, isRequired })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalPickerContext.Provider, {
                    value: {
                        size
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                            includeNecessityIndicatorInAccessibilityName: true,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            size: size,
                            labelPosition: labelPosition,
                            labelAlign: labelAlign,
                            isQuiet: isQuiet,
                            necessityIndicator: necessityIndicator,
                            contextualHelp: props1.contextualHelp,
                            children: label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerButton, {
                            loadingState: loadingState,
                            isOpen: isOpen,
                            isQuiet: isQuiet,
                            isFocusVisible: isFocusVisible,
                            size: size,
                            isInvalid: isInvalid,
                            isDisabled: isDisabled,
                            buttonRef: domRef,
                            loadingCircle: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerProgressCircle, {
                                id: spinnerId,
                                size: size,
                                "aria-label": stringFormatter.format('table.loading')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                            size: size,
                            isDisabled: isDisabled,
                            isInvalid: isInvalid,
                            description: descriptionMessage,
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
                            layout: (0, _reactAriaComponents.ListLayout),
                            layoutOptions: {
                                estimatedRowHeight: 32,
                                estimatedHeadingHeight: 50,
                                padding: 8,
                                loaderHeight: (0, _comboBox.LOADER_ROW_HEIGHTS)[size][scale]
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                                hideArrow: true,
                                padding: "none",
                                offset: menuOffset,
                                crossOffset: isQuiet ? RTLFlipOffset * -12 : undefined,
                                placement: `${direction} ${align}`,
                                shouldFlip: shouldFlip,
                                UNSAFE_style: {
                                    width: menuWidth && !isQuiet ? `${menuWidth}px` : undefined
                                },
                                styles: function anonymous(props) {
                                    let rules = " ";
                                    if (props.isQuiet) rules += ' Nh12';
                                    else rules += ' NuHSBze12';
                                    if (props.isQuiet) rules += ' ZbWuche12';
                                    else rules += ' ZuHSBze12';
                                    return rules;
                                }(props1),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sd12 Za12 Fb12",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                        values: [
                                            [
                                                (0, _content.HeaderContext),
                                                {
                                                    styles: (0, _comboBox.listboxHeader)({
                                                        size
                                                    })
                                                }
                                            ],
                                            [
                                                (0, _content.HeadingContext),
                                                {
                                                    // @ts-ignore
                                                    role: 'presentation',
                                                    styles: (0, _menu.sectionHeading)
                                                }
                                            ],
                                            [
                                                (0, _content.TextContext),
                                                {
                                                    slots: {
                                                        description: {
                                                            styles: (0, _menu.description)({
                                                                size
                                                            })
                                                        }
                                                    }
                                                }
                                            ]
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                                            dependencies: props1.dependencies,
                                            items: items,
                                            className: (0, _comboBox.listbox)({
                                                size
                                            }),
                                            children: renderer
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
    });
});
function PickerProgressCircle(props) {
    let { id, size, 'aria-label': ariaLabel } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
        id: id,
        isIndeterminate: true,
        size: "S",
        "aria-label": ariaLabel,
        styles: progressCircleStyles({
            size
        })
    });
}
const avatarSize = {
    S: 16,
    M: 20,
    L: 22,
    XL: 26
};
// Needs to be hidable component or otherwise the PressResponder throws a warning when rendered in the fake DOM and tries to register
const PickerButton = (0, _collections.createHideableComponent)(function PickerButton(props) {
    let { isOpen, isQuiet, isFocusVisible, size, isInvalid, isDisabled, loadingState, loadingCircle, buttonRef } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // For mouse interactions, pickers open on press start. When the popover underlay appears
    // it covers the trigger button, causing onPressEnd to fire immediately and no press scaling
    // to occur. We override this by listening for pointerup on the document ourselves.
    let [isPressed, setPressed] = (0, _react.useState)(false);
    let { addGlobalListener } = (0, _utils1.useGlobalListeners)();
    let onPressStart = (e)=>{
        if (e.pointerType !== 'mouse') return;
        setPressed(true);
        addGlobalListener(document, 'pointerup', ()=>{
            setPressed(false);
        }, {
            once: true,
            capture: true
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interactions.PressResponder), {
        onPressStart: onPressStart,
        isPressed: isPressed,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
            ref: buttonRef,
            style: (renderProps)=>(0, _pressScale.pressScale)(buttonRef)(renderProps),
            // Prevent press scale from sticking while Picker is open.
            // @ts-ignore
            isPressed: false,
            className: (renderProps)=>inputButton({
                    ...renderProps,
                    size: size,
                    isOpen,
                    isQuiet
                }),
            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                            className: valueStyles({
                                isQuiet
                            }) + ' ' + "pqYuhc",
                            children: ({ selectedItems, defaultChildren })=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                    values: [
                                        [
                                            (0, _icon.IconContext),
                                            {
                                                slots: {
                                                    icon: {
                                                        render: (0, _centerBaseline.centerBaseline)({
                                                            slot: 'icon',
                                                            styles: (0, _menu.iconCenterWrapper)
                                                        }),
                                                        styles: (0, _menu.icon)
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            (0, _avatar.AvatarContext),
                                            {
                                                slots: {
                                                    avatar: {
                                                        size: avatarSize[size ?? 'M'],
                                                        styles: avatar
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            (0, _content.TextContext),
                                            {
                                                slots: {
                                                    description: {},
                                                    [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                                        styles: " sb12 _ub12 _Nc12 Pc12 _Yb12 _7c12",
                                                        // @ts-ignore
                                                        'data-slot': 'label'
                                                    },
                                                    label: {
                                                        styles: " sb12 _ub12 _Nc12 Pc12 _Yb12 _7c12",
                                                        // @ts-ignore not technically necessary, but good for consistency
                                                        'data-slot': 'label'
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            InsideSelectValueContext,
                                            true
                                        ]
                                    ],
                                    children: selectedItems.length <= 1 ? defaultChildren : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                        slot: "label",
                                        children: stringFormatter.format('picker.selectedCount', {
                                            count: selectedItems.length
                                        })
                                    })
                                });
                            }
                        }),
                        isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                            isDisabled: isDisabled
                        }),
                        loadingState === 'loading' && !isOpen && loadingCircle,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                            size: size,
                            className: iconStyles({
                                isLoading: loadingState === 'loading'
                            })
                        }),
                        isFocusVisible && isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: quietFocusLine
                        }),
                        isInvalid && !isDisabled && !isQuiet && // @ts-ignore known limitation detecting functions from the theme
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: invalidBorder({
                                ...renderProps,
                                size
                            })
                        })
                    ]
                })
        })
    });
});
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function PickerItem(props) {
    let ref = (0, _react.useRef)(null);
    let isLink = props.href != null;
    let { size } = (0, _react.useContext)(InternalPickerContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, _pressScale.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _comboBox.listboxItem)({
                ...renderProps,
                size,
                isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children } = props;
            let checkboxRenderProps = {
                ...renderProps,
                size,
                isFocused: false,
                isFocusVisible: false,
                isIndeterminate: false,
                isReadOnly: false,
                isInvalid: false,
                isRequired: false
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultProvider, {
                context: (0, _icon.IconContext),
                value: {
                    slots: {
                        icon: {
                            render: (0, _centerBaseline.centerBaseline)({
                                slot: 'icon',
                                styles: (0, _menu.iconCenterWrapper)
                            }),
                            styles: (0, _menu.icon)
                        }
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultProvider, {
                    context: (0, _avatar.AvatarContext),
                    value: {
                        slots: {
                            avatar: {
                                size: avatarSize[size],
                                styles: avatar
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DefaultProvider, {
                        context: (0, _content.TextContext),
                        value: {
                            slots: {
                                [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                    styles: (0, _menu.label)({
                                        size
                                    })
                                },
                                label: {
                                    styles: (0, _menu.label)({
                                        size
                                    })
                                },
                                description: {
                                    styles: (0, _menu.description)({
                                        ...renderProps,
                                        size
                                    })
                                }
                            }
                        },
                        children: [
                            renderProps.selectionMode === 'single' && !isLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                size: checkmarkIconSize[size],
                                className: (0, _menu.checkmark)({
                                    ...renderProps,
                                    size
                                })
                            }),
                            renderProps.selectionMode === 'multiple' && !isLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _runtime.mergeStyles)((0, _menu.checkbox), (0, _checkbox.box)(checkboxRenderProps)),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                    size: size,
                                    className: (0, _checkbox.iconStyles)
                                })
                            }),
                            typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                slot: "label",
                                children: children
                            }) : children
                        ]
                    })
                })
            });
        }
    });
}
// A Context.Provider that only sets a value if not inside SelectValue.
function DefaultProvider({ context, value, children }) {
    let inSelectValue = (0, _react.useContext)(InsideSelectValueContext);
    if (inSelectValue) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(context.Provider, {
        value: value,
        children: children
    });
}
function PickerSection(props) {
    let { size } = (0, _react.useContext)(InternalPickerContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
                ...props,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.Divider), {
                size: size
            })
        ]
    });
}

},{"0":"aS7ZA","1":"5WHt7","2":"5V7Sj","3":"dol1O","4":"hrqnm","5":"jzZJR","6":"1Wio4","7":"6KRa5","8":"jAdD5","9":"2Vx52","10":"2trHW","11":"bbYwv","12":"a4kEc","13":"6CPSd","14":"8pVEl","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Collection","2Jd0Q"],["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxLoadMoreItem","dNdIK"],["ListBoxSection","dNdIK"],["ListLayout","6OEhs"],["Select","f92ET"],["SelectValue","f92ET"],["Virtualizer","2WSF6"]],"./Avatar":"f3T9F","./Checkbox":"jdSVu","./CenterBaseline":"1vpL9","./Menu":"1F0Yz","../ui-icons/Checkmark":"gK3Wp","../ui-icons/Chevron":"1904U","@react-aria/collections":"jY1vZ","./ComboBox":"9azF3","./Field":"eI7CE","./Form":"cHqN4","./Content":"10r6w","./Icon":"jQAJE","../intl/*.json":"gDH3q","../style/runtime":"8g9no","./Popover":"62puW","@react-aria/interactions":"bmg7W","./pressScale":"8Ufux","./ProgressCircle":"dztOy","react":"a1TxN","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useGlobalListeners","ceyTG"],["useSlotId","jbI4Y"]],"@react-aria/i18n":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"./utils":"9papc","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aS7ZA":[function() {},{}],"5WHt7":[function() {},{}],"5V7Sj":[function() {},{}],"dol1O":[function() {},{}],"hrqnm":[function() {},{}],"jzZJR":[function() {},{}],"1Wio4":[function() {},{}],"6KRa5":[function() {},{}],"jAdD5":[function() {},{}],"2Vx52":[function() {},{}],"2trHW":[function() {},{}],"bbYwv":[function() {},{}],"a4kEc":[function() {},{}],"6CPSd":[function() {},{}],"8pVEl":[function() {},{}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"6OEhs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ListLayout is a virtualizer Layout implementation
 * that arranges its items in a vertical stack. It supports both fixed
 * and variable height items.
 */ parcelHelpers.export(exports, "ListLayout", ()=>ListLayout);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_HEIGHT = 48;
class ListLayout extends (0, _virtualizer.Layout) {
    /**
   * Creates a new ListLayout with options. See the list of properties below for a description
   * of the options that can be provided.
   */ constructor(options = {}){
        super();
        this.rowHeight = options.rowHeight ?? null;
        this.estimatedRowHeight = options.estimatedRowHeight ?? null;
        this.headingHeight = options.headingHeight ?? null;
        this.estimatedHeadingHeight = options.estimatedHeadingHeight ?? null;
        this.loaderHeight = options.loaderHeight ?? null;
        this.dropIndicatorThickness = options.dropIndicatorThickness || 2;
        this.gap = options.gap || 0;
        this.padding = options.padding || 0;
        this.layoutNodes = new Map();
        this.rootNodes = [];
        this.lastCollection = null;
        this.invalidateEverything = false;
        this.validRect = new (0, _virtualizer.Rect)();
        this.requestedRect = new (0, _virtualizer.Rect)();
        this.contentSize = new (0, _virtualizer.Size)();
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    getLayoutInfo(key) {
        this.ensureLayoutInfo(key);
        return this.layoutNodes.get(key)?.layoutInfo || null;
    }
    getVisibleLayoutInfos(rect) {
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 for getDropTargetFromPoint)
        if (rect.height > 1) {
            let rowHeight = (this.rowHeight ?? this.estimatedRowHeight ?? DEFAULT_HEIGHT) + this.gap;
            rect.y = Math.floor(rect.y / rowHeight) * rowHeight;
            rect.height = Math.ceil(rect.height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        let addNodes = (nodes)=>{
            for (let node of nodes)if (this.isVisible(node, rect)) {
                res.push(node.layoutInfo);
                if (node.children) addNodes(node.children);
            }
        };
        addNodes(this.rootNodes);
        return res;
    }
    layoutIfNeeded(rect) {
        if (!this.lastCollection) return;
        if (!this.requestedRect.containsRect(rect)) {
            this.requestedRect = this.requestedRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        // Ensure all of the persisted keys are available.
        for (let key of this.virtualizer.persistedKeys){
            if (this.ensureLayoutInfo(key)) return;
        }
    }
    ensureLayoutInfo(key) {
        // If the layout info wasn't found, it might be outside the bounds of the area that we've
        // computed layout for so far. This can happen when accessing a random key, e.g pressing Home/End.
        // Compute the full layout and try again.
        if (!this.layoutNodes.has(key) && this.requestedRect.area < this.contentSize.area && this.lastCollection) {
            this.requestedRect = new (0, _virtualizer.Rect)(0, 0, Infinity, Infinity);
            this.rootNodes = this.buildCollection();
            this.requestedRect = new (0, _virtualizer.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
            return true;
        }
        return false;
    }
    isVisible(node, rect) {
        return node.layoutInfo.rect.intersects(rect) || node.layoutInfo.isSticky || node.layoutInfo.type === 'header' || node.layoutInfo.type === 'loader' || this.virtualizer.isPersistedKey(node.layoutInfo.key);
    }
    shouldInvalidateEverything(invalidationContext) {
        // Invalidate cache if the size of the collection changed.
        // In this case, we need to recalculate the entire layout.
        // Also invalidate if fixed sizes/gaps change.
        let options = invalidationContext.layoutOptions;
        return invalidationContext.sizeChanged || this.rowHeight !== (options?.rowHeight ?? this.rowHeight) || this.headingHeight !== (options?.headingHeight ?? this.headingHeight) || this.loaderHeight !== (options?.loaderHeight ?? this.loaderHeight) || this.gap !== (options?.gap ?? this.gap) || this.padding !== (options?.padding ?? this.padding);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.rowHeight !== oldOptions.rowHeight || newOptions.estimatedRowHeight !== oldOptions.estimatedRowHeight || newOptions.headingHeight !== oldOptions.headingHeight || newOptions.estimatedHeadingHeight !== oldOptions.estimatedHeadingHeight || newOptions.loaderHeight !== oldOptions.loaderHeight || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.gap !== oldOptions.gap || newOptions.padding !== oldOptions.padding;
    }
    update(invalidationContext) {
        let collection = this.virtualizer.collection;
        // Reset valid rect if we will have to invalidate everything.
        // Otherwise we can reuse cached layout infos outside the current visible rect.
        this.invalidateEverything = this.shouldInvalidateEverything(invalidationContext);
        if (this.invalidateEverything) {
            this.requestedRect = this.virtualizer.visibleRect.copy();
            this.layoutNodes.clear();
        }
        let options = invalidationContext.layoutOptions;
        this.rowHeight = options?.rowHeight ?? this.rowHeight;
        this.estimatedRowHeight = options?.estimatedRowHeight ?? this.estimatedRowHeight;
        this.headingHeight = options?.headingHeight ?? this.headingHeight;
        this.estimatedHeadingHeight = options?.estimatedHeadingHeight ?? this.estimatedHeadingHeight;
        this.loaderHeight = options?.loaderHeight ?? this.loaderHeight;
        this.dropIndicatorThickness = options?.dropIndicatorThickness ?? this.dropIndicatorThickness;
        this.gap = options?.gap ?? this.gap;
        this.padding = options?.padding ?? this.padding;
        this.rootNodes = this.buildCollection();
        // Remove deleted layout nodes
        if (this.lastCollection && collection !== this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!collection.getItem(key)) {
                let layoutNode = this.layoutNodes.get(key);
                if (layoutNode) this.layoutNodes.delete(key);
            }
        }
        this.lastCollection = collection;
        this.invalidateEverything = false;
        this.validRect = this.requestedRect.copy();
    }
    buildCollection(y = this.padding) {
        let collection = this.virtualizer.collection;
        let collectionNodes = [
            ...collection
        ];
        let loaderNodes = collectionNodes.filter((node)=>node.type === 'loader');
        let nodes = [];
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) y = 0;
        for (let node of collectionNodes){
            let rowHeight = (this.rowHeight ?? this.estimatedRowHeight ?? DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (node.type === 'item' && y + rowHeight < this.requestedRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                continue;
            }
            let layoutNode = this.buildChild(node, this.padding, y, null);
            y = layoutNode.layoutInfo.rect.maxY + this.gap;
            nodes.push(layoutNode);
            if (node.type === 'loader') {
                let index = loaderNodes.indexOf(node);
                loaderNodes.splice(index, 1);
            }
            // Build each loader that exists in the collection that is outside the visible rect so that they are persisted
            // at the proper estimated location. If the node.type is "section" then we don't do this shortcut since we have to
            // build the sections to see how tall they are.
            if ((node.type === 'item' || node.type === 'loader') && y > this.requestedRect.maxY) {
                let lastProcessedIndex = collectionNodes.indexOf(node);
                for (let loaderNode of loaderNodes){
                    let loaderNodeIndex = collectionNodes.indexOf(loaderNode);
                    // Subtract by an additional 1 since we've already added the current item's height to y
                    y += (loaderNodeIndex - lastProcessedIndex - 1) * rowHeight;
                    let loader = this.buildChild(loaderNode, this.padding, y, null);
                    nodes.push(loader);
                    y = loader.layoutInfo.rect.maxY;
                    lastProcessedIndex = loaderNodeIndex;
                }
                // Account for the rest of the items after the last loader spinner, subtract by 1 since we've processed the current node's height already
                y += (collectionNodes.length - lastProcessedIndex - 1) * rowHeight;
                break;
            }
        }
        y -= this.gap;
        y += isEmptyOrLoading ? 0 : this.padding;
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
        return nodes;
    }
    isValid(node, y) {
        let cached = this.layoutNodes.get(node.key);
        return !this.invalidateEverything && !!cached && cached.node === node && y === cached.layoutInfo.rect.y && cached.layoutInfo.rect.intersects(this.validRect) && cached.validRect.containsRect(cached.layoutInfo.rect.intersection(this.requestedRect));
    }
    buildChild(node, x, y, parentKey) {
        if (this.isValid(node, y)) return this.layoutNodes.get(node.key);
        let layoutNode = this.buildNode(node, x, y);
        layoutNode.layoutInfo.parentKey = parentKey ?? null;
        layoutNode.layoutInfo.allowOverflow = true;
        this.layoutNodes.set(node.key, layoutNode);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'section':
                return this.buildSection(node, x, y);
            case 'item':
                return this.buildItem(node, x, y);
            case 'header':
                return this.buildSectionHeader(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            case 'separator':
                return this.buildItem(node, x, y);
            default:
                throw new Error('Unsupported node type: ' + node.type);
        }
    }
    buildLoader(node, x, y) {
        let rect = new (0, _virtualizer.Rect)(x, y, this.padding, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)('loader', node.key, rect);
        rect.width = this.virtualizer.contentSize.width - this.padding - x;
        // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
        // room for the loader alongside rendering the emptyState
        rect.height = node.props.isLoading ? this.loaderHeight ?? this.rowHeight ?? this.estimatedRowHeight ?? DEFAULT_HEIGHT : 0;
        return {
            layoutInfo,
            validRect: rect.intersection(this.requestedRect)
        };
    }
    buildSection(node, x, y) {
        let collection = this.virtualizer.collection;
        let width = this.virtualizer.visibleRect.width - this.padding;
        let rect = new (0, _virtualizer.Rect)(x, y, width - x, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        let startY = y;
        let skipped = 0;
        let children = [];
        for (let child of (0, _collections.getChildNodes)(node, collection)){
            let rowHeight = (this.rowHeight ?? this.estimatedRowHeight ?? DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (y + rowHeight < this.requestedRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.buildChild(child, x, y, layoutInfo.key);
            y = layoutNode.layoutInfo.rect.maxY + this.gap;
            children.push(layoutNode);
            if (y > this.requestedRect.maxY) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                y += ([
                    ...(0, _collections.getChildNodes)(node, collection)
                ].length - (children.length + skipped)) * rowHeight;
                break;
            }
        }
        y -= this.gap;
        rect.height = y - startY;
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node
        };
    }
    buildSectionHeader(node, x, y) {
        let width = this.virtualizer.visibleRect.width - this.padding;
        let rectHeight = this.headingHeight;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            let previousLayoutInfo = previousLayoutNode?.layoutInfo;
            if (previousLayoutInfo) {
                let curNode = this.virtualizer.collection.getItem(node.key);
                let lastNode = this.lastCollection ? this.lastCollection.getItem(node.key) : null;
                rectHeight = previousLayoutInfo.rect.height;
                isEstimated = width !== previousLayoutInfo.rect.width || curNode !== lastNode || previousLayoutInfo.estimatedSize;
            } else {
                rectHeight = node.rendered ? this.estimatedHeadingHeight : 0;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        let headerRect = new (0, _virtualizer.Rect)(x, y, width - x, rectHeight);
        let header = new (0, _virtualizer.LayoutInfo)('header', node.key, headerRect);
        header.estimatedSize = isEstimated;
        return {
            layoutInfo: header,
            children: [],
            validRect: header.rect.intersection(this.requestedRect),
            node
        };
    }
    buildItem(node, x, y) {
        let width = this.virtualizer.visibleRect.width - this.padding - x;
        let rectHeight = this.rowHeight;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                rectHeight = previousLayoutNode.layoutInfo.rect.height;
                isEstimated = width !== previousLayoutNode.layoutInfo.rect.width || node !== previousLayoutNode.node || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                rectHeight = this.estimatedRowHeight;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        let rect = new (0, _virtualizer.Rect)(x, y, width, rectHeight);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            children: [],
            validRect: layoutInfo.rect,
            node
        };
    }
    updateItemSize(key, size) {
        let layoutNode = this.layoutNodes.get(key);
        // If no layoutInfo, item has been deleted/removed.
        if (!layoutNode) return false;
        let collection = this.virtualizer.collection;
        let layoutInfo = layoutNode.layoutInfo;
        layoutInfo.estimatedSize = false;
        if (layoutInfo.rect.height !== size.height) {
            // Copy layout info rather than mutating so that later caches are invalidated.
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            layoutNode.layoutInfo = newLayoutInfo;
            // Items after this layoutInfo will need to be repositioned to account for the new height.
            // Adjust the validRect so that only items above remain valid.
            this.validRect.height = Math.min(this.validRect.height, layoutInfo.rect.y - this.validRect.y);
            // The requestedRect also needs to be adjusted to account for the height difference.
            this.requestedRect.height += newLayoutInfo.rect.height - layoutInfo.rect.height;
            // Invalidate layout for this layout node and all parents
            this.updateLayoutNode(key, layoutInfo, newLayoutInfo);
            let node = layoutInfo.parentKey != null ? collection.getItem(layoutInfo.parentKey) : null;
            while(node){
                this.updateLayoutNode(node.key, layoutInfo, newLayoutInfo);
                node = node.parentKey != null ? collection.getItem(node.parentKey) : null;
            }
            return true;
        }
        return false;
    }
    updateLayoutNode(key, oldLayoutInfo, newLayoutInfo) {
        let n = this.layoutNodes.get(key);
        if (n) {
            // Invalidate by intersecting the validRect of this node with the overall validRect.
            n.validRect = n.validRect.intersection(this.validRect);
            // Replace layout info in LayoutNode
            if (n.layoutInfo === oldLayoutInfo) n.layoutInfo = newLayoutInfo;
        }
    }
    getContentSize() {
        return this.contentSize;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, _virtualizer.Rect)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (!candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (target.dropPosition === 'before') rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, Math.max(0, layoutInfo.rect.y - this.dropIndicatorThickness / 2), layoutInfo.rect.width, this.dropIndicatorThickness);
        else if (target.dropPosition === 'after') {
            // Render after last visible descendant of the drop target.
            let targetNode = this.collection.getItem(target.key);
            if (targetNode) {
                let targetLevel = targetNode.level ?? 0;
                let currentKey = this.collection.getKeyAfter(target.key);
                while(currentKey != null){
                    let node = this.collection.getItem(currentKey);
                    if (!node || node.level <= targetLevel) break;
                    layoutInfo = this.getLayoutInfo(currentKey) || layoutInfo;
                    currentKey = this.collection.getKeyAfter(currentKey);
                }
            }
            rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, layoutInfo.rect.maxY - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        } else rect = layoutInfo.rect;
        return new (0, _virtualizer.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
}

},{"@react-stately/collections":"HxEYQ","@react-stately/virtualizer":[["Layout","fnAag"],["LayoutInfo","6H2VJ"],["Rect","l3p76"],["Size","F8cca"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9azF3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBoxContext", ()=>ComboBoxContext);
parcelHelpers.export(exports, "listbox", ()=>listbox);
parcelHelpers.export(exports, "listboxItem", ()=>listboxItem);
parcelHelpers.export(exports, "listboxHeader", ()=>listboxHeader);
parcelHelpers.export(exports, "LOADER_ROW_HEIGHTS", ()=>LOADER_ROW_HEIGHTS);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
parcelHelpers.export(exports, "ComboBoxItem", ()=>ComboBoxItem);
parcelHelpers.export(exports, "ComboBoxSection", ()=>ComboBoxSection);
parcelHelpers.export(exports, "Divider", ()=>Divider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _avatar = require("./Avatar");
var _collections = require("@react-aria/collections");
var _centerBaseline = require("./CenterBaseline");
var _menu = require("./Menu");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _content = require("./Content");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _popover = require("./Popover");
var _pressScale = require("./pressScale");
var _progressCircle = require("./ProgressCircle");
var _i18N = require("@react-aria/i18n");
var _utils2 = require("./utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ComboBoxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-oa12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' sd12';
    rules += ' _Le12';
    rules += ' _Wa12';
    rules += ' _je12';
    rules += ' eb12';
    rules += ' _Ca12';
    if (props.size === "XL") rules += ' ZC12';
    else if (props.size === "L") rules += ' Zo12';
    else if (props.size === "M") rules += ' Zm12';
    else if (props.size === "S") rules += ' Zu12';
    if (props.size === "XL") rules += ' Fx12';
    else if (props.size === "L") rules += ' Fp12';
    else if (props.size === "M") rules += ' Fn12';
    else if (props.size === "S") rules += ' Ft12';
    rules += ' Iw12';
    rules += ' fa12';
    rules += ' _va12';
    rules += ' Yd12';
    rules += ' Yle12';
    rules += ' Xb12';
    rules += ' Xlb12';
    rules += ' _2b12';
    rules += ' _2lb12';
    if (props.isDisabled) rules += ' gH12';
    else if (props.isOpen) rules += ' gF12';
    else {
        if (props.isPressed) rules += ' gF12';
        else if (props.isFocusVisible) rules += ' gF12';
        else if (props.isHovered) rules += ' gF12';
        else rules += ' gH12';
    }
    if (props.isDisabled) rules += ' gld12';
    else if (props.isOpen) rules += ' gle12';
    else if (props.isHovered) rules += ' gle12';
    else rules += ' glc12';
    if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' pla12';
    return rules;
};
const iconStyles = " _va12 _Sd12 -_8sjo0b-t5ZbAob12";
const loadingWrapperStyles = " z2mU12 yzZKy12 sd12 eb12 _Ca12 Jv12 Gv12";
const progressCircleStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' Zp12';
    else if (props.size === "L") rules += ' Zn12';
    else if (props.size === "M") rules += ' Zm12';
    else if (props.size === "S") rules += ' Zu12';
    if (props.size === "XL") rules += ' Fq12';
    else if (props.size === "L") rules += ' Fo12';
    else if (props.size === "M") rules += ' Fn12';
    else if (props.size === "S") rules += ' Ft12';
    if (props.isInput) {
        rules += ' It12';
        rules += ' Isu12';
    }
    return rules;
};
const emptyStateText = function anonymous(props) {
    let rules = " ";
    rules += ' FRuFGYc12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "M") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "M") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "M") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.size === "XL") rules += ' pt12';
    else if (props.size === "L") rules += ' pt12';
    else if (props.size === "M") rules += ' pt12';
    else if (props.size === "S") rules += ' pt12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' Sv12';
    if (props.size === "XL") rules += ' -F_-Fz12';
    else if (props.size === "L") rules += ' -F_-Fv12';
    else if (props.size === "M") rules += ' -F_-Fx12';
    else if (props.size === "S") rules += ' -F_-Fp12';
    return rules;
};
let listbox = function anonymous(props) {
    let rules = " ";
    rules += ' Za12';
    rules += ' _oa12';
    rules += ' K40ub4c12';
    rules += ' Pa12';
    rules += ' _Nc12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' _Le12';
    return rules;
};
let listboxItem = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let gridColumnStart = false;
    let gridColumnEnd = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "z") gridColumnStart = true;
        if (p[1] === "y") gridColumnEnd = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) {
        rules += ' pp12';
        rules += ' plc12';
    } else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' se12';
    rules += ' ea12';
    rules += ' _oa12';
    rules += ' Sd12';
    rules += ' Rd12';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl12';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj12';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf12';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne12';
    } else if (!minWidth) rules += ' Nk12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' qh12';
    rules += ' -Qg41Lb-IAxCW0c12';
    rules += ' -Qg41Lb-gLWx3bIy12';
    rules += ' MAyFGYc12';
    rules += ' Td12';
    rules += ' QAzEcG12';
    rules += ' -aRvJDd-Tu7Fubd12';
    if (props.isFocused) rules += ' gF12';
    else rules += ' g912';
    if (!position) rules += ' _Pc12';
    if (!gridColumnStart) rules += ' z2mU12';
    if (!gridColumnEnd) rules += ' yzZKy12';
    rules += ' CHV1uCd12';
    if (props.size === "XL") rules += ' DTw5ujc12';
    else if (props.size === "L") rules += ' DdpPw412';
    else if (props.size === "M") rules += ' Dxy3qDe12';
    else if (props.size === "S") rules += ' DfLJE012';
    rules += ' EpvfBwb12';
    rules += ' EDNKd2dZQmDFe12';
    rules += ' UDNKd2dai5a012';
    rules += ' FF12';
    rules += ' _Xa12';
    if (props.isLink) rules += ' ry12';
    else rules += ' ri12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.size === "XL") rules += ' -M_-Mk12';
    else if (props.size === "L") rules += ' -M_-Mh12';
    else if (props.size === "S") rules += ' -M_-Mg12';
    else if (props.size === "XS") rules += ' -M_-Mf12';
    else rules += ' -M_-Mi12';
    return rules;
};
let listboxHeader = function anonymous(props) {
    let rules = " ";
    rules += ' pt12';
    rules += ' _oa12';
    rules += ' MAyFGYc12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    if (props.size === "XL") rules += ' I2d3n12';
    else if (props.size === "L") rules += ' IaxPIqb12';
    else if (props.size === "M") rules += ' Ip2UVod12';
    else if (props.size === "S") rules += ' IH8XZ7c12';
    if (props.size === "XL") rules += ' H2d3n12';
    else if (props.size === "L") rules += ' HaxPIqb12';
    else if (props.size === "M") rules += ' Hp2UVod12';
    else if (props.size === "S") rules += ' HH8XZ7c12';
    if (props.size === "XL") rules += ' -M_-Mk12';
    else if (props.size === "L") rules += ' -M_-Mh12';
    else if (props.size === "S") rules += ' -M_-Mg12';
    else if (props.size === "XS") rules += ' -M_-Mf12';
    else rules += ' -M_-Mi12';
    return rules;
};
const separatorWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' sd12';
    if (props.size === "XL") rules += ' I2d3n12';
    else if (props.size === "L") rules += ' IaxPIqb12';
    else if (props.size === "M") rules += ' Ip2UVod12';
    else if (props.size === "S") rules += ' IH8XZ7c12';
    if (props.size === "XL") rules += ' H2d3n12';
    else if (props.size === "L") rules += ' HaxPIqb12';
    else if (props.size === "M") rules += ' Hp2UVod12';
    else if (props.size === "S") rules += ' HH8XZ7c12';
    rules += ' Fk12';
    rules += ' eb12';
    return rules;
};
const dividerStyle = " gF12 gl_a12 og12 ng12 kg12 jg12 FLvNfn12 Za12";
const avatar = " z2U5Crc12 y2U5Crc12 B2U5Crc12 A2U5Crc12 Ht12 Hsu12";
const LOADER_ROW_HEIGHTS = {
    S: {
        medium: 24,
        large: 30
    },
    M: {
        medium: 32,
        large: 40
    },
    L: {
        medium: 40,
        large: 50
    },
    XL: {
        medium: 48,
        large: 60
    }
};
let InternalComboboxContext = /*#__PURE__*/ (0, _react.createContext)({
    size: 'M'
});
const ComboBox = /*#__PURE__*/ (0, _react.forwardRef)(function ComboBox(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, ComboBoxContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { size = 'M', labelPosition = 'top', UNSAFE_className = '', UNSAFE_style, ...comboBoxProps } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ComboBox), {
        ...comboBoxProps,
        allowsEmptyCollection: true,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                }
            }
            if (props.isInForm) rules += ' DLwlgod12';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb12';
                else if (props.labelPosition === "top") rules += ' DM8Mfn12';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb12';
            else if (props.labelPosition === "top") rules += ' E4w1sLc12';
            if (props.labelPosition === "side") rules += ' CbRM95c12';
            else if (props.labelPosition === "top") rules += ' Cxaocre12';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                rules += ' vx12';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                rules += ' vx12';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                rules += ' vx12';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                rules += ' vx12';
            } else {
                rules += ' -_6BNtrc-c12';
                rules += ' vx12';
            }
            rules += ' ea12';
            rules += ' _Fd12';
            rules += ' _FnuYUweb12';
            if (props.size === "XL") rules += ' -BhX7R-Fz12';
            else if (props.size === "L") rules += ' -BhX7R-Fv12';
            else if (props.size === "S") rules += ' -BhX7R-Fp12';
            else if (props.size === "XS") rules += ' -BhX7R-Fn12';
            else rules += ' -BhX7R-Fx12';
            rules += ' -AJjOLd-UVkF0Db12';
            rules += ' qg12';
            rules += ' __ca12';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isOpen, isRequired, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ComboboxInner, {
                ...props1,
                isDisabled: isDisabled,
                isOpen: isOpen,
                isRequired: isRequired,
                isInvalid: isInvalid,
                ref: ref
            })
    });
});
const avatarSize = {
    S: 16,
    M: 20,
    L: 22,
    XL: 26
};
const checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function ComboBoxItem(props) {
    let ref = (0, _react.useRef)(null);
    let isLink = props.href != null;
    let { size } = (0, _react.useContext)(InternalComboboxContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, _pressScale.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + listboxItem({
                ...renderProps,
                size,
                isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children } = props;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _icon.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, _centerBaseline.centerBaseline)({
                                            slot: 'icon',
                                            styles: (0, _menu.iconCenterWrapper)
                                        }),
                                        styles: (0, _menu.icon)
                                    }
                                }
                            }
                        ],
                        [
                            (0, _avatar.AvatarContext),
                            {
                                slots: {
                                    avatar: {
                                        size: avatarSize[size],
                                        styles: avatar
                                    }
                                }
                            }
                        ],
                        [
                            (0, _content.TextContext),
                            {
                                slots: {
                                    label: {
                                        styles: (0, _menu.label)({
                                            size
                                        })
                                    },
                                    description: {
                                        styles: (0, _menu.description)({
                                            ...renderProps,
                                            size
                                        })
                                    }
                                }
                            }
                        ]
                    ],
                    children: [
                        !isLink && !props.onAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: checkmarkIconSize[size],
                            className: (0, _menu.checkmark)({
                                ...renderProps,
                                size
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
}
function ComboBoxSection(props) {
    let { size } = (0, _react.useContext)(InternalComboboxContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
                ...props,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Divider, {
                size: size
            })
        ]
    });
}
const ComboboxInner = /*#__PURE__*/ (0, _react.forwardRef)(function ComboboxInner(props1, ref) {
    let { direction = 'bottom', align = 'start', shouldFlip = true, menuWidth, label, description: descriptionMessage, errorMessage, children, defaultItems, items, size = 'M', labelPosition = 'top', labelAlign = 'start', necessityIndicator, loadingState, isDisabled, isOpen, isRequired, isInvalid, menuTrigger, onLoadMore } = props1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _react.useRef)(null);
    let buttonRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    let triggerRef = (0, _react.useRef)(null);
    // Make menu width match input + button
    let [triggerWidth, setTriggerWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (triggerRef.current) {
            let inputRect = triggerRef.current.getBoundingClientRect();
            let minX = inputRect.left;
            let maxX = inputRect.right;
            setTriggerWidth(maxX - minX + 'px');
        }
    }, [
        triggerRef,
        setTriggerWidth
    ]);
    (0, _utils1.useResizeObserver)({
        ref: triggerRef,
        onResize: onResize
    });
    let state = (0, _react.useContext)((0, _reactAriaComponents.ComboBoxStateContext));
    let timeout = (0, _react.useRef)(null);
    let [showLoading, setShowLoading] = (0, _react.useState)(false);
    let isLoadingOrFiltering = loadingState === 'loading' || loadingState === 'filtering';
    let showFieldSpinner = (0, _react.useMemo)(()=>showLoading && (isOpen || menuTrigger === 'manual' || loadingState === 'loading'), [
        showLoading,
        isOpen,
        menuTrigger,
        loadingState
    ]);
    let spinnerId = (0, _utils1.useSlotId)([
        showFieldSpinner
    ]);
    let inputValue = state?.inputValue;
    let lastInputValue = (0, _react.useRef)(inputValue);
    (0, _react.useEffect)(()=>{
        if (isLoadingOrFiltering && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (!isLoadingOrFiltering) {
            // If loading is no longer happening, clear any timers and hide the loading circle
            setShowLoading(false);
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        isLoadingOrFiltering,
        showLoading,
        inputValue
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        };
    }, []);
    let renderer;
    let listBoxLoadingCircle = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxLoadMoreItem), {
        // Only show the spinner in the list when loading more
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: loadingWrapperStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            size: "S",
            styles: progressCircleStyles({
                size
            }),
            // Same loading string as table
            "aria-label": stringFormatter.format('table.loadingMore')
        })
    });
    if (typeof children === 'function') renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: items ?? defaultItems,
                dependencies: props1.dependencies,
                children: children
            }),
            listBoxLoadingCircle
        ]
    });
    else // TODO: is there a case where the user might provide items to the Combobox but doesn't provide a function renderer?
    // Same case for other components that have this logic (TableView/CardView/Picker)
    renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            listBoxLoadingCircle
        ]
    });
    let scale = (0, _utils2.useScale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalComboboxContext.Provider, {
            value: {
                size
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                    includeNecessityIndicatorInAccessibilityName: true,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    size: size,
                    labelPosition: labelPosition,
                    labelAlign: labelAlign,
                    necessityIndicator: necessityIndicator,
                    contextualHelp: props1.contextualHelp,
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                    ref: triggerRef,
                    role: "presentation",
                    isDisabled: isDisabled,
                    isInvalid: isInvalid,
                    size: size,
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' zXcEWr12';
                        rules += ' yXcEWr12';
                        rules += ' BXcEWr12';
                        rules += ' AXcEWr12';
                        if (props.size === "XL") rules += ' Nl12';
                        else if (props.size === "L") rules += ' Nj12';
                        else if (props.size === "S") rules += ' Nf12';
                        else if (props.size === "XS") rules += ' Ne12';
                        else rules += ' Nk12';
                        if (props.isQuiet) rules += ' _qd12';
                        else rules += ' _qtb12';
                        if (props.size === "XL") rules += ' -Anxdcc-Zt12';
                        else if (props.size === "L") rules += ' -Anxdcc-ZStdtne12';
                        else if (props.size === "S") rules += ' -Anxdcc-Zr12';
                        else rules += ' -Anxdcc-Z3fn9H12';
                        rules += ' __v6TNLWb12';
                        rules += ' SMBFGYc12';
                        rules += ' RfBFGYc12';
                        rules += ' -S_-Sv12';
                        rules += ' -R_-Rjxyh812';
                        return rules;
                    }({
                        size
                    }),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                            children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                    value: {
                                        ...ctx,
                                        ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                        "aria-describedby": spinnerId
                                    })
                                })
                        }),
                        isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                            isDisabled: isDisabled
                        }),
                        showFieldSpinner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                            id: spinnerId,
                            isIndeterminate: true,
                            size: "S",
                            styles: progressCircleStyles({
                                size,
                                isInput: true
                            }),
                            "aria-label": stringFormatter.format('table.loading')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                            ref: buttonRef,
                            // Prevent press scale from sticking while ComboBox is open.
                            // @ts-ignore
                            isPressed: false,
                            style: (renderProps)=>(0, _pressScale.pressScale)(buttonRef)(renderProps),
                            className: (renderProps)=>inputButton({
                                    ...renderProps,
                                    size,
                                    isOpen
                                }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                size: size,
                                className: iconStyles
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                    size: size,
                    isDisabled: isDisabled,
                    isInvalid: isInvalid,
                    description: descriptionMessage,
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                    hideArrow: true,
                    triggerRef: triggerRef,
                    offset: menuOffset,
                    placement: `${direction} ${align}`,
                    shouldFlip: shouldFlip,
                    UNSAFE_style: {
                        '--trigger-width': menuWidth ? menuWidth + 'px' : triggerWidth
                    },
                    padding: "none",
                    styles: " NuHSBze12 ZuHSBze12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd12 Za12 Fb12",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                            values: [
                                [
                                    (0, _content.HeaderContext),
                                    {
                                        styles: listboxHeader({
                                            size
                                        })
                                    }
                                ],
                                [
                                    (0, _content.HeadingContext),
                                    {
                                        // @ts-ignore
                                        role: 'presentation',
                                        styles: (0, _menu.sectionHeading)
                                    }
                                ],
                                [
                                    (0, _content.TextContext),
                                    {
                                        slots: {
                                            'description': {
                                                styles: (0, _menu.description)({
                                                    size
                                                })
                                            }
                                        }
                                    }
                                ]
                            ],
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
                                layout: (0, _reactAriaComponents.ListLayout),
                                layoutOptions: {
                                    estimatedRowHeight: 32,
                                    padding: 8,
                                    estimatedHeadingHeight: 50,
                                    loaderHeight: LOADER_ROW_HEIGHTS[size][scale]
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                                    dependencies: props1.dependencies,
                                    renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: emptyStateText({
                                                size
                                            }),
                                            children: loadingState === 'loading' ? stringFormatter.format('table.loading') : stringFormatter.format('combobox.noResults')
                                        }),
                                    items: items,
                                    className: listbox({
                                        size
                                    }),
                                    children: renderer
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
});
class SeparatorNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'separator';
    }
    filter(collection, newCollection) {
        let prevItem = newCollection.getItem(this.prevKey);
        if (prevItem && prevItem.type !== 'separator') {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
const Divider = /*#__PURE__*/ (0, _collections.createLeafComponent)(SeparatorNode, function Divider({ size }, ref, node) {
    let listState = (0, _react.useContext)((0, _reactAriaComponents.ListStateContext));
    let nextNode = node.nextKey != null && listState.collection.getItem(node.nextKey);
    if (node.prevKey == null || !nextNode || nextNode.type === 'separator' || nextNode.type === 'loader' && nextNode.nextKey == null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: separatorWrapper({
            size
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: ref,
            className: dividerStyle
        })
    });
});

},{"0":"hmBuP","1":"A9QhD","2":"7U7F7","3":"bssr3","4":"ext4W","5":"kOLmt","6":"disps","7":"eN10y","8":"7sCKr","9":"03oX3","10":"cNj9D","11":"hROmA","12":"fOQZm","13":"fAbH1","14":"gBMKy","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Collection","2Jd0Q"],["ComboBox","aR9kO"],["ComboBoxStateContext","aR9kO"],["InputContext","jU9y1"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxLoadMoreItem","dNdIK"],["ListBoxSection","dNdIK"],["ListStateContext","dNdIK"],["ListLayout","6OEhs"],["Provider","bA6Cz"],["Virtualizer","2WSF6"]],"./Avatar":"f3T9F","@react-aria/collections":[["CollectionNode","ab6Rh"],["createLeafComponent","2Jd0Q"]],"./CenterBaseline":"1vpL9","./Menu":"1F0Yz","../ui-icons/Checkmark":"gK3Wp","../ui-icons/Chevron":"1904U","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./Content":"10r6w","./Icon":"jQAJE","../intl/*.json":"gDH3q","@react-aria/utils":[["mergeRefs","1vHgg"],["useResizeObserver","7OAb4"],["useSlotId","jbI4Y"]],"./Popover":"62puW","./pressScale":"8Ufux","./ProgressCircle":"dztOy","@react-aria/i18n":"7lxyl","./utils":"9papc","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hmBuP":[function() {},{}],"A9QhD":[function() {},{}],"7U7F7":[function() {},{}],"bssr3":[function() {},{}],"ext4W":[function() {},{}],"kOLmt":[function() {},{}],"disps":[function() {},{}],"eN10y":[function() {},{}],"7sCKr":[function() {},{}],"03oX3":[function() {},{}],"cNj9D":[function() {},{}],"hROmA":[function() {},{}],"fOQZm":[function() {},{}],"fAbH1":[function() {},{}],"gBMKy":[function() {},{}],"aR9kO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBoxContext", ()=>ComboBoxContext);
parcelHelpers.export(exports, "ComboBoxStateContext", ()=>ComboBoxStateContext);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _listBox = require("./ListBox");
var _dialog = require("./Dialog");
var _popover = require("./Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const ComboBoxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ComboBoxStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ComboBox = /*#__PURE__*/ (0, _react.forwardRef)(function ComboBox(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ComboBoxContext);
    let { children, isDisabled = false, isInvalid = false, isRequired = false } = props;
    let content = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListBoxContext).Provider, {
            value: {
                items: props.items ?? props.defaultItems
            }
        }, typeof children === 'function' ? children({
            isOpen: false,
            isDisabled,
            isInvalid,
            isRequired,
            defaultChildren: null
        }) : children), [
        children,
        isDisabled,
        isInvalid,
        isRequired,
        props.items,
        props.defaultItems
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.CollectionBuilder), {
        content: content
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ComboBoxInner, {
            props: props,
            collection: collection,
            comboBoxRef: ref
        }));
});
// Contexts to clear inside the popover.
const CLEAR_CONTEXTS = [
    (0, _label.LabelContext),
    (0, _button.ButtonContext),
    (0, _input.InputContext),
    (0, _group.GroupContext),
    (0, _text.TextContext)
];
function ComboBoxInner({ props, collection, comboBoxRef: ref }) {
    let { name, formValue = 'key', allowsCustomValue } = props;
    if (allowsCustomValue) formValue = 'text';
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let { contains } = (0, _reactAria.useFilter)({
        sensitivity: 'base'
    });
    let state = (0, _reactStately.useComboBoxState)({
        defaultFilter: props.defaultFilter || contains,
        ...props,
        // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
        items: props.items,
        children: undefined,
        collection,
        validationBehavior
    });
    let buttonRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let listBoxRef = (0, _react.useRef)(null);
    let popoverRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { buttonProps, inputProps, listBoxProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useComboBox)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        inputRef,
        buttonRef,
        listBoxRef,
        popoverRef,
        name: formValue === 'text' ? name : undefined,
        validationBehavior
    }, state);
    // Make menu width match input + button
    let [menuWidth, setMenuWidth] = (0, _react.useState)(null);
    let onResize = (0, _react.useCallback)(()=>{
        if (inputRef.current) {
            let buttonRect = buttonRef.current?.getBoundingClientRect();
            let inputRect = inputRef.current.getBoundingClientRect();
            let minX = buttonRect ? Math.min(buttonRect.left, inputRect.left) : inputRect.left;
            let maxX = buttonRect ? Math.max(buttonRect.right, inputRect.right) : inputRect.right;
            setMenuWidth(maxX - minX + 'px');
        }
    }, [
        buttonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, _utils1.useResizeObserver)({
        ref: inputRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, _react.useMemo)(()=>({
            isOpen: state.isOpen,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-ComboBox'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ComboBoxStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    ref: buttonRef,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    ref: popoverRef,
                    triggerRef: inputRef,
                    scrollRef: listBoxRef,
                    placement: 'bottom start',
                    isNonModal: true,
                    trigger: 'ComboBox',
                    style: {
                        '--trigger-width': menuWidth
                    },
                    clearContexts: CLEAR_CONTEXTS
                }
            ],
            [
                (0, _listBox.ListBoxContext),
                {
                    ...listBoxProps,
                    ref: listBoxRef
                }
            ],
            [
                (0, _listBox.ListStateContext),
                state
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }), name && formValue === 'key' && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: name,
        form: props.form,
        value: state.selectedKey ?? ''
    }));
}

},{"react-aria":[["useComboBox","2vFIF"],["useFilter","eUaoA"]],"./Button":"9G5XO","./utils":"bA6Cz","react-stately":"4sOwm","@react-aria/collections":"2Jd0Q","./FieldError":"algyu","@react-aria/utils":[["filterDOMProps","3upVm"],["useResizeObserver","7OAb4"]],"./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","./ListBox":"dNdIK","./Dialog":"l2uUY","./Popover":"l4JC0","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2vFIF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a combo box component.
 * A combo box combines a text input with a listbox, allowing users to filter a list of options to items matching a query.
 * @param props - Props for the combo box.
 * @param state - State for the select, as returned by `useComboBoxState`.
 */ parcelHelpers.export(exports, "useComboBox", ()=>useComboBox);
var _liveAnnouncer = require("@react-aria/live-announcer");
var _overlays = require("@react-aria/overlays");
var _listbox = require("@react-aria/listbox");
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _collections = require("@react-stately/collections");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _selection = require("@react-aria/selection");
var _form = require("@react-stately/form");
var _i18N = require("@react-aria/i18n");
var _menu = require("@react-aria/menu");
var _textfield = require("@react-aria/textfield");
function useComboBox(props, state) {
    let { buttonRef, popoverRef, inputRef, listBoxRef, keyboardDelegate, layoutDelegate, // completionMode = 'suggest',
    shouldFocusWrap, isReadOnly, isDisabled } = props;
    let backupBtnRef = (0, _react.useRef)(null);
    buttonRef = buttonRef ?? backupBtnRef;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/combobox');
    let { menuTriggerProps, menuProps } = (0, _menu.useMenuTrigger)({
        type: 'listbox',
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    // Set listbox id so it can be used when calling getItemId later
    (0, _listbox.listData).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let { collection } = state;
    let { disabledKeys } = state.selectionManager;
    let delegate = (0, _react.useMemo)(()=>keyboardDelegate || new (0, _selection.ListKeyboardDelegate)({
            collection,
            disabledKeys,
            ref: listBoxRef,
            layoutDelegate
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps } = (0, _selection.useSelectableCollection)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    let router = (0, _utils.useRouter)();
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        if (e.nativeEvent.isComposing) return;
        switch(e.key){
            case 'Enter':
            case 'Tab':
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === 'Enter') e.preventDefault();
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && listBoxRef.current && state.selectionManager.focusedKey != null) {
                    let collectionItem = state.collection.getItem(state.selectionManager.focusedKey);
                    if (collectionItem?.props.href) {
                        let item = listBoxRef.current.querySelector(`[data-key="${CSS.escape(state.selectionManager.focusedKey.toString())}"]`);
                        if (e.key === 'Enter' && item instanceof HTMLAnchorElement) router.open(item, e, collectionItem.props.href, collectionItem.props.routerOptions);
                        state.close();
                        break;
                    } else if (collectionItem?.props.onAction) {
                        collectionItem.props.onAction();
                        state.close();
                        break;
                    }
                }
                state.commit();
                break;
            case 'Escape':
                if (state.selectedKey !== null || state.inputValue === '' || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case 'ArrowDown':
                state.open('first', 'manual');
                break;
            case 'ArrowUp':
                state.open('last', 'manual');
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        let blurFromButton = buttonRef?.current && buttonRef.current === e.relatedTarget;
        let blurIntoPopover = popoverRef.current?.contains(e.relatedTarget);
        // Ignore blur if focused moved to the button(if exists) or into the popover.
        if (blurFromButton || blurIntoPopover) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, inputProps, descriptionProps, errorMessageProps } = (0, _textfield.useTextField)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown) : props.onKeyDown,
        onBlur,
        value: state.inputValue,
        defaultValue: state.defaultInputValue,
        onFocus,
        autoComplete: 'off',
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === 'touch') {
            // Focus the input field in case it isn't focused yet
            inputRef.current?.focus();
            state.toggle(null, 'manual');
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== 'touch') {
            inputRef.current?.focus();
            state.toggle(e.pointerType === 'keyboard' || e.pointerType === 'virtual' ? 'first' : null, 'manual');
        }
    };
    let triggerLabelProps = (0, _utils.useLabels)({
        id: menuTriggerProps.id,
        'aria-label': stringFormatter.format('buttonLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    let listBoxProps = (0, _utils.useLabels)({
        id: menuProps.id,
        'aria-label': stringFormatter.format('listboxLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (0, _react.useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current?.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current?.focus();
            state.toggle(null, 'manual');
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    let sectionKey = focusedItem?.parentKey ?? null;
    let itemKey = state.selectionManager.focusedKey ?? null;
    let lastSection = (0, _react.useRef)(sectionKey);
    let lastItem = (0, _react.useRef)(itemKey);
    (0, _react.useEffect)(()=>{
        if ((0, _utils.isAppleDevice)() && focusedItem != null && itemKey != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = section?.['aria-label'] || (typeof section?.rendered === 'string' ? section.rendered : '') || '';
            let announcement = stringFormatter.format('focusAnnouncement', {
                isGroupChange: (section && sectionKey !== lastSection.current) ?? false,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...(0, _collections.getChildNodes)(section, state.collection)
                ].length : 0,
                optionText: focusedItem['aria-label'] || focusedItem.textValue || '',
                isSelected
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = (0, _collections.getItemCount)(state.collection);
    let lastSize = (0, _react.useRef)(optionCount);
    let lastOpen = (0, _react.useRef)(state.isOpen);
    (0, _react.useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, _utils.isAppleDevice)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format('countAnnouncement', {
                optionCount
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (0, _react.useRef)(state.selectedKey);
    (0, _react.useEffect)(()=>{
        if ((0, _utils.isAppleDevice)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem['aria-label'] || state.selectedItem.textValue || '';
            let announcement = stringFormatter.format('selectedAnnouncement', {
                optionText
            });
            (0, _liveAnnouncer.announce)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (0, _react.useEffect)(()=>{
        if (state.isOpen) return (0, _overlays.ariaHideOutside)([
            inputRef.current,
            popoverRef.current
        ].filter((element)=>element != null));
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    (0, _utils.useUpdateEffect)(()=>{
        // Re-show focus ring when there is no virtually focused item.
        if (!focusedItem && inputRef.current && (0, _utils.getActiveElement)((0, _utils.getOwnerDocument)(inputRef.current)) === inputRef.current) (0, _focus.dispatchVirtualFocus)(inputRef.current, null);
    }, [
        focusedItem
    ]);
    (0, _utils.useEvent)(listBoxRef, 'react-aria-item-action', state.isOpen ? ()=>{
        state.close();
    } : undefined);
    return {
        labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            onPress,
            onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: (0, _utils.mergeProps)(inputProps, {
            role: 'combobox',
            'aria-expanded': menuTriggerProps['aria-expanded'],
            'aria-controls': state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            'aria-autocomplete': 'list',
            'aria-activedescendant': focusedItem ? (0, _listbox.getItemId)(state, focusedItem.key) : undefined,
            onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: 'off',
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: 'false'
        }),
        listBoxProps: (0, _utils.mergeProps)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy || true,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            linkBehavior: 'selection',
            ['UNSTABLE_itemBehavior']: 'action'
        }),
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/live-announcer":"3nbSW","@react-aria/overlays":"cUlZ5","@react-aria/listbox":"64vKz","@react-aria/utils":[["chain","ij7eS"],["getActiveElement","9OiSj"],["getOwnerDocument","fioCG"],["isAppleDevice","7AGiA"],["mergeProps","aNvcY"],["useEvent","c8GoD"],["useLabels","7Uhyw"],["useRouter","4FGnT"],["useUpdateEffect","ekc37"]],"@react-aria/focus":"5dDnl","react":"a1TxN","@react-stately/collections":[["getChildNodes","HxEYQ"],["getItemCount","12H8i"]],"../intl/*.json":"l6PVj","@react-aria/selection":[["ListKeyboardDelegate","gVeiB"],["useSelectableCollection","agala"]],"@react-stately/form":"icH0S","@react-aria/i18n":"7lxyl","@react-aria/menu":"hw55r","@react-aria/textfield":"j6sGd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l6PVj":[function(require,module,exports,__globalThis) {
const _temp0 = require("bda209fc0795baf0");
const _temp1 = require("f4fb218734320b1c");
const _temp2 = require("db73d7282e7f0b72");
const _temp3 = require("8a89c20812888ac5");
const _temp4 = require("a90a393d42fd1ac0");
const _temp5 = require("758b19f6dbaa515a");
const _temp6 = require("bc257e3896baaa59");
const _temp7 = require("302f7e60e499de20");
const _temp8 = require("952535943a1235f2");
const _temp9 = require("f92b00de8074435d");
const _temp10 = require("1f9178c7b8f748b");
const _temp11 = require("cd26659b414d8184");
const _temp12 = require("ddcbedac816178a0");
const _temp13 = require("f9345e760610146c");
const _temp14 = require("e01ec2e07d7b968e");
const _temp15 = require("3e57c57b9e92b500");
const _temp16 = require("f46530bb786ed179");
const _temp17 = require("3d6a7d1d727a2430");
const _temp18 = require("855997635d80c698");
const _temp19 = require("91e18e6496db6994");
const _temp20 = require("85f18ef82418793a");
const _temp21 = require("dafe1a7a9b19814b");
const _temp22 = require("174c8dfc91ce423b");
const _temp23 = require("4ca0cd9f2e1674e");
const _temp24 = require("b843c0f0be1a5594");
const _temp25 = require("641171703c4c2319");
const _temp26 = require("e37240b59dce71ee");
const _temp27 = require("6f423c247b201d1c");
const _temp28 = require("4943e512073ce766");
const _temp29 = require("a6dc08871bdb2569");
const _temp30 = require("50874404f5be2ced");
const _temp31 = require("94e3081da8d25736");
const _temp32 = require("d83de5c43e7ebfbc");
const _temp33 = require("2e7e43f150f68960");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"bda209fc0795baf0":"ctpKo","f4fb218734320b1c":"ctpKo","db73d7282e7f0b72":"ctpKo","8a89c20812888ac5":"ctpKo","a90a393d42fd1ac0":"ctpKo","758b19f6dbaa515a":"ctpKo","bc257e3896baaa59":"dMtcB","302f7e60e499de20":"ctpKo","952535943a1235f2":"ctpKo","f92b00de8074435d":"ctpKo","1f9178c7b8f748b":"ctpKo","cd26659b414d8184":"ctpKo","ddcbedac816178a0":"ctpKo","f9345e760610146c":"ctpKo","e01ec2e07d7b968e":"ctpKo","3e57c57b9e92b500":"ctpKo","f46530bb786ed179":"ctpKo","3d6a7d1d727a2430":"ctpKo","855997635d80c698":"ctpKo","91e18e6496db6994":"ctpKo","85f18ef82418793a":"ctpKo","dafe1a7a9b19814b":"ctpKo","174c8dfc91ce423b":"ctpKo","4ca0cd9f2e1674e":"ctpKo","b843c0f0be1a5594":"ctpKo","641171703c4c2319":"ctpKo","e37240b59dce71ee":"ctpKo","6f423c247b201d1c":"ctpKo","4943e512073ce766":"ctpKo","a6dc08871bdb2569":"ctpKo","50874404f5be2ced":"ctpKo","94e3081da8d25736":"ctpKo","d83de5c43e7ebfbc":"ctpKo","2e7e43f150f68960":"ctpKo"}],"dMtcB":[function(require,module,exports,__globalThis) {
module.exports = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};

},{}],"4sOwm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a combo box component. Handles building a collection
 * of items from props and manages the option selection state of the combo box. In addition, it tracks the input value,
 * focus state, and other properties of the combo box.
 */ parcelHelpers.export(exports, "useComboBoxState", ()=>useComboBoxState);
var _form = require("@react-stately/form");
var _collections = require("@react-stately/collections");
var _list = require("@react-stately/list");
var _overlays = require("@react-stately/overlays");
var _react = require("react");
var _utils = require("@react-stately/utils");
function useComboBoxState(props) {
    let { defaultFilter, menuTrigger = 'input', allowsEmptyCollection = false, allowsCustomValue, shouldCloseOnBlur = true } = props;
    let [showAllItems, setShowAllItems] = (0, _react.useState)(false);
    let [isFocused, setFocusedState] = (0, _react.useState)(false);
    let [focusStrategy, setFocusStrategy] = (0, _react.useState)(null);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            closeMenu();
        }
    };
    let { collection, selectionManager, selectedKey, setSelectedKey, selectedItem, disabledKeys } = (0, _list.useSingleSelectListState)({
        ...props,
        onSelectionChange,
        items: props.items ?? props.defaultItems
    });
    let [inputValue, setInputValue] = (0, _utils.useControlledState)(props.inputValue, getDefaultInputValue(props.defaultInputValue, selectedKey, collection) || '', props.onInputChange);
    let [initialSelectedKey] = (0, _react.useState)(selectedKey);
    let [initialValue] = (0, _react.useState)(inputValue);
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (0, _react.useMemo)(()=>// No default filter if items are controlled.
        props.items != null || !defaultFilter ? collection : filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    let [lastCollection, setLastCollection] = (0, _react.useState)(filteredCollection);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (0, _react.useRef)('focus');
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
        selectionManager.setFocused(open);
        if (!open) selectionManager.setFocusedKey(null);
    };
    let triggerState = (0, _overlays.useOverlayTriggerState)({
        ...props,
        onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is manually opened. Only care about this if items are undefined
            setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            setFocusStrategy(focusStrategy);
            triggerState.open();
        }
    };
    let toggle = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is toggled open. Only care about this if items are undefined
        setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        toggleMenu(focusStrategy);
    };
    let updateLastCollection = (0, _react.useCallback)(()=>{
        setLastCollection(showAllItems ? originalCollection : filteredCollection);
    }, [
        showAllItems,
        originalCollection,
        filteredCollection
    ]);
    // If menu is going to close, save the current collection so we can freeze the displayed collection when the
    // user clicks outside the popover to close the menu. Prevents the menu contents from updating as the menu closes.
    let toggleMenu = (0, _react.useCallback)((focusStrategy = null)=>{
        if (triggerState.isOpen) updateLastCollection();
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
    }, [
        triggerState,
        updateLastCollection
    ]);
    let closeMenu = (0, _react.useCallback)(()=>{
        if (triggerState.isOpen) {
            updateLastCollection();
            triggerState.close();
        }
    }, [
        triggerState,
        updateLastCollection
    ]);
    let [lastValue, setLastValue] = (0, _react.useState)(inputValue);
    let resetInputValue = ()=>{
        let itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
        setLastValue(itemText);
        setInputValue(itemText);
    };
    let lastSelectedKey = (0, _react.useRef)(props.selectedKey ?? props.defaultSelectedKey ?? null);
    let lastSelectedKeyText = (0, _react.useRef)(selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '');
    // intentional omit dependency array, want this to happen on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useEffect)(()=>{
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue && menuTrigger !== 'manual') open(null, 'input');
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) closeMenu();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) closeMenu();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === '' && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else if (lastValue !== inputValue) setLastValue(inputValue);
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                setLastValue(selectedItemText);
                setInputValue(selectedItemText);
            }
        }
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: (0, _react.useMemo)(()=>({
                inputValue,
                selectedKey
            }), [
            inputValue,
            selectedKey
        ])
    });
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        closeMenu();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            props.onSelectionChange?.(selectedKey);
            // Stop menu from reopening from useEffect
            let itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
            setLastValue(itemText);
            closeMenu();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            closeMenu();
        }
    };
    const commitValue = ()=>{
        if (allowsCustomValue) {
            const itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
            inputValue === itemText ? commitSelection() : commitCustomValue();
        } else // Reset inputValue and close menu
        commitSelection();
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else commitValue();
    };
    let valueOnFocus = (0, _react.useRef)(inputValue);
    let setFocused = (isFocused)=>{
        if (isFocused) {
            valueOnFocus.current = inputValue;
            if (menuTrigger === 'focus' && !props.isReadOnly) open(null, 'focus');
        } else {
            if (shouldCloseOnBlur) commitValue();
            if (inputValue !== valueOnFocus.current) validation.commitValidation();
        }
        setFocusedState(isFocused);
    };
    let displayedCollection = (0, _react.useMemo)(()=>{
        if (triggerState.isOpen) {
            if (showAllItems) return originalCollection;
            else return filteredCollection;
        } else return lastCollection;
    }, [
        triggerState.isOpen,
        originalCollection,
        filteredCollection,
        showAllItems,
        lastCollection
    ]);
    let defaultSelectedKey = props.defaultSelectedKey ?? initialSelectedKey;
    return {
        ...validation,
        ...triggerState,
        focusStrategy,
        toggle,
        open,
        close: commitValue,
        selectionManager,
        selectedKey,
        defaultSelectedKey,
        setSelectedKey,
        disabledKeys,
        isFocused,
        setFocused,
        selectedItem,
        collection: displayedCollection,
        inputValue,
        defaultInputValue: getDefaultInputValue(props.defaultInputValue, defaultSelectedKey, collection) ?? initialValue,
        setInputValue,
        commit,
        revert
    };
}
function filterCollection(collection, inputValue, filter) {
    return new (0, _list.ListCollection)(filterNodes(collection, collection, inputValue, filter));
}
function filterNodes(collection, nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === 'section' && node.hasChildNodes) {
            let filtered = filterNodes(collection, (0, _collections.getChildNodes)(node, collection), inputValue, filter);
            if ([
                ...filtered
            ].some((node)=>node.type === 'item')) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type === 'item' && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
        else if (node.type !== 'item') filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}
function getDefaultInputValue(defaultInputValue, selectedKey, collection) {
    if (defaultInputValue == null) {
        if (selectedKey != null) return collection.getItem(selectedKey)?.textValue ?? '';
    }
    return defaultInputValue;
}

},{"@react-stately/form":"icH0S","@react-stately/collections":"HxEYQ","@react-stately/list":[["ListCollection","aa9cW"],["useSingleSelectListState","c6gMj"]],"@react-stately/overlays":"1hSAS","react":"a1TxN","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9papc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobileDevice", ()=>useIsMobileDevice);
parcelHelpers.export(exports, "useScale", ()=>useScale);
var _utils = require("@react-spectrum/utils");
function useIsMobileDevice() {
    return (0, _utils.useMediaQuery)('(max-width: 640px)');
}
function useScale() {
    let matchesFine = (0, _utils.useMediaQuery)('not ((hover: hover) and (pointer: fine))');
    if (matchesFine) return 'large';
    return 'medium';
}

},{"@react-spectrum/utils":"5Q3yF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4mbjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribe", ()=>subscribe);
parcelHelpers.export(exports, "getSnapshot", ()=>getSnapshot);
parcelHelpers.export(exports, "setNavigationPromise", ()=>setNavigationPromise);
parcelHelpers.export(exports, "getPageFromPathname", ()=>getPageFromPathname);
parcelHelpers.export(exports, "NavigationSuspense", ()=>NavigationSuspense);
var _jsxRuntime = require("react/jsx-runtime");
var _pageSkeleton = require("./PageSkeleton");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const SKELETON_DELAY = 150;
let navigationPromise = null;
let targetPathname = null;
let listeners = new Set();
let cachedSnapshot = {
    promise: null,
    pathname: null
};
function subscribe(callback) {
    listeners.add(callback);
    return ()=>listeners.delete(callback);
}
function getSnapshot() {
    if (cachedSnapshot.promise !== navigationPromise || cachedSnapshot.pathname !== targetPathname) cachedSnapshot = {
        promise: navigationPromise,
        pathname: targetPathname
    };
    return cachedSnapshot;
}
function setNavigationPromise(promise, pathname) {
    targetPathname = pathname || null;
    navigationPromise = promise;
    if (promise) promise.finally(()=>{
        if (navigationPromise === promise) {
            navigationPromise = null;
            listeners.forEach((callback)=>callback());
        }
    });
    listeners.forEach((callback)=>callback());
}
function normalizePathname(urlOrPathname, publicUrlPrefix) {
    let pathname;
    try {
        if (urlOrPathname.startsWith('http://') || urlOrPathname.startsWith('https://')) pathname = new URL(urlOrPathname).pathname;
        else pathname = new URL(urlOrPathname, location.href).pathname;
    } catch  {
        const [basePathname] = urlOrPathname.split('?');
        const [cleanPathname] = basePathname.split('#');
        pathname = cleanPathname;
    }
    let pathnameWithoutPrefix = pathname;
    if (publicUrlPrefix !== '/' && pathname.startsWith(publicUrlPrefix)) {
        pathnameWithoutPrefix = pathname.slice(publicUrlPrefix.length);
        if (!pathnameWithoutPrefix.startsWith('/')) pathnameWithoutPrefix = '/' + pathnameWithoutPrefix;
    }
    return pathnameWithoutPrefix.startsWith('/') ? pathnameWithoutPrefix : '/' + pathnameWithoutPrefix;
}
function getPageFromPathname(pages, pathname) {
    if (!pathname) return null;
    let publicUrl = "https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs";
    let publicUrlPathname = publicUrl.startsWith('http') ? new URL(publicUrl).pathname : publicUrl;
    let publicUrlPrefix = publicUrlPathname === '/' ? '/' : publicUrlPathname.replace(/\/$/, '');
    let normalizedPathname = normalizePathname(pathname, publicUrlPrefix);
    const targetPage = pages.find((p)=>{
        let normalizedPageUrl = normalizePathname(p.url, publicUrlPrefix);
        return normalizedPageUrl === normalizedPathname || normalizedPageUrl === normalizedPathname.replace(/\.html$/, '') || normalizedPageUrl === normalizedPathname + '.html';
    });
    return targetPage ?? null;
}
function getPageInfo(pages, pathname) {
    const targetPage = getPageFromPathname(pages, pathname);
    if (!targetPage) return {};
    const title = targetPage.tableOfContents?.[0]?.title;
    const section = targetPage.exports?.section || 'Components';
    const hasToC = !targetPage.exports?.hideNav && targetPage.tableOfContents?.[0]?.children && targetPage.tableOfContents?.[0]?.children?.length > 0;
    return {
        title,
        section,
        hasToC
    };
}
function NavigationContent({ children }) {
    // Subscribe to navigation promise changes to ensure React re-renders when setNavigationPromise() is called.
    const snapshot = (0, _react.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    let [delayedPromise, setDelayedPromise] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        let promise = snapshot.promise;
        if (!promise) return;
        let timeout = setTimeout(()=>{
            setDelayedPromise(promise);
        }, SKELETON_DELAY);
        return ()=>clearTimeout(timeout);
    }, [
        snapshot
    ]);
    if (delayedPromise) (0, _react.use)(delayedPromise);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
}
function NavigationSuspense({ children, pages }) {
    // Subscribe to get the latest targetPathname for skeleton page info
    const snapshot = (0, _react.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    const pageInfo = getPageInfo(pages, snapshot.pathname);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
        fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageSkeleton.PageSkeleton), {
            title: pageInfo.title,
            section: pageInfo.section,
            hasToC: pageInfo.hasToC
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavigationContent, {
            children: children
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","./PageSkeleton":"6r2Q6","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6r2Q6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageSkeleton", ()=>PageSkeleton);
var _jsxRuntime = require("react/jsx-runtime");
var _textWidth = require("./textWidth");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const h1 = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 veOoCPe12 -_6BNtrc-pwoabcc12 vpx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 _Fd12 _FnuYUweb12 po12 Jy12 Gy12";
const skeletonPageDescription = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 upk12 upcJ9TBTb12 upd3Euai12 upea12 upgb12 uphd12 upje12 up2NhKxcl12 upic12 -_6BNtrc-e12 vx12 -_6BNtrc-pf12 vpx12 xb12 _xa12 xpb12 _xpa12 _Fb12 _FnuYUwec12 _Fpb12 _FpnuYUwec12 pt12 ppt12 JA12 GA12 Za12";
const skeletonParagraph = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 upk12 upcJ9TBTb12 upd3Euai12 upea12 upgb12 uphd12 upje12 up2NhKxcl12 upic12 -_6BNtrc-d12 vx12 -_6BNtrc-pe12 vpx12 xb12 _xa12 xpb12 _xpa12 _Fb12 _FnuYUwec12 _Fpb12 _FpnuYUwec12 pt12 ppt12 JA12 GA12 Za12";
const skeletonH2 = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-lcY1Ce12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 _Fd12 _FnuYUweb12 po12 JI12 GC12 ZuvNfn12";
function SkeletonVisualExample() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
        src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E",
        styles: " Te12 Tph12 Qe12 Qph12 Se12 Sph12 Re12 Rph12 Jz12 oe12 ne12 ke12 je12 Za12 _oa12 Fd4Eyud12 FpwHzgQe12 _Hb12",
        alt: "Loading example"
    });
}
const skeletonArticle = function anonymous(props) {
    let rules = " ";
    if (props.isWithToC) rules += ' Lk12';
    else rules += ' Lp12';
    rules += ' Za12';
    rules += ' FD12';
    return rules;
};
function PageSkeleton({ title, section, hasToC }) {
    const isComponents = section === 'Components';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        className: skeletonArticle({
            isWithToC: hasToC
        }),
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                id: "top",
                style: {
                    '--width-per-em': (0, _textWidth.getTextWidth)(title)
                },
                className: h1,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Skeleton), {
                isLoading: true,
                children: [
                    !title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 veOoCPe12 -_6BNtrc-pwoabcc12 vpx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 _Fd12 _FnuYUweb12 po12 Jy12 Gy12 ZC4Nfn12",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            children: "Page Title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: skeletonPageDescription,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            children: "This is placeholder content for the page description that approximates the typical length of component descriptions."
                        })
                    }),
                    isComponents ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonVisualExample, {}),
                            [
                                1,
                                2,
                                3
                            ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: skeletonH2,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                children: "Section Heading"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: skeletonParagraph,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                children: "Placeholder content for a section that describes various aspects of the component or feature being documented."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonVisualExample, {})
                                    ]
                                }, i))
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: [
                            1,
                            2,
                            3,
                            4
                        ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: skeletonH2,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                            children: "Section Heading"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: skeletonParagraph,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                            children: "Placeholder content for a section that describes various aspects of the topic being documented."
                                        })
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
}

},{"0":"1iSJW","1":"Frub5","2":"4BPFo","3":"aFECv","4":"glq79","5":"gDQi7","6":"aZeG9","react/jsx-runtime":"2Is6Z","./textWidth":"f8NV3","@react-spectrum/s2":[["Image","4LTiE"],["Skeleton","1mUnF"],["Text","10r6w"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1iSJW":[function() {},{}],"Frub5":[function() {},{}],"4BPFo":[function() {},{}],"aFECv":[function() {},{}],"glq79":[function() {},{}],"gDQi7":[function() {},{}],"aZeG9":[function() {},{}],"f8NV3":[function(require,module,exports,__globalThis) {
// Map of characters to width per em, generated from Adobe Clean Spectrum VF.
// Multiply by the font size to get the pixel width.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Gets the width of a string of text. Multiply by font size to get pixel width.
parcelHelpers.export(exports, "getTextWidth", ()=>getTextWidth);
let letters = {
    '0': 0.5467998461797813,
    '1': 0.33863281002940315,
    '2': 0.4949392889121938,
    '3': 0.5016111737184715,
    '4': 0.5308981693435971,
    '5': 0.5023057133155973,
    '6': 0.5481826272455199,
    '7': 0.46165110064312254,
    '8': 0.5277358292705409,
    '9': 0.5432406635520582,
    A: 0.6059440599655305,
    B: 0.5832495796806406,
    C: 0.5565531328751679,
    D: 0.6598042449318364,
    E: 0.5300641635661462,
    F: 0.5081749911055526,
    G: 0.6455998072113557,
    H: 0.6693259321022943,
    I: 0.2697145809246694,
    J: 0.32189760597286665,
    K: 0.5840943795209466,
    L: 0.501062476701323,
    M: 0.8308132582427056,
    N: 0.6825471255294288,
    O: 0.6920027568250859,
    P: 0.5665339951757473,
    Q: 0.6920027568250859,
    R: 0.5871806978309012,
    S: 0.4962879123859901,
    T: 0.5402653527717012,
    U: 0.6519305325732583,
    V: 0.6040336065898666,
    W: 0.8548425854690754,
    X: 0.5435315369653245,
    Y: 0.537968827408557,
    Z: 0.5471876252326289,
    a: 0.4964378641768902,
    b: 0.5449183176910446,
    c: 0.43080009202470115,
    d: 0.5425954554028817,
    e: 0.5017767421059094,
    f: 0.2770022918782831,
    g: 0.5140052743477447,
    h: 0.5515482646395446,
    i: 0.24808137309258887,
    j: 0.24821074492252418,
    k: 0.4986819080010872,
    l: 0.26457503647320485,
    m: 0.8461911554090422,
    n: 0.5513497527462953,
    o: 0.5444509990673368,
    p: 0.5447198057977952,
    q: 0.5452413834173114,
    r: 0.34813664273642425,
    s: 0.4001812142580505,
    t: 0.3153228837303483,
    u: 0.5453896125268208,
    v: 0.48007624993851516,
    w: 0.7385096424408182,
    x: 0.456618258856363,
    y: 0.47805235885526454,
    z: 0.4210896632430806,
    ' ': 0.22853845854089036,
    '!': 0.29312679093582983,
    '@': 0.8559711917318172,
    '#': 0.523247739616419,
    '$': 0.5030891266153872,
    '%': 0.8450454594859704,
    '^': 0.5117092967393077,
    '&': 0.6946158587165351,
    '*': 0.4013355993759323,
    '(': 0.35453398280709264,
    ')': 0.3521490453929629,
    _: 0.5150663688638459,
    '-': 0.32678529376509985,
    '+': 0.5590725652733067,
    '=': 0.5494543793394757,
    '.': 0.20820494555165425,
    ',': 0.2075588140991205,
    '/': 0.3632512652560671
};
function getTextWidth(s) {
    let width = 0;
    for (let c of s){
        let w = letters[c];
        if (w != null) width += w;
    }
    return width;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4lnNg":[function(require,module,exports,__globalThis) {
var _client = require("@parcel/rsc/client");
var _prefetch = require("./prefetch");
var _navigationSuspense = require("./NavigationSuspense");
var _s2 = require("@react-spectrum/s2");
'use client-entry';
let isClientLink = (link, pathname)=>{
    return link && link instanceof HTMLAnchorElement && link.href && (!link.target || link.target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && link.pathname.startsWith(pathname);
};
// Hydrate initial RSC payload embedded in the HTML.
let updateRoot = (0, _client.hydrate)({
    // Intercept HMR window reloads, and do it with RSC instead.
    onHmrReload () {
        navigate(location.pathname + location.search + location.hash);
    }
});
// Track the current navigation to prevent race conditions
let currentNavigationId = 0;
let currentAbortController = null;
// A very simple router. When we navigate, we'll fetch a new RSC payload from the server,
// and in a React transition, stream in the new page. Once complete, we'll pushState to
// update the URL in the browser.
async function navigate(pathname, push = false) {
    let [basePath, pathAnchor] = pathname.split('#');
    let currentPath = location.pathname;
    let isSamePageAnchor = (!basePath || basePath === currentPath) && pathAnchor;
    if (isSamePageAnchor) {
        if (push) history.pushState(null, '', pathname);
        // Scroll to the anchor
        let element = document.getElementById(pathAnchor);
        if (element) element.scrollIntoView();
        return;
    }
    let rscPath = basePath.replace('.html', '.rsc');
    // Cancel any in-flight navigation
    if (currentAbortController) currentAbortController.abort('Aborting due to new navigation');
    // Create a new abort controller for this navigation
    const abortController = new AbortController();
    currentAbortController = abortController;
    const navigationId = ++currentNavigationId;
    const navigationPromise = (async ()=>{
        window.dispatchEvent(new CustomEvent('rsc-navigation-start'));
        // Use prefetched result if available, otherwise fetch
        const prefetchedPromise = (0, _prefetch.getPrefetchedPromise)(rscPath);
        const fetchPromise = prefetchedPromise ?? (0, _client.fetchRSC)(rscPath);
        try {
            let res = await fetchPromise;
            // Check if this navigation is still current before updating
            if (navigationId !== currentNavigationId) // A newer navigation has started, ignore this result
            return;
            // Check if this navigation was aborted
            if (abortController.signal.aborted) return;
            let currentPath = location.pathname;
            let [newBasePath, newPathAnchor] = pathname.split('#');
            // Return a promise that resolves after updateRoot callback completes
            await new Promise((resolve)=>{
                updateRoot(res, ()=>{
                    if (push) {
                        history.pushState(null, '', pathname);
                        push = false;
                    }
                    // Reset scroll if navigating to a different page without an anchor
                    if (currentPath !== newBasePath && !newPathAnchor) window.scrollTo(0, 0);
                    else if (newPathAnchor) {
                        let element = document.getElementById(newPathAnchor);
                        if (element) element.scrollIntoView();
                    }
                    queueMicrotask(()=>{
                        window.dispatchEvent(new CustomEvent('rsc-navigation'));
                        resolve();
                    });
                });
            });
        } catch (error) {
            // Check if this navigation was aborted
            if (abortController.signal.aborted) return;
            // Check if this navigation is still current
            if (navigationId !== currentNavigationId) return;
            try {
                let errorRes = await (0, _client.fetchRSC)('/error.rsc');
                // Check again if still current after error fetch
                if (navigationId !== currentNavigationId || abortController.signal.aborted) return;
                await new Promise((resolve)=>{
                    updateRoot(errorRes, ()=>{
                        if (push) history.pushState(null, '', '/error.html');
                        resolve();
                    });
                });
            } catch  {
                // Only show error toast if this is still the current navigation
                if (navigationId === currentNavigationId && !abortController.signal.aborted) (0, _s2.UNSTABLE_ToastQueue).negative('Failed to load page. Check your connection and try again.');
                throw error; // Re-throw to keep promise rejected
            }
        }
    })();
    (0, _navigationSuspense.setNavigationPromise)(navigationPromise, pathname);
}
// Prefetch routes on pointerover
// Use a delay to avoid prefetching when quickly moving over multiple links.
const PREFETCH_DELAY_MS = 100;
let prefetchTimeout = null;
let currentPrefetchLink = null;
function clearPrefetchTimeout() {
    if (prefetchTimeout) {
        clearTimeout(prefetchTimeout);
        prefetchTimeout = null;
    }
    currentPrefetchLink = null;
}
document.addEventListener('pointerover', (e)=>{
    let link = e.target instanceof Element ? e.target.closest('a') : null;
    let publicUrl = "https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs";
    let publicUrlPathname = publicUrl.startsWith('http') ? new URL(publicUrl).pathname : publicUrl;
    // Clear any pending prefetch
    clearPrefetchTimeout();
    if (link && isClientLink(link, publicUrlPathname) && link.pathname !== location.pathname) {
        currentPrefetchLink = link;
        prefetchTimeout = setTimeout(()=>{
            (0, _prefetch.prefetchRoute)(link.pathname + link.search + link.hash);
            prefetchTimeout = null;
        }, PREFETCH_DELAY_MS);
    }
}, true);
// Clear prefetch timeout when pointer leaves a link
document.addEventListener('pointerout', (e)=>{
    let link = e.target instanceof Element ? e.target.closest('a') : null;
    if (link && link === currentPrefetchLink) clearPrefetchTimeout();
}, true);
document.addEventListener('focus', (e)=>{
    let link = e.target instanceof Element ? e.target.closest('a') : null;
    let publicUrl = "https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs";
    let publicUrlPathname = publicUrl.startsWith('http') ? new URL(publicUrl).pathname : publicUrl;
    // Clear any pending prefetch
    clearPrefetchTimeout();
    if (link && isClientLink(link, publicUrlPathname) && link.pathname !== location.pathname) {
        currentPrefetchLink = link;
        prefetchTimeout = setTimeout(()=>{
            (0, _prefetch.prefetchRoute)(link.pathname + link.search + link.hash);
            prefetchTimeout = null;
        }, PREFETCH_DELAY_MS);
    }
}, true);
// Clear prefetch timeout when focus leaves a link
document.addEventListener('blur', (e)=>{
    let link = e.target instanceof Element ? e.target.closest('a') : null;
    if (link && link === currentPrefetchLink) clearPrefetchTimeout();
}, true);
// Intercept link clicks to perform RSC navigation.
document.addEventListener('click', (e)=>{
    let link = e.target instanceof Element ? e.target.closest('a') : null;
    let publicUrl = "https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs";
    let publicUrlPathname = publicUrl.startsWith('http') ? new URL(publicUrl).pathname : publicUrl;
    if (link && isClientLink(link, publicUrlPathname) && e.button === 0 && // left clicks only
    !e.metaKey && // open in new tab (mac)
    !e.ctrlKey && // open in new tab (windows)
    !e.altKey && // download
    !e.shiftKey && !e.defaultPrevented) {
        e.preventDefault();
        navigate(link.pathname + link.search + link.hash, true);
    }
});
// When the user clicks the back button, navigate with RSC.
window.addEventListener('popstate', ()=>{
    navigate(location.pathname + location.search + location.hash);
});
function scrollToCurrentHash() {
    if (!location.hash || location.hash === '#') return;
    let anchorId = location.hash.slice(1);
    try {
        anchorId = decodeURIComponent(anchorId);
    } catch  {
    // Fall back to raw hash
    }
    if (!anchorId) return;
    requestAnimationFrame(()=>{
        let element = document.getElementById(anchorId);
        if (element) element.scrollIntoView();
    });
}
if (document.readyState === 'complete' || document.readyState === 'interactive') scrollToCurrentHash();
else window.addEventListener('DOMContentLoaded', ()=>{
    scrollToCurrentHash();
}, {
    once: true
});

},{"@parcel/rsc/client":"dvyUn","./prefetch":"foxg0","./NavigationSuspense":"4mbjg","@react-spectrum/s2":[["UNSTABLE_ToastQueue","9R0uF","ToastQueue"]]}],"dvyUn":[function(require,module,exports,__globalThis) {
/* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setServerCallback", ()=>setServerCallback);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "fetchRSC", ()=>fetchRSC);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-server-dom-parcel/client");
var _client1 = require("rsc-html-stream/client");
var _client2 = require("react-dom/client");
function setServerCallback(cb) {
    return (0, _client.setServerCallback)(cb);
}
// Stream in initial RSC payload embedded in the HTML.
let initialRSCPayload;
function RSCRoot({ value, cb }) {
    initialRSCPayload ??= (0, _client.createFromReadableStream)((0, _client1.rscStream));
    (0, _react.useInsertionEffect)(()=>{
        cb?.();
    });
    return value === undefined ? initialRSCPayload : value;
}
function hydrate(options) {
    if (options?.callServer) setServerCallback(options.callServer);
    if (options?.onHmrReload) window.addEventListener('parcelhmrreload', (e)=>{
        e.preventDefault();
        options?.onHmrReload?.();
    });
    let root;
    (0, _react.startTransition)(()=>{
        root = (0, _client2.hydrateRoot)(document, /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSCRoot, {}), options);
    });
    return (value, cb)=>{
        (0, _react.startTransition)(()=>{
            root?.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RSCRoot, {
                value: value,
                cb: ()=>{
                    cb?.();
                    cb = undefined;
                }
            }));
        });
    };
}
async function fetchRSC(url, options) {
    const temporaryReferences = (0, _client.createTemporaryReferenceSet)();
    const response = fetch(url, {
        ...options,
        headers: {
            Accept: 'text/x-component',
            ...options?.headers
        },
        body: options && 'body' in options ? await (0, _client.encodeReply)(options.body, {
            temporaryReferences,
            signal: options?.signal
        }) : undefined
    });
    return (0, _client.createFromFetch)(response, {
        temporaryReferences
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-server-dom-parcel/client":"8pUYL","rsc-html-stream/client":"2n5QP","react-dom/client":"fRKjd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8pUYL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a3a6240ced92f943");

},{"a3a6240ced92f943":"17zd7"}],"17zd7":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-client.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var decoderOptions = {
    stream: !0
};
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var ReactDOMSharedInternals = require("da607ba755542785").__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator, isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf, ObjectPrototype = Object.prototype, knownServerReferences = new WeakMap();
function serializeNumber(number) {
    return Number.isFinite(number) ? 0 === number && -Infinity === 1 / number ? "$-0" : number : Infinity === number ? "$Infinity" : -Infinity === number ? "$-Infinity" : "$NaN";
}
function processReply(root, formFieldPrefix, temporaryReferences, resolve, reject) {
    function serializeTypedArray(tag, typedArray) {
        typedArray = new Blob([
            new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength)
        ]);
        var blobId = nextPartId++;
        null === formData && (formData = new FormData());
        formData.append(formFieldPrefix + blobId, typedArray);
        return "$" + tag + blobId.toString(16);
    }
    function serializeBinaryReader(reader) {
        function progress(entry) {
            entry.done ? (entry = nextPartId++, data.append(formFieldPrefix + entry, new Blob(buffer)), data.append(formFieldPrefix + streamId, '"$o' + entry.toString(16) + '"'), data.append(formFieldPrefix + streamId, "C"), pendingParts--, 0 === pendingParts && resolve(data)) : (buffer.push(entry.value), reader.read(new Uint8Array(1024)).then(progress, reject));
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++, buffer = [];
        reader.read(new Uint8Array(1024)).then(progress, reject);
        return "$r" + streamId.toString(16);
    }
    function serializeReader(reader) {
        function progress(entry) {
            if (entry.done) data.append(formFieldPrefix + streamId, "C"), pendingParts--, 0 === pendingParts && resolve(data);
            else try {
                var partJSON = JSON.stringify(entry.value, resolveToJSON);
                data.append(formFieldPrefix + streamId, partJSON);
                reader.read().then(progress, reject);
            } catch (x) {
                reject(x);
            }
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++;
        reader.read().then(progress, reject);
        return "$R" + streamId.toString(16);
    }
    function serializeReadableStream(stream) {
        try {
            var binaryReader = stream.getReader({
                mode: "byob"
            });
        } catch (x) {
            return serializeReader(stream.getReader());
        }
        return serializeBinaryReader(binaryReader);
    }
    function serializeAsyncIterable(iterable, iterator) {
        function progress(entry) {
            if (entry.done) {
                if (void 0 === entry.value) data.append(formFieldPrefix + streamId, "C");
                else try {
                    var partJSON = JSON.stringify(entry.value, resolveToJSON);
                    data.append(formFieldPrefix + streamId, "C" + partJSON);
                } catch (x) {
                    reject(x);
                    return;
                }
                pendingParts--;
                0 === pendingParts && resolve(data);
            } else try {
                var partJSON$21 = JSON.stringify(entry.value, resolveToJSON);
                data.append(formFieldPrefix + streamId, partJSON$21);
                iterator.next().then(progress, reject);
            } catch (x$22) {
                reject(x$22);
            }
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++;
        iterable = iterable === iterator;
        iterator.next().then(progress, reject);
        return "$" + (iterable ? "x" : "X") + streamId.toString(16);
    }
    function resolveToJSON(key, value) {
        if (null === value) return null;
        if ("object" === typeof value) {
            switch(value.$$typeof){
                case REACT_ELEMENT_TYPE:
                    if (void 0 !== temporaryReferences && -1 === key.indexOf(":")) {
                        var parentReference = writtenObjects.get(this);
                        if (void 0 !== parentReference) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
                    }
                    throw Error("React Element cannot be passed to Server Functions from the Client without a temporary reference set. Pass a TemporaryReferenceSet to the options.");
                case REACT_LAZY_TYPE:
                    parentReference = value._payload;
                    var init = value._init;
                    null === formData && (formData = new FormData());
                    pendingParts++;
                    try {
                        var resolvedModel = init(parentReference), lazyId = nextPartId++, partJSON = serializeModel(resolvedModel, lazyId);
                        formData.append(formFieldPrefix + lazyId, partJSON);
                        return "$" + lazyId.toString(16);
                    } catch (x) {
                        if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                            pendingParts++;
                            var lazyId$23 = nextPartId++;
                            parentReference = function() {
                                try {
                                    var partJSON$24 = serializeModel(value, lazyId$23), data$25 = formData;
                                    data$25.append(formFieldPrefix + lazyId$23, partJSON$24);
                                    pendingParts--;
                                    0 === pendingParts && resolve(data$25);
                                } catch (reason) {
                                    reject(reason);
                                }
                            };
                            x.then(parentReference, parentReference);
                            return "$" + lazyId$23.toString(16);
                        }
                        reject(x);
                        return null;
                    } finally{
                        pendingParts--;
                    }
            }
            if ("function" === typeof value.then) {
                null === formData && (formData = new FormData());
                pendingParts++;
                var promiseId = nextPartId++;
                value.then(function(partValue) {
                    try {
                        var partJSON$27 = serializeModel(partValue, promiseId);
                        partValue = formData;
                        partValue.append(formFieldPrefix + promiseId, partJSON$27);
                        pendingParts--;
                        0 === pendingParts && resolve(partValue);
                    } catch (reason) {
                        reject(reason);
                    }
                }, reject);
                return "$@" + promiseId.toString(16);
            }
            parentReference = writtenObjects.get(value);
            if (void 0 !== parentReference) {
                if (modelRoot === value) modelRoot = null;
                else return parentReference;
            } else -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference && (key = parentReference + ":" + key, writtenObjects.set(value, key), void 0 !== temporaryReferences && temporaryReferences.set(key, value)));
            if (isArrayImpl(value)) return value;
            if (value instanceof FormData) {
                null === formData && (formData = new FormData());
                var data$31 = formData;
                key = nextPartId++;
                var prefix = formFieldPrefix + key + "_";
                value.forEach(function(originalValue, originalKey) {
                    data$31.append(prefix + originalKey, originalValue);
                });
                return "$K" + key.toString(16);
            }
            if (value instanceof Map) return key = nextPartId++, parentReference = serializeModel(Array.from(value), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$Q" + key.toString(16);
            if (value instanceof Set) return key = nextPartId++, parentReference = serializeModel(Array.from(value), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$W" + key.toString(16);
            if (value instanceof ArrayBuffer) return key = new Blob([
                value
            ]), parentReference = nextPartId++, null === formData && (formData = new FormData()), formData.append(formFieldPrefix + parentReference, key), "$A" + parentReference.toString(16);
            if (value instanceof Int8Array) return serializeTypedArray("O", value);
            if (value instanceof Uint8Array) return serializeTypedArray("o", value);
            if (value instanceof Uint8ClampedArray) return serializeTypedArray("U", value);
            if (value instanceof Int16Array) return serializeTypedArray("S", value);
            if (value instanceof Uint16Array) return serializeTypedArray("s", value);
            if (value instanceof Int32Array) return serializeTypedArray("L", value);
            if (value instanceof Uint32Array) return serializeTypedArray("l", value);
            if (value instanceof Float32Array) return serializeTypedArray("G", value);
            if (value instanceof Float64Array) return serializeTypedArray("g", value);
            if (value instanceof BigInt64Array) return serializeTypedArray("M", value);
            if (value instanceof BigUint64Array) return serializeTypedArray("m", value);
            if (value instanceof DataView) return serializeTypedArray("V", value);
            if ("function" === typeof Blob && value instanceof Blob) return null === formData && (formData = new FormData()), key = nextPartId++, formData.append(formFieldPrefix + key, value), "$B" + key.toString(16);
            if (key = getIteratorFn(value)) return parentReference = key.call(value), parentReference === value ? (key = nextPartId++, parentReference = serializeModel(Array.from(parentReference), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$i" + key.toString(16)) : Array.from(parentReference);
            if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(value);
            key = value[ASYNC_ITERATOR];
            if ("function" === typeof key) return serializeAsyncIterable(value, key.call(value));
            key = getPrototypeOf(value);
            if (key !== ObjectPrototype && (null === key || null !== getPrototypeOf(key))) {
                if (void 0 === temporaryReferences) throw Error("Only plain objects, and a few built-ins, can be passed to Server Functions. Classes or null prototypes are not supported.");
                return "$T";
            }
            return value;
        }
        if ("string" === typeof value) {
            if ("Z" === value[value.length - 1] && this[key] instanceof Date) return "$D" + value;
            key = "$" === value[0] ? "$" + value : value;
            return key;
        }
        if ("boolean" === typeof value) return value;
        if ("number" === typeof value) return serializeNumber(value);
        if ("undefined" === typeof value) return "$undefined";
        if ("function" === typeof value) {
            parentReference = knownServerReferences.get(value);
            if (void 0 !== parentReference) return key = JSON.stringify({
                id: parentReference.id,
                bound: parentReference.bound
            }, resolveToJSON), null === formData && (formData = new FormData()), parentReference = nextPartId++, formData.set(formFieldPrefix + parentReference, key), "$F" + parentReference.toString(16);
            if (void 0 !== temporaryReferences && -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference)) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
            throw Error("Client Functions cannot be passed directly to Server Functions. Only Functions passed from the Server can be passed back again.");
        }
        if ("symbol" === typeof value) {
            if (void 0 !== temporaryReferences && -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference)) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
            throw Error("Symbols cannot be passed to a Server Function without a temporary reference set. Pass a TemporaryReferenceSet to the options.");
        }
        if ("bigint" === typeof value) return "$n" + value.toString(10);
        throw Error("Type " + typeof value + " is not supported as an argument to a Server Function.");
    }
    function serializeModel(model, id) {
        "object" === typeof model && null !== model && (id = "$" + id.toString(16), writtenObjects.set(model, id), void 0 !== temporaryReferences && temporaryReferences.set(id, model));
        modelRoot = model;
        return JSON.stringify(model, resolveToJSON);
    }
    var nextPartId = 1, pendingParts = 0, formData = null, writtenObjects = new WeakMap(), modelRoot = root, json = serializeModel(root, 0);
    null === formData ? resolve(json) : (formData.set(formFieldPrefix + "0", json), 0 === pendingParts && resolve(formData));
    return function() {
        0 < pendingParts && (pendingParts = 0, null === formData ? resolve(json) : resolve(formData));
    };
}
function registerBoundServerReference(reference, id, bound) {
    knownServerReferences.has(reference) || knownServerReferences.set(reference, {
        id: id,
        originalBind: reference.bind,
        bound: bound
    });
}
function createBoundServerReference(metaData, callServer) {
    function action() {
        var args = Array.prototype.slice.call(arguments);
        return bound ? "fulfilled" === bound.status ? callServer(id, bound.value.concat(args)) : Promise.resolve(bound).then(function(boundArgs) {
            return callServer(id, boundArgs.concat(args));
        }) : callServer(id, args);
    }
    var id = metaData.id, bound = metaData.bound;
    registerBoundServerReference(action, id, bound);
    return action;
}
function createServerReference$1(id, callServer) {
    function action() {
        var args = Array.prototype.slice.call(arguments);
        return callServer(id, args);
    }
    registerBoundServerReference(action, id, null);
    return action;
}
function ReactPromise(status, value, reason) {
    this.status = status;
    this.value = value;
    this.reason = reason;
}
ReactPromise.prototype = Object.create(Promise.prototype);
ReactPromise.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
            break;
        case "resolved_module":
            initializeModuleChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            "function" === typeof resolve && resolve(this.value);
            break;
        case "pending":
        case "blocked":
            "function" === typeof resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            "function" === typeof reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        case "halted":
            break;
        default:
            "function" === typeof reject && reject(this.reason);
    }
};
function readChunk(chunk) {
    switch(chunk.status){
        case "resolved_model":
            initializeModelChunk(chunk);
            break;
        case "resolved_module":
            initializeModuleChunk(chunk);
    }
    switch(chunk.status){
        case "fulfilled":
            return chunk.value;
        case "pending":
        case "blocked":
        case "halted":
            throw chunk;
        default:
            throw chunk.reason;
    }
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++){
        var listener = listeners[i];
        "function" === typeof listener ? listener(value) : fulfillReference(listener, value);
    }
}
function rejectChunk(listeners, error) {
    for(var i = 0; i < listeners.length; i++){
        var listener = listeners[i];
        "function" === typeof listener ? listener(error) : rejectReference(listener, error);
    }
}
function resolveBlockedCycle(resolvedChunk, reference) {
    var referencedChunk = reference.handler.chunk;
    if (null === referencedChunk) return null;
    if (referencedChunk === resolvedChunk) return reference.handler;
    reference = referencedChunk.value;
    if (null !== reference) for(referencedChunk = 0; referencedChunk < reference.length; referencedChunk++){
        var listener = reference[referencedChunk];
        if ("function" !== typeof listener && (listener = resolveBlockedCycle(resolvedChunk, listener), null !== listener)) return listener;
    }
    return null;
}
function wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners) {
    switch(chunk.status){
        case "fulfilled":
            wakeChunk(resolveListeners, chunk.value);
            break;
        case "blocked":
            for(var i = 0; i < resolveListeners.length; i++){
                var listener = resolveListeners[i];
                if ("function" !== typeof listener) {
                    var cyclicHandler = resolveBlockedCycle(chunk, listener);
                    null !== cyclicHandler && (fulfillReference(listener, cyclicHandler.value), resolveListeners.splice(i, 1), i--, null !== rejectListeners && (listener = rejectListeners.indexOf(listener), -1 !== listener && rejectListeners.splice(listener, 1)));
                }
            }
        case "pending":
            if (chunk.value) for(i = 0; i < resolveListeners.length; i++)chunk.value.push(resolveListeners[i]);
            else chunk.value = resolveListeners;
            if (chunk.reason) {
                if (rejectListeners) for(resolveListeners = 0; resolveListeners < rejectListeners.length; resolveListeners++)chunk.reason.push(rejectListeners[resolveListeners]);
            } else chunk.reason = rejectListeners;
            break;
        case "rejected":
            rejectListeners && rejectChunk(rejectListeners, chunk.reason);
    }
}
function triggerErrorOnChunk(response, chunk, error) {
    "pending" !== chunk.status && "blocked" !== chunk.status ? chunk.reason.error(error) : (response = chunk.reason, chunk.status = "rejected", chunk.reason = error, null !== response && rejectChunk(response, error));
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new ReactPromise("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", response);
}
function resolveIteratorResultChunk(response, chunk, value, done) {
    resolveModelChunk(response, chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}");
}
function resolveModelChunk(response, chunk, value) {
    if ("pending" !== chunk.status) chunk.reason.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = response;
        null !== resolveListeners && (initializeModelChunk(chunk), wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners));
    }
}
function resolveModuleChunk(response, chunk, value) {
    if ("pending" === chunk.status || "blocked" === chunk.status) {
        response = chunk.value;
        var rejectListeners = chunk.reason;
        chunk.status = "resolved_module";
        chunk.value = value;
        null !== response && (initializeModuleChunk(chunk), wakeChunkIfInitialized(chunk, response, rejectListeners));
    }
}
var initializingHandler = null;
function initializeModelChunk(chunk) {
    var prevHandler = initializingHandler;
    initializingHandler = null;
    var resolvedModel = chunk.value, response = chunk.reason;
    chunk.status = "blocked";
    chunk.value = null;
    chunk.reason = null;
    try {
        var value = JSON.parse(resolvedModel, response._fromJSON), resolveListeners = chunk.value;
        null !== resolveListeners && (chunk.value = null, chunk.reason = null, wakeChunk(resolveListeners, value));
        if (null !== initializingHandler) {
            if (initializingHandler.errored) throw initializingHandler.reason;
            if (0 < initializingHandler.deps) {
                initializingHandler.value = value;
                initializingHandler.chunk = chunk;
                return;
            }
        }
        chunk.status = "fulfilled";
        chunk.value = value;
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingHandler = prevHandler;
    }
}
function initializeModuleChunk(chunk) {
    try {
        var value = requireModule(chunk.value);
        chunk.status = "fulfilled";
        chunk.value = value;
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    }
}
function reportGlobalError(weakResponse, error) {
    weakResponse._closed = !0;
    weakResponse._closedReason = error;
    weakResponse._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(weakResponse, chunk, error);
    });
}
function createLazyChunkWrapper(chunk) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: chunk,
        _init: readChunk
    };
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._closed ? new ReactPromise("rejected", null, response._closedReason) : new ReactPromise("pending", null, null), chunks.set(id, chunk));
    return chunk;
}
function fulfillReference(reference, value) {
    for(var response = reference.response, handler = reference.handler, parentObject = reference.parentObject, key = reference.key, map = reference.map, path = reference.path, i = 1; i < path.length; i++){
        for(; value.$$typeof === REACT_LAZY_TYPE;)if (value = value._payload, value === handler.chunk) value = handler.value;
        else {
            switch(value.status){
                case "resolved_model":
                    initializeModelChunk(value);
                    break;
                case "resolved_module":
                    initializeModuleChunk(value);
            }
            switch(value.status){
                case "fulfilled":
                    value = value.value;
                    continue;
                case "blocked":
                    var cyclicHandler = resolveBlockedCycle(value, reference);
                    if (null !== cyclicHandler) {
                        value = cyclicHandler.value;
                        continue;
                    }
                case "pending":
                    path.splice(0, i - 1);
                    null === value.value ? value.value = [
                        reference
                    ] : value.value.push(reference);
                    null === value.reason ? value.reason = [
                        reference
                    ] : value.reason.push(reference);
                    return;
                case "halted":
                    return;
                default:
                    rejectReference(reference, value.reason);
                    return;
            }
        }
        value = value[path[i]];
    }
    reference = map(response, value, parentObject, key);
    parentObject[key] = reference;
    "" === key && null === handler.value && (handler.value = reference);
    if (parentObject[0] === REACT_ELEMENT_TYPE && "object" === typeof handler.value && null !== handler.value && handler.value.$$typeof === REACT_ELEMENT_TYPE) switch(parentObject = handler.value, key){
        case "3":
            parentObject.props = reference;
    }
    handler.deps--;
    0 === handler.deps && (key = handler.chunk, null !== key && "blocked" === key.status && (parentObject = key.value, key.status = "fulfilled", key.value = handler.value, key.reason = handler.reason, null !== parentObject && wakeChunk(parentObject, handler.value)));
}
function rejectReference(reference, error) {
    var handler = reference.handler;
    reference = reference.response;
    handler.errored || (handler.errored = !0, handler.value = null, handler.reason = error, handler = handler.chunk, null !== handler && "blocked" === handler.status && triggerErrorOnChunk(reference, handler, error));
}
function waitForReference(referencedChunk, parentObject, key, response, map, path) {
    if (initializingHandler) {
        var handler = initializingHandler;
        handler.deps++;
    } else handler = initializingHandler = {
        parent: null,
        chunk: null,
        value: null,
        reason: null,
        deps: 1,
        errored: !1
    };
    parentObject = {
        response: response,
        handler: handler,
        parentObject: parentObject,
        key: key,
        map: map,
        path: path
    };
    null === referencedChunk.value ? referencedChunk.value = [
        parentObject
    ] : referencedChunk.value.push(parentObject);
    null === referencedChunk.reason ? referencedChunk.reason = [
        parentObject
    ] : referencedChunk.reason.push(parentObject);
    return null;
}
function loadServerReference(response, metaData, parentObject, key) {
    if (!response._serverReferenceConfig) return createBoundServerReference(metaData, response._callServer);
    var serverReference = resolveServerReference(response._serverReferenceConfig, metaData.id), promise = preloadModule(serverReference);
    if (promise) metaData.bound && (promise = Promise.all([
        promise,
        metaData.bound
    ]));
    else if (metaData.bound) promise = Promise.resolve(metaData.bound);
    else return promise = requireModule(serverReference), registerBoundServerReference(promise, metaData.id, metaData.bound), promise;
    if (initializingHandler) {
        var handler = initializingHandler;
        handler.deps++;
    } else handler = initializingHandler = {
        parent: null,
        chunk: null,
        value: null,
        reason: null,
        deps: 1,
        errored: !1
    };
    promise.then(function() {
        var resolvedValue = requireModule(serverReference);
        if (metaData.bound) {
            var boundArgs = metaData.bound.value.slice(0);
            boundArgs.unshift(null);
            resolvedValue = resolvedValue.bind.apply(resolvedValue, boundArgs);
        }
        registerBoundServerReference(resolvedValue, metaData.id, metaData.bound);
        parentObject[key] = resolvedValue;
        "" === key && null === handler.value && (handler.value = resolvedValue);
        if (parentObject[0] === REACT_ELEMENT_TYPE && "object" === typeof handler.value && null !== handler.value && handler.value.$$typeof === REACT_ELEMENT_TYPE) switch(boundArgs = handler.value, key){
            case "3":
                boundArgs.props = resolvedValue;
        }
        handler.deps--;
        0 === handler.deps && (resolvedValue = handler.chunk, null !== resolvedValue && "blocked" === resolvedValue.status && (boundArgs = resolvedValue.value, resolvedValue.status = "fulfilled", resolvedValue.value = handler.value, null !== boundArgs && wakeChunk(boundArgs, handler.value)));
    }, function(error) {
        if (!handler.errored) {
            handler.errored = !0;
            handler.value = null;
            handler.reason = error;
            var chunk = handler.chunk;
            null !== chunk && "blocked" === chunk.status && triggerErrorOnChunk(response, chunk, error);
        }
    });
    return null;
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
            break;
        case "resolved_module":
            initializeModuleChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            var value = id.value;
            for(id = 1; id < reference.length; id++){
                for(; value.$$typeof === REACT_LAZY_TYPE;){
                    value = value._payload;
                    switch(value.status){
                        case "resolved_model":
                            initializeModelChunk(value);
                            break;
                        case "resolved_module":
                            initializeModuleChunk(value);
                    }
                    switch(value.status){
                        case "fulfilled":
                            value = value.value;
                            break;
                        case "blocked":
                        case "pending":
                            return waitForReference(value, parentObject, key, response, map, reference.slice(id - 1));
                        case "halted":
                            return initializingHandler ? (response = initializingHandler, response.deps++) : initializingHandler = {
                                parent: null,
                                chunk: null,
                                value: null,
                                reason: null,
                                deps: 1,
                                errored: !1
                            }, null;
                        default:
                            return initializingHandler ? (initializingHandler.errored = !0, initializingHandler.value = null, initializingHandler.reason = value.reason) : initializingHandler = {
                                parent: null,
                                chunk: null,
                                value: null,
                                reason: value.reason,
                                deps: 0,
                                errored: !0
                            }, null;
                    }
                }
                value = value[reference[id]];
            }
            return map(response, value, parentObject, key);
        case "pending":
        case "blocked":
            return waitForReference(id, parentObject, key, response, map, reference);
        case "halted":
            return initializingHandler ? (response = initializingHandler, response.deps++) : initializingHandler = {
                parent: null,
                chunk: null,
                value: null,
                reason: null,
                deps: 1,
                errored: !1
            }, null;
        default:
            return initializingHandler ? (initializingHandler.errored = !0, initializingHandler.value = null, initializingHandler.reason = id.reason) : initializingHandler = {
                parent: null,
                chunk: null,
                value: null,
                reason: id.reason,
                deps: 0,
                errored: !0
            }, null;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function createBlob(response, model) {
    return new Blob(model.slice(1), {
        type: model[0]
    });
}
function createFormData(response, model) {
    response = new FormData();
    for(var i = 0; i < model.length; i++)response.append(model[i][0], model[i][1]);
    return response;
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseModelString(response, parentObject, key, value) {
    if ("$" === value[0]) {
        if ("$" === value) return null !== initializingHandler && "0" === key && (initializingHandler = {
            parent: initializingHandler,
            chunk: null,
            value: null,
            reason: null,
            deps: 0,
            errored: !1
        }), REACT_ELEMENT_TYPE;
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "L":
                return parentObject = parseInt(value.slice(2), 16), response = getChunk(response, parentObject), createLazyChunkWrapper(response);
            case "@":
                return parentObject = parseInt(value.slice(2), 16), getChunk(response, parentObject);
            case "S":
                return Symbol.for(value.slice(2));
            case "F":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, loadServerReference);
            case "T":
                parentObject = "$" + value.slice(2);
                response = response._tempRefs;
                if (null == response) throw Error("Missing a temporary reference set but the RSC response returned a temporary reference. Pass a temporaryReference option with the set that was used with the reply.");
                return response.get(parentObject);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createSet);
            case "B":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createBlob);
            case "K":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createFormData);
            case "Z":
                return resolveErrorProd();
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
            default:
                return value = value.slice(1), getOutlinedModel(response, value, parentObject, key, createModel);
        }
    }
    return value;
}
function missingCall() {
    throw Error('Trying to call a function from "use server" but the callServer option was not implemented in your router runtime.');
}
function ResponseInstance(bundlerConfig, serverReferenceConfig, moduleLoading, callServer, encodeFormAction, nonce, temporaryReferences) {
    var chunks = new Map();
    this._bundlerConfig = bundlerConfig;
    this._serverReferenceConfig = serverReferenceConfig;
    this._moduleLoading = moduleLoading;
    this._callServer = void 0 !== callServer ? callServer : missingCall;
    this._encodeFormAction = encodeFormAction;
    this._nonce = nonce;
    this._chunks = chunks;
    this._stringDecoder = new TextDecoder();
    this._fromJSON = null;
    this._closed = !1;
    this._closedReason = null;
    this._tempRefs = temporaryReferences;
    this._fromJSON = createFromJSONCallback(this);
}
function resolveBuffer(response, id, buffer) {
    response = response._chunks;
    var chunk = response.get(id);
    chunk && "pending" !== chunk.status ? chunk.reason.enqueueValue(buffer) : response.set(id, new ReactPromise("fulfilled", buffer, null));
}
function resolveModule(response, id, model) {
    var chunks = response._chunks, chunk = chunks.get(id), clientReference = JSON.parse(model, response._fromJSON);
    if (model = preloadModule(clientReference)) {
        if (chunk) {
            var blockedChunk = chunk;
            blockedChunk.status = "blocked";
        } else blockedChunk = new ReactPromise("blocked", null, null), chunks.set(id, blockedChunk);
        model.then(function() {
            return resolveModuleChunk(response, blockedChunk, clientReference);
        }, function(error) {
            return triggerErrorOnChunk(response, blockedChunk, error);
        });
    } else chunk ? resolveModuleChunk(response, chunk, clientReference) : chunks.set(id, new ReactPromise("resolved_module", clientReference, null));
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    response = chunks.get(id);
    response ? "pending" === response.status && (id = response.value, response.status = "fulfilled", response.value = stream, response.reason = controller, null !== id && wakeChunk(id, response.value)) : chunks.set(id, new ReactPromise("fulfilled", stream, controller));
}
function startReadableStream(response, id, type) {
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, id, type, {
        enqueueValue: function(value) {
            null === previousBlockedChunk ? controller.enqueue(value) : previousBlockedChunk.then(function() {
                controller.enqueue(value);
            });
        },
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new ReactPromise("resolved_model", json, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$52 = new ReactPromise("pending", null, null);
                chunk$52.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$52;
                chunk.then(function() {
                    previousBlockedChunk === chunk$52 && (previousBlockedChunk = null);
                    resolveModelChunk(response, chunk$52, json);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function startAsyncIterable(response, id, iterator) {
    var buffer = [], closed = !1, nextWriteIndex = 0, iterable = {};
    iterable[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new ReactPromise("fulfilled", {
                    done: !0,
                    value: void 0
                }, null);
                buffer[nextReadIndex] = new ReactPromise("pending", null, null);
            }
            return buffer[nextReadIndex++];
        });
    };
    resolveStream(response, id, iterator ? iterable[ASYNC_ITERATOR]() : iterable, {
        enqueueValue: function(value) {
            if (nextWriteIndex === buffer.length) buffer[nextWriteIndex] = new ReactPromise("fulfilled", {
                done: !1,
                value: value
            }, null);
            else {
                var chunk = buffer[nextWriteIndex], resolveListeners = chunk.value, rejectListeners = chunk.reason;
                chunk.status = "fulfilled";
                chunk.value = {
                    done: !1,
                    value: value
                };
                null !== resolveListeners && wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners);
            }
            nextWriteIndex++;
        },
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(response, buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(response, buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(response, buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = new ReactPromise("pending", null, null)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(response, buffer[nextWriteIndex++], error);
        }
    });
}
function resolveErrorProd() {
    var error = Error("An error occurred in the Server Components render. The specific message is omitted in production builds to avoid leaking sensitive details. A digest property is included on this error instance which may provide additional details about the nature of the error.");
    error.stack = "Error: " + error.message;
    return error;
}
function mergeBuffer(buffer, lastChunk) {
    for(var l = buffer.length, byteLength = lastChunk.length, i = 0; i < l; i++)byteLength += buffer[i].byteLength;
    byteLength = new Uint8Array(byteLength);
    for(var i$53 = i = 0; i$53 < l; i$53++){
        var chunk = buffer[i$53];
        byteLength.set(chunk, i);
        i += chunk.byteLength;
    }
    byteLength.set(lastChunk, i);
    return byteLength;
}
function resolveTypedArray(response, id, buffer, lastChunk, constructor, bytesPerElement) {
    buffer = 0 === buffer.length && 0 === lastChunk.byteOffset % bytesPerElement ? lastChunk : mergeBuffer(buffer, lastChunk);
    constructor = new constructor(buffer.buffer, buffer.byteOffset, buffer.byteLength / bytesPerElement);
    resolveBuffer(response, id, constructor);
}
function processFullBinaryRow(response, id, tag, buffer, chunk) {
    switch(tag){
        case 65:
            resolveBuffer(response, id, mergeBuffer(buffer, chunk).buffer);
            return;
        case 79:
            resolveTypedArray(response, id, buffer, chunk, Int8Array, 1);
            return;
        case 111:
            resolveBuffer(response, id, 0 === buffer.length ? chunk : mergeBuffer(buffer, chunk));
            return;
        case 85:
            resolveTypedArray(response, id, buffer, chunk, Uint8ClampedArray, 1);
            return;
        case 83:
            resolveTypedArray(response, id, buffer, chunk, Int16Array, 2);
            return;
        case 115:
            resolveTypedArray(response, id, buffer, chunk, Uint16Array, 2);
            return;
        case 76:
            resolveTypedArray(response, id, buffer, chunk, Int32Array, 4);
            return;
        case 108:
            resolveTypedArray(response, id, buffer, chunk, Uint32Array, 4);
            return;
        case 71:
            resolveTypedArray(response, id, buffer, chunk, Float32Array, 4);
            return;
        case 103:
            resolveTypedArray(response, id, buffer, chunk, Float64Array, 8);
            return;
        case 77:
            resolveTypedArray(response, id, buffer, chunk, BigInt64Array, 8);
            return;
        case 109:
            resolveTypedArray(response, id, buffer, chunk, BigUint64Array, 8);
            return;
        case 86:
            resolveTypedArray(response, id, buffer, chunk, DataView, 1);
            return;
    }
    for(var stringDecoder = response._stringDecoder, row = "", i = 0; i < buffer.length; i++)row += stringDecoder.decode(buffer[i], decoderOptions);
    buffer = row += stringDecoder.decode(chunk);
    switch(tag){
        case 73:
            resolveModule(response, id, buffer);
            break;
        case 72:
            id = buffer[0];
            buffer = buffer.slice(1);
            response = JSON.parse(buffer, response._fromJSON);
            buffer = ReactDOMSharedInternals.d;
            switch(id){
                case "D":
                    buffer.D(response);
                    break;
                case "C":
                    "string" === typeof response ? buffer.C(response) : buffer.C(response[0], response[1]);
                    break;
                case "L":
                    id = response[0];
                    tag = response[1];
                    3 === response.length ? buffer.L(id, tag, response[2]) : buffer.L(id, tag);
                    break;
                case "m":
                    "string" === typeof response ? buffer.m(response) : buffer.m(response[0], response[1]);
                    break;
                case "X":
                    "string" === typeof response ? buffer.X(response) : buffer.X(response[0], response[1]);
                    break;
                case "S":
                    "string" === typeof response ? buffer.S(response) : buffer.S(response[0], 0 === response[1] ? void 0 : response[1], 3 === response.length ? response[2] : void 0);
                    break;
                case "M":
                    "string" === typeof response ? buffer.M(response) : buffer.M(response[0], response[1]);
            }
            break;
        case 69:
            tag = response._chunks;
            chunk = tag.get(id);
            buffer = JSON.parse(buffer);
            stringDecoder = resolveErrorProd();
            stringDecoder.digest = buffer.digest;
            chunk ? triggerErrorOnChunk(response, chunk, stringDecoder) : tag.set(id, new ReactPromise("rejected", null, stringDecoder));
            break;
        case 84:
            response = response._chunks;
            (tag = response.get(id)) && "pending" !== tag.status ? tag.reason.enqueueValue(buffer) : response.set(id, new ReactPromise("fulfilled", buffer, null));
            break;
        case 78:
        case 68:
        case 74:
        case 87:
            throw Error("Failed to read a RSC payload created by a development version of React on the server while using a production version on the client. Always use matching versions on the server and the client.");
        case 82:
            startReadableStream(response, id, void 0);
            break;
        case 114:
            startReadableStream(response, id, "bytes");
            break;
        case 88:
            startAsyncIterable(response, id, !1);
            break;
        case 120:
            startAsyncIterable(response, id, !0);
            break;
        case 67:
            (response = response._chunks.get(id)) && "fulfilled" === response.status && response.reason.close("" === buffer ? '"$undefined"' : buffer);
            break;
        default:
            tag = response._chunks, (chunk = tag.get(id)) ? resolveModelChunk(response, chunk, buffer) : tag.set(id, new ReactPromise("resolved_model", buffer, response));
    }
}
function createFromJSONCallback(response) {
    return function(key, value) {
        if ("string" === typeof value) return parseModelString(response, this, key, value);
        if ("object" === typeof value && null !== value) {
            if (value[0] === REACT_ELEMENT_TYPE) {
                if (key = {
                    $$typeof: REACT_ELEMENT_TYPE,
                    type: value[1],
                    key: value[2],
                    ref: null,
                    props: value[3]
                }, null !== initializingHandler) {
                    if (value = initializingHandler, initializingHandler = value.parent, value.errored) key = new ReactPromise("rejected", null, value.reason), key = createLazyChunkWrapper(key);
                    else if (0 < value.deps) {
                        var blockedChunk = new ReactPromise("blocked", null, null);
                        value.value = key;
                        value.chunk = blockedChunk;
                        key = createLazyChunkWrapper(blockedChunk);
                    }
                }
            } else key = value;
            return key;
        }
        return value;
    };
}
var callServer = null;
function callCurrentServerCallback(id, args) {
    if (!callServer) throw Error("No server callback has been registered. Call setServerCallback to register one.");
    return callServer(id, args);
}
function startReadingFromStream(response, stream, isSecondaryStream) {
    function progress(_ref2) {
        var value = _ref2.value;
        if (_ref2.done) isSecondaryStream || reportGlobalError(response, Error("Connection closed."));
        else {
            var i = 0, rowState = streamState._rowState;
            _ref2 = streamState._rowID;
            for(var rowTag = streamState._rowTag, rowLength = streamState._rowLength, buffer = streamState._buffer, chunkLength = value.length; i < chunkLength;){
                var lastIdx = -1;
                switch(rowState){
                    case 0:
                        lastIdx = value[i++];
                        58 === lastIdx ? rowState = 1 : _ref2 = _ref2 << 4 | (96 < lastIdx ? lastIdx - 87 : lastIdx - 48);
                        continue;
                    case 1:
                        rowState = value[i];
                        84 === rowState || 65 === rowState || 79 === rowState || 111 === rowState || 85 === rowState || 83 === rowState || 115 === rowState || 76 === rowState || 108 === rowState || 71 === rowState || 103 === rowState || 77 === rowState || 109 === rowState || 86 === rowState ? (rowTag = rowState, rowState = 2, i++) : 64 < rowState && 91 > rowState || 35 === rowState || 114 === rowState || 120 === rowState ? (rowTag = rowState, rowState = 3, i++) : (rowTag = 0, rowState = 3);
                        continue;
                    case 2:
                        lastIdx = value[i++];
                        44 === lastIdx ? rowState = 4 : rowLength = rowLength << 4 | (96 < lastIdx ? lastIdx - 87 : lastIdx - 48);
                        continue;
                    case 3:
                        lastIdx = value.indexOf(10, i);
                        break;
                    case 4:
                        lastIdx = i + rowLength, lastIdx > value.length && (lastIdx = -1);
                }
                var offset = value.byteOffset + i;
                if (-1 < lastIdx) rowLength = new Uint8Array(value.buffer, offset, lastIdx - i), processFullBinaryRow(response, _ref2, rowTag, buffer, rowLength), i = lastIdx, 3 === rowState && i++, rowLength = _ref2 = rowTag = rowState = 0, buffer.length = 0;
                else {
                    value = new Uint8Array(value.buffer, offset, value.byteLength - i);
                    buffer.push(value);
                    rowLength -= value.byteLength;
                    break;
                }
            }
            streamState._rowState = rowState;
            streamState._rowID = _ref2;
            streamState._rowTag = rowTag;
            streamState._rowLength = rowLength;
            return reader.read().then(progress).catch(error);
        }
    }
    function error(e) {
        reportGlobalError(response, e);
    }
    var streamState = {
        _rowState: 0,
        _rowID: 0,
        _rowTag: 0,
        _rowLength: 0,
        _buffer: []
    }, reader = stream.getReader();
    reader.read().then(progress).catch(error);
}
exports.createFromFetch = function(promiseForResponse, options) {
    var response = new ResponseInstance(null, null, null, callCurrentServerCallback, void 0, void 0, options && options.temporaryReferences ? options.temporaryReferences : void 0);
    promiseForResponse.then(function(r) {
        startReadingFromStream(response, r.body, !1);
    }, function(e) {
        reportGlobalError(response, e);
    });
    return getChunk(response, 0);
};
exports.createFromReadableStream = function(stream, options) {
    options = new ResponseInstance(null, null, null, callCurrentServerCallback, void 0, void 0, options && options.temporaryReferences ? options.temporaryReferences : void 0);
    startReadingFromStream(options, stream, !1);
    return getChunk(options, 0);
};
exports.createServerReference = function(id, exportName) {
    return createServerReference$1(id + "#" + exportName, callCurrentServerCallback);
};
exports.createTemporaryReferenceSet = function() {
    return new Map();
};
exports.encodeReply = function(value, options) {
    return new Promise(function(resolve, reject) {
        var abort = processReply(value, "", options && options.temporaryReferences ? options.temporaryReferences : void 0, resolve, reject);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(signal.reason);
            else {
                var listener = function() {
                    abort(signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
    });
};
exports.registerServerReference = function(reference, id) {
    registerBoundServerReference(reference, id, null);
    return reference;
};
exports.setServerCallback = function(fn) {
    callServer = fn;
};

},{"da607ba755542785":"gC2PC"}],"2n5QP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rscStream", ()=>rscStream);
let encoder = new TextEncoder();
let streamController;
let rscStream = new ReadableStream({
    start (controller) {
        if (typeof window === 'undefined') return;
        let handleChunk = (chunk)=>{
            if (typeof chunk === 'string') controller.enqueue(encoder.encode(chunk));
            else controller.enqueue(chunk);
        };
        window.__FLIGHT_DATA ||= [];
        window.__FLIGHT_DATA.forEach(handleChunk);
        window.__FLIGHT_DATA.push = (chunk)=>{
            handleChunk(chunk);
        };
        streamController = controller;
    }
});
if (typeof document !== 'undefined' && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    streamController?.close();
});
else streamController?.close();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fRKjd":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"eIjR2"}],"eIjR2":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionLane = 256, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM) {
        var isSupported$jscomp$inline_417 = "oninput" in document;
        if (!isSupported$jscomp$inline_417) {
            var element$jscomp$inline_418 = document.createElement("div");
            element$jscomp$inline_418.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
        }
        JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            track(instance);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$3, noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
        thenableIndexCounter$1 = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        onActionError(actionQueue, node, error$38);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, createEffectInstance(), actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, createEffectInstance(), create, createDeps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
}
function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$41 = enqueueUpdate(provider, fiber, lane);
                null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
}, HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, thenableState = null, thenableIndexCounter = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && (shellBoundary = fiber);
        }
    } else reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            if (isHydrating) {
                var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(nextInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                pushProvider(workInProgress, CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError(init);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[internalInstanceKey] = workInProgress, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes, current), markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, init = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = init, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild)) : nextHydratableInstance = init), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild), rootOrSingletonContext = !1, init = !0) : init = !1;
                init || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = init);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, prevState = createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary)) throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? (markUpdate(workInProgress), null !== renderLanes ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[internalInstanceKey] = workInProgress;
                    current[internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch(setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
        var actionScopeLane = currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
}
function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if (suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: noop
        }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : 1) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        handleThrow(root, thrownValue$169);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects(wasDelayedCommit);
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$174, root$174 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++){
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1530, "on" + capitalizedEvent$jscomp$inline_1531);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = getParent(inCapturePhase);
                                reactEventName = getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            track(domElement);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$244 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$244 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$250)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = requestUpdateLane();
                            lane = getBumpedLaneForHydrationByLane(lane);
                            var root = enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && scheduleUpdateOnFiber(root, nearestMounted, lane);
                            markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1785 = React.version;
if ("19.1.0" !== isomorphicReactPackageVersion$jscomp$inline_1785) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber) try {
        rendererID = hook$jscomp$inline_2257.inject(internals$jscomp$inline_2256), injectedHook = hook$jscomp$inline_2257;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.1.0";

},{"934b50a50c275743":"4IVUq","56d30b16d84cc622":"a1TxN","d42dbe4aacaa6df4":"gC2PC"}],"4IVUq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"c6kKM"}],"c6kKM":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"foxg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefetchRoute", ()=>prefetchRoute);
parcelHelpers.export(exports, "getPrefetchedPromise", ()=>getPrefetchedPromise);
var _client = require("@parcel/rsc/client");
'use client';
const prefetchPromises = new Map();
function prefetchRoute(pathname) {
    let [basePath] = pathname.split('#');
    let rscPath = basePath.replace('.html', '.rsc');
    // Skip if currently prefetching
    if (prefetchPromises.has(rscPath)) return;
    // Start prefetch and cache the promise
    const prefetchPromise = (0, _client.fetchRSC)(rscPath).then((res)=>{
        // Remove from cache once resolved (rely on browser cache for subsequent requests)
        prefetchPromises.delete(rscPath);
        return res;
    }).catch(()=>{
        prefetchPromises.delete(rscPath);
        return Promise.reject(new Error('Prefetch failed'));
    });
    // Silently handle prefetch failures
    prefetchPromise.catch(()=>{});
    prefetchPromises.set(rscPath, prefetchPromise);
}
function getPrefetchedPromise(rscPath) {
    return prefetchPromises.get(rscPath);
}

},{"@parcel/rsc/client":"dvyUn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"515lj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeFold", ()=>CodeFold);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _chevron = require("../../../@react-spectrum/s2/ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _more = require("@react-spectrum/s2/icons/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
'use client';
const trigger = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    rules += ' Td12';
    rules += ' Qd12';
    rules += ' Sd12';
    rules += ' Rd12';
    rules += ' Id12';
    rules += ' g912';
    rules += ' _je12';
    rules += ' _740ub4c12';
    rules += ' u40ub4c12';
    rules += ' v40ub4c12';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd12';
    else if (props.isRTL) rules += ' _Sc12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' pt12';
    rules += ' -_8sjo0b-t5ZbAob12';
    rules += ' _va12';
    rules += ' Hs12';
    return rules;
};
const more = function anonymous(props) {
    let rules = " ";
    if (props.isPressed) rules += ' gF12';
    else if (props.isFocusVisible) rules += ' gF12';
    else if (props.isHovered) rules += ' gF12';
    else rules += ' gH12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    rules += ' Sp12';
    rules += ' Rp12';
    rules += ' Is12';
    rules += ' Hs12';
    rules += ' Ft12';
    rules += ' sh12';
    rules += ' eb12';
    rules += ' _5c12';
    rules += ' _4c12';
    rules += ' -_8sjo0b-tjQquMe12';
    return rules;
};
function CodeFold({ children }) {
    let ref = (0, _react.useRef)(null);
    let [firstLine, collapsed, lastLine] = (0, _react.useMemo)(()=>{
        let firstLine = [];
        let collapsed = [];
        let lastLine = [];
        // Iterate forward to find the first newline.
        for (let [i, child] of children.entries()){
            if (typeof child === 'string') {
                let index = child.indexOf('\n');
                if (index === 0) {
                    collapsed = children.slice(i);
                    break;
                } else if (index > 0) {
                    firstLine.push(child.slice(0, index));
                    if (index < child.length) collapsed.push(child.slice(index));
                    collapsed.push(...children.slice(i + 1));
                    break;
                }
            }
            firstLine.push(child);
        }
        // Iterate backward to find the last newline.
        for(let i = collapsed.length - 1; i >= 0; i--){
            let child = collapsed[i];
            if (typeof child === 'string') {
                let c = child;
                if (i === collapsed.length - 1) // Ignore the last newline if it is at the very end of the code.
                c = c.trimEnd();
                let index = c.lastIndexOf('\n');
                if (index === 0) break;
                else if (index > 0) {
                    lastLine.unshift(c.slice(index));
                    break;
                }
            }
            lastLine.unshift(child);
        }
        if (typeof collapsed[0] === 'string') collapsed[0] = collapsed[0].replace(/^\n/, '');
        if (typeof lastLine[0] === 'string') lastLine[0] = lastLine[0].trimStart();
        return [
            firstLine,
            collapsed,
            lastLine
        ];
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Disclosure), {
        children: ({ isExpanded })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "trigger",
                        className: trigger,
                        children: ({ isHovered, isPressed, isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                        size: "S",
                                        "aria-hidden": true,
                                        className: chevronStyles({
                                            isExpanded,
                                            isHovered,
                                            isPressed,
                                            isFocusVisible
                                        })
                                    }),
                                    firstLine,
                                    !isExpanded ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                ref: ref,
                                                style: (0, _s2.pressScale)(ref)({
                                                    isPressed
                                                }),
                                                className: more({
                                                    isHovered,
                                                    isPressed,
                                                    isFocusVisible
                                                }),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreDefault.default), {
                                                    UNSAFE_style: {
                                                        width: 14
                                                    }
                                                })
                                            }),
                                            lastLine
                                        ]
                                    }) : null
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosurePanel), {
                        children: collapsed
                    })
                ]
            })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Disclosure","hRrWd"],["DisclosurePanel","hRrWd"]],"../../../@react-spectrum/s2/ui-icons/Chevron":"1904U","@react-spectrum/s2/icons/More":"gP3id","@react-spectrum/s2":"8Ufux","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"el6b6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "getAnchorProps", ()=>getAnchorProps);
parcelHelpers.export(exports, "ColorLink", ()=>ColorLink);
parcelHelpers.export(exports, "CodeLink", ()=>CodeLink);
parcelHelpers.export(exports, "TitleLink", ()=>TitleLink);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function Link({ href, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
        ...props,
        href: href,
        ...getAnchorProps(href)
    });
}
function getAnchorProps(href) {
    if (!/^http/.test(href) || /localhost|reactspectrum\.blob\.core\.windows\.net|react-spectrum\.(corp\.)?adobe\.com|^#/.test(href)) return {};
    if (/^\//.test(href)) return {};
    return {
        target: '_blank',
        rel: 'noreferrer'
    };
}
const colorLink = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    if (props.type === "variable") rules += ' p1gYRFc12';
    else if (props.type === "keyword") rules += ' pplLfSc12';
    else rules += ' p37ZLpd12';
    rules += ' plf12';
    rules += ' _Xb12';
    rules += ' __Va12';
    rules += ' __ca12';
    rules += ' ry12';
    return rules;
};
function ColorLink({ type, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        className: (r)=>colorLink({
                ...r,
                type
            })
    });
}
function CodeLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        style: ({ isHovered })=>({
                textDecorationStyle: isHovered ? 'solid' : 'dotted'
            })
    });
}
const titleLink = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' veOoCPe12';
    rules += ' -_6BNtrc-pg12';
    rules += ' vpx12';
    rules += ' xe12';
    rules += ' _xa12';
    rules += ' xX0cczbd12';
    rules += ' _xX0cczba12';
    rules += ' xfe12';
    rules += ' _xfa12';
    rules += ' xfX0cczbd12';
    rules += ' _xfX0cczba12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    rules += ' po12';
    rules += ' plf12';
    rules += ' Jy12';
    rules += ' Gy12';
    return rules;
};
function TitleLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        className: titleLink
    });
}

},{"0":"fzJz7","1":"vFDyX","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"42COX","react-aria-components":"fOCdV","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += ((overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    if (props.isStaticColor) rules += ' Oe12';
    else rules += ' Oh12';
    rules += ' Olc12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr12';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    if (props.isStandalone) {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.isStandalone) {
        rules += ' xc12';
        rules += ' _xa12';
    }
    if (props.isStandalone) {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isStaticColor) rules += ' pl12';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps12';
        else if (props.isFocusVisible) rules += ' ps12';
        else if (props.isHovered) rules += ' ps12';
        else rules += ' pu12';
    }
    rules += ' plf12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb12';
                rules += ' __Va12';
            } else if (props.isHovered) {
                rules += ' _Xb12';
                rules += ' __Va12';
            } else rules += ' _Xa12';
        }
    } else {
        rules += ' _Xb12';
        rules += ' __Va12';
    }
    rules += ' __ca12';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react-aria-components":"fOCdV","react":"a1TxN","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","@react-aria/utils":"2ViQu","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"fzJz7":[function() {},{}],"vFDyX":[function() {},{}],"ayXXD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconPicker", ()=>IconPicker);
parcelHelpers.export(exports, "VisualExampleClient", ()=>VisualExampleClient);
parcelHelpers.export(exports, "Output", ()=>Output);
parcelHelpers.export(exports, "CodeOutput", ()=>CodeOutput);
parcelHelpers.export(exports, "CodeProps", ()=>CodeProps);
parcelHelpers.export(exports, "Control", ()=>Control);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _addCircle = require("@react-spectrum/s2/icons/AddCircle");
var _addCircleDefault = parcelHelpers.interopDefault(_addCircle);
var _codePlatter = require("./CodePlatter");
var _exampleOutput = require("./ExampleOutput");
var _exampleSwitcher = require("./ExampleSwitcher");
var _reactDom = require("react-dom");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _runtime = require("../../../@react-spectrum/s2/style/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _removeCircle = require("@react-spectrum/s2/icons/RemoveCircle");
var _removeCircleDefault = parcelHelpers.interopDefault(_removeCircle);
var _reactAria = require("react-aria");
'use client';
const IconPicker = /*#__PURE__*/ (0, _react.lazy)(()=>require("78276cdf15345291").then(({ IconPicker })=>({
            default: IconPicker
        })));
const Context = /*#__PURE__*/ (0, _react.createContext)({
    component: 'div',
    name: 'Button',
    controls: {},
    props: {},
    setProps: ()=>{}
});
function VisualExampleClient({ component, name, importSource, controls, children, initialProps = {}, propsObject }) {
    let [props, setProps] = (0, _react.useState)(()=>{
        let props = {
            ...initialProps
        };
        for(let name in controls){
            let defaultValue = controls[name].default;
            if (!(name in initialProps)) props[name] = defaultValue;
            if (controls[name].value.type === 'interface' && controls[name].value.name === 'Size') {
                if (typeof props[name] === 'object') props[name] = new (0, _reactAriaComponents.Size)(props[name].width, props[name].height);
                else delete props[name];
            }
        }
        return props;
    });
    let ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Find previous heading element.
        let node = ref.current;
        while(node && node.parentElement?.tagName !== 'ARTICLE')node = node.parentElement;
        while(node && !(node instanceof HTMLHeadingElement))node = node.previousElementSibling;
        let id = node instanceof HTMLHeadingElement ? node.id : null;
        if (id && location.hash === '#' + id) {
            let params = new URLSearchParams(location.search);
            let newProps = {
                ...props
            };
            for (let [name, value] of params)try {
                if (value) newProps[name] = JSON.parse(value);
            } catch  {
            // ignore
            }
            setProps(newProps);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let searchParams = new URLSearchParams();
    let exampleType = (0, _react.useContext)((0, _exampleSwitcher.ExampleSwitcherContext));
    if (exampleType) searchParams.set('exampleType', String(exampleType));
    for(let prop in props){
        let value = props[prop];
        if (value != null && controls[prop] != null && (controls[prop].default == null || value !== controls[prop].default)) searchParams.set(prop, JSON.stringify(value));
    }
    let url = '?' + searchParams.toString();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Context.Provider, {
        value: {
            component,
            name,
            importSource,
            controls,
            props,
            setProps,
            propsObject
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                hidden: true,
                ref: ref
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.ShareUrlProvider), {
                value: url,
                children: children
            })
        ]
    });
}
function Output({ align = 'center', acceptOrientation }) {
    let { component, props, propsObject } = (0, _react.useContext)(Context);
    if (!/*#__PURE__*/ (0, _react.isValidElement)(component)) {
        let children = props.children;
        if (children?.iconJSX || children?.avatar || children?.badge) children = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                children.avatar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                    src: "https://i.imgur.com/xIe7Wlb.png"
                }) : children.iconJSX,
                children.text && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                    children: children.text
                }),
                children.badge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NotificationBadge), {
                    value: 12
                })
            ]
        });
        else if (children?.text != null) children = children.text;
        props = {
            ...props,
            children
        };
    }
    if (props.contextualHelp) props = {
        ...props,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ContextualHelp), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                    children: "Heading"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                    children: "Content"
                })
            ]
        })
    };
    if (propsObject) props = {
        [propsObject]: props
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleOutput.ExampleOutput), {
        component: component,
        props: props,
        align: align,
        orientation: acceptOrientation ? props.orientation : undefined
    });
}
function CodeOutput({ code, type, showCoachMark }) {
    let { name, importSource, props, controls, propsObject } = (0, _react.useContext)(Context);
    if (propsObject) props = {
        [propsObject]: props
    };
    code ||= /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.Pre), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
            style: {
                fontFamily: 'inherit',
                WebkitTextSizeAdjust: 'none'
            },
            children: [
                importSource ? renderImports(name, importSource, props) : null,
                renderElement(name, props, controls)
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.CodePlatter), {
        type: type,
        showCoachMark: showCoachMark,
        children: code
    });
}
function CodeProps({ indent = '' }) {
    let { props, controls, propsObject } = (0, _react.useContext)(Context);
    if (propsObject) props = {
        [propsObject]: props
    };
    let renderedProps = Object.keys(props).filter((prop)=>prop !== 'children').map((prop)=>renderProp(prop, props[prop], controls[prop], indent)).filter(Boolean);
    let newlines = indent.length > 0 || countChars(renderedProps) > 40;
    let separator = newlines ? indent || '  ' : ' ';
    renderedProps = renderedProps.map((p, i)=>{
        let sep = separator;
        if (newlines) sep = (indent && i === 0 ? '' : '\n') + separator;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                sep,
                p
            ]
        }, i);
    });
    if (newlines && indent && renderedProps.length) renderedProps.push('\n');
    return renderedProps;
}
function renderElement(name, props, controls, indent = '') {
    let start = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "<",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " p37ZLpd12",
                children: name
            })
        ]
    });
    let renderedProps = Object.keys(props).filter((prop)=>prop !== 'children').map((prop)=>renderProp(prop, props[prop], controls?.[prop], '  ' + indent)).filter(Boolean);
    let newlines = name.length + countChars(renderedProps) > 40;
    renderedProps = renderedProps.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                newlines ? '\n  ' + indent : ' ',
                p
            ]
        }, i));
    if (props.children) {
        let end = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "</",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " p37ZLpd12",
                    children: name
                }),
                ">"
            ]
        });
        let children = renderChildren(props.children, indent);
        if (typeof children !== 'string') newlines = true;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                start,
                renderedProps,
                ">",
                newlines ? '\n  ' + indent : null,
                children,
                newlines ? '\n' + indent : null,
                end
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            start,
            renderedProps,
            " />"
        ]
    });
}
function renderChildren(children, indent = '') {
    if (children?.icon || children?.avatar || children?.badge) {
        let result = null;
        if (children.avatar) result = renderElement('Avatar', {
            src: 'https://i.imgur.com/xIe7Wlb.png'
        }, undefined, indent);
        else if (children.icon) result = renderElement(children.icon.replace(/^(\d)/, '_$1'), {}, undefined, indent);
        if (children.text) {
            let text = renderElement('Text', {
                children: children.text
            }, undefined, indent);
            result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    result,
                    result ? '\n  ' + indent : null,
                    text
                ]
            });
        }
        if (children.badge) {
            let badge = renderElement('NotificationBadge', {
                value: 12
            }, undefined, indent);
            result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    result,
                    result ? '\n  ' + indent : null,
                    badge
                ]
            });
        }
        return result;
    } else if (children?.text != null) return children.text;
    else if (Array.isArray(children)) return children.map((c, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                i > 0 ? '\n  ' + indent : null,
                c
            ]
        }, i));
    return children;
}
function countChars(element) {
    if (typeof element === 'string') return element.length;
    else if (Array.isArray(element)) return element.reduce((p, i)=>p + countChars(i), 0);
    else if (element && typeof element === 'object' && 'props' in element && element.props) return countChars(element.props.children);
    return 0;
}
function renderProp(name, value, control, indent = '') {
    if (value === control?.default) return null;
    let propName = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: " pz2bZib12",
        children: name
    });
    let propValue = null;
    if (typeof value === 'string') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: " p8wMsQe12",
        children: [
            '"',
            value,
            '"'
        ]
    });
    else if (typeof value === 'number') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            '{',
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pG3CxWc12",
                children: String(value)
            }),
            '}'
        ]
    });
    else if (typeof value === 'boolean') {
        if (value === false && control?.optional) return null;
        if (name === 'contextualHelp') {
            let res = renderElement('ContextualHelp', {
                children: [
                    renderElement('Heading', {
                        children: 'Heading'
                    }),
                    renderElement('Content', {
                        children: 'Content'
                    })
                ]
            }, undefined, indent + '    ');
            propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    `{\n    ${indent}`,
                    res,
                    `\n  ${indent}}`
                ]
            });
        } else propValue = value === false ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                '{',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " pplLfSc12",
                    children: String(value)
                }),
                '}'
            ]
        }) : null;
    } else if (value == null) return null;
    else if (typeof value === 'object') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            '{',
            renderValue(value, indent),
            '}'
        ]
    });
    if (propValue) propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "=",
            propValue
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            propName,
            propValue
        ]
    }, name);
}
function renderValue(value, indent = '') {
    switch(typeof value){
        case 'string':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " p8wMsQe12",
                children: [
                    '"',
                    value,
                    '"'
                ]
            });
        case 'number':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pG3CxWc12",
                children: String(value)
            });
        case 'boolean':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc12",
                children: String(value)
            });
        case 'object':
            {
                if (value == null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " pplLfSc12",
                    children: String(value)
                });
                if (Array.isArray(value)) {
                    let res = value.map((item, i)=>{
                        let result = renderValue(item, indent);
                        if (i < value.length - 1) result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                result,
                                ", "
                            ]
                        });
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                            children: result
                        }, i);
                    });
                    if (countChars(res) > 40) {
                        res = res.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                children: [
                                    '\n  ' + indent,
                                    p
                                ]
                            }, i));
                        res.push('\n  ');
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            '[',
                            res,
                            ']'
                        ]
                    });
                }
                if (value instanceof (0, _reactAriaComponents.Size)) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pplLfSc12",
                            children: "new"
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " p37ZLpd12",
                            children: "Size"
                        }),
                        "(",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pG3CxWc12",
                            children: value.width
                        }),
                        ", ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pG3CxWc12",
                            children: value.height
                        }),
                        ")"
                    ]
                });
                let entries = Object.entries(value);
                let res = entries.map(([name, value], i)=>{
                    let result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: " pz2bZib12",
                                children: name
                            }),
                            ": ",
                            renderValue(value, indent)
                        ]
                    });
                    if (i < entries.length - 1) result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            result,
                            ", "
                        ]
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                        children: result
                    }, i);
                });
                if (countChars(res) > 40) {
                    res = res.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                            children: [
                                '\n  ' + indent,
                                p
                            ]
                        }, i));
                    res.push('\n' + indent);
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        '{',
                        res,
                        '}'
                    ]
                });
            }
    }
}
function renderImports(name, importSource, props) {
    let imports = [];
    let components = [
        name
    ];
    if (props.children?.avatar) components.push('Avatar');
    if (props.children?.badge) components.push('NotificationBadge');
    if (components.length > 1 || props.children?.icon) components.push('Text');
    if (props.contextualHelp) components.push('ContextualHelp', 'Heading', 'Content');
    imports.push(renderImport(components.join(', '), importSource));
    if (props.children?.icon && !props.children?.avatar) imports.push('\n', renderImport(props.children.icon.replace(/^(\d)/, '_$1'), `@react-spectrum/s2/icons/${props.children.icon}`, true));
    imports.push('\n\n');
    return imports;
}
function renderImport(name, from, isDefault = false) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc12",
                children: "import"
            }),
            " ",
            isDefault ? null : '{',
            name,
            isDefault ? null : '}',
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc12",
                children: "from"
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " p8wMsQe12",
                children: [
                    "'",
                    from,
                    "'"
                ]
            }),
            ";"
        ]
    }, from);
}
function Control({ name }) {
    let { controls, props, setProps } = (0, _react.useContext)(Context);
    let control = controls[name];
    let value = props[name];
    let onChange = (value)=>{
        setProps((props)=>({
                ...props,
                [name]: value
            }));
    };
    switch(control.value.type){
        case 'boolean':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'union':
            if (name === 'channel' || name === 'xChannel' || name === 'yChannel') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (name === 'colorSpace') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSpaceControl, {
                control: control,
                value: value
            });
            if (name === 'placement' && control.value.elements.length === 22) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'number':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'identifier':
            if (control.value.name === 'Intl.NumberFormatOptions') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberFormatControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (name === 'contextualHelp') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (control.value.name === 'ReactNode') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChildrenControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            break;
        case 'string':
            if (name === 'locale') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocaleControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'interface':
            if (control.value.name === 'DateDuration') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (control.value.name === 'Size') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SizeControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            break;
        case 'array':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrayControl, {
                control: control,
                valueType: control.value.elementType,
                value: value,
                onChange: onChange
            });
        case 'application':
            if (control.value.base.type === 'identifier' && (control.value.base.name === 'ReadonlyArray' || control.value.base.name === 'Array')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrayControl, {
                control: control,
                value: value,
                valueType: control.value.typeParameters[0],
                onChange: onChange
            });
        default:
            if (name === 'children') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            console.warn(control);
    }
}
function BooleanControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Switch), {
            isSelected: value || false,
            onChange: onChange,
            "aria-label": control.name
        })
    });
}
function UnionControl({ control, value, onChange, isPicker = false }) {
    let length = control.value.elements.reduce((p, v)=>p + v.value, '').length;
    if (isPicker || control.options?.control === 'picker' || length > 18) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value == null && control.optional && !control.default ? '__none' : value,
        onChange: (v)=>onChange(v === '__none' ? null : v),
        styles: " ZVouohd12",
        children: [
            control.optional && !control.default ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                id: "__none",
                children: "Default"
            }) : null,
            control.value.elements.filter((e)=>e.value).map((element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                    id: element.value,
                    children: String(element.value)
                }, element.value))
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: function anonymous(props) {
            let rules = " ";
            rules += ' z2mU12';
            if (props.isLong) rules += ' yzZKy12';
            else rules += ' y2mU12';
            return rules;
        }({
            isLong: length > 12 || control.value.elements.length > 3
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButtonGroup), {
            "aria-label": control.name,
            disallowEmptySelection: !control.optional || !!control.default,
            selectedKeys: [
                value
            ],
            onSelectionChange: (keys)=>onChange([
                    ...keys
                ][0]),
            density: "compact",
            styles: " Js12 Gs12",
            children: control.value.elements.map((element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                    id: element.value,
                    styles: " _ub12 _upa12",
                    children: element.value
                }, element.value))
        })
    });
}
function Wrapper({ control, children, styles, ref }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: (0, _runtime.mergeStyles)(" sd12 _ta12 Ub12 qb12", styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xb12 _xa12 _Fd12 _FnuYUweb12 pv12 __Za12",
                children: [
                    control.name,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: " _7c12",
                        children: [
                            "\xa0",
                            control.description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    display: 'inline-flex'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
                                    control: control
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            children
        ]
    });
}
function PropContextualHelp({ control }) {
    if (!control.description) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ContextualHelp), {
        variant: "info",
        size: "XS",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                children: control.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                children: control.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Footer), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    className: " uj12 -_6BNtrc-b12 vx12 xb12 _xa12 _Fb12 _FnuYUwec12 pt12",
                    children: control.valueType
                })
            })
        ]
    });
}
function NumberControl({ control, value, onChange }) {
    if (control.options?.control === 'slider') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value,
        onChange: onChange,
        styles: " ZVouohd12"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
        label: control.name,
        placeholder: "\u2013",
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value,
        onChange: onChange,
        styles: " ZVouohd12",
        minValue: control.options?.minValue,
        maxValue: control.options?.maxValue,
        formatOptions: control.name === 'delay' || control.name === 'closeDelay' ? {
            style: 'unit',
            unit: 'millisecond'
        } : undefined
    });
}
function NumberFormatControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: control.name,
                contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
                    control: control
                }),
                value: value?.style || 'decimal',
                onChange: (id)=>{
                    switch(id){
                        case 'decimal':
                            onChange({
                                style: 'decimal'
                            });
                            break;
                        case 'percent':
                            onChange({
                                style: 'percent'
                            });
                            break;
                        case 'currency':
                            onChange({
                                style: 'currency',
                                currency: 'USD'
                            });
                            break;
                        case 'unit':
                            onChange({
                                style: 'unit',
                                unit: 'inch'
                            });
                            break;
                    }
                },
                styles: " ZVouohd12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "decimal",
                        children: "Decimal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "percent",
                        children: "Percent"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "currency",
                        children: "Currency"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "unit",
                        children: "Unit"
                    })
                ]
            }),
            control.options?.showDetails && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.RangeSlider), {
                        label: "Decimals",
                        value: {
                            start: value?.minimumFractionDigits ?? 0,
                            end: value?.maximumFractionDigits ?? 5
                        },
                        minValue: 0,
                        maxValue: 5,
                        onChange: (v)=>onChange({
                                ...value,
                                minimumFractionDigits: v.start,
                                maximumFractionDigits: v.end
                            }),
                        styles: " ZVouohd12"
                    }),
                    value?.style === 'decimal' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                        label: "Sign Display",
                        value: value?.signDisplay ?? 'auto',
                        onChange: (signDisplay)=>onChange({
                                ...value,
                                signDisplay
                            }),
                        styles: " ZVouohd12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "auto",
                                children: "Auto"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "always",
                                children: "Always"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "exceptZero",
                                children: "Except zero"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "negative",
                                children: "Negative"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "never",
                                children: "Never"
                            })
                        ]
                    }),
                    value?.style === 'currency' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBox), {
                                label: "Currency",
                                selectedKey: value.currency,
                                onSelectionChange: (currency)=>onChange({
                                        ...value,
                                        currency
                                    }),
                                styles: " ZVouohd12",
                                children: Intl.supportedValuesOf('currency').map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                        id: c,
                                        children: c
                                    }, c))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                                control: {
                                    name: 'Currency Display',
                                    optional: true,
                                    default: 'symbol',
                                    value: {
                                        elements: [
                                            {
                                                value: 'code'
                                            },
                                            {
                                                value: 'symbol'
                                            },
                                            {
                                                value: 'narrowSymbol'
                                            },
                                            {
                                                value: 'name'
                                            }
                                        ]
                                    }
                                },
                                value: value.currencyDisplay ?? 'symbol',
                                onChange: (currencyDisplay)=>onChange({
                                        ...value,
                                        currencyDisplay
                                    })
                            })
                        ]
                    }),
                    value?.style === 'unit' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBox), {
                                label: "Unit",
                                selectedKey: value.unit,
                                onSelectionChange: (unit)=>onChange({
                                        ...value,
                                        unit
                                    }),
                                styles: " ZVouohd12",
                                children: Intl.supportedValuesOf('unit').map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                        id: c,
                                        children: c
                                    }, c))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                                control: {
                                    name: 'Unit Display',
                                    optional: true,
                                    default: 'short',
                                    value: {
                                        elements: [
                                            {
                                                value: 'narrow'
                                            },
                                            {
                                                value: 'short'
                                            },
                                            {
                                                value: 'long'
                                            }
                                        ]
                                    }
                                },
                                value: value.unitDisplay ?? 'short',
                                onChange: (unitDisplay)=>onChange({
                                        ...value,
                                        unitDisplay
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function StringControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
        label: control.name,
        placeholder: "\u2013",
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value || '',
        onChange: onChange,
        styles: " ZVouohd12"
    });
}
function ChildrenControl({ control, value, onChange }) {
    if (control.slots) {
        let objectValue = typeof value === 'string' ? {
            text: value
        } : value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
            control: control,
            styles: " z2mU12 yzZKy12",
            children: [
                control.slots.icon && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd12 Ub12 qb12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
                            "aria-label": control.name,
                            placeholder: "\u2013",
                            value: objectValue?.text || '',
                            onChange: (text)=>onChange({
                                    ...objectValue,
                                    text
                                }),
                            styles: " ZKniM12 _ub12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconPicker, {
                            value: value,
                            onChange: onChange
                        })
                    ]
                }),
                (control.slots.avatar || control.slots.badge) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                    density: "compact",
                    isJustified: true,
                    children: [
                        control.slots.avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                            isSelected: objectValue?.avatar ?? false,
                            onChange: (avatar)=>onChange({
                                    ...objectValue,
                                    avatar
                                }),
                            children: "Avatar"
                        }),
                        control.slots.badge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                            isSelected: objectValue?.badge ?? false,
                            onChange: (badge)=>onChange({
                                    ...objectValue,
                                    badge
                                }),
                            children: "Badge"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
        control: control,
        value: value,
        onChange: onChange
    });
}
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    // Tier 1
    {
        value: 'fr-FR'
    },
    {
        value: 'fr-CA'
    },
    {
        value: 'de-DE'
    },
    {
        value: 'en-US'
    },
    {
        value: 'en-GB'
    },
    {
        value: 'ja-JP',
        ordering: 'gregory japanese'
    },
    // // Tier 2
    {
        value: 'da-DK'
    },
    {
        value: 'nl-NL'
    },
    {
        value: 'fi-FI'
    },
    {
        value: 'it-IT'
    },
    {
        value: 'nb-NO'
    },
    {
        value: 'es-ES'
    },
    {
        value: 'sv-SE'
    },
    {
        value: 'pt-BR'
    },
    // // Tier 3
    {
        value: 'zh-CN'
    },
    {
        value: 'zh-TW',
        ordering: 'gregory roc chinese'
    },
    {
        value: 'ko-KR'
    },
    // // Tier 4
    {
        value: 'bg-BG'
    },
    {
        value: 'hr-HR'
    },
    {
        value: 'cs-CZ'
    },
    {
        value: 'et-EE'
    },
    {
        value: 'hu-HU'
    },
    {
        value: 'lv-LV'
    },
    {
        value: 'lt-LT'
    },
    {
        value: 'pl-PL'
    },
    {
        value: 'ro-RO'
    },
    {
        value: 'ru-RU'
    },
    {
        value: 'sr-SP'
    },
    {
        value: 'sk-SK'
    },
    {
        value: 'sl-SI'
    },
    {
        value: 'tr-TR'
    },
    {
        value: 'uk-UA'
    },
    // // Tier 5
    {
        value: 'ar-AE',
        ordering: 'gregory islamic-umalqura islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-DZ',
        ordering: 'gregory islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-EG',
        ordering: 'gregory coptic islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-SA',
        ordering: 'islamic-umalqura gregory islamic islamic-rgsa'
    },
    {
        value: 'el-GR'
    },
    {
        value: 'he-IL',
        ordering: 'gregory hebrew islamic islamic-civil islamic-tbla'
    },
    {
        value: 'fa-AF',
        ordering: 'persian gregory islamic islamic-civil islamic-tbla'
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        value: 'am-ET',
        ordering: 'gregory ethiopic ethioaa'
    },
    {
        value: 'hi-IN',
        ordering: 'gregory indian'
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        value: 'th-TH',
        ordering: 'buddhist gregory'
    }
];
const calendars = [
    {
        key: 'gregory',
        name: 'Gregorian'
    },
    {
        key: 'japanese',
        name: 'Japanese'
    },
    {
        key: 'buddhist',
        name: 'Buddhist'
    },
    {
        key: 'roc',
        name: 'Taiwan'
    },
    {
        key: 'persian',
        name: 'Persian'
    },
    {
        key: 'indian',
        name: 'Indian'
    },
    {
        key: 'islamic-umalqura',
        name: 'Islamic (Umm al-Qura)'
    },
    {
        key: 'islamic-civil',
        name: 'Islamic Civil'
    },
    {
        key: 'islamic-tbla',
        name: 'Islamic Tabular'
    },
    {
        key: 'hebrew',
        name: 'Hebrew'
    },
    {
        key: 'coptic',
        name: 'Coptic'
    },
    {
        key: 'ethiopic',
        name: 'Ethiopic'
    },
    {
        key: 'ethioaa',
        name: 'Ethiopic (Amete Alem)'
    }
];
function matchLocale(defaultLocale) {
    let parsed;
    try {
        parsed = new Intl.Locale(defaultLocale);
    } catch  {
        return 'en-US';
    }
    let locales = preferences.map((p)=>new Intl.Locale(p.value));
    // Try with both language and region first, and if that fails, try again with just language
    let p = locales.find((locale)=>locale.language === parsed.language && locale.region === parsed.region) || locales.find((locale)=>locale.language === parsed.language);
    return p?.toString() || 'en-US';
}
function LocaleControl({ control, value, onChange }) {
    let { locale: defaultLocale } = (0, _reactAria.useLocale)();
    let langDisplay = (0, _react.useMemo)(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'language'
        }), [
        defaultLocale
    ]);
    let regionDisplay = (0, _react.useMemo)(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'region'
        }), [
        defaultLocale
    ]);
    let locales = (0, _react.useMemo)(()=>{
        return preferences.map((item)=>{
            let locale = new Intl.Locale(item.value);
            return {
                ...item,
                label: `${langDisplay.of(locale.language)} (${regionDisplay.of(locale.region)})`
            };
        }).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        langDisplay,
        regionDisplay
    ]);
    let matched = (0, _react.useMemo)(()=>matchLocale(value), [
        value
    ]);
    let pref = preferences.find((p)=>p.value === matched);
    // @ts-ignore there cannot be any undefined values in the array
    let preferredCalendars = (0, _react.useMemo)(()=>pref ? (pref.ordering || 'gregory').split(' ').map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _react.useMemo)(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p?.key === c.key)), [
        preferredCalendars
    ]);
    let extension = control.options ?? 'calendar';
    let updateLocale = (locale)=>{
        let calendar, numberingSystem;
        if (extension === 'calendar') calendar = (preferences.find((p)=>p.value === locale)?.ordering || 'gregory').split(' ')[0];
        else if (extension === 'numberingSystem') {
            numberingSystem = new Intl.NumberFormat(locale).resolvedOptions().numberingSystem;
            if (numberingSystem === 'arabext') numberingSystem = 'arab';
        }
        let newLocale = new Intl.Locale(locale, {
            calendar,
            numberingSystem
        });
        onChange(newLocale.toString());
    };
    let updateCalendar = (calendar)=>{
        let newLocale = new Intl.Locale(value, {
            calendar
        });
        onChange(newLocale.toString());
    };
    let updateNumberingSystem = (numberingSystem)=>{
        let newLocale = new Intl.Locale(value, {
            numberingSystem
        });
        onChange(newLocale.toString());
    };
    let lang = null;
    let calendar = null;
    let numberingSystem = null;
    if (value) {
        let locale = new Intl.Locale(value);
        lang = locale.baseName;
        calendar = locale.calendar || null;
        numberingSystem = locale.numberingSystem || null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Picker), {
                label: "Locale",
                items: locales,
                value: lang,
                onChange: updateLocale,
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: item.value,
                        children: item.label
                    })
            }),
            extension === 'calendar' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: "Calendar",
                value: calendar,
                onChange: updateCalendar,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.PickerSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Preferred"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                                items: preferredCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                        children: item.name
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.PickerSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Other"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                                items: otherCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                        children: item.name
                                    })
                            })
                        ]
                    })
                ]
            }),
            extension === 'numberingSystem' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: "Numbering system",
                value: numberingSystem,
                onChange: updateNumberingSystem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "latn",
                        children: "Latin"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "arab",
                        children: "Arabic"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "hanidec",
                        children: "Hanidec"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "deva",
                        children: "Devanagari"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "beng",
                        children: "Bengali"
                    })
                ]
            })
        ]
    });
}
function DurationControl({ control, value, onChange }) {
    // For now we only care about months.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
        label: control.name,
        placeholder: "\u2013",
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value.months,
        minValue: 1,
        onChange: (months)=>onChange({
                months
            }),
        styles: " ZVouohd12",
        formatOptions: {
            style: 'unit',
            unit: 'month',
            unitDisplay: 'long'
        }
    });
}
function ChannelControl({ control, value, onChange }) {
    let { props } = (0, _react.useContext)(Context);
    let colorSpace = props.colorSpace;
    if (!colorSpace && props.defaultValue) {
        let color = typeof props.defaultValue === 'string' ? (0, _reactStately.parseColor)(props.defaultValue) : props.defaultValue;
        colorSpace = color.getColorSpace();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
        isPicker: true,
        control: {
            ...control,
            value: {
                type: 'union',
                elements: [
                    ...(0, _reactStately.getColorChannels)(colorSpace).map((v)=>({
                            type: 'string',
                            value: v
                        })),
                    {
                        type: 'string',
                        value: 'alpha'
                    }
                ]
            }
        },
        value: value,
        onChange: onChange
    });
}
function ColorSpaceControl({ control, value }) {
    let { setProps } = (0, _react.useContext)(Context);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
        control: {
            ...control,
            optional: false
        },
        value: value,
        onChange: (colorSpace)=>{
            setProps((props)=>{
                props = {
                    ...props,
                    colorSpace
                };
                if (props.channel) props.channel = (0, _reactStately.getColorChannels)(colorSpace)[0];
                delete props.xChannel;
                delete props.yChannel;
                return props;
            });
        }
    });
}
function PlacementControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: " z2mU12 yzZKy12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBox), {
            "aria-label": control.name,
            layout: "grid",
            selectionMode: "single",
            disallowEmptySelection: true,
            selectedKeys: [
                value
            ],
            onSelectionChange: (keys)=>onChange([
                    ...keys
                ][0]),
            className: "",
            style: {
                display: 'grid',
                gridTemplateAreas: `
            ".  ts tc te . "
            "st .  .  .  et"
            "sc .  .  .  ec"
            "sb .  .  .  eb"
            ".  bs bc be . "
          `,
                gridTemplateColumns: '25px 24px 24px 25px 24px',
                gridTemplateRows: '25px 24px 24px 25px 24px'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top start",
                    style: {
                        gridArea: 'ts'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top",
                    style: {
                        gridArea: 'tc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top end",
                    style: {
                        gridArea: 'te'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start top",
                    style: {
                        gridArea: 'st'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end top",
                    style: {
                        gridArea: 'et'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start",
                    style: {
                        gridArea: 'sc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end",
                    style: {
                        gridArea: 'ec'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start bottom",
                    style: {
                        gridArea: 'sb'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end bottom",
                    style: {
                        gridArea: 'eb'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom start",
                    style: {
                        gridArea: 'bs'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom",
                    style: {
                        gridArea: 'bc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom end",
                    style: {
                        gridArea: 'be'
                    }
                })
            ]
        })
    });
}
function PlacementControlItem(props1) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props1,
        "aria-label": props1.id,
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf12';
            else rules += ' _Le12';
            rules += ' Oh12';
            rules += ' _Mc12';
            rules += ' _Kd12';
            rules += ' Zo12';
            rules += ' Fp12';
            rules += ' Yd12';
            rules += ' Xb12';
            rules += ' _2b12';
            if (props.isSelected) rules += ' g012';
            else {
                if (props.isPressed) rules += ' gF12';
                else if (props.isFocusVisible) rules += ' gF12';
                else if (props.isHovered) rules += ' gF12';
                else rules += ' gH12';
            }
            if (props.isSelected) rules += ' px12';
            else rules += ' pt12';
            if (props.isFocusVisible) rules += ' _9c12';
            else rules += ' _9b12';
            return rules;
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: " Za12 Fb12 _Lf12 OOIem5c12 _Mb12"
        })
    });
}
function ArrayControl({ control, valueType, value = [], onChange }) {
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
        ref: ref,
        control: control,
        styles: " z2mU12 yzZKy12 ZNqBXK12",
        children: [
            value.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                size: "S",
                "aria-label": "Add item",
                styles: " _de12",
                onPress: ()=>{
                    (0, _reactDom.flushSync)(()=>onChange([
                            ''
                        ]));
                    ref.current?.querySelector('input')?.focus();
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCircleDefault.default), {})
            }),
            value.map((item, index)=>{
                let rendered;
                switch(valueType.type){
                    case 'string':
                        rendered = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
                            "aria-label": `${control.name}, item ${index}`,
                            size: "S",
                            styles: " _ub12",
                            value: item,
                            onChange: (newValue)=>{
                                let arr = [
                                    ...value
                                ];
                                arr[index] = newValue;
                                onChange(arr);
                            }
                        });
                        break;
                    default:
                        console.warn('unknown array element type', valueType);
                        return null;
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd12 Ub12 qb12",
                    children: [
                        rendered,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                            size: "S",
                            "aria-label": "Add item after",
                            onPress: ()=>{
                                let arr = [
                                    ...value
                                ];
                                arr.splice(index + 1, 0, '');
                                (0, _reactDom.flushSync)(()=>onChange(arr));
                                ref.current?.querySelectorAll('input')[index + 1]?.focus();
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCircleDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                            size: "S",
                            "aria-label": "Remove item",
                            onPress: ()=>{
                                let arr = [
                                    ...value
                                ];
                                arr.splice(index, 1);
                                (0, _reactDom.flushSync)(()=>onChange(arr));
                                if (arr.length > 0) ref.current?.querySelectorAll('input')[Math.min(arr.length - 1, index)]?.focus();
                                else ref.current?.querySelector('button')?.focus();
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeCircleDefault.default), {})
                        })
                    ]
                }, index);
            })
        ]
    });
}
function SizeControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: " z2mU12 yzZKy12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: " sd12 Ub12 qb12 ZVouohd12",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                    "aria-label": "Width",
                    placeholder: "\u2013",
                    value: value?.width,
                    onChange: (width)=>onChange(new (0, _reactAriaComponents.Size)(width, value?.height ?? 0)),
                    styles: " _vb12 _ub12",
                    hideStepper: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                    "aria-label": "Height",
                    placeholder: "\u2013",
                    value: value?.height,
                    onChange: (height)=>onChange(new (0, _reactAriaComponents.Size)(value?.width ?? 0, height)),
                    styles: " _vb12 _ub12",
                    hideStepper: true
                })
            ]
        })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","9":"4oKuc","10":"4oKuc","11":"4oKuc","12":"4oKuc","13":"4oKuc","14":"4oKuc","15":"4oKuc","16":"4oKuc","17":"4oKuc","18":"4oKuc","19":"4oKuc","20":"4oKuc","21":"4oKuc","22":"4oKuc","23":"4oKuc","24":"4oKuc","25":"4oKuc","26":"4oKuc","27":"4oKuc","28":"4oKuc","29":"4oKuc","30":"4oKuc","31":"4oKuc","32":"4oKuc","33":"4oKuc","34":"4oKuc","35":"4oKuc","36":"4oKuc","37":"4oKuc","38":"4oKuc","39":"4oKuc","40":"4oKuc","41":"4oKuc","42":"4oKuc","43":"4oKuc","44":"4oKuc","45":"4oKuc","46":"4oKuc","47":"4oKuc","48":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Avatar","f3T9F"],["Collection","2Jd0Q"],["ComboBox","9azF3"],["ComboBoxItem","9azF3"],["Content","10r6w"],["Footer","10r6w"],["Header","10r6w"],["Heading","10r6w"],["Text","10r6w"],["ContextualHelp","5GtuV"],["NotificationBadge","czhBl"],["NumberField","kptFj"],["Picker","akpch"],["PickerItem","akpch"],["PickerSection","akpch"],["RangeSlider","9SuNb"],["Slider","ixJJx"],["Switch","dIOQS"],["TextField","7oxrW"],["ToggleButton","6wKQe"],["ToggleButtonGroup","Df7oZ"]],"@react-spectrum/s2/icons/AddCircle":"k8LxT","./CodePlatter":"hi4fC","./ExampleOutput":"lHe2T","./ExampleSwitcher":"kHsTJ","react-dom":"gC2PC","react-stately":"71wqN","react-aria-components":[["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["Size","F8cca"]],"../../../@react-spectrum/s2/style/runtime":"8g9no","react":"a1TxN","@react-spectrum/s2/icons/RemoveCircle":"8rNDD","react-aria":"4k4z8","78276cdf15345291":"6Hb2X","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kptFj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFieldContext", ()=>NumberFieldContext);
parcelHelpers.export(exports, "NumberField", ()=>NumberField);
var _jsxRuntime = require("react/jsx-runtime");
var _add = require("../ui-icons/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _dash = require("../ui-icons/Dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _field = require("./Field");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const NumberFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-oa12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' sd12';
    rules += ' _Le12';
    rules += ' _Wa12';
    rules += ' _je12';
    rules += ' eb12';
    rules += ' _Ca12';
    if (props.size === "XL") rules += ' ZC12';
    else if (props.size === "L") rules += ' Zo12';
    else if (props.size === "M") rules += ' Zm12';
    else if (props.size === "S") rules += ' Zu12';
    rules += ' Fd12';
    if (props.type === "increment") rules += ' Iy12';
    else rules += ' Iw12';
    rules += ' fa12';
    rules += ' _va12';
    rules += ' Ma12';
    rules += ' Yd12';
    rules += ' Yle12';
    rules += ' Xb12';
    rules += ' Xlb12';
    rules += ' _2b12';
    rules += ' _2lb12';
    if (props.isDisabled) rules += ' gH12';
    else {
        if (props.isPressed) rules += ' gF12';
        else if (props.isFocusVisible) rules += ' gF12';
        else if (props.isHovered) rules += ' gF12';
        else rules += ' gH12';
    }
    if (props.isDisabled) rules += ' gld12';
    else if (props.isHovered) rules += ' gle12';
    else rules += ' glc12';
    if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' pla12';
    rules += ' ri12';
    return rules;
};
const iconStyles = " _va12 -_8sjo0b-t5ZbAob12";
const stepperContainerStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sd12';
    rules += ' _tc12';
    if (props.size === "XL") rules += ' Ue12';
    else if (props.size === "L") rules += ' Ue12';
    else if (props.size === "M") rules += ' Ub12';
    else if (props.size === "S") rules += ' Ue12';
    if (props.size === "XL") rules += ' qe12';
    else if (props.size === "L") rules += ' qe12';
    else if (props.size === "M") rules += ' qb12';
    else if (props.size === "S") rules += ' qe12';
    if (props.size === "XL") rules += ' HWJpoB12';
    else if (props.size === "L") rules += ' HWJpoB12';
    else if (props.size === "M") rules += ' Hs12';
    else if (props.size === "S") rules += ' Hr12';
    return rules;
};
const NumberField = /*#__PURE__*/ (0, _react.forwardRef)(function NumberField(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, NumberFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, hideStepper, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...numberFieldProps } = props1;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let decrementButtonRef = (0, _react.useRef)(null);
    let incrementButtonRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.NumberField), {
        ref: domRef,
        isRequired: isRequired,
        ...numberFieldProps,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                }
            }
            if (props.isInForm) rules += ' DLwlgod12';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb12';
                else if (props.labelPosition === "top") rules += ' DM8Mfn12';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb12';
            else if (props.labelPosition === "top") rules += ' E4w1sLc12';
            if (props.labelPosition === "side") rules += ' CbRM95c12';
            else if (props.labelPosition === "top") rules += ' Cxaocre12';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                rules += ' vx12';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                rules += ' vx12';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                rules += ' vx12';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                rules += ' vx12';
            } else {
                rules += ' -_6BNtrc-c12';
                rules += ' vx12';
            }
            rules += ' ea12';
            rules += ' _Fd12';
            rules += ' _FnuYUweb12';
            if (props.size === "XL") rules += ' -BhX7R-Fz12';
            else if (props.size === "L") rules += ' -BhX7R-Fv12';
            else if (props.size === "S") rules += ' -BhX7R-Fp12';
            else if (props.size === "XS") rules += ' -BhX7R-Fn12';
            else rules += ' -BhX7R-Fx12';
            rules += ' -AJjOLd-UVkF0Db12';
            rules += ' qg12';
            rules += ' __ca12';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, props1.styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr12';
                            rules += ' yXcEWr12';
                            rules += ' BXcEWr12';
                            rules += ' AXcEWr12';
                            if (props.size === "XL") rules += ' Nl12';
                            else if (props.size === "L") rules += ' Nj12';
                            else if (props.size === "S") rules += ' Nf12';
                            else if (props.size === "XS") rules += ' Ne12';
                            else rules += ' Nk12';
                            if (props.isQuiet) rules += ' _qd12';
                            else rules += ' _qtb12';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt12';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne12';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr12';
                            else rules += ' -Anxdcc-Z3fn9H12';
                            rules += ' __v6TNLWb12';
                            rules += ' SMBFGYc12';
                            rules += ' RfBFGYc12';
                            rules += ' -S_-Sv12';
                            if (props.isStepperHidden) rules += ' -R_-Rv12';
                            else rules += ' -R_-Rd12';
                            return rules;
                        }({
                            size,
                            isStepperHidden: hideStepper
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                                children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                        value: {
                                            ...ctx,
                                            ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {})
                                    })
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            }),
                            !hideStepper && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: stepperContainerStyles({
                                    size
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepButton, {
                                        ref: decrementButtonRef,
                                        slot: "decrement",
                                        style: (renderProps)=>(0, _pressScale.pressScale)(decrementButtonRef)(renderProps),
                                        className: (renderProps)=>inputButton({
                                                ...renderProps,
                                                type: 'decrement',
                                                size
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashDefault.default), {
                                            size: size,
                                            className: iconStyles
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepButton, {
                                        ref: incrementButtonRef,
                                        slot: "increment",
                                        style: (renderProps)=>(0, _pressScale.pressScale)(incrementButtonRef)(renderProps),
                                        className: (renderProps)=>inputButton({
                                                ...renderProps,
                                                type: 'increment',
                                                size
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                                            size: size,
                                            className: iconStyles
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});
const additionalButtonHTMLAttributes = new Set([
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'name',
    'value'
]);
let StepButton = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    [props, ref] = (0, _reactAriaComponents.useContextProps)(props, ref, (0, _reactAriaComponents.ButtonContext));
    let ctx = props;
    /**
   * Must use div for now because Safari pointer event bugs on disabled form elements.
   * Link https://bugs.webkit.org/show_bug.cgi?id=219188.
   */ let { buttonProps, isPressed } = (0, _reactAria.useButton)({
        ...props,
        elementType: 'div'
    }, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)(props);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = useRenderProps({
        ...props,
        values: {
            isHovered,
            isPressed,
            isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false
        },
        defaultClassName: 'react-aria-Button'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils1.filterDOMProps)(props, {
            propNames: additionalButtonHTMLAttributes
        }),
        ...(0, _utils1.mergeProps)(buttonProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": ctx.isPressed || isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
});
// replace from RAC
function useRenderProps(props) {
    let { className, style, children, defaultClassName, defaultChildren, defaultStyle, values } = props;
    return (0, _react.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName ?? defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren ?? defaultChildren,
            'data-rac': ''
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values
    ]);
}

},{"0":"iXP0o","1":"goHnK","2":"38GPZ","3":"d7amk","4":"3KuXr","react/jsx-runtime":"2Is6Z","../ui-icons/Add":"1Tnir","react-aria-components":[["ButtonContext","9G5XO"],["InputContext","jU9y1"],["NumberField","7hOK8"],["useContextProps","bA6Cz"]],"react":"a1TxN","@react-spectrum/utils":"jqfrX","../ui-icons/Dash":"NC9AJ","./Field":"eI7CE","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["mergeRefs","1vHgg"]],"./Form":"cHqN4","./pressScale":"8Ufux","react-aria":[["useButton","exEOU"],["useFocusRing","6TXyU"],["useHover","k6FLA"]],"./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iXP0o":[function() {},{}],"goHnK":[function() {},{}],"38GPZ":[function() {},{}],"d7amk":[function() {},{}],"3KuXr":[function() {},{}],"1Tnir":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Add);
var _jsxRuntime = require("react/jsx-runtime");
var _s2AddSize200Svg = require("./S2_AddSize200.svg");
var _s2AddSize200SvgDefault = parcelHelpers.interopDefault(_s2AddSize200Svg);
var _s2AddSize100Svg = require("./S2_AddSize100.svg");
var _s2AddSize100SvgDefault = parcelHelpers.interopDefault(_s2AddSize100Svg);
var _s2AddSize75Svg = require("./S2_AddSize75.svg");
var _s2AddSize75SvgDefault = parcelHelpers.interopDefault(_s2AddSize75Svg);
var _s2AddSize300Svg = require("./S2_AddSize300.svg");
var _s2AddSize300SvgDefault = parcelHelpers.interopDefault(_s2AddSize300Svg);
var _s2AddSize50Svg = require("./S2_AddSize50.svg");
var _s2AddSize50SvgDefault = parcelHelpers.interopDefault(_s2AddSize50Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zh12';
    else if (props.size === "XS") rules += ' Zh12';
    else if (props.size === "XL") rules += ' Zj12';
    else if (props.size === "L") rules += ' Zj12';
    else if (props.size === "M") rules += ' Zi12';
    if (props.size === "S") rules += ' Fi12';
    else if (props.size === "XS") rules += ' Fi12';
    else if (props.size === "XL") rules += ' Fk12';
    else if (props.size === "L") rules += ' Fk12';
    else if (props.size === "M") rules += ' Fj12';
    return rules;
};
function Add(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize50SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AddSize75SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"jBbST","react/jsx-runtime":"2Is6Z","./S2_AddSize200.svg":"9jFfI","./S2_AddSize100.svg":"7LAa1","./S2_AddSize75.svg":"5IOHQ","./S2_AddSize300.svg":"JVk80","./S2_AddSize50.svg":"e6cOb","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jBbST":[function() {},{}],"9jFfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.021 4.959h-2.98v-2.98a1.04 1.04 0 1 0-2.082 0v2.98h-2.98a1.04 1.04 0 1 0 0 2.082h2.98v2.98a1.04 1.04 0 1 0 2.082 0v-2.98h2.98a1.04 1.04 0 1 0 0-2.082"
        })
    });
exports.default = SvgS2AddSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7LAa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.5 4H6V1.5a1 1 0 1 0-2 0V4H1.5a1 1 0 1 0 0 2H4v2.5a1 1 0 1 0 2 0V6h2.5a1 1 0 1 0 0-2"
        })
    });
exports.default = SvgS2AddSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5IOHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7 3.04H4.96V1a.96.96 0 1 0-1.92 0v2.04H1a.96.96 0 1 0 0 1.92h2.04V7a.96.96 0 1 0 1.92 0V4.96H7a.96.96 0 1 0 0-1.92"
        })
    });
exports.default = SvgS2AddSize75;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"JVk80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.61 4.915H7.085V1.39a1.084 1.084 0 1 0-2.17 0v3.525H1.39a1.084 1.084 0 1 0 0 2.17h3.525v3.525a1.084 1.084 0 1 0 2.17 0V7.085h3.525a1.084 1.084 0 1 0 0-2.17"
        })
    });
exports.default = SvgS2AddSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e6cOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AddSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.625 3.078H4.922V1.375a.922.922 0 0 0-1.844 0v1.703H1.375a.922.922 0 0 0 0 1.844h1.703v1.703a.922.922 0 0 0 1.844 0V4.922h1.703a.922.922 0 0 0 0-1.844"
        })
    });
exports.default = SvgS2AddSize50;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7hOK8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFieldContext", ()=>NumberFieldContext);
parcelHelpers.export(exports, "NumberFieldStateContext", ()=>NumberFieldStateContext);
parcelHelpers.export(exports, "NumberField", ()=>NumberField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const NumberFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const NumberFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const NumberField = /*#__PURE__*/ (0, _react.forwardRef)(function NumberField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, NumberFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useNumberFieldState)({
        ...props,
        locale,
        validationBehavior
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps, groupProps, inputProps, incrementButtonProps, decrementButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useNumberField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-NumberField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                NumberFieldStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                groupProps
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        increment: incrementButtonProps,
                        decrement: decrementButtonProps
                    }
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": validation.isInvalid || undefined
    }), props.name && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: props.name,
        form: props.form,
        value: isNaN(state.numberValue) ? '' : state.numberValue,
        disabled: props.isDisabled || undefined
    }));
});

},{"react-aria":[["useLocale","4k4z8"],["useNumberField","7QmQx"]],"./Button":"9G5XO","./utils":"bA6Cz","./FieldError":"algyu","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react-stately":"kM0E9","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7QmQx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a number field component.
 * Number fields allow users to enter a number, and increment or decrement the value using stepper buttons.
 */ parcelHelpers.export(exports, "useNumberField", ()=>useNumberField);
var _utils = require("@react-aria/utils");
var _react = require("react");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _form = require("@react-stately/form");
var _interactions = require("@react-aria/interactions");
var _textfield = require("@react-aria/textfield");
var _i18N = require("@react-aria/i18n");
var _spinbutton = require("@react-aria/spinbutton");
function useNumberField(props, state, inputRef) {
    let { id, decrementAriaLabel, incrementAriaLabel, isDisabled, isReadOnly, isRequired, minValue, maxValue, autoFocus, label, formatOptions, onBlur = ()=>{}, onFocus, onFocusChange, onKeyDown, onKeyUp, description, errorMessage, isWheelDisabled, ...otherProps } = props;
    let { increment, incrementToMax, decrement, decrementToMin, numberValue, inputValue, commit, commitValidation } = state;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/numberfield');
    let inputId = (0, _utils.useId)(id);
    let { focusProps } = (0, _interactions.useFocus)({
        onBlur () {
            // Set input value to normalized valid value
            commit();
        }
    });
    let numberFormatter = (0, _i18N.useNumberFormatter)(formatOptions);
    let intlOptions = (0, _react.useMemo)(()=>numberFormatter.resolvedOptions(), [
        numberFormatter
    ]);
    // Replace negative textValue formatted using currencySign: 'accounting'
    // with a textValue that can be announced using a minus sign.
    let textValueFormatter = (0, _i18N.useNumberFormatter)({
        ...formatOptions,
        currencySign: undefined
    });
    let textValue = (0, _react.useMemo)(()=>isNaN(numberValue) ? '' : textValueFormatter.format(numberValue), [
        textValueFormatter,
        numberValue
    ]);
    let { spinButtonProps, incrementButtonProps: incButtonProps, decrementButtonProps: decButtonProps } = (0, _spinbutton.useSpinButton)({
        isDisabled,
        isReadOnly,
        isRequired,
        maxValue,
        minValue,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: numberValue,
        textValue
    });
    let [focusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, _react.useCallback)((e)=>{
        // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
        // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
        // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
        // especially if the user is scrolling near 45deg
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, _interactions.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, inputRef);
    // The inputMode attribute influences the software keyboard that is shown on touch devices.
    // Browsers and operating systems are quite inconsistent about what keys are available, however.
    // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
    // and based on testing on various devices to determine what keys are available in each inputMode.
    let hasDecimals = (intlOptions.maximumFractionDigits ?? 0) > 0;
    let hasNegative = state.minValue === undefined || isNaN(state.minValue) || state.minValue < 0;
    let inputMode = 'numeric';
    if ((0, _utils.isIPhone)()) {
        // iPhone doesn't have a minus sign in either numeric or decimal.
        // Note this is only for iPhone, not iPad, which always has both
        // minus and decimal in numeric.
        if (hasNegative) inputMode = 'text';
        else if (hasDecimals) inputMode = 'decimal';
    } else if ((0, _utils.isAndroid)()) {
        // Android numeric has both a decimal point and minus key.
        // decimal does not have a minus key.
        if (hasNegative) inputMode = 'numeric';
        else if (hasDecimals) inputMode = 'decimal';
    }
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let domProps = (0, _utils.filterDOMProps)(props);
    let onKeyDownEnter = (0, _react.useCallback)((e)=>{
        if (e.nativeEvent.isComposing) return;
        if (e.key === 'Enter') {
            commit();
            commitValidation();
        } else e.continuePropagation();
    }, [
        commit,
        commitValidation
    ]);
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, inputProps: textFieldProps, descriptionProps, errorMessageProps } = (0, _textfield.useFormattedTextField)({
        ...otherProps,
        ...domProps,
        // These props are added to a hidden input rather than the formatted textfield.
        name: undefined,
        form: undefined,
        label,
        autoFocus,
        isDisabled,
        isReadOnly,
        isRequired,
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state,
        value: inputValue,
        defaultValue: '!',
        autoComplete: 'off',
        'aria-label': props['aria-label'] || undefined,
        'aria-labelledby': props['aria-labelledby'] || undefined,
        id: inputId,
        type: 'text',
        inputMode,
        onChange,
        onBlur,
        onFocus,
        onFocusChange,
        onKeyDown: (0, _react.useMemo)(()=>(0, _utils.chain)(onKeyDownEnter, onKeyDown), [
            onKeyDownEnter,
            onKeyDown
        ]),
        onKeyUp,
        description,
        errorMessage
    }, state, inputRef);
    (0, _utils.useFormReset)(inputRef, state.defaultNumberValue, state.setNumberValue);
    let inputProps = (0, _utils.mergeProps)(spinButtonProps, focusProps, textFieldProps, {
        // override the spinbutton role, we can't focus a spin button with VO
        role: null,
        // ignore aria-roledescription on iOS so that required state will announce when it is present
        'aria-roledescription': !(0, _utils.isIOS)() ? stringFormatter.format('numberField') : null,
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false'
    });
    if (props.validationBehavior === 'native') inputProps['aria-required'] = undefined;
    let onButtonPressStart = (e)=>{
        // If focus is already on the input, keep it there so we don't hide the
        // software keyboard when tapping the increment/decrement buttons.
        if (document.activeElement === inputRef.current) return;
        // Otherwise, when using a mouse, move focus to the input.
        // On touch, or with a screen reader, focus the button so that the software
        // keyboard does not appear and the screen reader cursor is not moved off the button.
        if (e.pointerType === 'mouse') inputRef.current?.focus();
        else e.target.focus();
    };
    // Determine the label for the increment and decrement buttons. There are 4 cases:
    //
    // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
    // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
    // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
    // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
    //
    // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
    // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
    // the order or add additional words around the label if needed.
    let fieldLabel = props['aria-label'] || (typeof props.label === 'string' ? props.label : '');
    let ariaLabelledby;
    if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props['aria-labelledby'];
    let incrementId = (0, _utils.useId)();
    let decrementId = (0, _utils.useId)();
    let incrementButtonProps = (0, _utils.mergeProps)(incButtonProps, {
        'aria-label': incrementAriaLabel || stringFormatter.format('increase', {
            fieldLabel
        }).trim(),
        id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
        'aria-labelledby': ariaLabelledby && !incrementAriaLabel ? `${incrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canIncrement,
        onPressStart: onButtonPressStart
    });
    let decrementButtonProps = (0, _utils.mergeProps)(decButtonProps, {
        'aria-label': decrementAriaLabel || stringFormatter.format('decrease', {
            fieldLabel
        }).trim(),
        id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
        'aria-labelledby': ariaLabelledby && !decrementAriaLabel ? `${decrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canDecrement,
        onPressStart: onButtonPressStart
    });
    return {
        groupProps: {
            ...focusWithinProps,
            role: 'group',
            'aria-disabled': isDisabled,
            'aria-invalid': isInvalid ? 'true' : undefined
        },
        labelProps,
        inputProps,
        incrementButtonProps,
        decrementButtonProps,
        errorMessageProps,
        descriptionProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/utils":[["chain","ij7eS"],["filterDOMProps","3upVm"],["isAndroid","7AGiA"],["isIOS","7AGiA"],["isIPhone","7AGiA"],["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useId","jbI4Y"]],"react":"a1TxN","../intl/*.json":"Kcxco","@react-stately/form":"icH0S","@react-aria/interactions":[["useFocus","j8nkn"],["useFocusWithin","8bxuk"],["useScrollWheel","iG9Gj"]],"@react-aria/textfield":"5KN7d","@react-aria/i18n":[["useLocalizedStringFormatter","7lxyl"],["useNumberFormatter","hZwAZ"]],"@react-aria/spinbutton":"7EPVf","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Kcxco":[function(require,module,exports,__globalThis) {
const _temp0 = require("185fee3035ca863b");
const _temp1 = require("3da6a8e4ed76ec6c");
const _temp2 = require("92021157ee0a262d");
const _temp3 = require("e4fc979f0cb1a0bb");
const _temp4 = require("336aee81b16595ed");
const _temp5 = require("a7cf322fc6e5ac34");
const _temp6 = require("fd0e8468a3bbff35");
const _temp7 = require("1f804eead1266472");
const _temp8 = require("a8dcbe18299f90b8");
const _temp9 = require("1ba4f693512a409e");
const _temp10 = require("f29fb461ab69f34f");
const _temp11 = require("4720ccf3baab71af");
const _temp12 = require("cd5794f7c8320d11");
const _temp13 = require("2c146b929f8ee675");
const _temp14 = require("2d3ecc1480a15d3f");
const _temp15 = require("c7cea25327e9e4f3");
const _temp16 = require("edb352aebb28969a");
const _temp17 = require("8c810638fc8b278d");
const _temp18 = require("b6de8393112d87dc");
const _temp19 = require("d334de30bfd941e4");
const _temp20 = require("c7ceef2128aeed91");
const _temp21 = require("a0fe1a7fd6d8ce74");
const _temp22 = require("932bdb42145ba3d1");
const _temp23 = require("eba100dd9c59ae90");
const _temp24 = require("475054a408226edb");
const _temp25 = require("8a56c91361b72742");
const _temp26 = require("915ea6f6f212c4c4");
const _temp27 = require("af07df4a537a2816");
const _temp28 = require("3156a0852d2e753a");
const _temp29 = require("bb98204977e55e0c");
const _temp30 = require("abb04c1ae90c3b3b");
const _temp31 = require("8ef0d3a5b47edd6");
const _temp32 = require("30cba5c7f09f9771");
const _temp33 = require("d80c2022dd982182");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"185fee3035ca863b":"ctpKo","3da6a8e4ed76ec6c":"ctpKo","92021157ee0a262d":"ctpKo","e4fc979f0cb1a0bb":"ctpKo","336aee81b16595ed":"ctpKo","a7cf322fc6e5ac34":"ctpKo","fd0e8468a3bbff35":"7vQSq","1f804eead1266472":"ctpKo","a8dcbe18299f90b8":"ctpKo","1ba4f693512a409e":"ctpKo","f29fb461ab69f34f":"ctpKo","4720ccf3baab71af":"ctpKo","cd5794f7c8320d11":"ctpKo","2c146b929f8ee675":"ctpKo","2d3ecc1480a15d3f":"ctpKo","c7cea25327e9e4f3":"ctpKo","edb352aebb28969a":"ctpKo","8c810638fc8b278d":"ctpKo","b6de8393112d87dc":"ctpKo","d334de30bfd941e4":"ctpKo","c7ceef2128aeed91":"ctpKo","a0fe1a7fd6d8ce74":"ctpKo","932bdb42145ba3d1":"ctpKo","eba100dd9c59ae90":"ctpKo","475054a408226edb":"ctpKo","8a56c91361b72742":"ctpKo","915ea6f6f212c4c4":"ctpKo","af07df4a537a2816":"ctpKo","3156a0852d2e753a":"ctpKo","bb98204977e55e0c":"ctpKo","abb04c1ae90c3b3b":"ctpKo","8ef0d3a5b47edd6":"ctpKo","30cba5c7f09f9771":"ctpKo","d80c2022dd982182":"ctpKo"}],"7vQSq":[function(require,module,exports,__globalThis) {
module.exports = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};

},{}],"iG9Gj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// scroll wheel needs to be added not passively so it's cancelable, small helper hook to remember that
parcelHelpers.export(exports, "useScrollWheel", ()=>useScrollWheel);
var _react = require("react");
var _utils = require("@react-aria/utils");
function useScrollWheel(props, ref) {
    let { onScroll, isDisabled } = props;
    let onScrollHandler = (0, _react.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, _utils.useEvent)(ref, 'wheel', isDisabled ? undefined : onScrollHandler);
}

},{"react":"a1TxN","@react-aria/utils":"c8GoD","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5KN7d":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormattedTextField", ()=>useFormattedTextField);
var _utils = require("@react-aria/utils");
var _useTextField = require("./useTextField");
var _react = require("react");
function supportsNativeBeforeInputEvent() {
    return typeof window !== 'undefined' && window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function';
}
function useFormattedTextField(props, state, inputRef) {
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    let onBeforeInputFallback = (0, _utils.useEffectEvent)((e)=>{
        let input = inputRef.current;
        if (!input) return;
        // Compute the next value of the input if the event is allowed to proceed.
        // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
        let nextValue = null;
        switch(e.inputType){
            case 'historyUndo':
            case 'historyRedo':
                // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                // because presumably the input would have already been validated previously.
                return;
            case 'insertLineBreak':
                // Explicitly allow "insertLineBreak" event, to allow onSubmit for "enter" key. e.data is null in this case.
                return;
            case 'deleteContent':
            case 'deleteByCut':
            case 'deleteByDrag':
                nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteContentForward':
                // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                // If we support additional locales in the future, this may need to change.
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteContentBackward':
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteSoftLineBackward':
            case 'deleteHardLineBackward':
                nextValue = input.value.slice(input.selectionStart);
                break;
            default:
                if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                break;
        }
        // If we did not compute a value, or the new value is invalid, prevent the event
        // so that the browser does not update the input text, move the selection, or add to
        // the undo/redo stack.
        if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
    });
    (0, _react.useEffect)(()=>{
        if (!supportsNativeBeforeInputEvent() || !inputRef.current) return;
        let input = inputRef.current;
        input.addEventListener('beforeinput', onBeforeInputFallback, false);
        return ()=>{
            input.removeEventListener('beforeinput', onBeforeInputFallback, false);
        };
    }, [
        inputRef
    ]);
    let onBeforeInput = !supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps, inputProps: textFieldProps, descriptionProps, errorMessageProps, ...validation } = (0, _useTextField.useTextField)(props, inputRef);
    let compositionStartState = (0, _react.useRef)(null);
    return {
        inputProps: (0, _utils.mergeProps)(textFieldProps, {
            onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value, selectionStart, selectionEnd } = inputRef.current;
                compositionStartState.current = {
                    value,
                    selectionStart,
                    selectionEnd
                };
            },
            onCompositionEnd () {
                if (inputRef.current && !state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value, selectionStart, selectionEnd } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":[["mergeProps","aNvcY"],["useEffectEvent","eg4dC"]],"./useTextField":"j6sGd","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7EPVf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSpinButton", ()=>useSpinButton);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useSpinButton(props) {
    const _async = (0, _react.useRef)(undefined);
    let { value, textValue, minValue, maxValue, isDisabled, isReadOnly, isRequired, onIncrement, onIncrementPage, onDecrement, onDecrementPage, onDecrementToMin, onIncrementToMax } = props;
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/spinbutton');
    let prevTouchPosition = (0, _react.useRef)(null);
    let isSpinning = (0, _react.useRef)(false);
    const clearAsync = ()=>{
        clearTimeout(_async.current);
        isSpinning.current = false;
    };
    (0, _react.useEffect)(()=>{
        return ()=>clearAsync();
    }, []);
    let onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly || e.nativeEvent.isComposing) return;
        switch(e.key){
            case 'PageUp':
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage?.();
                    break;
                }
            // fallthrough!
            case 'ArrowUp':
            case 'Up':
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement?.();
                }
                break;
            case 'PageDown':
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage?.();
                    break;
                }
            // fallthrough
            case 'ArrowDown':
            case 'Down':
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement?.();
                }
                break;
            case 'Home':
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin?.();
                }
                break;
            case 'End':
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax?.();
                }
                break;
        }
    };
    let isFocused = (0, _react.useRef)(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    let ariaTextValue = textValue === '' ? stringFormatter.format('Empty') : (textValue || `${value}`).replace('-', '\u2212');
    (0, _react.useEffect)(()=>{
        if (isFocused.current) {
            (0, _liveAnnouncer.clearAnnouncer)('assertive');
            (0, _liveAnnouncer.announce)(ariaTextValue, 'assertive');
        }
    }, [
        ariaTextValue
    ]);
    // For touch users, if they move their finger like they're scrolling, we don't want to trigger a spin.
    let onTouchMove = (0, _react.useCallback)((e)=>{
        if (!prevTouchPosition.current) prevTouchPosition.current = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };
        let touchPosition = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };
        // Arbitrary distance that worked in testing, even with slight movements or a slow-ish start to scrolling.
        if (Math.abs(touchPosition.x - prevTouchPosition.current.x) > 1 || Math.abs(touchPosition.y - prevTouchPosition.current.y) > 1) clearAsync();
        prevTouchPosition.current = touchPosition;
    }, []);
    const onIncrementPressStart = (0, _utils.useEffectEvent)((initialStepDelay)=>{
        clearAsync();
        isSpinning.current = true;
        onIncrement?.();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (maxValue === undefined || isNaN(maxValue) || value === undefined || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    });
    const onDecrementPressStart = (0, _utils.useEffectEvent)((initialStepDelay)=>{
        clearAsync();
        isSpinning.current = true;
        onDecrement?.();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (minValue === undefined || isNaN(minValue) || value === undefined || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    });
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils.useGlobalListeners)();
    // Tracks in touch if the press end event was preceded by a press up.
    // If it wasn't, then we know the finger left the button while still in contact with the screen.
    // This means that the user is trying to scroll or interact in some way that shouldn't trigger
    // an increment or decrement.
    let isUp = (0, _react.useRef)(false);
    let [isIncrementPressed, setIsIncrementPressed] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (isIncrementPressed === 'touch') onIncrementPressStart(60);
        else if (isIncrementPressed) onIncrementPressStart(400);
    }, [
        isIncrementPressed
    ]);
    let [isDecrementPressed, setIsDecrementPressed] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (isDecrementPressed === 'touch') onDecrementPressStart(60);
        else if (isDecrementPressed) onDecrementPressStart(400);
    }, [
        isDecrementPressed
    ]);
    return {
        spinButtonProps: {
            role: 'spinbutton',
            'aria-valuenow': value !== undefined && !isNaN(value) ? value : undefined,
            'aria-valuetext': ariaTextValue,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-disabled': isDisabled || undefined,
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onKeyDown,
            onFocus,
            onBlur
        },
        incrementButtonProps: {
            onPressStart: (e)=>{
                if (e.pointerType !== 'touch') setIsIncrementPressed('mouse');
                else {
                    if (_async.current) clearAsync();
                    addGlobalListener(window, 'touchmove', onTouchMove, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    _async.current = window.setTimeout(()=>{
                        setIsIncrementPressed('touch');
                    }, 600);
                }
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressUp: (e)=>{
                if (e.pointerType === 'touch') isUp.current = true;
                prevTouchPosition.current = null;
                clearAsync();
                removeAllGlobalListeners();
                setIsIncrementPressed(null);
            },
            onPressEnd: (e)=>{
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onIncrement?.();
                }
                isUp.current = false;
                setIsIncrementPressed(null);
            },
            onFocus,
            onBlur
        },
        decrementButtonProps: {
            onPressStart: (e)=>{
                if (e.pointerType !== 'touch') setIsDecrementPressed('mouse');
                else {
                    if (_async.current) clearAsync();
                    addGlobalListener(window, 'touchmove', onTouchMove, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    _async.current = window.setTimeout(()=>{
                        setIsDecrementPressed('touch');
                    }, 600);
                }
            },
            onPressUp: (e)=>{
                if (e.pointerType === 'touch') isUp.current = true;
                prevTouchPosition.current = null;
                clearAsync();
                removeAllGlobalListeners();
                setIsDecrementPressed(null);
            },
            onPressEnd: (e)=>{
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onDecrement?.();
                }
                isUp.current = false;
                setIsDecrementPressed(null);
            },
            onFocus,
            onBlur
        }
    };
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"cq1oA","react":"a1TxN","@react-aria/utils":[["useEffectEvent","eg4dC"],["useGlobalListeners","ceyTG"]],"@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cq1oA":[function(require,module,exports,__globalThis) {
const _temp0 = require("e2e6d1d7a87a1068");
const _temp1 = require("414310b71025b887");
const _temp2 = require("dd0bafaf5c4a28a0");
const _temp3 = require("d2283b80c234f014");
const _temp4 = require("d6fc1bb7dc8d85b6");
const _temp5 = require("987c7b64af92b3ee");
const _temp6 = require("4913d7132bdfb41d");
const _temp7 = require("a35b1e4258964a66");
const _temp8 = require("940c5203fdf29b00");
const _temp9 = require("119bf55e15c9b210");
const _temp10 = require("a351320a90199fa8");
const _temp11 = require("4c64342ad3ffb260");
const _temp12 = require("728b38d585aad9ed");
const _temp13 = require("d98e674722b576b");
const _temp14 = require("ca759f97e288298");
const _temp15 = require("26928643ba133bc9");
const _temp16 = require("961db255eefe7a9f");
const _temp17 = require("1ade1a0dc3049a27");
const _temp18 = require("c5da72b6c86d5c04");
const _temp19 = require("9dfd0fe49cf3eca8");
const _temp20 = require("5e5bcd1106669804");
const _temp21 = require("dff99ce707b4bb16");
const _temp22 = require("c2032c1e6e3207c2");
const _temp23 = require("8239762010d814c7");
const _temp24 = require("bc9973caf80807ee");
const _temp25 = require("691b643538992d8a");
const _temp26 = require("2d1cae8f1f1a9a7f");
const _temp27 = require("9a3ea1aef8a494a0");
const _temp28 = require("ffd904f000e76fe5");
const _temp29 = require("d5213dfa06f5f7c0");
const _temp30 = require("e79acbf5257f7402");
const _temp31 = require("845d11885c368d14");
const _temp32 = require("1ae1cd48ea8c602");
const _temp33 = require("6f695e77df35ff14");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"e2e6d1d7a87a1068":"ctpKo","414310b71025b887":"ctpKo","dd0bafaf5c4a28a0":"ctpKo","d2283b80c234f014":"ctpKo","d6fc1bb7dc8d85b6":"ctpKo","987c7b64af92b3ee":"ctpKo","4913d7132bdfb41d":"c0pto","a35b1e4258964a66":"ctpKo","940c5203fdf29b00":"ctpKo","119bf55e15c9b210":"ctpKo","a351320a90199fa8":"ctpKo","4c64342ad3ffb260":"ctpKo","728b38d585aad9ed":"ctpKo","d98e674722b576b":"ctpKo","ca759f97e288298":"ctpKo","26928643ba133bc9":"ctpKo","961db255eefe7a9f":"ctpKo","1ade1a0dc3049a27":"ctpKo","c5da72b6c86d5c04":"ctpKo","9dfd0fe49cf3eca8":"ctpKo","5e5bcd1106669804":"ctpKo","dff99ce707b4bb16":"ctpKo","c2032c1e6e3207c2":"ctpKo","8239762010d814c7":"ctpKo","bc9973caf80807ee":"ctpKo","691b643538992d8a":"ctpKo","2d1cae8f1f1a9a7f":"ctpKo","9a3ea1aef8a494a0":"ctpKo","ffd904f000e76fe5":"ctpKo","d5213dfa06f5f7c0":"ctpKo","e79acbf5257f7402":"ctpKo","845d11885c368d14":"ctpKo","1ae1cd48ea8c602":"ctpKo","6f695e77df35ff14":"ctpKo"}],"c0pto":[function(require,module,exports,__globalThis) {
module.exports = {
    "Empty": `Empty`
};

},{}],"kM0E9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a number field component. Number fields allow users to enter a number,
 * and increment or decrement the value using stepper buttons.
 */ parcelHelpers.export(exports, "useNumberFieldState", ()=>useNumberFieldState);
var _utils = require("@react-stately/utils");
var _form = require("@react-stately/form");
var _number = require("@internationalized/number");
var _react = require("react");
function useNumberFieldState(props) {
    let { minValue, maxValue, step, formatOptions, value, defaultValue = NaN, onChange, locale, isDisabled, isReadOnly } = props;
    if (value === null) value = NaN;
    if (value !== undefined && !isNaN(value)) {
        if (step !== undefined && !isNaN(step)) value = (0, _utils.snapValueToStep)(value, minValue, maxValue, step);
        else value = (0, _utils.clamp)(value, minValue, maxValue);
    }
    if (!isNaN(defaultValue)) {
        if (step !== undefined && !isNaN(step)) defaultValue = (0, _utils.snapValueToStep)(defaultValue, minValue, maxValue, step);
        else defaultValue = (0, _utils.clamp)(defaultValue, minValue, maxValue);
    }
    let [numberValue, setNumberValue] = (0, _utils.useControlledState)(value, isNaN(defaultValue) ? NaN : defaultValue, onChange);
    let [initialValue] = (0, _react.useState)(numberValue);
    let [inputValue, setInputValue] = (0, _react.useState)(()=>isNaN(numberValue) ? '' : new (0, _number.NumberFormatter)(locale, formatOptions).format(numberValue));
    let numberParser = (0, _react.useMemo)(()=>new (0, _number.NumberParser)(locale, formatOptions), [
        locale,
        formatOptions
    ]);
    let numberingSystem = (0, _react.useMemo)(()=>numberParser.getNumberingSystem(inputValue), [
        numberParser,
        inputValue
    ]);
    let formatter = (0, _react.useMemo)(()=>new (0, _number.NumberFormatter)(locale, {
            ...formatOptions,
            numberingSystem
        }), [
        locale,
        formatOptions,
        numberingSystem
    ]);
    let intlOptions = (0, _react.useMemo)(()=>formatter.resolvedOptions(), [
        formatter
    ]);
    let format = (0, _react.useCallback)((value)=>isNaN(value) || value === null ? '' : formatter.format(value), [
        formatter
    ]);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: numberValue
    });
    let clampStep = step !== undefined && !isNaN(step) ? step : 1;
    if (intlOptions.style === 'percent' && (step === undefined || isNaN(step))) clampStep = 0.01;
    // Update the input value when the number value or format options change. This is done
    // in a useEffect so that the controlled behavior is correct and we only update the
    // textfield after prop changes.
    let [prevValue, setPrevValue] = (0, _react.useState)(numberValue);
    let [prevLocale, setPrevLocale] = (0, _react.useState)(locale);
    let [prevFormatOptions, setPrevFormatOptions] = (0, _react.useState)(formatOptions);
    if (!Object.is(numberValue, prevValue) || locale !== prevLocale || formatOptions !== prevFormatOptions) {
        setInputValue(format(numberValue));
        setPrevValue(numberValue);
        setPrevLocale(locale);
        setPrevFormatOptions(formatOptions);
    }
    let parsedValue = (0, _react.useMemo)(()=>numberParser.parse(inputValue), [
        numberParser,
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            setNumberValue(NaN);
            setInputValue(value === undefined ? '' : format(numberValue));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (isNaN(parsedValue)) {
            setInputValue(format(numberValue));
            return;
        }
        // Clamp to min and max, round to the nearest step, and round to specified number of digits
        let clampedValue;
        if (step === undefined || isNaN(step)) clampedValue = (0, _utils.clamp)(parsedValue, minValue, maxValue);
        else clampedValue = (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, step);
        clampedValue = numberParser.parse(format(clampedValue));
        setNumberValue(clampedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        setInputValue(format(value === undefined ? clampedValue : numberValue));
        validation.commitValidation();
    };
    let safeNextStep = (operation, minMax = 0)=>{
        let prev = parsedValue;
        if (isNaN(prev)) {
            // if the input is empty, start from the min/max value when incrementing/decrementing,
            // or zero if there is no min/max value defined.
            let newValue = isNaN(minMax) ? 0 : minMax;
            return (0, _utils.snapValueToStep)(newValue, minValue, maxValue, clampStep);
        } else {
            // otherwise, first snap the current value to the nearest step. if it moves in the direction
            // we're going, use that value, otherwise add the step and snap that value.
            let newValue = (0, _utils.snapValueToStep)(prev, minValue, maxValue, clampStep);
            if (operation === '+' && newValue > prev || operation === '-' && newValue < prev) return newValue;
            return (0, _utils.snapValueToStep)(handleDecimalOperation(operation, prev, clampStep), minValue, maxValue, clampStep);
        }
    };
    let increment = ()=>{
        let newValue = safeNextStep('+', minValue);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = safeNextStep('-', maxValue);
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>{
        if (maxValue != null) {
            setNumberValue((0, _utils.snapValueToStep)(maxValue, minValue, maxValue, clampStep));
            validation.commitValidation();
        }
    };
    let decrementToMin = ()=>{
        if (minValue != null) {
            setNumberValue(minValue);
            validation.commitValidation();
        }
    };
    let canIncrement = (0, _react.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || maxValue === undefined || isNaN(maxValue) || (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) > parsedValue || handleDecimalOperation('+', parsedValue, clampStep) <= maxValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let canDecrement = (0, _react.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || minValue === undefined || isNaN(minValue) || (0, _utils.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) < parsedValue || handleDecimalOperation('-', parsedValue, clampStep) >= minValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let validate = (value)=>numberParser.isValidPartialNumber(value, minValue, maxValue);
    return {
        ...validation,
        validate,
        increment,
        incrementToMax,
        decrement,
        decrementToMin,
        canIncrement,
        canDecrement,
        minValue,
        maxValue,
        numberValue: parsedValue,
        defaultNumberValue: isNaN(defaultValue) ? initialValue : defaultValue,
        setNumberValue,
        setInputValue,
        inputValue,
        commit
    };
}
function handleDecimalOperation(operator, value1, value2) {
    let result = operator === '+' ? value1 + value2 : value1 - value2;
    // Check if we have decimals
    if (value1 % 1 !== 0 || value2 % 1 !== 0) {
        const value1Decimal = value1.toString().split('.');
        const value2Decimal = value2.toString().split('.');
        const value1DecimalLength = value1Decimal[1] && value1Decimal[1].length || 0;
        const value2DecimalLength = value2Decimal[1] && value2Decimal[1].length || 0;
        const multiplier = Math.pow(10, Math.max(value1DecimalLength, value2DecimalLength));
        // Transform the decimals to integers based on the precision
        value1 = Math.round(value1 * multiplier);
        value2 = Math.round(value2 * multiplier);
        // Perform the operation on integers values to make sure we don't get a fancy decimal value
        result = operator === '+' ? value1 + value2 : value1 - value2;
        // Transform the integer result back to decimal
        result /= multiplier;
    }
    return result;
}

},{"@react-stately/utils":[["clamp","kO94U"],["snapValueToStep","kO94U"],["useControlledState","4Nj6T"]],"@react-stately/form":"icH0S","@internationalized/number":[["NumberFormatter","2z0fS"],["NumberParser","d6DMA"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d6DMA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A NumberParser can be used to perform locale-aware parsing of numbers from Unicode strings,
 * as well as validation of partial user input. It automatically detects the numbering system
 * used in the input, and supports parsing decimals, percentages, currency values, and units
 * according to the locale.
 */ parcelHelpers.export(exports, "NumberParser", ()=>NumberParser);
var _numberFormatter = require("./NumberFormatter");
const CURRENCY_SIGN_REGEX = new RegExp('^.*\\(.*\\).*$');
const NUMBERING_SYSTEMS = [
    'latn',
    'arab',
    'hanidec',
    'deva',
    'beng',
    'fullwide'
];
class NumberParser {
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
}
const numberParserCache = new Map();
function getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes('-nu-') && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = getCachedNumberParser(locale + (locale.includes('-u-') ? '-nu-' : '-u-nu-') + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    let parser = numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new NumberParserImpl(locale, options);
        numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class NumberParserImpl {
    constructor(locale, options = {}){
        this.locale = locale;
        // see https://tc39.es/ecma402/#sec-setnfdigitoptions, when using roundingIncrement, the maximumFractionDigits and minimumFractionDigits must be equal
        // by default, they are 0 and 3 respectively, so we set them to 0 if neither are set
        if (options.roundingIncrement !== 1 && options.roundingIncrement != null) {
            if (options.maximumFractionDigits == null && options.minimumFractionDigits == null) {
                options.maximumFractionDigits = 0;
                options.minimumFractionDigits = 0;
            } else if (options.maximumFractionDigits == null) options.maximumFractionDigits = options.minimumFractionDigits;
            else if (options.minimumFractionDigits == null) options.minimumFractionDigits = options.maximumFractionDigits;
        // if both are specified, let the normal Range Error be thrown
        }
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = getSymbols(locale, this.formatter, this.options, options);
        if (this.options.style === 'percent' && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18)) console.warn('NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.');
    }
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) // Remove group characters, and replace decimal points and numerals with ASCII values.
        fullySanitizedValue = replaceAll(fullySanitizedValue, this.symbols.group, '');
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, '.');
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, '-');
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === 'percent') {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf('-');
            fullySanitizedValue = fullySanitizedValue.replace('-', '');
            fullySanitizedValue = fullySanitizedValue.replace('+', '');
            let index = fullySanitizedValue.indexOf('.');
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace('.', '');
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = '0.00';
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === 'percent') {
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: 'decimal',
                minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
                maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
            };
            return new NumberParser(this.locale, options).parse(new (0, _numberFormatter.NumberFormatter)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === 'accounting' && CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, '');
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace('-', this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === 'arab') {
            if (this.symbols.decimal) {
                value = value.replace(',', this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = replaceAll(value, '.', this.symbols.group);
        }
        // In some locale styles, such as swiss currency, the group character can be a special single quote
        // that keyboards don't typically have. This expands the character to include the easier to type single quote.
        if (this.symbols.group === "\u2019" && value.includes("'")) value = replaceAll(value, "'", this.symbols.group);
        // fr-FR group character is narrow non-breaking space, char code 8239 (U+202F), but that's not a key on the french keyboard,
        // so allow space and non-breaking space as a group char as well
        if (this.options.locale === 'fr-FR' && this.symbols.group) {
            value = replaceAll(value, ' ', this.symbols.group);
            value = replaceAll(value, /\u00A0/g, this.symbols.group);
        }
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = replaceAll(value, this.symbols.group, '');
        value = value.replace(this.symbols.numeral, '');
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, '');
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
}
const nonLiteralParts = new Set([
    'decimal',
    'fraction',
    'integer',
    'minusSign',
    'plusSign',
    'group'
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function getSymbols(locale, formatter, intlOptions, originalOptions) {
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        // Resets so we get the full range of symbols
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21,
        roundingIncrement: 1,
        roundingPriority: 'auto',
        roundingMode: 'halfExpand'
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    let minusSign = allParts.find((p)=>p.type === 'minusSign')?.value ?? '-';
    let plusSign = posAllParts.find((p)=>p.type === 'plusSign')?.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    if (!plusSign && (originalOptions?.signDisplay === 'exceptZero' || originalOptions?.signDisplay === 'always')) plusSign = '+';
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = decimalParts.find((p)=>p.type === 'decimal')?.value;
    let group = allParts.find((p)=>p.type === 'group')?.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!nonLiteralParts.has(p.type)).map((p)=>escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!nonLiteralParts.has(p.type)).map((p)=>escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp('[\\p{White_Space}]', 'gu') : new RegExp(`${sortedLiterals.join('|')}|[\\p{White_Space}]`, 'gu');
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join('')}]`, 'g');
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign,
        plusSign,
        decimal,
        group,
        literals,
        numeral,
        index
    };
}
function replaceAll(str, find, replace) {
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

},{"./NumberFormatter":"2z0fS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9SuNb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeSliderContext", ()=>RangeSliderContext);
parcelHelpers.export(exports, "RangeSlider", ()=>RangeSlider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _slider = require("./Slider");
var _form = require("./Form");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeSliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RangeSlider = /*#__PURE__*/ (0, _react.forwardRef)(function RangeSlider(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeSliderContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { labelPosition = 'top', size = 'M', isEmphasized, trackStyle = 'thin', thumbStyle = 'default' } = props;
    let lowerThumbRef = (0, _react.useRef)(null);
    let upperThumbRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null); // TODO: need to pass inputRef to SliderThumb when we release the next version of RAC 1.3.0
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let { direction } = (0, _i18N.useLocale)();
    let cssDirection = direction === 'rtl' ? 'right' : 'left';
    let defaultThumbValues = undefined;
    if (props.defaultValue != null) defaultThumbValues = [
        props.defaultValue.start,
        props.defaultValue.end
    ];
    else if (props.value == null) // make sure that useSliderState knows we have two handles
    defaultThumbValues = [
        props.minValue ?? 0,
        props.maxValue ?? 100
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slider.SliderBase), {
        ...props,
        value: props.value ? [
            props.value.start,
            props.value.end
        ] : undefined,
        defaultValue: defaultThumbValues,
        onChange: (v)=>props.onChange?.({
                start: v[0],
                end: v[1]
            }),
        onChangeEnd: (v)=>props.onChangeEnd?.({
                start: v[0],
                end: v[1]
            }),
        sliderRef: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
            className: (0, _slider.track)({
                size,
                labelPosition,
                isInForm: !!formContext
            }),
            children: ({ state, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _slider.upperTrack)({
                                isDisabled,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                width: `${Math.abs(state.getThumbPercent(0) - state.getThumbPercent(1)) * 100}%`,
                                [cssDirection]: `${state.getThumbPercent(0) * 100}%`
                            },
                            className: (0, _slider.filledTrack)({
                                isDisabled,
                                isEmphasized,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: (0, _slider.thumbContainer),
                            index: 0,
                            name: props.startName,
                            form: props.form,
                            "aria-label": stringFormatter.format('slider.minimum'),
                            ref: lowerThumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(lowerThumbRef, {
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: state.getThumbPercent(0) === 1 ? 1 : undefined
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _slider.thumbHitArea)({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _slider.thumb)({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: (0, _slider.thumbContainer),
                            index: 1,
                            name: props.endName,
                            form: props.form,
                            "aria-label": stringFormatter.format('slider.maximum'),
                            ref: upperThumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(upperThumbRef, {
                                    transform: 'translate(-50%, -50%)'
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _slider.thumbHitArea)({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _slider.thumb)({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        })
                    ]
                })
        })
    });
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"34zZe","react":"a1TxN","./Slider":"ixJJx","./Form":"cHqN4","../intl/*.json":"gDH3q","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@react-aria/i18n":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"34zZe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderContext", ()=>SliderContext);
parcelHelpers.export(exports, "SliderStateContext", ()=>SliderStateContext);
parcelHelpers.export(exports, "SliderTrackContext", ()=>SliderTrackContext);
parcelHelpers.export(exports, "SliderOutputContext", ()=>SliderOutputContext);
parcelHelpers.export(exports, "Slider", ()=>Slider);
parcelHelpers.export(exports, "SliderOutput", ()=>SliderOutput);
parcelHelpers.export(exports, "SliderTrack", ()=>SliderTrack);
parcelHelpers.export(exports, "SliderThumb", ()=>SliderThumb);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
const SliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderTrackContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SliderOutputContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Slider = /*#__PURE__*/ (0, _react.forwardRef)(function Slider(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderContext);
    let trackRef = (0, _react.useRef)(null);
    let numberFormatter = (0, _reactAria.useNumberFormatter)(props.formatOptions);
    let state = (0, _reactStately.useSliderState)({
        ...props,
        numberFormatter
    });
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps, trackProps, labelProps, outputProps } = (0, _reactAria.useSlider)({
        ...props,
        label
    }, state, trackRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        },
        defaultClassName: 'react-aria-Slider'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                SliderStateContext,
                state
            ],
            [
                SliderTrackContext,
                {
                    ...trackProps,
                    ref: trackRef
                }
            ],
            [
                SliderOutputContext,
                outputProps
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": state.orientation,
        "data-disabled": state.isDisabled || undefined
    }));
});
const SliderOutput = /*#__PURE__*/ (0, _react.forwardRef)(function SliderOutput(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderOutputContext);
    let { children, style, className, ...otherProps } = props;
    let state = (0, _react.useContext)(SliderStateContext);
    let renderProps = (0, _utils.useRenderProps)({
        className,
        style,
        children,
        defaultChildren: state.getThumbValueLabel(0),
        defaultClassName: 'react-aria-SliderOutput',
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("output", {
        ...otherProps,
        ...renderProps,
        ref: ref,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
});
const SliderTrack = /*#__PURE__*/ (0, _react.forwardRef)(function SliderTrack(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SliderTrackContext);
    let state = (0, _react.useContext)(SliderStateContext);
    let { onHoverStart, onHoverEnd, onHoverChange, ...otherProps } = props;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        onHoverStart,
        onHoverEnd,
        onHoverChange
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SliderTrack',
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            isHovered,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(otherProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
});
const SliderThumb = /*#__PURE__*/ (0, _react.forwardRef)(function SliderThumb(props, ref) {
    let { inputRef: userInputRef = null } = props;
    let state = (0, _react.useContext)(SliderStateContext);
    let { ref: trackRef } = (0, _utils.useSlottedContext)(SliderTrackContext);
    let { index = 0 } = props;
    let defaultInputRef = (0, _react.useRef)(null);
    let inputRef = userInputRef || defaultInputRef;
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { thumbProps, inputProps, labelProps, isDragging, isFocused, isDisabled } = (0, _reactAria.useSliderThumb)({
        ...props,
        index,
        trackRef: trackRef,
        inputRef,
        label
    }, state);
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SliderThumb',
        values: {
            state,
            isHovered,
            isDragging,
            isFocused,
            isFocusVisible,
            isDisabled
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, thumbProps, hoverProps),
        ...renderProps,
        ref: ref,
        style: {
            ...thumbProps.style,
            ...renderProps.style
        },
        "data-hovered": isHovered || undefined,
        "data-dragging": isDragging || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputRef,
        ...(0, _reactAria.mergeProps)(inputProps, focusProps)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useNumberFormatter","hZwAZ"],["useSlider","1xOFO"],["useSliderThumb","8sp6a"],["VisuallyHidden","7zrGr"]],"./utils":"bA6Cz","@react-aria/utils":"3upVm","./Label":"fjKq6","react":"a1TxN","react-stately":"4wUXI","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1xOFO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a slider component representing one or more values.
 *
 * @param props Props for the slider.
 * @param state State for the slider, as returned by `useSliderState`.
 * @param trackRef Ref for the "track" element.  The width of this element provides the "length"
 * of the track -- the span of one dimensional space that the slider thumb can be.  It also
 * accepts click and drag motions, so that the closest thumb will follow clicks and drags on
 * the track.
 */ parcelHelpers.export(exports, "useSlider", ()=>useSlider);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
function useSlider(props, state, trackRef) {
    let { labelProps, fieldProps } = (0, _label.useLabel)(props);
    let isVertical = props.orientation === 'vertical';
    // Attach id of the label to the state so it can be accessed by useSliderThumb.
    (0, _utils1.sliderData).set(state, {
        id: labelProps.id ?? fieldProps.id,
        'aria-describedby': props['aria-describedby'],
        'aria-details': props['aria-details']
    });
    let { direction } = (0, _i18N.useLocale)();
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    // When the user clicks or drags the track, we want the motion to set and drag the
    // closest thumb.  Hence we also need to install useMove() on the track element.
    // Here, we keep track of which index is the "closest" to the drag start point.
    // It is set onMouseDown/onTouchDown; see trackProps below.
    const realTimeTrackDraggingIndex = (0, _react.useRef)(null);
    const reverseX = direction === 'rtl';
    const currentPosition = (0, _react.useRef)(null);
    const { moveProps } = (0, _interactions.useMove)({
        onMoveStart () {
            currentPosition.current = null;
        },
        onMove ({ deltaX, deltaY }) {
            if (!trackRef.current) return;
            let { height, width } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null && realTimeTrackDraggingIndex.current != null) currentPosition.current = state.getThumbPercent(realTimeTrackDraggingIndex.current) * size;
            let delta = isVertical ? deltaY : deltaX;
            if (isVertical || reverseX) delta = -delta;
            currentPosition.current += delta;
            if (realTimeTrackDraggingIndex.current != null && trackRef.current) {
                const percent = (0, _utils.clamp)(currentPosition.current / size, 0, 1);
                state.setThumbPercent(realTimeTrackDraggingIndex.current, percent);
            }
        },
        onMoveEnd () {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
        }
    });
    let currentPointer = (0, _react.useRef)(undefined);
    let onDownTrack = (e, id, clientX, clientY)=>{
        // We only trigger track-dragging if the user clicks on the track itself and nothing is currently being dragged.
        if (trackRef.current && !props.isDisabled && state.values.every((_, i)=>!state.isThumbDragging(i))) {
            let { height, width, top, left } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            // Find the closest thumb
            const trackPosition = isVertical ? top : left;
            const clickPosition = isVertical ? clientY : clientX;
            const offset = clickPosition - trackPosition;
            let percent = offset / size;
            if (direction === 'rtl' || isVertical) percent = 1 - percent;
            let value = state.getPercentValue(percent);
            // to find the closet thumb we split the array based on the first thumb position to the "right/end" of the click.
            let closestThumb;
            let split = state.values.findIndex((v)=>value - v < 0);
            if (split === 0) closestThumb = split;
            else if (split === -1) closestThumb = state.values.length - 1;
            else {
                let lastLeft = state.values[split - 1];
                let firstRight = state.values[split];
                // Pick the last left/start thumb, unless they are stacked on top of each other, then pick the right/end one
                if (Math.abs(lastLeft - value) < Math.abs(firstRight - value)) closestThumb = split - 1;
                else closestThumb = split;
            }
            // Confirm that the found closest thumb is editable, not disabled, and move it
            if (closestThumb >= 0 && state.isThumbEditable(closestThumb)) {
                // Don't unfocus anything
                e.preventDefault();
                realTimeTrackDraggingIndex.current = closestThumb;
                state.setFocusedThumb(closestThumb);
                currentPointer.current = id;
                state.setThumbDragging(realTimeTrackDraggingIndex.current, true);
                state.setThumbValue(closestThumb, value);
                addGlobalListener(window, 'mouseup', onUpTrack, false);
                addGlobalListener(window, 'touchend', onUpTrack, false);
                addGlobalListener(window, 'pointerup', onUpTrack, false);
            } else realTimeTrackDraggingIndex.current = null;
        }
    };
    let onUpTrack = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
            removeGlobalListener(window, 'mouseup', onUpTrack, false);
            removeGlobalListener(window, 'touchend', onUpTrack, false);
            removeGlobalListener(window, 'pointerup', onUpTrack, false);
        }
    };
    if ('htmlFor' in labelProps && labelProps.htmlFor) {
        // Ideally the `for` attribute should point to the first thumb, but VoiceOver on iOS
        // causes this to override the `aria-labelledby` on the thumb. This causes the first
        // thumb to only be announced as the slider label rather than its individual name as well.
        // See https://bugs.webkit.org/show_bug.cgi?id=172464.
        delete labelProps.htmlFor;
        labelProps.onClick = ()=>{
            // Safari does not focus <input type="range"> elements when clicking on an associated <label>,
            // so do it manually. In addition, make sure we show the focus ring.
            document.getElementById((0, _utils1.getSliderThumbId)(state, 0))?.focus();
            (0, _interactions.setInteractionModality)('keyboard');
        };
    }
    return {
        labelProps,
        // The root element of the Slider will have role="group" to group together
        // all the thumb inputs in the Slider.  The label of the Slider will
        // be used to label the group.
        groupProps: {
            role: 'group',
            ...fieldProps
        },
        trackProps: (0, _utils.mergeProps)({
            onMouseDown (e) {
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDownTrack(e, undefined, e.clientX, e.clientY);
            },
            onPointerDown (e) {
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onDownTrack(e, e.pointerId, e.clientX, e.clientY);
            },
            onTouchStart (e) {
                onDownTrack(e, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            },
            style: {
                position: 'relative',
                touchAction: 'none'
            }
        }, moveProps),
        outputProps: {
            htmlFor: state.values.map((_, index)=>(0, _utils1.getSliderThumbId)(state, index)).join(' '),
            'aria-live': 'off'
        }
    };
}

},{"@react-aria/utils":[["clamp","kO94U"],["mergeProps","aNvcY"],["useGlobalListeners","ceyTG"]],"./utils":"g86lM","react":"a1TxN","@react-aria/interactions":[["setInteractionModality","dkfxW"],["useMove","kqQMp"]],"@react-aria/label":"baGld","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g86lM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sliderData", ()=>sliderData);
parcelHelpers.export(exports, "getSliderThumbId", ()=>getSliderThumbId);
const sliderData = new WeakMap();
function getSliderThumbId(state, index) {
    let data = sliderData.get(state);
    if (!data) throw new Error('Unknown slider state');
    return `${data.id}-${index}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kqQMp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles move interactions across mouse, touch, and keyboard, including dragging with
 * the mouse or touch, and using the arrow keys. Normalizes behavior across browsers and
 * platforms, and ignores emulated mouse events on touch devices.
 */ parcelHelpers.export(exports, "useMove", ()=>useMove);
var _textSelection = require("./textSelection");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useMove(props) {
    let { onMoveStart, onMove, onMoveEnd } = props;
    let state = (0, _react.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let move = (0, _react.useCallback)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart?.({
                type: 'movestart',
                pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove?.({
            type: 'move',
            pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    }, [
        onMoveStart,
        onMove,
        state
    ]);
    let moveEvent = (0, _utils.useEffectEvent)(move);
    let end = (0, _react.useCallback)((originalEvent, pointerType)=>{
        (0, _textSelection.restoreTextSelection)();
        if (state.current.didMove) onMoveEnd?.({
            type: 'moveend',
            pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    }, [
        onMoveEnd,
        state
    ]);
    let endEvent = (0, _utils.useEffectEvent)(end);
    let [pointerDown, setPointerDown] = (0, _react.useState)(null);
    (0, _utils.useLayoutEffect)(()=>{
        if (pointerDown === 'pointer') {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    moveEvent(e, pointerType, e.pageX - (state.current.lastPosition?.pageX ?? 0), e.pageY - (state.current.lastPosition?.pageY ?? 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    endEvent(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, 'pointermove', onPointerMove, false);
                    removeGlobalListener(window, 'pointerup', onPointerUp, false);
                    removeGlobalListener(window, 'pointercancel', onPointerUp, false);
                    setPointerDown(null);
                }
            };
            addGlobalListener(window, 'pointermove', onPointerMove, false);
            addGlobalListener(window, 'pointerup', onPointerUp, false);
            addGlobalListener(window, 'pointercancel', onPointerUp, false);
            return ()=>{
                removeGlobalListener(window, 'pointermove', onPointerMove, false);
                removeGlobalListener(window, 'pointerup', onPointerUp, false);
                removeGlobalListener(window, 'pointercancel', onPointerUp, false);
            };
        } else {
            pointerDown;
            pointerDown;
        }
    }, [
        pointerDown,
        addGlobalListener,
        removeGlobalListener
    ]);
    let moveProps = (0, _react.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            (0, _textSelection.disableTextSelection)();
            state.current.didMove = false;
        };
        typeof PointerEvent;
        var e, e1;
        moveProps.onPointerDown = (e)=>{
            if (e.button === 0 && state.current.id == null) {
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: e.pageX,
                    pageY: e.pageY
                };
                state.current.id = e.pointerId;
                setPointerDown('pointer');
            }
        };
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, 'keyboard', deltaX, deltaY);
            end(e, 'keyboard');
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case 'Left':
                case 'ArrowLeft':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case 'Right':
                case 'ArrowRight':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case 'Up':
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case 'Down':
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        move,
        end
    ]);
    return {
        moveProps
    };
}

},{"./textSelection":"4IHjs","react":"a1TxN","@react-aria/utils":[["useEffectEvent","eg4dC"],["useGlobalListeners","ceyTG"],["useLayoutEffect","2ViQu"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8sp6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides behavior and accessibility for a thumb of a slider component.
 *
 * @param opts Options for this Slider thumb.
 * @param state Slider state, created via `useSliderState`.
 */ parcelHelpers.export(exports, "useSliderThumb", ()=>useSliderThumb);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
function useSliderThumb(opts, state) {
    let { index = 0, isRequired, validationState, isInvalid, trackRef, inputRef, orientation = state.orientation, name, form } = opts;
    let isDisabled = opts.isDisabled || state.isDisabled;
    let isVertical = orientation === 'vertical';
    let { direction } = (0, _i18N.useLocale)();
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let data = (0, _utils1.sliderData).get(state);
    const { labelProps, fieldProps } = (0, _label.useLabel)({
        ...opts,
        id: (0, _utils1.getSliderThumbId)(state, index),
        'aria-labelledby': `${data.id} ${opts['aria-labelledby'] ?? ''}`.trim()
    });
    const value = state.values[index];
    const focusInput = (0, _react.useCallback)(()=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    const isFocused = state.focusedThumb === index;
    (0, _react.useEffect)(()=>{
        if (isFocused) focusInput();
    }, [
        isFocused,
        focusInput
    ]);
    let reverseX = direction === 'rtl';
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            let { getThumbMaxValue, getThumbMinValue, decrementThumb, incrementThumb, setThumbValue, setThumbDragging, pageSize } = state;
            // these are the cases that useMove or useSlider don't handle
            if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, stopPropagation to prevent useSlider from handling the event as well.
            e.preventDefault();
            // remember to set this so that onChangeEnd is fired
            setThumbDragging(index, true);
            switch(e.key){
                case 'PageUp':
                    incrementThumb(index, pageSize);
                    break;
                case 'PageDown':
                    decrementThumb(index, pageSize);
                    break;
                case 'Home':
                    setThumbValue(index, getThumbMinValue(index));
                    break;
                case 'End':
                    setThumbValue(index, getThumbMaxValue(index));
                    break;
            }
            setThumbDragging(index, false);
        }
    });
    let { moveProps } = (0, _interactions.useMove)({
        onMoveStart () {
            currentPosition.current = null;
            state.setThumbDragging(index, true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            const { getThumbPercent, setThumbPercent, decrementThumb, incrementThumb, step, pageSize } = state;
            if (!trackRef.current) return;
            let { width, height } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null) currentPosition.current = getThumbPercent(index) * size;
            if (pointerType === 'keyboard') {
                if (deltaX > 0 && reverseX || deltaX < 0 && !reverseX || deltaY > 0) decrementThumb(index, shiftKey ? pageSize : step);
                else incrementThumb(index, shiftKey ? pageSize : step);
            } else {
                let delta = isVertical ? deltaY : deltaX;
                if (isVertical || reverseX) delta = -delta;
                currentPosition.current += delta;
                setThumbPercent(index, (0, _utils.clamp)(currentPosition.current / size, 0, 1));
            }
        },
        onMoveEnd () {
            state.setThumbDragging(index, false);
        }
    });
    // Immediately register editability with the state
    state.setThumbEditable(index, !isDisabled);
    const { focusableProps } = (0, _interactions.useFocusable)((0, _utils.mergeProps)(opts, {
        onFocus: ()=>state.setFocusedThumb(index),
        onBlur: ()=>state.setFocusedThumb(undefined)
    }), inputRef);
    let currentPointer = (0, _react.useRef)(undefined);
    let onDown = (id)=>{
        focusInput();
        currentPointer.current = id;
        state.setThumbDragging(index, true);
        addGlobalListener(window, 'mouseup', onUp, false);
        addGlobalListener(window, 'touchend', onUp, false);
        addGlobalListener(window, 'pointerup', onUp, false);
    };
    let onUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setThumbDragging(index, false);
            removeGlobalListener(window, 'mouseup', onUp, false);
            removeGlobalListener(window, 'touchend', onUp, false);
            removeGlobalListener(window, 'pointerup', onUp, false);
        }
    };
    let thumbPosition = state.getThumbPercent(index);
    if (isVertical || direction === 'rtl') thumbPosition = 1 - thumbPosition;
    let interactions = !isDisabled ? (0, _utils.mergeProps)(keyboardProps, moveProps, {
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown();
        },
        onPointerDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onDown(e.changedTouches[0].identifier);
        }
    }) : {};
    (0, _utils.useFormReset)(inputRef, state.defaultValues[index], (v)=>{
        state.setThumbValue(index, v);
    });
    // We install mouse handlers for the drag motion on the thumb div, but
    // not the key handler for moving the thumb with the slider.  Instead,
    // we focus the range input, and let the browser handle the keyboard
    // interactions; we then listen to input's onChange to update state.
    return {
        inputProps: (0, _utils.mergeProps)(focusableProps, fieldProps, {
            type: 'range',
            tabIndex: !isDisabled ? 0 : undefined,
            min: state.getThumbMinValue(index),
            max: state.getThumbMaxValue(index),
            step: state.step,
            value: value,
            name,
            form,
            disabled: isDisabled,
            'aria-orientation': orientation,
            'aria-valuetext': state.getThumbValueLabel(index),
            'aria-required': isRequired || undefined,
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': opts['aria-errormessage'],
            'aria-describedby': [
                data['aria-describedby'],
                opts['aria-describedby']
            ].filter(Boolean).join(' '),
            'aria-details': [
                data['aria-details'],
                opts['aria-details']
            ].filter(Boolean).join(' '),
            onChange: (e)=>{
                state.setThumbValue(index, parseFloat(e.target.value));
            }
        }),
        thumbProps: {
            ...interactions,
            style: {
                position: 'absolute',
                [isVertical ? 'top' : 'left']: `${thumbPosition * 100}%`,
                transform: 'translate(-50%, -50%)',
                touchAction: 'none'
            }
        },
        labelProps,
        isDragging: state.isThumbDragging(index),
        isDisabled,
        isFocused
    };
}

},{"@react-aria/utils":[["clamp","kO94U"],["focusWithoutScrolling","81NOP"],["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useGlobalListeners","ceyTG"]],"./utils":"g86lM","react":"a1TxN","@react-aria/interactions":[["useFocusable","kCQqy"],["useKeyboard","vsbUl"],["useMove","kqQMp"]],"@react-aria/label":"baGld","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4wUXI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a slider component. Stores values for all thumbs,
 * formats values for localization, and provides methods to update the position
 * of any thumbs.
 * @param props
 */ parcelHelpers.export(exports, "useSliderState", ()=>useSliderState);
var _utils = require("@react-stately/utils");
var _react = require("react");
const DEFAULT_MIN_VALUE = 0;
const DEFAULT_MAX_VALUE = 100;
const DEFAULT_STEP_VALUE = 1;
function useSliderState(props) {
    const { isDisabled = false, minValue = DEFAULT_MIN_VALUE, maxValue = DEFAULT_MAX_VALUE, numberFormatter: formatter, step = DEFAULT_STEP_VALUE, orientation = 'horizontal' } = props;
    // Page step should be at least equal to step and always a multiple of the step.
    let pageSize = (0, _react.useMemo)(()=>{
        let calcPageSize = (maxValue - minValue) / 10;
        calcPageSize = (0, _utils.snapValueToStep)(calcPageSize, 0, calcPageSize + step, step);
        return Math.max(calcPageSize, step);
    }, [
        step,
        maxValue,
        minValue
    ]);
    let restrictValues = (0, _react.useCallback)((values)=>values?.map((val, idx)=>{
            let min = idx === 0 ? minValue : values[idx - 1];
            let max = idx === values.length - 1 ? maxValue : values[idx + 1];
            return (0, _utils.snapValueToStep)(val, min, max, step);
        }), [
        minValue,
        maxValue,
        step
    ]);
    let value = (0, _react.useMemo)(()=>restrictValues(convertValue(props.value)), [
        props.value,
        restrictValues
    ]);
    let defaultValue = (0, _react.useMemo)(()=>restrictValues(convertValue(props.defaultValue) ?? [
            minValue
        ]), [
        props.defaultValue,
        minValue,
        restrictValues
    ]);
    let onChange = createOnChange(props.value, props.defaultValue, props.onChange);
    let onChangeEnd = createOnChange(props.value, props.defaultValue, props.onChangeEnd);
    const [values, setValuesState] = (0, _utils.useControlledState)(value, defaultValue, onChange);
    let [initialValues] = (0, _react.useState)(values);
    const [isDraggings, setDraggingsState] = (0, _react.useState)(new Array(values.length).fill(false));
    const isEditablesRef = (0, _react.useRef)(new Array(values.length).fill(true));
    const [focusedIndex, setFocusedIndex] = (0, _react.useState)(undefined);
    const valuesRef = (0, _react.useRef)(values);
    const isDraggingsRef = (0, _react.useRef)(isDraggings);
    let setValues = (values)=>{
        valuesRef.current = values;
        setValuesState(values);
    };
    let setDraggings = (draggings)=>{
        isDraggingsRef.current = draggings;
        setDraggingsState(draggings);
    };
    function getValuePercent(value) {
        return (value - minValue) / (maxValue - minValue);
    }
    function getThumbMinValue(index) {
        return index === 0 ? minValue : values[index - 1];
    }
    function getThumbMaxValue(index) {
        return index === values.length - 1 ? maxValue : values[index + 1];
    }
    function isThumbEditable(index) {
        return isEditablesRef.current[index];
    }
    function setThumbEditable(index, editable) {
        isEditablesRef.current[index] = editable;
    }
    function updateValue(index, value) {
        if (isDisabled || !isThumbEditable(index)) return;
        const thisMin = getThumbMinValue(index);
        const thisMax = getThumbMaxValue(index);
        // Round value to multiple of step, clamp value between min and max
        value = (0, _utils.snapValueToStep)(value, thisMin, thisMax, step);
        let newValues = replaceIndex(valuesRef.current, index, value);
        setValues(newValues);
    }
    function updateDragging(index, dragging) {
        if (isDisabled || !isThumbEditable(index)) return;
        if (dragging) valuesRef.current = values;
        const wasDragging = isDraggingsRef.current[index];
        isDraggingsRef.current = replaceIndex(isDraggingsRef.current, index, dragging);
        setDraggings(isDraggingsRef.current);
        // Call onChangeEnd if no handles are dragging.
        if (onChangeEnd && wasDragging && !isDraggingsRef.current.some(Boolean)) onChangeEnd(valuesRef.current);
    }
    function getFormattedValue(value) {
        return formatter.format(value);
    }
    function setThumbPercent(index, percent) {
        updateValue(index, getPercentValue(percent));
    }
    function getRoundedValue(value) {
        return Math.round((value - minValue) / step) * step + minValue;
    }
    function getPercentValue(percent) {
        const val = percent * (maxValue - minValue) + minValue;
        return (0, _utils.clamp)(getRoundedValue(val), minValue, maxValue);
    }
    function incrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, _utils.snapValueToStep)(values[index] + s, minValue, maxValue, step));
    }
    function decrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, _utils.snapValueToStep)(values[index] - s, minValue, maxValue, step));
    }
    return {
        values: values,
        defaultValues: props.defaultValue !== undefined ? defaultValue : initialValues,
        getThumbValue: (index)=>values[index],
        setThumbValue: updateValue,
        setThumbPercent,
        isThumbDragging: (index)=>isDraggings[index],
        setThumbDragging: updateDragging,
        focusedThumb: focusedIndex,
        setFocusedThumb: setFocusedIndex,
        getThumbPercent: (index)=>getValuePercent(values[index]),
        getValuePercent,
        getThumbValueLabel: (index)=>getFormattedValue(values[index]),
        getFormattedValue,
        getThumbMinValue,
        getThumbMaxValue,
        getPercentValue,
        isThumbEditable,
        setThumbEditable,
        incrementThumb,
        decrementThumb,
        step,
        pageSize,
        orientation,
        isDisabled
    };
}
function replaceIndex(array, index, value) {
    if (array[index] === value) return array;
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
}
function convertValue(value) {
    if (value == null) return undefined;
    return Array.isArray(value) ? value : [
        value
    ];
}
function createOnChange(value, defaultValue, onChange) {
    return (newValue)=>{
        if (typeof value === 'number' || typeof defaultValue === 'number') onChange?.(newValue[0]);
        else onChange?.(newValue);
    };
}

},{"@react-stately/utils":[["clamp","kO94U"],["snapValueToStep","kO94U"],["useControlledState","4Nj6T"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ixJJx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderContext", ()=>SliderContext);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "thumbContainer", ()=>thumbContainer);
parcelHelpers.export(exports, "thumbHitArea", ()=>thumbHitArea);
parcelHelpers.export(exports, "thumb", ()=>thumb);
parcelHelpers.export(exports, "upperTrack", ()=>upperTrack);
parcelHelpers.export(exports, "filledTrack", ()=>filledTrack);
parcelHelpers.export(exports, "SliderBase", ()=>SliderBase);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _field = require("./Field");
var _form = require("./Form");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _utils1 = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const slider = function anonymous(props, overrides) {
    let rules = " ";
    rules += ((overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) rules += ' pp12';
    else rules += ' pv12';
    if (props.labelPosition === "side") rules += ' eb12';
    if (props.isInForm) rules += ' qg12';
    else if (props.size === "XL") rules += ' qj12';
    else if (props.size === "L") rules += ' qi12';
    else if (props.size === "M") rules += ' ql12';
    else if (props.size === "S") rules += ' ql12';
    return rules;
};
const labelContainer = function anonymous(props) {
    let rules = " ";
    if (props.labelPosition === "top") rules += ' se12';
    rules += ' zv6x9r12';
    rules += ' yv6x9r12';
    rules += ' Bv6x9r12';
    rules += ' Av6x9r12';
    rules += ' Za12';
    if (props.labelPosition === "top") rules += ' C09aAFd12';
    if (props.labelPosition === "top") rules += ' Dxumf9b12';
    if (props.labelPosition === "side") {
        if (props.labelAlign === "end") rules += ' _Wb12';
        else if (props.labelAlign === "start") rules += ' _Wd12';
    }
    rules += ' -AJjOLd-Qd12';
    return rules;
};
const output = function anonymous(props) {
    let rules = " ";
    rules += ' zChk6v12';
    rules += ' yChk6v12';
    rules += ' BChk6v12';
    rules += ' AChk6v12';
    if (props.labelPosition === "side") {
        if (props.isInForm) rules += ' _Wb12';
        else if (props.direction === "rtl") rules += ' _Wb12';
        else if (props.direction === "ltr") rules += ' _Wd12';
    } else if (props.labelPosition === "top") {
        if (props.direction === "rtl") rules += ' _Wd12';
        else if (props.direction === "ltr") rules += ' _Wb12';
    }
    return rules;
};
let track = function anonymous(props) {
    let rules = " ";
    rules += ' zCPUPs12';
    rules += ' yCPUPs12';
    rules += ' BCPUPs12';
    rules += ' ACPUPs12';
    rules += ' _Pc12';
    rules += ' Za12';
    if (props.size === "XL") rules += ' Fz12';
    else if (props.size === "L") rules += ' Fv12';
    else if (props.size === "M") rules += ' Fx12';
    else if (props.size === "S") rules += ' Fp12';
    return rules;
};
let thumbContainer = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' Zo12';
    else if (props.size === "L") rules += ' Zn12';
    else if (props.size === "M") rules += ' Zm12';
    else if (props.size === "S") rules += ' Zl12';
    if (props.size === "XL") rules += ' Fp12';
    else if (props.size === "L") rules += ' Fo12';
    else if (props.size === "M") rules += ' Fn12';
    else if (props.size === "S") rules += ' Fm12';
    rules += ' sg12';
    rules += ' _Pa12';
    rules += ' WF12';
    return rules;
};
let thumbHitArea = function anonymous(props) {
    let rules = " ";
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Zp12';
        else if (props.size === "L") rules += ' Zo12';
        else if (props.size === "M") rules += ' Zn12';
        else if (props.size === "S") rules += ' Zm12';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Zo12';
        else if (props.size === "L") rules += ' Zn12';
        else if (props.size === "M") rules += ' Zm12';
        else if (props.size === "S") rules += ' Zl12';
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Fq12';
        else if (props.size === "L") rules += ' Fp12';
        else if (props.size === "M") rules += ' Fo12';
        else if (props.size === "S") rules += ' Fn12';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Fp12';
        else if (props.size === "L") rules += ' Fo12';
        else if (props.size === "M") rules += ' Fn12';
        else if (props.size === "S") rules += ' Fm12';
    }
    return rules;
};
let thumb = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' sg12';
    rules += ' _oa12';
    rules += ' _Pa12';
    rules += ' WF12';
    rules += ' _EF12';
    rules += ' _Zd12';
    if (props.thumbStyle === "precise") rules += ' Zg12';
    else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Zo12';
        else if (props.size === "L") rules += ' Zn12';
        else if (props.size === "M") rules += ' Zm12';
        else if (props.size === "S") rules += ' Zl12';
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Fq12';
        else if (props.size === "L") rules += ' Fp12';
        else if (props.size === "M") rules += ' Fo12';
        else if (props.size === "S") rules += ' Fn12';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Fp12';
        else if (props.size === "L") rules += ' Fo12';
        else if (props.size === "M") rules += ' Fn12';
        else if (props.size === "S") rules += ' Fm12';
    }
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    rules += ' _jf12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    if (props.isDisabled) rules += ' iq12';
    else if (props.isDragging) rules += ' in12';
    else if (props.isHovered) rules += ' in12';
    else rules += ' iv12';
    if (props.isDisabled) rules += ' ilc12';
    rules += ' gX12';
    return rules;
};
const trackStyling = {
    height: {
        trackStyle: {
            thin: 4,
            thick: 16
        }
    },
    top: '50%',
    borderRadius: {
        trackStyle: {
            thin: 'lg',
            thick: 'sm'
        }
    }
};
let upperTrack = function anonymous(props) {
    let rules = " ";
    if (props.trackStyle === "thick") rules += ' Ft12';
    else if (props.trackStyle === "thin") rules += ' Fe12';
    rules += ' WF12';
    if (props.trackStyle === "thick") rules += ' oa12';
    else if (props.trackStyle === "thin") rules += ' oc12';
    if (props.trackStyle === "thick") rules += ' na12';
    else if (props.trackStyle === "thin") rules += ' nc12';
    if (props.trackStyle === "thick") rules += ' ka12';
    else if (props.trackStyle === "thin") rules += ' kc12';
    if (props.trackStyle === "thick") rules += ' ja12';
    else if (props.trackStyle === "thin") rules += ' jc12';
    rules += ' _Pa12';
    if (props.isDisabled) rules += ' gH12';
    else rules += ' gE12';
    rules += ' -_8PloMd-m12';
    rules += ' __Ya12';
    rules += ' Za12';
    rules += ' _oa12';
    rules += ' _jf12';
    rules += ' _kEjZtrc12';
    rules += ' hEjZtrc12';
    rules += ' mEjZtrc12';
    rules += ' lEjZtrc12';
    rules += ' iA12';
    if (props.isDisabled) rules += ' ilc12';
    else rules += ' ilb12';
    return rules;
};
let filledTrack = function anonymous(props) {
    let rules = " ";
    if (props.trackStyle === "thick") rules += ' Ft12';
    else if (props.trackStyle === "thin") rules += ' Fe12';
    rules += ' WF12';
    if (props.trackStyle === "thick") rules += ' oa12';
    else if (props.trackStyle === "thin") rules += ' oc12';
    if (props.trackStyle === "thick") rules += ' na12';
    else if (props.trackStyle === "thin") rules += ' nc12';
    if (props.trackStyle === "thick") rules += ' ka12';
    else if (props.trackStyle === "thin") rules += ' kc12';
    if (props.trackStyle === "thick") rules += ' ja12';
    else if (props.trackStyle === "thin") rules += ' jc12';
    rules += ' _Pa12';
    if (props.isDisabled) rules += ' gH12';
    else if (props.isEmphasized) rules += ' g312';
    else rules += ' g_i12';
    if (props.isDisabled) rules += ' gld12';
    else rules += ' gle12';
    rules += ' _oa12';
    rules += ' _jf12';
    rules += ' _kEjZtrc12';
    rules += ' hEjZtrc12';
    rules += ' mEjZtrc12';
    rules += ' lEjZtrc12';
    rules += ' iA12';
    if (props.isDisabled) rules += ' ilc12';
    else rules += ' ilb12';
    rules += ' -_8PloMd-m12';
    rules += ' __Ya12';
    return rules;
};
function SliderBase(props1) {
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { label, labelPosition = 'top', labelAlign = 'start', size = 'M', minValue = 0, maxValue = 100, formatOptions } = props1;
    let formatter = (0, _i18N.useNumberFormatter)(formatOptions);
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Slider), {
        ...props1,
        ref: props1.sliderRef,
        className: (renderProps)=>(props1.UNSAFE_className || '') + (0, _runtime.mergeStyles)(function anonymous(props) {
                let rules = " ";
                rules += ' se12';
                if (props.isInForm) rules += ' z2mU12';
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' yvoofG12';
                }
                if (props.isInForm) rules += ' DLwlgod12';
                else {
                    if (props.labelPosition === "side") rules += ' DPlN5qb12';
                    else if (props.labelPosition === "top") rules += ' DM8Mfn12';
                }
                if (props.labelPosition === "side") rules += ' EPlN5qb12';
                else if (props.labelPosition === "top") rules += ' E4w1sLc12';
                if (props.labelPosition === "side") rules += ' CbRM95c12';
                else if (props.labelPosition === "top") rules += ' Cxaocre12';
                if (props.size === "XL") {
                    rules += ' -_6BNtrc-e12';
                    rules += ' vx12';
                } else if (props.size === "L") {
                    rules += ' -_6BNtrc-d12';
                    rules += ' vx12';
                } else if (props.size === "S") {
                    rules += ' -_6BNtrc-b12';
                    rules += ' vx12';
                } else if (props.size === "XS") {
                    rules += ' -_6BNtrc-a12';
                    rules += ' vx12';
                } else {
                    rules += ' -_6BNtrc-c12';
                    rules += ' vx12';
                }
                rules += ' ea12';
                rules += ' _Fd12';
                rules += ' _FnuYUweb12';
                if (props.size === "XL") rules += ' -BhX7R-Fz12';
                else if (props.size === "L") rules += ' -BhX7R-Fv12';
                else if (props.size === "S") rules += ' -BhX7R-Fp12';
                else if (props.size === "XS") rules += ' -BhX7R-Fn12';
                else rules += ' -BhX7R-Fx12';
                rules += ' -AJjOLd-UVkF0Db12';
                rules += ' qg12';
                rules += ' __ca12';
                return rules;
            }({
                labelPosition,
                isInForm: !!formContext
            }), slider({
                ...renderProps,
                labelPosition,
                size,
                isInForm: !!formContext
            }, props1.styles)),
        children: ({ state })=>{
            let maxLabelLength = Math.max([
                ...formatter.format(minValue)
            ].length, [
                ...formatter.format(maxValue)
            ].length);
            switch(state.values.length){
                case 1:
                    break;
                case 2:
                    // This should really use the NumberFormat#formatRange proposal...
                    // https://github.com/tc39/ecma402/issues/393
                    // https://github.com/tc39/proposal-intl-numberformat-v3#formatrange-ecma-402-393
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatRange
                    maxLabelLength = 3 + 2 * Math.max(maxLabelLength, [
                        ...formatter.format(minValue)
                    ].length, [
                        ...formatter.format(maxValue)
                    ].length);
                    break;
                default:
                    throw new Error('Only sliders with 1 or 2 handles are supported!');
            }
            let outputValue = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderOutput), {
                style: {
                    width: `${maxLabelLength}ch`,
                    minWidth: `${maxLabelLength}ch`,
                    fontVariantNumeric: 'tabular-nums'
                },
                className: output({
                    direction,
                    labelPosition,
                    isInForm: !!formContext
                }),
                children: ({ state })=>state.values.map((_, i)=>state.getThumbValueLabel(i)).join(" \u2013 ")
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: labelContainer({
                            labelPosition,
                            labelAlign
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                                isDisabled: props1.isDisabled,
                                size: props1.size,
                                labelPosition: labelPosition,
                                labelAlign: labelAlign,
                                contextualHelp: props1.contextualHelp,
                                children: label
                            }),
                            labelPosition === 'top' && outputValue
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr12';
                            rules += ' yXcEWr12';
                            rules += ' BXcEWr12';
                            rules += ' AXcEWr12';
                            if (props.size === "XL") rules += ' Nl12';
                            else if (props.size === "L") rules += ' Nj12';
                            else if (props.size === "S") rules += ' Nf12';
                            else if (props.size === "XS") rules += ' Ne12';
                            else rules += ' Nk12';
                            if (props.isQuiet) rules += ' _qd12';
                            else rules += ' _qtb12';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt12';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne12';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr12';
                            else rules += ' -Anxdcc-Z3fn9H12';
                            rules += ' __v6TNLWb12';
                            rules += ' sh12';
                            rules += ' eb12';
                            if (props.size === "XL") rules += ' Uj12';
                            else if (props.size === "L") rules += ' Ui12';
                            else rules += ' Ul12';
                            if (props.size === "XL") rules += ' qj12';
                            else if (props.size === "L") rules += ' qi12';
                            else rules += ' ql12';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            props1.children,
                            labelPosition === 'side' && outputValue
                        ]
                    })
                ]
            });
        }
    });
}
const Slider = /*#__PURE__*/ (0, _react.forwardRef)(function Slider(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SliderContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { labelPosition = 'top', size = 'M', fillOffset, isEmphasized, trackStyle = 'thin', thumbStyle = 'default' } = props;
    let thumbRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null); // TODO: need to pass inputRef to SliderThumb when we release the next version of RAC 1.3.0
    let domRef = (0, _utils1.useFocusableRef)(ref, inputRef);
    let { direction } = (0, _i18N.useLocale)();
    let cssDirection = direction === 'rtl' ? 'right' : 'left';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SliderBase, {
        ...props,
        sliderRef: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
            className: track({
                size,
                labelPosition,
                isInForm: !!formContext
            }),
            children: ({ state, isDisabled })=>{
                fillOffset = fillOffset !== undefined ? (0, _utils.clamp)(fillOffset, state.getThumbMinValue(0), state.getThumbMaxValue(0)) : state.getThumbMinValue(0);
                let fillWidth = state.getThumbPercent(0) - state.getValuePercent(fillOffset);
                let isRightOfOffset = fillWidth > 0;
                let offset = isRightOfOffset ? state.getValuePercent(fillOffset) : state.getThumbPercent(0);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: upperTrack({
                                isDisabled,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                width: `${Math.abs(fillWidth) * 100}%`,
                                [cssDirection]: `${offset * 100}%`
                            },
                            className: filledTrack({
                                isDisabled,
                                isEmphasized,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: thumbContainer,
                            index: 0,
                            name: props.name,
                            form: props.form,
                            ref: thumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(thumbRef, {
                                    transform: 'translate(-50%, -50%)'
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: thumbHitArea({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: thumb({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        })
                    ]
                });
            }
        })
    });
});

},{"0":"96mNm","1":"i8QXE","2":"bhXQi","3":"fuZZr","4":"hQuwD","5":"4pCjV","6":"knqgT","7":"jtgUC","8":"l66Pv","9":"cmeSK","10":"3c6qI","react/jsx-runtime":"2Is6Z","react-aria-components":"34zZe","@react-aria/utils":"kO94U","react":"a1TxN","./Field":"eI7CE","./Form":"cHqN4","../style/runtime":"8g9no","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@react-aria/i18n":[["useLocale","4k4z8"],["useNumberFormatter","hZwAZ"]],"./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"96mNm":[function() {},{}],"i8QXE":[function() {},{}],"bhXQi":[function() {},{}],"fuZZr":[function() {},{}],"hQuwD":[function() {},{}],"4pCjV":[function() {},{}],"knqgT":[function() {},{}],"jtgUC":[function() {},{}],"l66Pv":[function() {},{}],"cmeSK":[function() {},{}],"3c6qI":[function() {},{}],"dIOQS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchContext", ()=>SwitchContext);
parcelHelpers.export(exports, "Switch", ()=>Switch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SwitchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let gridColumnStart = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "z") gridColumnStart = true;
        rules += p[0];
    }
    rules += ' sd12';
    rules += ' qf12';
    rules += ' ea12';
    if (!width) rules += ' ZJ12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) {
        rules += ' pp12';
        rules += ' plc12';
    } else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' Yc12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' zhJUGr12';
    }
    rules += ' __ca12';
    return rules;
};
const track = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    rules += ' -ERv7Xb-ZmDIzbc12';
    if (props.size === "XL") rules += ' -LsrJQc-Fn12';
    else if (props.size === "L") rules += ' -LsrJQc-Fm12';
    else if (props.size === "S") rules += ' -LsrJQc-Fl12';
    else rules += ' -LsrJQc-Ft12';
    rules += ' ZAkyXj12';
    rules += ' Fpk5ROc12';
    rules += ' _oa12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    rules += ' _jf12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _yb12';
    if (props.isSelected) rules += ' iA12';
    else if (props.isDisabled) {
        rules += ' io12';
        rules += ' ilc12';
    } else {
        if (props.isPressed) rules += ' in12';
        else if (props.isFocusVisible) rules += ' in12';
        else if (props.isHovered) rules += ' in12';
        else rules += ' iv12';
        rules += ' ila12';
    }
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' gw12';
            rules += ' gld12';
        } else {
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' gY12';
                else if (props.isFocusVisible) rules += ' gY12';
                else if (props.isHovered) rules += ' gY12';
                else rules += ' g312';
            } else {
                if (props.isPressed) rules += ' gu12';
                else if (props.isFocusVisible) rules += ' gu12';
                else if (props.isHovered) rules += ' gu12';
                else rules += ' g012';
            }
            rules += ' gle12';
        }
    } else rules += ' gX12';
    return rules;
};
const handle = function anonymous(props) {
    let rules = " ";
    rules += ' Fb12';
    rules += ' fa12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    if (props.isSelected) rules += ' gX12';
    else if (props.isDisabled) {
        rules += ' gw12';
        rules += ' gld12';
    } else {
        if (props.isPressed) rules += ' gu12';
        else if (props.isFocusVisible) rules += ' gu12';
        else if (props.isHovered) rules += ' gu12';
        else rules += ' g012';
    }
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    return rules;
};
// Use an inline style to calculate the transform so we can combine it with the press scale.
const transformStyle = ({ isSelected, direction })=>{
    // In the default state, the handle is 8px smaller than the track. When selected it grows to 6px smaller than the track.
    // Normally this could be calculated as a scale transform with (trackHeight - 8px) / trackHeight, however,
    // CSS does not allow division with units. To solve this we use a 3d perspective transform. Perspective is the
    // distance from the Z=0 plane to the viewer. Since we want to scale the handle by a fixed amount and we cannot divide
    // by a value with units, we can set the Z translation to a fixed amount and change the perspective in order to achieve
    // the desired effect. Given the following formula:
    //
    //   scale = perspective / (perspective - translateZ)
    //
    // and desired scale factors (accounting for the 2px border on each side of the track):
    //
    //   defaultScale = (trackHeight - 8px) / (trackHeight - 4px)
    //   selectedScale = (trackHeight - 6px) / (trackHeight - 4px)
    //
    // we can solve for the perspective needed in each case where translateZ is hard coded to -4px:
    //
    //    defaultPerspective = trackHeight - 8px
    //    selectedPerspective = 2 * (trackHeight - 6px)
    const placement = direction === 'ltr' ? 'translateX(calc(var(--trackWidth) - 100% - 4px)) perspective(calc(2 * (var(--trackHeight) - 6px))) translateZ(-4px)' : 'translateX(calc(100% - var(--trackWidth) + 4px)) perspective(calc(2 * (var(--trackHeight) - 6px))) translateZ(-4px)';
    return {
        transform: isSelected ? placement : 'perspective(calc(var(--trackHeight) - 8px)) translateZ(-4px)'
    };
};
const Switch = /*#__PURE__*/ (0, _react.forwardRef)(function Switch(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SwitchContext);
    let { children, UNSAFE_className = '', UNSAFE_style } = props;
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let handleRef = (0, _react.useRef)(null);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    let { direction } = (0, _reactAriaComponents.useLocale)();
    props = (0, _form.useFormProps)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Switch), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + wrapper({
                ...renderProps,
                isInForm,
                size: props.size || 'M'
            }, props.styles),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: track({
                                ...renderProps,
                                size: props.size || 'M',
                                isEmphasized: props.isEmphasized
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                ref: handleRef,
                                style: (0, _pressScale.pressScale)(handleRef, transformStyle)({
                                    ...renderProps,
                                    direction
                                }),
                                className: handle(renderProps)
                            })
                        })
                    }),
                    children
                ]
            })
    });
});

},{"0":"jTpo6","1":"i6yuc","2":"bOZGh","react/jsx-runtime":"2Is6Z","react-aria-components":[["Switch","fs6Z0"],["useLocale","4k4z8"]],"./CenterBaseline":"1vpL9","react":"a1TxN","./Form":"cHqN4","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jTpo6":[function() {},{}],"i6yuc":[function() {},{}],"bOZGh":[function() {},{}],"fs6Z0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchContext", ()=>SwitchContext);
parcelHelpers.export(exports, "Switch", ()=>Switch);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
const SwitchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Switch = /*#__PURE__*/ (0, _react.forwardRef)(function Switch(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, _utils.useContextProps)(otherProps, ref, SwitchContext);
    let inputRef = (0, _utils1.useObjectRef)((0, _utils1.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null));
    let state = (0, _reactStately.useToggleState)(props);
    let { labelProps, inputProps, isSelected, isDisabled, isReadOnly, isPressed } = (0, _reactAria.useSwitch)({
        ...(0, _utils.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let isInteractionDisabled = props.isDisabled || props.isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Switch',
        values: {
            isSelected,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly,
            state
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _reactAria.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _reactAria.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});

},{"react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useSwitch","24TrV"],["VisuallyHidden","7zrGr"]],"./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeRefs","1vHgg"],["useObjectRef","laqO5"]],"react":"a1TxN","react-stately":"gqIeU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"24TrV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a switch component.
 * A switch is similar to a checkbox, but represents on/off values as opposed to selection.
 * @param props - Props for the switch.
 * @param state - State for the switch, as returned by `useToggleState`.
 * @param ref - Ref to the HTML input element.
 */ parcelHelpers.export(exports, "useSwitch", ()=>useSwitch);
var _toggle = require("@react-aria/toggle");
function useSwitch(props, state, ref) {
    let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = (0, _toggle.useToggle)(props, state, ref);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            role: 'switch',
            checked: isSelected
        },
        isSelected,
        isPressed,
        isDisabled,
        isReadOnly
    };
}

},{"@react-aria/toggle":"1FamP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7oxrW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextFieldContext", ()=>TextFieldContext);
parcelHelpers.export(exports, "TextField", ()=>TextField);
parcelHelpers.export(exports, "TextAreaContext", ()=>TextAreaContext);
parcelHelpers.export(exports, "TextArea", ()=>TextArea);
parcelHelpers.export(exports, "TextFieldBase", ()=>TextFieldBase);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TextFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TextField = /*#__PURE__*/ (0, _react.forwardRef)(function TextField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TextFieldContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextFieldBase, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {})
    });
});
const TextAreaContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TextArea = /*#__PURE__*/ (0, _react.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TextAreaContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextFieldBase, {
        ...props,
        ref: ref,
        fieldGroupCss: " ea12 Fd12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextAreaInput, {})
    });
});
const TextFieldBase = /*#__PURE__*/ (0, _react.forwardRef)(function TextFieldBase(props, ref) {
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _react.useRef)(null);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', fieldGroupCss, UNSAFE_style, UNSAFE_className = '', ...textFieldProps } = props;
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TextField), {
        ...textFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                }
            }
            if (props.isInForm) rules += ' DLwlgod12';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb12';
                else if (props.labelPosition === "top") rules += ' DM8Mfn12';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb12';
            else if (props.labelPosition === "top") rules += ' E4w1sLc12';
            if (props.labelPosition === "side") rules += ' CbRM95c12';
            else if (props.labelPosition === "top") rules += ' Cxaocre12';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                rules += ' vx12';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                rules += ' vx12';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                rules += ' vx12';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                rules += ' vx12';
            } else {
                rules += ' -_6BNtrc-c12';
                rules += ' vx12';
            }
            rules += ' ea12';
            rules += ' _Fd12';
            rules += ' _FnuYUweb12';
            if (props.size === "XL") rules += ' -BhX7R-Fz12';
            else if (props.size === "L") rules += ' -BhX7R-Fv12';
            else if (props.size === "S") rules += ' -BhX7R-Fp12';
            else if (props.size === "XS") rules += ' -BhX7R-Fn12';
            else rules += ' -BhX7R-Fx12';
            rules += ' -AJjOLd-UVkF0Db12';
            rules += ' qg12';
            rules += ' __ca12';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        size: props.size,
                        styles: fieldGroupCss,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Consumer, {
                                children: (ctx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.InputContext).Provider, {
                                        value: {
                                            ...ctx,
                                            ref: (0, _utils1.mergeRefs)(ctx?.ref, inputRef)
                                        },
                                        children: children
                                    })
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            }))
    });
});
function TextAreaInput() {
    // Force re-render when value changes so we update the height.
    let { placeholder } = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.TextAreaContext)) ?? {};
    let onHeightChange = (input)=>{
        // TODO: only do this if an explicit height is not given?
        if (input) {
            let prevAlignment = input.style.alignSelf;
            let prevOverflow = input.style.overflow;
            // Firefox scroll position is lost when overflow: 'hidden' is applied so we skip applying it.
            // The measure/applied height is also incorrect/reset if we turn on and off
            // overflow: hidden in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1787062
            let isFirefox = 'MozAppearance' in input.style;
            if (!isFirefox) input.style.overflow = 'hidden';
            input.style.alignSelf = 'start';
            input.style.height = 'auto';
            // offsetHeight - clientHeight accounts for the border/padding.
            input.style.height = `${input.scrollHeight + (input.offsetHeight - input.clientHeight)}px`;
            input.style.overflow = prevOverflow;
            input.style.alignSelf = prevAlignment;
        }
    };
    let { ref } = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.InputContext)) ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TextArea), {
        ref: (0, _utils1.mergeRefs)(onHeightChange, ref),
        // Workaround for baseline alignment bug in Safari.
        // https://bugs.webkit.org/show_bug.cgi?id=142968
        placeholder: placeholder ?? ' ',
        className: function anonymous(props) {
            let rules = " ";
            rules += ' Sd12';
            rules += ' Rd12';
            rules += ' Tu7Fubd12';
            rules += ' Qu7Fubd12';
            rules += ' MAyFGYc12';
            rules += ' _oa12';
            rules += ' g912';
            rules += ' p40ub4c12';
            rules += ' pYFIK2bn12';
            rules += ' u40ub4c12';
            rules += ' v40ub4c12';
            rules += ' x40ub4c12';
            rules += ' _xa12';
            rules += ' _F40ub4c12';
            rules += ' _ub12';
            rules += ' Na12';
            rules += ' _Le12';
            rules += ' _je12';
            rules += ' _Qc12';
            rules += ' _Nc12';
            if (props.size === "XL") rules += ' -M_-Mk12';
            else if (props.size === "L") rules += ' -M_-Mh12';
            else if (props.size === "S") rules += ' -M_-Mg12';
            else if (props.size === "XS") rules += ' -M_-Mf12';
            else rules += ' -M_-Mi12';
            return rules;
        }
    });
}

},{"0":"2olis","1":"fH59b","2":"46KDr","react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["useSlottedContext","bA6Cz"],["InputContext","jU9y1"],["TextArea","eeWHl"],["TextAreaContext","eeWHl"],["TextField","3CtQI"]],"react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","@react-aria/utils":"1vHgg","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2olis":[function() {},{}],"fH59b":[function() {},{}],"46KDr":[function() {},{}],"eeWHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaContext", ()=>TextAreaContext);
parcelHelpers.export(exports, "TextArea", ()=>TextArea);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TextAreaContext = /*#__PURE__*/ (0, _react.createContext)({});
let filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart, onHoverChange, onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const TextArea = /*#__PURE__*/ (0, _react.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TextAreaContext);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid
        },
        defaultClassName: 'react-aria-TextArea'
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("textarea", {
        ...(0, _reactAria.mergeProps)(filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});

},{"./utils":"bA6Cz","react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3CtQI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextFieldContext", ()=>TextFieldContext);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _rspcontexts = require("./RSPContexts");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textArea = require("./TextArea");
var _text = require("./Text");
const TextFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TextField = /*#__PURE__*/ (0, _collections.createHideableComponent)(function TextField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TextFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, _react.useRef)(null);
    [props, inputRef] = (0, _utils.useContextProps)(props, inputRef, (0, _rspcontexts.FieldInputContext));
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let [inputElementType, setInputElementType] = (0, _react.useState)('input');
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useTextField)({
        ...(0, _utils.removeDataAttributes)(props),
        inputElementType,
        label,
        validationBehavior
    }, inputRef);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    let inputOrTextAreaRef = (0, _react.useCallback)((el)=>{
        inputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? 'textarea' : 'input');
    }, [
        inputRef
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TextField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, _textArea.TextAreaContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"j6sGd","./utils":"bA6Cz","@react-aria/collections":"jY1vZ","./FieldError":"algyu","./RSPContexts":"lIerG","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","./TextArea":"eeWHl","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6wKQe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonContext", ()=>ToggleButtonContext);
parcelHelpers.export(exports, "ToggleButton", ()=>ToggleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _icon = require("./Icon");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _utils = require("@react-spectrum/utils");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ToggleButtonContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ToggleButton = /*#__PURE__*/ (0, _react.forwardRef)(function ToggleButton(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ToggleButtonContext);
    props = (0, _form.useFormProps)(props);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let ctx = (0, _reactAriaComponents.useSlottedContext)((0, _toggleButtonGroup.ToggleButtonGroupContext));
    let isInGroup = !!ctx;
    let { density = 'regular', isJustified, orientation = 'horizontal', staticColor = props.staticColor, isQuiet = props.isQuiet, isEmphasized = props.isEmphasized, size = props.size || 'M', isDisabled = props.isDisabled } = ctx || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        ...props,
        isDisabled: isDisabled,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _actionButton.btnStyles)({
                ...renderProps,
                staticColor,
                isStaticColor: !!staticColor,
                size,
                isQuiet,
                isEmphasized,
                isPending: false,
                density,
                isJustified,
                orientation,
                isInGroup
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _skeleton.SkeletonContext),
                    null
                ],
                [
                    (0, _content.TextContext),
                    {
                        styles: " TAzEcG12 QAzEcG12 _Jb12 _Nc12 Pc12 _Yb12 _7c12"
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " _Ja12"
                        }),
                        styles: " ZuUmpre12 FuUmpre12 I67logd12 _va12"
                    }
                ]
            ],
            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: props.children
            }) : props.children
        })
    });
});

},{"0":"1VYsM","1":"lQTNY","2":"9lOqG","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","./CenterBaseline":"1vpL9","react-aria-components":[["Provider","bA6Cz"],["useSlottedContext","bA6Cz"],["ToggleButton","98v4o"]],"react":"a1TxN","./Icon":"jQAJE","./pressScale":"8Ufux","./Skeleton":"1mUnF","./Content":"10r6w","./ToggleButtonGroup":"Df7oZ","@react-spectrum/utils":"jqfrX","./Form":"cHqN4","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1VYsM":[function() {},{}],"lQTNY":[function() {},{}],"9lOqG":[function() {},{}],"98v4o":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonContext", ()=>ToggleButtonContext);
parcelHelpers.export(exports, "ToggleButton", ()=>ToggleButton);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionIndicator = require("./SelectionIndicator");
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _reactStately = require("react-stately");
const ToggleButtonContext = /*#__PURE__*/ (0, _react.createContext)({});
const ToggleButton = /*#__PURE__*/ (0, _react.forwardRef)(function ToggleButton(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ToggleButtonContext);
    let groupState = (0, _react.useContext)((0, _toggleButtonGroup.ToggleGroupStateContext));
    let state = (0, _reactStately.useToggleState)(groupState && props.id != null ? {
        isSelected: groupState.selectedKeys.has(props.id),
        onChange (isSelected) {
            groupState.setSelected(props.id, isSelected);
        }
    } : props);
    let { buttonProps, isPressed, isSelected, isDisabled } = groupState && props.id != null ? (0, _reactAria.useToggleButtonGroupItem)({
        ...props,
        id: props.id
    }, groupState, ref) : (0, _reactAria.useToggleButton)({
        ...props,
        id: props.id != null ? String(props.id) : undefined
    }, state, ref);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)(props);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        values: {
            isHovered,
            isPressed,
            isFocused,
            isSelected: state.isSelected,
            isFocusVisible,
            isDisabled,
            state
        },
        defaultClassName: 'react-aria-ToggleButton'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-disabled": isDisabled || undefined,
        "data-pressed": isPressed || undefined,
        "data-selected": isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectionIndicator.SelectionIndicatorContext).Provider, {
        value: {
            isSelected
        }
    }, renderProps.children));
});

},{"react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useToggleButton","9zWT2"],["useToggleButtonGroupItem","dV4RG"]],"./utils":"bA6Cz","@react-aria/utils":"3upVm","react":"a1TxN","./SelectionIndicator":"dgQU7","./ToggleButtonGroup":"8CiqT","react-stately":"gqIeU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9zWT2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a toggle button component.
 * ToggleButtons allow users to toggle a selection on or off, for example switching between two states or modes.
 */ parcelHelpers.export(exports, "useToggleButton", ()=>useToggleButton);
var _useButton = require("./useButton");
var _utils = require("@react-aria/utils");
function useToggleButton(props, state, ref) {
    const { isSelected } = state;
    const { isPressed, buttonProps } = (0, _useButton.useButton)({
        ...props,
        onPress: (0, _utils.chain)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed,
        isSelected,
        isDisabled: props.isDisabled || false,
        buttonProps: (0, _utils.mergeProps)(buttonProps, {
            'aria-pressed': isSelected
        })
    };
}

},{"./useButton":"exEOU","@react-aria/utils":[["chain","ij7eS"],["mergeProps","aNvcY"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dV4RG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggleButtonGroup", ()=>useToggleButtonGroup);
/**
 * Provides the behavior and accessibility implementation for a toggle button component.
 * ToggleButtons allow users to toggle a selection on or off, for example switching between two states or modes.
 */ parcelHelpers.export(exports, "useToggleButtonGroupItem", ()=>useToggleButtonGroupItem);
var _useToggleButton = require("./useToggleButton");
var _toolbar = require("@react-aria/toolbar");
function useToggleButtonGroup(props, state, ref) {
    let { isDisabled } = props;
    let { toolbarProps } = (0, _toolbar.useToolbar)(props, ref);
    return {
        groupProps: {
            ...toolbarProps,
            role: state.selectionMode === 'single' ? 'radiogroup' : toolbarProps.role,
            'aria-disabled': isDisabled
        }
    };
}
function useToggleButtonGroupItem(props, state, ref) {
    let toggleState = {
        isSelected: state.selectedKeys.has(props.id),
        defaultSelected: false,
        setSelected (isSelected) {
            state.setSelected(props.id, isSelected);
        },
        toggle () {
            state.toggleKey(props.id);
        }
    };
    let { isPressed, isSelected, isDisabled, buttonProps } = (0, _useToggleButton.useToggleButton)({
        ...props,
        id: undefined,
        isDisabled: props.isDisabled || state.isDisabled
    }, toggleState, ref);
    if (state.selectionMode === 'single') {
        buttonProps.role = 'radio';
        buttonProps['aria-checked'] = toggleState.isSelected;
        delete buttonProps['aria-pressed'];
    }
    return {
        isPressed,
        isSelected,
        isDisabled,
        buttonProps
    };
}

},{"./useToggleButton":"9zWT2","@react-aria/toolbar":"gH8gm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8CiqT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonGroupContext", ()=>ToggleButtonGroupContext);
parcelHelpers.export(exports, "ToggleGroupStateContext", ()=>ToggleGroupStateContext);
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>ToggleButtonGroup);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sharedElementTransition = require("./SharedElementTransition");
var _reactStately = require("react-stately");
const ToggleButtonGroupContext = /*#__PURE__*/ (0, _react.createContext)({});
const ToggleGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ToggleButtonGroup = /*#__PURE__*/ (0, _react.forwardRef)(function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ToggleButtonGroupContext);
    let state = (0, _reactStately.useToggleGroupState)(props);
    let { groupProps } = (0, _reactAria.useToggleButtonGroup)(props, state, ref);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            state
        },
        defaultClassName: 'react-aria-ToggleButtonGroup'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'horizontal',
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ToggleGroupStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, renderProps.children)));
});

},{"react-aria":"dV4RG","./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"react":"a1TxN","./SharedElementTransition":"iVZnk","react-stately":"jh5do","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jh5do":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a group of toggles.
 * It supports both single and multiple selected items.
 */ parcelHelpers.export(exports, "useToggleGroupState", ()=>useToggleGroupState);
var _utils = require("@react-stately/utils");
var _react = require("react");
function useToggleGroupState(props) {
    let { selectionMode = 'single', disallowEmptySelection, isDisabled = false } = props;
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)((0, _react.useMemo)(()=>props.selectedKeys ? new Set(props.selectedKeys) : undefined, [
        props.selectedKeys
    ]), (0, _react.useMemo)(()=>props.defaultSelectedKeys ? new Set(props.defaultSelectedKeys) : new Set(), [
        props.defaultSelectedKeys
    ]), props.onSelectionChange);
    return {
        selectionMode,
        isDisabled,
        selectedKeys,
        setSelectedKeys,
        toggleKey (key) {
            let keys;
            if (selectionMode === 'multiple') {
                keys = new Set(selectedKeys);
                if (keys.has(key) && (!disallowEmptySelection || keys.size > 1)) keys.delete(key);
                else keys.add(key);
            } else keys = new Set(selectedKeys.has(key) && !disallowEmptySelection ? [] : [
                key
            ]);
            setSelectedKeys(keys);
        },
        setSelected (key, isSelected) {
            if (isSelected !== selectedKeys.has(key)) this.toggleKey(key);
        }
    };
}

},{"@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Df7oZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonGroupContext", ()=>ToggleButtonGroupContext);
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>ToggleButtonGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ToggleButtonGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ToggleButtonGroup = /*#__PURE__*/ (0, _react.forwardRef)(function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ToggleButtonGroupContext);
    let { density = 'regular', size = 'M', orientation = 'horizontal', isJustified, children, UNSAFE_className = '', UNSAFE_style, styles } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButtonGroup), {
        ...props,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, _actionButtonGroup.actionGroupStyle)({
            size,
            density,
            orientation,
            isJustified
        }, styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonGroupContext.Provider, {
            value: props,
            children: children
        })
    });
});

},{"react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","react-aria-components":"8CiqT","react":"a1TxN","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hi4fC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodePlatterProvider", ()=>CodePlatterProvider);
parcelHelpers.export(exports, "FileProvider", ()=>FileProvider);
parcelHelpers.export(exports, "ShadcnProvider", ()=>ShadcnProvider);
parcelHelpers.export(exports, "ShareUrlProvider", ()=>ShareUrlProvider);
parcelHelpers.export(exports, "CodePlatter", ()=>CodePlatter);
parcelHelpers.export(exports, "Pre", ()=>Pre);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _copyButton = require("./CopyButton");
var _codeSandbox = require("./CodeSandbox");
var _stackBlitz = require("./StackBlitz");
var _download = require("@react-spectrum/s2/icons/Download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _link = require("@react-spectrum/s2/icons/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _openIn = require("@react-spectrum/s2/icons/OpenIn");
var _openInDefault = parcelHelpers.interopDefault(_openIn);
var _polygon4 = require("@react-spectrum/s2/icons/Polygon4");
var _polygon4Default = parcelHelpers.interopDefault(_polygon4);
var _prompt = require("@react-spectrum/s2/icons/Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shadcnCommand = require("./ShadcnCommand");
var _zip = require("./zip");
'use client';
const platterStyle = " g_g12 oc12 nc12 kc12 jc12 -J75D5c-Sf12 -kAdake-Rf12 -wBZ9ae-Tf12 _Pc12";
const CodePlatterContext = /*#__PURE__*/ (0, _react.createContext)({
    library: 'react-spectrum'
});
function CodePlatterProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CodePlatterContext.Provider, {
        value: props,
        children: props.children
    });
}
const FileProviderContext = /*#__PURE__*/ (0, _react.createContext)(null);
function FileProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FileProviderContext, {
        ...props
    });
}
const ShadcnContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ShadcnProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShadcnContext, {
        ...props
    });
}
const ShareContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ShareUrlProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShareContext, {
        ...props
    });
}
function CodePlatter({ children, type, showCoachMark }) {
    let codeRef = (0, _react.useRef)(null);
    let [showShadcn, setShowShadcn] = (0, _react.useState)(false);
    let getText = ()=>codeRef.current.querySelector('pre').textContent;
    let { library } = (0, _react.useContext)(CodePlatterContext);
    if (!type) {
        if (library === 'react-aria') type = 'vanilla';
        else if (library === 'react-spectrum') type = 's2';
    }
    let { files, deps = {}, urls = {}, entry } = (0, _react.useContext)(FileProviderContext) ?? {};
    let registryUrl = (0, _react.useContext)(ShadcnContext);
    let shareUrl = (0, _react.useContext)(ShareContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: platterStyle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toolbar, {
                showCoachMark: showCoachMark,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButtonGroup), {
                    orientation: "vertical",
                    isQuiet: true,
                    density: "regular",
                    size: "S",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButton.CopyButton), {
                            ariaLabel: "Copy code",
                            tooltip: "Copy code",
                            getText: getText
                        }),
                        (shareUrl || files || registryUrl) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TooltipTrigger), {
                                    placement: "end",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            "aria-label": "Open in\u2026",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tooltip), {
                                            children: "Open in\u2026"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                    hideLinkOutIcon: true,
                                    children: [
                                        shareUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                // Find previous heading element to get hash.
                                                let url = new URL(shareUrl, location.href);
                                                let node = codeRef.current;
                                                while(node && node.parentElement?.tagName !== 'ARTICLE')node = node.parentElement;
                                                while(node && !(node instanceof HTMLHeadingElement))node = node.previousElementSibling;
                                                if (node instanceof HTMLHeadingElement && node.id) url.hash = '#' + node.id;
                                                navigator.clipboard.writeText(url.toString()).catch(()=>{
                                                    (0, _s2.UNSTABLE_ToastQueue).negative('Failed to copy link.');
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Copy link"
                                                })
                                            ]
                                        }),
                                        files && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                let filesToDownload = (0, _codeSandbox.getCodeSandboxFiles)(getExampleFiles(codeRef, files, urls, entry), deps, type, entry);
                                                let filesToZip = {};
                                                for(let key in filesToDownload)if (filesToDownload[key] && !key.startsWith('.codesandbox') && !key.startsWith('.devcontainer')) filesToZip[key] = filesToDownload[key].content;
                                                let blob = (0, _zip.zip)(filesToZip);
                                                let a = document.createElement('a');
                                                a.href = URL.createObjectURL(blob);
                                                a.download = 'example.zip';
                                                a.hidden = true;
                                                document.body.appendChild(a);
                                                a.click();
                                                a.remove();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Download ZIP"
                                                })
                                            ]
                                        }),
                                        registryUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>setShowShadcn(true),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    children: "Install with shadcn"
                                                })
                                            ]
                                        }),
                                        files && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                (0, _codeSandbox.createCodeSandbox)(getExampleFiles(codeRef, files, urls, entry), deps, type, entry);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polygon4Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Open in CodeSandbox"
                                                })
                                            ]
                                        }),
                                        files && type !== 's2' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                (0, _stackBlitz.createStackBlitz)(getExampleFiles(codeRef, files, urls, entry), deps, type, entry);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Flash, {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Open in StackBlitz"
                                                })
                                            ]
                                        }),
                                        registryUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            href: `https://v0.dev/chat/api/open?url=${"https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs/registry"}/${registryUrl}`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(V0, {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    children: "Open in v0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: codeRef,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DialogContainer), {
                onDismiss: ()=>setShowShadcn(false),
                children: showShadcn && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShadcnDialog, {
                    registryUrl: registryUrl
                })
            })
        ]
    });
}
const pre = " oc12 nc12 kc12 jc12 uj12 upj12 -_6BNtrc-b12 vx12 -_6BNtrc-pc12 vpx12 xb12 _xa12 xpb12 _xpa12 _Fb12 _FnuYUwec12 _Fpb12 _FpnuYUwec12 pt12 ppt12 Jy12 Gy12 Iy12 Hy12 SDlzPTd12 Rym9Jc12 T47Xf8d12 Q47Xf8d12 ZJ12 Nb12 _oa12";
function Pre({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
        className: pre,
        children: children
    });
}
function getExampleFiles(codeRef, files, urls, entry) {
    if (!entry) return {
        ...files,
        'Example.tsx': getExampleCode(codeRef, urls)
    };
    return files;
}
function getExampleCode(codeRef, urls) {
    let code = codeRef.current.querySelector('pre').textContent;
    let fileTabs = codeRef.current.closest('[data-files]');
    if (fileTabs) {
        let example = fileTabs.querySelector('[data-example] pre');
        if (example) code = example.textContent;
    }
    return code// Export the last function
    .replace(/\nfunction ([^(]+)((.|\n)+\n\}\n?)$/, '\nexport default function Example$2')// Add function wrapper around raw JSX in examples.
    .replace(/\n<((?:.|\n)+)/, (_, code)=>{
        let res = '\nexport default function Example() {\n  return (\n    <';
        let lines = code.split('\n');
        res += lines.shift();
        for (let line of lines)res += '\n    ' + line;
        res += '\n  );\n}\n';
        return res;
    })// Resolve urls
    .replace(/import (.*?) from ['"](url:.*?)['"]/g, (_, name, specifier)=>{
        return `const ${name} = '${urls[specifier]}'`;
    });
}
const V0 = (0, _s2.createIcon)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 40 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M23.3919 0H32.9188C36.7819 0 39.9136 3.13165 39.9136 6.99475V16.0805H36.0006V6.99475C36.0006 6.90167 35.9969 6.80925 35.9898 6.71766L26.4628 16.079C26.4949 16.08 26.5272 16.0805 26.5595 16.0805H36.0006V19.7762H26.5595C22.6964 19.7762 19.4788 16.6139 19.4788 12.7508V3.68923H23.3919V12.7508C23.3919 12.9253 23.4054 13.0977 23.4316 13.2668L33.1682 3.6995C33.0861 3.6927 33.003 3.68923 32.9188 3.68923H23.3919V0Z",
                fill: "var(--iconPrimary)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M13.7688 19.0956L0 3.68759H5.53933L13.6231 12.7337V3.68759H17.7535V17.5746C17.7535 19.6705 15.1654 20.6584 13.7688 19.0956Z",
                fill: "var(--iconPrimary)"
            })
        ]
    }));
const Flash = (0, _s2.createIcon)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M9.20215,18.76367c-.18262,0-.37012-.03711-.55078-.11621-.62598-.27051-.94238-.91992-.77051-1.5791l1.17383-4.50586-3.34863.06348c-.52441,0-1.00879-.28418-1.26465-.74121-.25684-.45801-.24512-1.01953.02832-1.4668L9.7002,1.88574c.35547-.58203,1.04297-.80664,1.67383-.53906.62988.26465.95312.91211.78613,1.57422l-1.20508,4.7959,3.33887-.06152c.52734,0,1.01465.28711,1.26953.74902s.23926,1.02637-.04199,1.47266l-5.19141,8.25098c-.25781.40918-.68066.63574-1.12793.63574ZM9.10254,11.12598c.45215,0,.87109.20508,1.14746.5625.27637.3584.37012.81445.25586,1.25195l-.92969,3.56836,4.62695-7.35352h-3.29688c-.4502,0-.86719-.20312-1.14355-.55859-.27637-.35449-.37207-.80859-.2627-1.24512l.96582-3.84473-4.7168,7.69434,3.35352-.0752Z",
            fill: "var(--iconPrimary, #222)",
            strokeWidth: "0"
        })
    }));
function ShadcnDialog({ registryUrl }) {
    let componentName = registryUrl.match(/([^/]+)\.json$/)[1];
    let preRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Dialog), {
        size: "L",
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                        slot: "title",
                        children: "Install with shadcn"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "Use the ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                                        href: "https://ui.shadcn.com/docs/cli",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "shadcn CLI"
                                    }),
                                    " to install ",
                                    componentName,
                                    " and its dependencies into your project."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shadcnCommand.ShadcnCommand), {
                                registryUrl: registryUrl,
                                preRef: preRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                variant: "secondary",
                                slot: "close",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                variant: "accent",
                                onPress: ()=>{
                                    navigator.clipboard.writeText(preRef.current.textContent).catch(()=>{
                                        (0, _s2.UNSTABLE_ToastQueue).negative('Failed to copy command. Please try again.');
                                    });
                                    close();
                                },
                                children: "Copy and close"
                            })
                        ]
                    })
                ]
            })
    });
}
const pulseAnimation = "yzKlUb";
const indicator = " _gca5SW12 _e0ERTvc12 _hb12 __ea12 _fc12 _Pa12 Wr12 _lr12 _Ar12 _zr12 ob12 nb12 kb12 jb12 _kc12 hc12 mc12 lc12 ix12 _jf12 OfuOC8d12 _Md12 _Lf12";
const toolbar = " sd12 _Cb12 Tp12 Qp12 Sp12 Rp12 _Pa12 WJ12 _zI12 g_g12 _nLeasBb12 ob12 nb12 kb12 jb12 _9c12";
function Toolbar({ children, showCoachMark }) {
    if (showCoachMark) children = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: indicator
            }),
            children
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: toolbar,
        children: children
    });
}

},{"0":"cjL5O","1":"f0N24","2":"i9emY","3":"4m5ZU","4":"bakRS","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["ActionButtonGroup","1RyqL"],["Button","gZHck"],["ButtonGroup","PBWa0"],["Content","10r6w"],["Heading","10r6w"],["Text","10r6w"],["createIcon","jQAJE"],["Dialog","bCzrO"],["DialogContainer","24qpm"],["Link","42COX"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["Tooltip","aI82z"],["TooltipTrigger","aI82z"],["UNSTABLE_ToastQueue","9R0uF","ToastQueue"]],"./CopyButton":"e24AO","./CodeSandbox":"entcx","./StackBlitz":"kuXEC","@react-spectrum/s2/icons/Download":"jifhr","@react-spectrum/s2/icons/Link":"ivjAn","@react-spectrum/s2/icons/OpenIn":"brg0k","@react-spectrum/s2/icons/Polygon4":"iLYOX","@react-spectrum/s2/icons/Prompt":"h0Yh9","react":"a1TxN","./ShadcnCommand":"8ccRO","./zip":"gkViL","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"24qpm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A DialogContainer accepts a single Dialog as a child, and manages showing and hiding
 * it in a modal. Useful in cases where there is no trigger element
 * or when the trigger unmounts while the dialog is open.
 */ parcelHelpers.export(exports, "DialogContainer", ()=>DialogContainer);
parcelHelpers.export(exports, "useDialogContainer", ()=>useDialogContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DialogContainer(props) {
    let { children, onDismiss } = props;
    let childArray = (0, _reactDefault.default).Children.toArray(children);
    if (childArray.length > 1) throw new Error('Only a single child can be passed to DialogContainer.');
    let [lastChild, setLastChild] = (0, _react.useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = undefined;
    if (Array.isArray(children)) child = children.find((0, _reactDefault.default).isValidElement);
    else if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let onOpenChange = (isOpen)=>{
        if (!isOpen) onDismiss();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalContext).Provider, {
        value: {
            isOpen: !!child,
            onOpenChange
        },
        children: lastChild
    });
}
function useDialogContainer() {
    let context = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.ModalContext));
    if (!context) throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
    return {
        dismiss () {
            context?.onOpenChange?.(false);
        }
    };
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["ModalContext","29rOq"],["useSlottedContext","bA6Cz"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aI82z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "CombinedTooltip", ()=>CombinedTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _provider = require("./Provider");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
const tooltip = function anonymous(props) {
    let rules = " ";
    if (props.colorScheme === "dark") rules += ' _pa12';
    else if (props.colorScheme === "light") rules += ' _pb12';
    else if (props.colorScheme === "light dark") rules += ' _pc12';
    else rules += ' _pN79Hzc12';
    rules += ' _Ca12';
    rules += ' eb12';
    rules += ' Le12';
    rules += ' MAyFGYc12';
    rules += ' _oa12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-b12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    rules += ' pr12';
    rules += ' plb12';
    rules += ' _kJ8iPYd12';
    rules += ' hXMFGYc12';
    rules += ' mlb12';
    rules += ' llb12';
    rules += ' _jlf12';
    rules += ' ilA12';
    rules += ' g012';
    rules += ' ob12';
    rules += ' nb12';
    rules += ' kb12';
    rules += ' jb12';
    rules += ' Sv12';
    rules += ' Rv12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    rules += ' Jv12';
    rules += ' Gv12';
    rules += ' Iv12';
    rules += ' Hv12';
    rules += ' Yd12';
    rules += ' Xc12';
    if (props.isExiting) rules += ' _2c12';
    if (props.placement === "right") {
        if (props.isExiting) {
            rules += ' -_7PloMd-m12';
            rules += ' __Ya12';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-m12';
            rules += ' __Ya12';
        }
    } else if (props.placement === "left") {
        if (props.isExiting) {
            rules += ' -_7PloMd-G12';
            rules += ' __Ya12';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-G12';
            rules += ' __Ya12';
        }
    }
    if (props.placement === "bottom") {
        if (props.isExiting) {
            rules += ' -_8PloMd-l12';
            rules += ' __Ya12';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-l12';
            rules += ' __Ya12';
        }
    } else if (props.placement === "top") {
        if (props.isExiting) {
            rules += ' -_8PloMd-F12';
            rules += ' __Ya12';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-F12';
            rules += ' __Ya12';
        }
    }
    if (props.isExiting) rules += ' _Ia12';
    else if (props.isEntering) rules += ' _Ia12';
    rules += ' -nTSCV-LTAEPe12';
    rules += ' -M_-Mg12';
    rules += ' -_k_-l_kb12';
    rules += ' -h_-lhb12';
    return rules;
};
const arrowStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sb12';
    rules += ' tr12';
    rules += ' Zi12';
    rules += ' Ff12';
    if (props.placement === "right") rules += ' _Sd12';
    else if (props.placement === "left") rules += ' _Sa12';
    else if (props.placement === "bottom") rules += ' _Sc12';
    else if (props.placement === "top") rules += ' _Sb12';
    if (props.placement === "right") {
        rules += ' -_7PloMd-y12';
        rules += ' __Ya12';
    } else if (props.placement === "left") {
        rules += ' -_7PloMd-e12';
        rules += ' __Ya12';
    }
    return rules;
};
let InternalTooltipTriggerContext = /*#__PURE__*/ (0, _react.createContext)({});
const Tooltip = /*#__PURE__*/ (0, _react.forwardRef)(function Tooltip(props, ref) {
    let { children, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { containerPadding, crossOffset, offset, placement = 'top', shouldFlip } = (0, _react.useContext)(InternalTooltipTriggerContext);
    let colorScheme = (0, _react.useContext)((0, _provider.ColorSchemeContext));
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    let [borderRadius, setBorderRadius] = (0, _react.useState)(0);
    // TODO: should we pass through lang and dir props in RAC?
    let tooltipRef = (0, _react.useCallback)((el)=>{
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
            let spectrumBorderRadius = typeof window !== 'undefined' ? window.getComputedStyle(el).borderRadius : '';
            if (spectrumBorderRadius !== '') setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tooltip), {
        ...props,
        arrowBoundaryOffset: borderRadius,
        containerPadding: containerPadding,
        crossOffset: crossOffset,
        offset: offset,
        placement: placement,
        shouldFlip: shouldFlip,
        ref: tooltipRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + tooltip({
                ...renderProps,
                colorScheme
            }),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            className: arrowStyles(renderProps),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 10 5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M4.29289 4.29289L0 0H10L5.70711 4.29289C5.31658 4.68342 4.68342 4.68342 4.29289 4.29289Z"
                            })
                        })
                    }),
                    children
                ]
            })
    });
});
function TooltipTrigger(props) {
    let { containerPadding, crossOffset, offset, placement, shouldFlip, ...triggerProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TooltipTrigger), {
        ...triggerProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTooltipTriggerContext.Provider, {
            value: {
                containerPadding: containerPadding,
                crossOffset: crossOffset,
                offset: offset,
                placement: placement,
                shouldFlip: shouldFlip
            },
            children: props.children
        })
    });
}
function CombinedTooltip(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
}

},{"0":"iurCn","1":"85h6d","react/jsx-runtime":"2Is6Z","react-aria-components":[["OverlayArrow","kMtnS"],["Tooltip","fLMVd"],["TooltipTrigger","fLMVd"],["useLocale","4k4z8"]],"./Provider":"31Rc2","react":"a1TxN","@react-spectrum/utils":"jqfrX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iurCn":[function() {},{}],"85h6d":[function() {},{}],"fLMVd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipTriggerStateContext", ()=>TooltipTriggerStateContext);
parcelHelpers.export(exports, "TooltipContext", ()=>TooltipContext);
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _overlayArrow = require("./OverlayArrow");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TooltipTriggerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TooltipContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TooltipTrigger(props) {
    let state = (0, _reactStately.useTooltipTriggerState)(props);
    let ref = (0, _react.useRef)(null);
    let { triggerProps, tooltipProps } = (0, _reactAria.useTooltipTrigger)(props, state, ref);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TooltipTriggerStateContext,
                state
            ],
            [
                TooltipContext,
                {
                    ...tooltipProps,
                    triggerRef: ref
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusableProvider), {
        ...triggerProps,
        ref: ref
    }, props.children));
}
const Tooltip = /*#__PURE__*/ (0, _react.forwardRef)(function Tooltip({ UNSTABLE_portalContainer, ...props }, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TooltipContext);
    let contextState = (0, _react.useContext)(TooltipTriggerStateContext);
    let localState = (0, _reactStately.useTooltipTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, _utils1.useExitAnimation)(ref, state.isOpen) || props.isExiting || false;
    if (!state.isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.OverlayContainer), {
        portalContainer: UNSTABLE_portalContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TooltipInner, {
        ...props,
        tooltipRef: ref,
        isExiting: isExiting
    }));
});
function TooltipInner(props) {
    let state = (0, _react.useContext)(TooltipTriggerStateContext);
    let arrowRef = (0, _react.useRef)(null);
    let { overlayProps, arrowProps, placement, triggerAnchorPoint } = (0, _reactAria.useOverlayPosition)({
        placement: props.placement || 'top',
        targetRef: props.triggerRef,
        overlayRef: props.tooltipRef,
        arrowRef,
        offset: props.offset,
        crossOffset: props.crossOffset,
        isOpen: state.isOpen,
        arrowBoundaryOffset: props.arrowBoundaryOffset,
        shouldFlip: props.shouldFlip,
        containerPadding: props.containerPadding,
        onClose: ()=>state.close(true)
    });
    let isEntering = (0, _utils1.useEnterAnimation)(props.tooltipRef, !!placement) || props.isEntering || false;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Tooltip',
        values: {
            placement,
            isEntering,
            isExiting: props.isExiting,
            state
        }
    });
    props = (0, _reactAria.mergeProps)(props, overlayProps);
    let { tooltipProps } = (0, _reactAria.useTooltip)(props, state);
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, tooltipProps),
        ref: props.tooltipRef,
        style: {
            ...overlayProps.style,
            '--trigger-anchor-point': triggerAnchorPoint ? `${triggerAnchorPoint.x}px ${triggerAnchorPoint.y}px` : undefined,
            ...renderProps.style
        },
        "data-placement": placement ?? undefined,
        "data-entering": isEntering || undefined,
        "data-exiting": props.isExiting || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlayArrow.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement,
            ref: arrowRef
        }
    }, renderProps.children));
}

},{"react-aria":[["mergeProps","aNvcY"],["OverlayContainer","hPIGg"],["useOverlayPosition","a4d2Q"],["useTooltip","5sJeH"],["useTooltipTrigger","flEGR"]],"./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"]],"@react-aria/focus":"kCQqy","./OverlayArrow":"kMtnS","react-stately":"cXd0F","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hPIGg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Each ModalProvider tracks how many modals are open in its subtree. On mount, the modals
 * trigger `addModal` to increment the count, and trigger `removeModal` on unmount to decrement it.
 * This is done recursively so that all parent providers are incremented and decremented.
 * If the modal count is greater than zero, we add `aria-hidden` to this provider to hide its
 * subtree from screen readers. This is done using React context in order to account for things
 * like portals, which can cause the React tree and the DOM tree to differ significantly in structure.
 */ parcelHelpers.export(exports, "ModalProvider", ()=>ModalProvider);
/**
 * Used to determine if the tree should be aria-hidden based on how many
 * modals are open.
 */ parcelHelpers.export(exports, "useModalProvider", ()=>useModalProvider);
/**
 * An OverlayProvider acts as a container for the top-level application.
 * Any application that uses modal dialogs or other overlays should
 * be wrapped in a `<OverlayProvider>`. This is used to ensure that
 * the main content of the application is hidden from screen readers
 * if a modal or other overlay is opened. Only the top-most modal or
 * overlay should be accessible at once.
 */ parcelHelpers.export(exports, "OverlayProvider", ()=>OverlayProvider);
/**
 * A container for overlays like modals and popovers. Renders the overlay
 * into a Portal which is placed at the end of the document body.
 * Also ensures that the overlay is hidden from screen readers if a
 * nested modal is opened. Only the top-most modal or overlay should
 * be accessible at once.
 */ parcelHelpers.export(exports, "OverlayContainer", ()=>OverlayContainer);
/**
 * Hides content outside the current `<OverlayContainer>` from screen readers
 * on mount and restores it on unmount. Typically used by modal dialogs and
 * other types of overlays to ensure that only the top-most modal is
 * accessible at once.
 */ parcelHelpers.export(exports, "useModal", ()=>useModal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _ssr = require("@react-aria/ssr");
var _portalProvider = require("./PortalProvider");
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function ModalProvider(props) {
    let { children } = props;
    let parent = (0, _react.useContext)(Context);
    let [modalCount, setModalCount] = (0, _react.useState)(0);
    let context = (0, _react.useMemo)(()=>({
            parent,
            modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: context
    }, children);
}
function useModalProvider() {
    let context = (0, _react.useContext)(Context);
    return {
        modalProviderProps: {
            'aria-hidden': context && context.modalCount > 0 ? true : undefined
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function OverlayContainerDOM(props) {
    let { modalProviderProps } = useModalProvider();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function OverlayProvider(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalProvider, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayContainerDOM, props));
}
function OverlayContainer(props) {
    let isSSR = (0, _ssr.useIsSSR)();
    let { portalContainer = isSSR ? null : document.body, ...rest } = props;
    let { getContainer } = (0, _portalProvider.useUNSAFE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    (0, _reactDefault.default).useEffect(()=>{
        if (portalContainer?.closest('[data-overlay-container]')) throw new Error('An OverlayContainer must not be inside another container. Please change the portalContainer prop.');
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayProvider, rest);
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, portalContainer);
}
function useModal(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, _react.useContext)(Context);
    if (!context) throw new Error('Modal is not contained within a provider');
    (0, _react.useEffect)(()=>{
        if (options?.isDisabled || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options?.isDisabled
    ]);
    return {
        modalProps: {
            'data-ismodal': !options?.isDisabled
        }
    };
}

},{"react":"a1TxN","react-dom":"gC2PC","@react-aria/ssr":"ictJr","./PortalProvider":"8uUhJ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5sJeH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a Tooltip component.
 */ parcelHelpers.export(exports, "useTooltip", ()=>useTooltip);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
function useTooltip(props, state) {
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let { hoverProps } = (0, _interactions.useHover)({
        onHoverStart: ()=>state?.open(true),
        onHoverEnd: ()=>state?.close()
    });
    return {
        tooltipProps: (0, _utils.mergeProps)(domProps, hoverProps, {
            role: 'tooltip'
        })
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"@react-aria/interactions":"k6FLA","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"flEGR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tooltip trigger, e.g. a button
 * that shows a description when focused or hovered.
 */ parcelHelpers.export(exports, "useTooltipTrigger", ()=>useTooltipTrigger);
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
var _react = require("react");
function useTooltipTrigger(props, state, ref) {
    let { isDisabled, trigger, closeOnPress = true } = props;
    let tooltipId = (0, _utils.useId)();
    let isHovered = (0, _react.useRef)(false);
    let isFocused = (0, _react.useRef)(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    (0, _react.useEffect)(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) // Escape after clicking something can give it keyboard focus
            // dismiss tooltip on esc key press
            {
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    state.close(true);
                }
            }
        };
        if (state.isOpen) {
            document.addEventListener('keydown', onKeyDown, true);
            return ()=>{
                document.removeEventListener('keydown', onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === 'focus') return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ((0, _interactions.getInteractionModality)() === 'pointer') isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === 'focus') return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // if closeOnPress is false, we should not close the tooltip
        if (!closeOnPress) return;
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = (0, _interactions.isFocusVisible)();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps } = (0, _interactions.useHover)({
        isDisabled,
        onHoverStart,
        onHoverEnd
    });
    let { focusableProps } = (0, _interactions.useFocusable)({
        isDisabled,
        onFocus,
        onBlur
    }, ref);
    return {
        triggerProps: {
            'aria-describedby': state.isOpen ? tooltipId : undefined,
            ...(0, _utils.mergeProps)(focusableProps, hoverProps, {
                onPointerDown: onPressStart,
                onKeyDown: onPressStart
            }),
            tabIndex: undefined
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

},{"@react-aria/interactions":[["getInteractionModality","dkfxW"],["isFocusVisible","dkfxW"],["useFocusable","kCQqy"],["useHover","k6FLA"]],"@react-aria/utils":[["mergeProps","aNvcY"],["useId","jbI4Y"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cXd0F":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for a tooltip trigger. Tracks whether the tooltip is open, and provides
 * methods to toggle this state. Ensures only one tooltip is open at a time and controls
 * the delay for showing a tooltip.
 */ parcelHelpers.export(exports, "useTooltipTriggerState", ()=>useTooltipTriggerState);
var _react = require("react");
var _overlays = require("@react-stately/overlays");
const TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
const TOOLTIP_COOLDOWN = 500;
let tooltips = {};
let tooltipId = 0;
let globalWarmedUp = false;
let globalWarmUpTimeout = null;
let globalCooldownTimeout = null;
function useTooltipTriggerState(props = {}) {
    let { delay = TOOLTIP_DELAY, closeDelay = TOOLTIP_COOLDOWN } = props;
    let { isOpen, open, close } = (0, _overlays.useOverlayTriggerState)(props);
    let id = (0, _react.useMemo)(()=>`${++tooltipId}`, []);
    let closeTimeout = (0, _react.useRef)(null);
    let closeCallback = (0, _react.useRef)(close);
    let ensureTooltipEntry = ()=>{
        tooltips[id] = hideTooltip;
    };
    let closeOpenTooltips = ()=>{
        for(let hideTooltipId in tooltips)if (hideTooltipId !== id) {
            tooltips[hideTooltipId](true);
            delete tooltips[hideTooltipId];
        }
    };
    let showTooltip = ()=>{
        if (closeTimeout.current) clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
        closeOpenTooltips();
        ensureTooltipEntry();
        globalWarmedUp = true;
        open();
        if (globalWarmUpTimeout) {
            clearTimeout(globalWarmUpTimeout);
            globalWarmUpTimeout = null;
        }
        if (globalCooldownTimeout) {
            clearTimeout(globalCooldownTimeout);
            globalCooldownTimeout = null;
        }
    };
    let hideTooltip = (immediate)=>{
        if (immediate || closeDelay <= 0) {
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
            closeCallback.current();
        } else if (!closeTimeout.current) closeTimeout.current = setTimeout(()=>{
            closeTimeout.current = null;
            closeCallback.current();
        }, closeDelay);
        if (globalWarmUpTimeout) {
            clearTimeout(globalWarmUpTimeout);
            globalWarmUpTimeout = null;
        }
        if (globalWarmedUp) {
            if (globalCooldownTimeout) clearTimeout(globalCooldownTimeout);
            globalCooldownTimeout = setTimeout(()=>{
                delete tooltips[id];
                globalCooldownTimeout = null;
                globalWarmedUp = false;
            }, Math.max(TOOLTIP_COOLDOWN, closeDelay));
        }
    };
    let warmupTooltip = ()=>{
        closeOpenTooltips();
        ensureTooltipEntry();
        if (!isOpen && !globalWarmUpTimeout && !globalWarmedUp) globalWarmUpTimeout = setTimeout(()=>{
            globalWarmUpTimeout = null;
            globalWarmedUp = true;
            showTooltip();
        }, delay);
        else if (!isOpen) showTooltip();
    };
    (0, _react.useEffect)(()=>{
        closeCallback.current = close;
    }, [
        close
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
            let tooltip = tooltips[id];
            if (tooltip) delete tooltips[id];
        };
    }, [
        id
    ]);
    return {
        isOpen,
        open: (immediate)=>{
            if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();
            else showTooltip();
        },
        close: hideTooltip
    };
}

},{"react":"a1TxN","@react-stately/overlays":"1hSAS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e24AO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _checkmarkCircle = require("@react-spectrum/s2/icons/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function CopyButton({ text, getText, ariaLabel = 'Copy', tooltip = 'Copy', isQuiet = false, size = 'S' }) {
    let [isCopied, setIsCopied] = (0, _react.useState)(false);
    let timeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopy = ()=>{
        if (timeout.current) clearTimeout(timeout.current);
        let value = text ?? getText?.();
        if (!value) return;
        navigator.clipboard.writeText(value).then(()=>{
            setIsCopied(true);
            timeout.current = setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>{
            (0, _s2.UNSTABLE_ToastQueue).negative('Failed to copy.');
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TooltipTrigger), {
        placement: "end",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                "aria-label": ariaLabel,
                isQuiet: isQuiet,
                size: size,
                onPress: handleCopy,
                children: isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkCircleDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tooltip), {
                children: tooltip
            })
        ]
    });
}
exports.default = CopyButton;

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Tooltip","aI82z"],["TooltipTrigger","aI82z"],["UNSTABLE_ToastQueue","9R0uF","ToastQueue"]],"@react-spectrum/s2/icons/CheckmarkCircle":"6hpGX","@react-spectrum/s2/icons/Copy":"6imrL","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"entcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCodeSandbox", ()=>createCodeSandbox);
parcelHelpers.export(exports, "getCodeSandboxFiles", ()=>getCodeSandboxFiles);
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
function createCodeSandbox(files, deps, type = 'vanilla', entry = 'Example') {
    let form = document.createElement('form');
    form.hidden = true;
    form.method = 'POST';
    form.action = 'https://codesandbox.io/api/v1/sandboxes/define';
    form.target = '_blank';
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'query';
    input.value = 'file=src/Example.tsx';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'environment';
    input.value = 'server';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'parameters';
    input.value = (0, _lzStringDefault.default).compressToBase64(JSON.stringify({
        files: getCodeSandboxFiles(files, deps, type, entry)
    }));
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
const devDependencies = {
    vanilla: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5'
    },
    tailwind: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5',
        'tailwindcss': '^4',
        '@tailwindcss/postcss': '^4',
        postcss: '^8',
        'tailwindcss-react-aria-components': '^2',
        'tailwindcss-animate': '^1'
    },
    s2: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5'
    }
};
function getCodeSandboxFiles(files, deps, type = 'vanilla', entry = 'Example') {
    let entryName = entry.split('/').pop().split('.')[0];
    return {
        '.codesandbox/tasks.json': {
            content: JSON.stringify({
                setupTasks: [
                    {
                        name: 'Installing Dependencies',
                        command: 'pnpm install'
                    }
                ],
                tasks: {
                    start: {
                        name: 'start',
                        command: 'pnpm start',
                        runAtStart: true,
                        preview: {
                            port: 5173
                        }
                    },
                    build: {
                        name: 'build',
                        command: 'pnpm build',
                        runAtStart: false
                    }
                }
            }, null, 2) + '\n'
        },
        '.devcontainer/devcontainer.json': {
            content: JSON.stringify({
                'name': 'Devcontainer',
                'image': 'ghcr.io/codesandbox/devcontainers/typescript-node:latest'
            }, null, 2) + '\n'
        },
        'package.json': {
            content: JSON.stringify({
                name: type === 's2' ? 's2-starter' : 'react-aria-starter',
                private: true,
                version: '0.0.0',
                source: 'src/index.html',
                scripts: {
                    start: 'parcel',
                    build: 'parcel build'
                },
                dependencies: {
                    react: '^19',
                    'react-dom': '^19',
                    ...deps
                },
                devDependencies: devDependencies[type]
            }, null, 2) + '\n'
        },
        '.postcssrc': type === 'tailwind' ? {
            content: JSON.stringify({
                plugins: {
                    '@tailwindcss/postcss': {}
                }
            }, null, 2) + '\n'
        } : undefined,
        'src/index.html': {
            content: `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>Test</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<body>
  <div id="root"></div>
  <script type="module" src="index.tsx"></script>${type === 'tailwind' ? '\n  <link href="index.css" rel="stylesheet">' : ''}
</body>
</html>
`
        },
        'src/index.tsx': {
            content: `import {createRoot} from 'react-dom/client';
import ${entryName} from './${entryName}';${type === 's2' ? "\nimport '@react-spectrum/s2/page.css';" : ''}

createRoot(document.getElementById('root')!).render(<${entryName} />);
`
        },
        'tsconfig.json': {
            content: JSON.stringify({
                compilerOptions: {
                    'target': 'ES2022',
                    'lib': [
                        'ES2022',
                        'DOM',
                        'DOM.Iterable'
                    ],
                    'module': 'ESNext',
                    strict: true,
                    'moduleResolution': 'bundler',
                    'noEmit': true,
                    'jsx': 'react-jsx'
                },
                'include': [
                    'src'
                ]
            }, null, 2) + '\n'
        },
        ...Object.fromEntries(Object.entries(files).map(([name, content])=>[
                'src/' + name,
                {
                    content
                }
            ]))
    };
}

},{"lz-string":"gTdn3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gTdn3":[function(require,module,exports,__globalThis) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

},{}],"kuXEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStackBlitz", ()=>createStackBlitz);
function createStackBlitz(files, deps, type = 'vanilla', entry = 'Example') {
    let form = document.createElement('form');
    form.hidden = true;
    form.method = 'POST';
    form.action = 'https://stackblitz.com/run?file=src/Example.tsx';
    form.target = '_blank';
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[template]';
    input.value = 'node';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[title]';
    input.value = 'Project';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[description]';
    input.value = 'description';
    form.appendChild(input);
    let generatedFiles = getFiles(files, deps, type, entry);
    for(let name in generatedFiles){
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `project[files][${name}]`;
        input.value = generatedFiles[name];
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
function getFiles(files, deps, type = 'vanilla', entry = 'Example') {
    let entryName = entry.split('/').pop().split('.')[0];
    return {
        'package.json': JSON.stringify({
            name: 'react-aria-starter',
            private: true,
            version: '0.0.0',
            type: 'module',
            scripts: {
                dev: 'vite',
                build: 'vite build',
                preview: 'vite preview'
            },
            dependencies: {
                react: '^19',
                'react-dom': '^19',
                ...deps
            },
            devDependencies: {
                '@types/react': '^19',
                '@types/react-dom': '^19',
                vite: '^6',
                '@vitejs/plugin-react': '^4',
                ...type === 'tailwind' ? {
                    'tailwindcss': '^4',
                    '@tailwindcss/vite': '^4',
                    'tailwindcss-react-aria-components': '^2',
                    'tailwindcss-animate': '^1'
                } : {}
            }
        }, null, 2) + '\n',
        'vite.config.ts': `import {defineConfig} from 'vite';
import react from '@vitejs/plugin-react';${type === 'tailwind' ? "\nimport tailwindcss from '@tailwindcss/vite';" : ''}

export default defineConfig({
  plugins: [react()${type === 'tailwind' ? ', tailwindcss()' : ''}],
});
`,
        'index.html': `<html lang="en">
<head>
  <meta charset="utf-8">
  <title>Test</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<body>
  <div id="root"></div>
  <script type="module" src="/src/index.tsx"></script>${type === 'tailwind' ? '\n  <link href="/src/index.css" rel="stylesheet">' : ''}
</body>
</html>
`,
        'src/index.tsx': `import {createRoot} from 'react-dom/client';
import ${entryName} from './${entryName}';

createRoot(document.getElementById('root')!).render(<${entryName} />);
`,
        'tsconfig.json': JSON.stringify({
            compilerOptions: {
                'target': 'ES2022',
                'useDefineForClassFields': true,
                'lib': [
                    'ES2022',
                    'DOM',
                    'DOM.Iterable'
                ],
                'module': 'ESNext',
                'skipLibCheck': true,
                /* Bundler mode */ 'moduleResolution': 'bundler',
                'allowImportingTsExtensions': true,
                'moduleDetection': 'force',
                'noEmit': true,
                'jsx': 'react-jsx',
                /* Linting */ 'strict': true,
                'noUnusedLocals': true,
                'noUnusedParameters': true,
                'erasableSyntaxOnly': true,
                'noFallthroughCasesInSwitch': true,
                'noUncheckedSideEffectImports': true
            },
            'include': [
                'src'
            ]
        }, null, 2) + '\n',
        ...Object.fromEntries(Object.entries(files).map(([name, contents])=>[
                'src/' + name,
                contents
            ]))
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8ccRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShadcnCommand", ()=>ShadcnCommand);
var _jsxRuntime = require("react/jsx-runtime");
var _copyButton = require("./CopyButton");
var _copyButtonDefault = parcelHelpers.interopDefault(_copyButton);
var _s2 = require("@react-spectrum/s2");
var _prompt = require("@react-spectrum/s2/icons/Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _useLocalStorage = require("./useLocalStorage");
'use client';
function ShadcnCommand({ registryUrl, preRef }) {
    let [packageManager, setPackageManager] = (0, _useLocalStorage.useLocalStorage)('packageManager', 'npm');
    let command = packageManager;
    if (packageManager === 'npm') command = 'npx';
    else if (packageManager === 'pnpm') command = 'pnpm dlx';
    let onSelectionChange = (value)=>{
        setPackageManager(String(value));
    };
    let cmd = `${command} shadcn@latest add ${"https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs/registry"}/${registryUrl}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " gqlRAZb12 oe12 ne12 ke12 je12 Tf12 Qf12 Sf12 Rf12 sd12 _ta12 Ul12 ql12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                "aria-label": "Package manager",
                selectedKey: packageManager,
                onSelectionChange: onSelectionChange,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "npm",
                        children: "npm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "yarn",
                        children: "yarn"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "pnpm",
                        children: "pnpm"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd12 eb12 Ug12 qg12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {
                        styles: " Zn12 Fo12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                        ref: preRef,
                        className: " uj12 upj12 -_6BNtrc-b12 vx12 -_6BNtrc-pc12 vpx12 xb12 _xa12 xpb12 _xpa12 _Fb12 _FnuYUwec12 _Fpb12 _FpnuYUwec12 pt12 ppt12 _Na12 Td12 Qd12 Sd12 Rd12 Jy12 Gy12 Iy12 Hy12",
                        children: cmd
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButtonDefault.default), {
                        ariaLabel: "Copy command",
                        tooltip: "Copy command",
                        text: cmd
                    })
                ]
            })
        ]
    });
}

},{"0":"1O8oh","1":"dex4A","2":"4XXte","3":"h8LE4","react/jsx-runtime":"2Is6Z","./CopyButton":"e24AO","@react-spectrum/s2":"hnIYG","@react-spectrum/s2/icons/Prompt":"h0Yh9","./useLocalStorage":"iKHiC","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hnIYG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlContext", ()=>SegmentedControlContext);
parcelHelpers.export(exports, "SegmentedControl", ()=>SegmentedControl);
parcelHelpers.export(exports, "SegmentedControlItem", ()=>SegmentedControlItem);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _icon = require("./Icon");
var _pressScale = require("./pressScale");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SegmentedControlContext = /*#__PURE__*/ (0, _react.createContext)(null);
const segmentedControl = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd12';
    rules += ' Ub12';
    rules += ' qb12';
    rules += ' gH12';
    rules += ' ob12';
    rules += ' nb12';
    rules += ' kb12';
    rules += ' jb12';
    if (!width) rules += ' ZJ12';
    return rules;
};
const controlItem = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let flexGrow = false;
    let flexBasis = false;
    let flexShrink = false;
    let zIndex = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_s") flexBasis = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_9") zIndex = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isDisabled) rules += ' pp12';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    } else {
        if (props.isPressed) rules += ' pt12';
        else if (props.isFocusVisible) rules += ' pt12';
        else if (props.isHovered) rules += ' pt12';
        else rules += ' pv12';
    }
    if (props.isSelected) rules += ' ple12';
    else if (props.isDisabled) rules += ' plc12';
    else rules += ' plb12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' _oa12';
    rules += ' Sv12';
    rules += ' SgLWx3bd12';
    rules += ' Rv12';
    rules += ' RgLWx3bd12';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl12';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj12';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf12';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne12';
    } else if (!minWidth) rules += ' Nk12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' qc12';
    rules += ' qsd12';
    rules += ' -Qg41Lb-IAxCW0c12';
    rules += ' -Qg41Lb-gLWx3bIy12';
    rules += ' FRuFGYc12';
    rules += ' _Ca12';
    if (!position) rules += ' _Pc12';
    rules += ' _yb12';
    if (props.isJustified) {
        if (!flexGrow) rules += ' _ub12';
    }
    if (props.isJustified) {
        if (!flexBasis) rules += ' _sb12';
    }
    if (!flexShrink) rules += ' _va12';
    rules += ' _7c12';
    rules += ' __ca12';
    rules += ' _4c12';
    rules += ' g912';
    rules += ' _je12';
    rules += ' -_8sjo0b-t5ZbAob12';
    if (props.isSelected) {
        if (!zIndex) rules += ' _9b12';
    } else if (!zIndex) rules += ' _9c12';
    if (props.size === "XL") rules += ' -F_-Fz12';
    else if (props.size === "L") rules += ' -F_-Fv12';
    else if (props.size === "S") rules += ' -F_-Fp12';
    else if (props.size === "XS") rules += ' -F_-Fn12';
    else rules += ' -F_-Fx12';
    return rules;
};
const slider = function anonymous(props) {
    let rules = " ";
    rules += ' gX12';
    if (props.isDisabled) rules += ' gld12';
    else rules += ' gle12';
    rules += ' Wr12';
    rules += ' _Er12';
    rules += ' Za12';
    rules += ' Fb12';
    rules += ' _qg12';
    rules += ' Yx6BKnd12';
    rules += ' Ydklsgce12';
    rules += ' Xc12';
    rules += ' _2a12';
    rules += ' _Pa12';
    rules += ' _oa12';
    rules += ' _jf12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    if (props.isDisabled) rules += ' iq12';
    else rules += ' in12';
    if (props.isDisabled) rules += ' ilc12';
    else rules += ' ild12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    return rules;
};
const InternalSegmentedControlContext = /*#__PURE__*/ (0, _react.createContext)({});
const SegmentedControl = /*#__PURE__*/ (0, _react.forwardRef)(function SegmentedControl(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SegmentedControlContext);
    let { defaultSelectedKey, selectedKey, onSelectionChange } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let onChange = (values)=>{
        if (onSelectionChange) {
            let firstKey = values.values().next().value;
            if (firstKey != null) onSelectionChange(firstKey);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButtonGroup), {
        ...props,
        selectedKeys: selectedKey != null ? [
            selectedKey
        ] : undefined,
        defaultSelectedKeys: defaultSelectedKey != null ? [
            defaultSelectedKey
        ] : undefined,
        disallowEmptySelection: true,
        ref: domRef,
        orientation: "horizontal",
        style: props.UNSAFE_style,
        onSelectionChange: onChange,
        className: (props.UNSAFE_className || '') + segmentedControl(null, props.styles),
        "aria-label": props['aria-label'],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultSelectionTracker, {
            defaultValue: defaultSelectedKey,
            value: selectedKey,
            isJustified: props.isJustified,
            children: props.children
        })
    });
});
function DefaultSelectionTracker(props) {
    let state = (0, _react.useContext)((0, _reactAriaComponents.ToggleGroupStateContext));
    let isRegistered = (0, _react.useRef)(!(props.defaultValue == null && props.value == null));
    // default select the first available item
    let register = (0, _react.useCallback)((value)=>{
        if (state && !isRegistered.current) {
            isRegistered.current = true;
            state.toggleKey(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                InternalSegmentedControlContext,
                {
                    register: register,
                    isJustified: props.isJustified
                }
            ]
        ],
        children: props.children
    });
}
const SegmentedControlItem = /*#__PURE__*/ (0, _react.forwardRef)(function SegmentedControlItem(props, ref) {
    let domRef = (0, _utils.useFocusableRef)(ref);
    let divRef = (0, _react.useRef)(null);
    let { register, isJustified } = (0, _react.useContext)(InternalSegmentedControlContext);
    (0, _utils1.useLayoutEffect)(()=>{
        register?.(props.id);
    }, [
        register,
        props.id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + controlItem({
                ...renderProps,
                isJustified
            }, props.styles),
        children: ({ isPressed, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectionIndicator), {
                        className: slider({
                            isDisabled
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _icon.IconContext),
                                {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: " _Ja12 _va12"
                                    })
                                }
                            ],
                            [
                                (0, _reactAriaComponents.TextContext),
                                {
                                    slots: {
                                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {}
                                    }
                                }
                            ],
                            [
                                (0, _content.TextContext),
                                {
                                    styles: " _Jb12 _Nc12 Pc12 _Yb12 _7c12"
                                }
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            ref: divRef,
                            style: (0, _pressScale.pressScale)(divRef)({
                                isPressed
                            }),
                            className: " sd12 Uc12 Usd12 qc12 qsd12 Yd12 Xb12 _2b12 eb12 Na12",
                            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                children: props.children
                            }) : props.children
                        })
                    })
                ]
            })
    });
});

},{"0":"dDL70","1":"9PwY2","2":"4U7m2","3":"8D3Jp","4":"LbC8K","5":"1JBVp","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components":[["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["SelectionIndicator","dgQU7"],["TextContext","jt9fm"],["ToggleButton","98v4o"],["ToggleButtonGroup","8CiqT"],["ToggleGroupStateContext","8CiqT"]],"react":"a1TxN","./Icon":"jQAJE","./pressScale":"8Ufux","./Content":"10r6w","@react-spectrum/utils":"jqfrX","@react-aria/utils":"2ViQu","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dDL70":[function() {},{}],"9PwY2":[function() {},{}],"4U7m2":[function() {},{}],"8D3Jp":[function() {},{}],"LbC8K":[function() {},{}],"1JBVp":[function() {},{}],"iKHiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalStorage", ()=>useLocalStorage);
var _react = require("react");
function useLocalStorage(key, defaultValue) {
    let [store] = (0, _react.useState)(()=>new Store(key, defaultValue));
    let value = (0, _react.useSyncExternalStore)(store.subscribe, store.getSnapshot, store.getServerSnapshot);
    return [
        value,
        store.setValue
    ];
}
class Store {
    constructor(key, defaultValue){
        this.subscribe = (fn)=>{
            if (!this.key) return ()=>{};
            let onStorage = (e)=>{
                if (e.key === this.key) fn();
            };
            window.addEventListener('storage', onStorage);
            return ()=>{
                window.removeEventListener('storage', onStorage);
            };
        };
        this.getSnapshot = ()=>{
            if (!this.key) return this.defaultValue;
            let search = new URLSearchParams(location.search);
            return search.get(this.key) ?? localStorage.getItem(this.key) ?? this.defaultValue;
        };
        this.getServerSnapshot = ()=>{
            return this.defaultValue;
        };
        this.setValue = (value)=>{
            if (!this.key) return;
            let oldValue = this.getSnapshot();
            localStorage.setItem(this.key, value);
            let search = new URLSearchParams(location.search);
            if (search.has(this.key)) {
                search.set(this.key, value);
                let url = new URL('?' + search.toString(), location.href);
                history.replaceState(null, '', url.toString());
            }
            window.dispatchEvent(new StorageEvent('storage', {
                key: this.key,
                oldValue,
                newValue: value
            }));
        };
        this.key = 's2.' + key;
        this.defaultValue = defaultValue;
        this.subscriptions = new Set();
    }
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1O8oh":[function() {},{}],"dex4A":[function() {},{}],"4XXte":[function() {},{}],"h8LE4":[function() {},{}],"gkViL":[function(require,module,exports,__globalThis) {
// https://gist.github.com/rvaiya/4a2192df729056880a027789ae3cd4b7
// Author: Raheman Vaiya
// License: WTFPL
// Generate the crc32 table instead of hardcoding it to avoid having a giant constant
// in the minified output...
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
const CRC32_TABLE = function() {
    let tbl = new Int32Array(256);
    let c;
    for(let n = 0; n < 256; n++){
        c = n;
        for(let k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        tbl[n] = c;
    }
    return tbl;
}();
function crc32(arr) {
    let crc = -1;
    for(let i = 0; i < arr.length; i++)crc = crc >>> 8 ^ CRC32_TABLE[(crc ^ arr[i]) & 0xFF];
    return (crc ^ -1) >>> 0;
}
function putUint32s(arr, offset, ...values) {
    let dv = new DataView(arr.buffer);
    values.forEach((v, i)=>dv.setUint32(offset + i * 4, v, true));
}
function putUint16s(arr, offset, ...values) {
    let dv = new DataView(arr.buffer);
    values.forEach((v, i)=>dv.setUint16(offset + i * 2, v, true));
}
function zip(files) {
    let records = [];
    let cdrs = [];
    let te = new TextEncoder();
    let offset = 0;
    let cdSz = 0;
    for(let name in files){
        let fh = new Uint8Array(30 + name.length);
        let fname = te.encode(name);
        let data = te.encode(files[name]);
        let chksum = crc32(data);
        putUint32s(fh, 0, 0x04034b50);
        putUint32s(fh, 14, chksum, data.length, data.length);
        putUint16s(fh, 26, name.length);
        fh.set(fname, 30);
        records.push(fh);
        records.push(data);
        // Create CD records pending flush at the end...
        let cdr = new Uint8Array(46 + name.length);
        putUint32s(cdr, 0, 0x02014b50);
        putUint32s(cdr, 16, chksum, data.length, data.length);
        putUint16s(cdr, 28, name.length);
        putUint32s(cdr, 42, offset);
        cdr.set(fname, 46);
        cdrs.push(cdr);
        cdSz += cdr.length;
        offset += fh.length + data.length;
    }
    // Push all accrued CD records..
    records.push(...cdrs);
    // Add EOCD record...
    let eocd = new Uint8Array(22);
    putUint32s(eocd, 0, 0x06054b50);
    putUint16s(eocd, 8, cdrs.length, cdrs.length);
    putUint32s(eocd, 12, cdSz, offset);
    records.push(eocd);
    return new Blob(records, {
        type: 'application/zip'
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cjL5O":[function() {},{}],"f0N24":[function() {},{}],"i9emY":[function() {},{}],"4m5ZU":[function() {},{}],"bakRS":[function() {},{}],"lHe2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleOutput", ()=>ExampleOutput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
function ExampleOutput({ component, props = {}, align = 'center', orientation = 'horizontal' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "group",
        "aria-label": "Rendered component",
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd12';
            if (props.orientation === "vertical") rules += ' _tc12';
            else if (props.orientation === "horizontal") rules += ' _ta12';
            if (props.align === "end") rules += ' _Cb12';
            else if (props.align === "start") rules += ' _Cg12';
            else if (props.align === "center") rules += ' _Ca12';
            rules += ' eb12';
            rules += ' Za12';
            rules += ' _Na12';
            rules += ' Pa12';
            rules += ' z7DIbxc12';
            rules += ' y7DIbxc12';
            rules += ' B7DIbxc12';
            rules += ' A7DIbxc12';
            rules += ' oc12';
            rules += ' nc12';
            rules += ' kc12';
            rules += ' jc12';
            rules += ' uk12';
            rules += ' ucJ9TBTb12';
            rules += ' ud3Euai12';
            rules += ' uea12';
            rules += ' ugb12';
            rules += ' uhd12';
            rules += ' uje12';
            rules += ' u2NhKxcl12';
            rules += ' uic12';
            rules += ' -_6BNtrc-c12';
            rules += ' vx12';
            rules += ' xb12';
            rules += ' _xa12';
            rules += ' _Fd12';
            rules += ' _FnuYUweb12';
            rules += ' pt12';
            rules += ' Te12';
            rules += ' Tph12';
            rules += ' Qe12';
            rules += ' Qph12';
            rules += ' Se12';
            rules += ' Sph12';
            rules += ' Re12';
            rules += ' Rph12';
            rules += ' _oa12';
            return rules;
        }({
            align,
            orientation
        }),
        style: {
            background: getBackgroundColor(props.staticColor || (props.isOverBackground ? 'white' : undefined))
        },
        children: /*#__PURE__*/ (0, _react.isValidElement)(component) ? /*#__PURE__*/ (0, _react.cloneElement)(component, props) : /*#__PURE__*/ (0, _react.createElement)(component, props)
    });
}
function getBackgroundColor(staticColor) {
    if (staticColor === 'black') return 'linear-gradient(to right,#ddd6fe,#fbcfe8)';
    else if (staticColor === 'white') return 'linear-gradient(to right,#0f172a,#334155)';
    return undefined;
}

},{"0":"a729t","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a729t":[function() {},{}],"kHsTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleSwitcherContext", ()=>ExampleSwitcherContext);
parcelHelpers.export(exports, "ExampleSwitcher", ()=>ExampleSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _useLocalStorage = require("./useLocalStorage");
'use client';
const exampleStyle = " gqlRAZb12 Jz12 Gz12 oe12 ne12 ke12 je12 se12 DAo196c12 DptEmQ4d12 C5gxEHe12 CpxPeKmd12 Te12 Tph12";
const switcher = " zMQbvYb12 yMQbvYb12 BMQbvYb12 AMQbvYb12 __Ab12 __Apd12 _Na12 Pa12 La12 Tp12 Qp12 Sp12 Rp12 Jb12 Gb12 Ib12 Hb12";
const themePicker = " zOyqOs12 yOyqOs12 BOyqOs12 AOyqOs12 ZOWVaZ12 Jx12 Jpy12 __Ab12 __Apd12";
const ExampleSwitcherContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DEFAULT_EXAMPLES = [
    'Vanilla CSS',
    'Tailwind'
];
function ExampleSwitcher({ type = 'style', examples = DEFAULT_EXAMPLES, children }) {
    let [selected, setSelected] = (0, _useLocalStorage.useLocalStorage)(type, examples[0]);
    let [theme, setTheme] = (0, _useLocalStorage.useLocalStorage)('theme', 'indigo');
    let [value, setValue] = (0, _react.useState)(examples[0]);
    if (!examples.includes(selected)) selected = examples[0];
    if (!type) selected = value;
    (0, _utils.useLayoutEffect)(()=>{
        document.documentElement.style.setProperty('--tint', `var(--${theme})`);
    }, [
        theme
    ]);
    let onSelectionChange = (key)=>{
        if (type) setSelected(String(key));
        else setValue(String(key));
    };
    let onThemeChange = (key)=>{
        setTheme(String(key));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: exampleStyle,
        "data-example-switcher": true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: switcher,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControl), {
                    "aria-label": type || 'example',
                    selectedKey: selected,
                    onSelectionChange: onSelectionChange,
                    children: examples.map((example)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                            id: example,
                            children: example
                        }, example))
                })
            }),
            selected === 'Vanilla CSS' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: "Theme",
                labelPosition: "side",
                value: theme,
                onChange: onThemeChange,
                styles: themePicker,
                contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ContextualHelp), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                            children: "Vanilla CSS theme"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                            children: [
                                "This sets the ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                    className: " uj12 -_6BNtrc-c12 vx12 xb12 _xa12 _Fb12 _FnuYUwec12 pt12",
                                    children: "--tint"
                                }),
                                " CSS variable used by the Vanilla CSS examples."
                            ]
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "indigo",
                        children: "Indigo"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "blue",
                        children: "Blue"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "cyan",
                        children: "Cyan"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "turquoise",
                        children: "Turquoise"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "green",
                        children: "Green"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "yellow",
                        children: "Yellow"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "orange",
                        children: "Orange"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "red",
                        children: "Red"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "pink",
                        children: "Pink"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "purple",
                        children: "Purple"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    gridArea: 'example'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExampleSwitcherContext.Provider, {
                    value: selected,
                    children: children[examples.indexOf(selected)]
                })
            })
        ]
    });
}

},{"0":"9pUlJ","1":"gHFe4","2":"1cydM","3":"2mEAU","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Content","10r6w"],["Heading","10r6w"],["ContextualHelp","5GtuV"],["Picker","akpch"],["PickerItem","akpch"],["SegmentedControl","hnIYG"],["SegmentedControlItem","hnIYG"]],"react":"a1TxN","@react-aria/utils":"2ViQu","./useLocalStorage":"iKHiC","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9pUlJ":[function() {},{}],"gHFe4":[function() {},{}],"1cydM":[function() {},{}],"2mEAU":[function() {},{}],"71wqN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Parses a color from a string value. Throws an error if the string could not be parsed. */ parcelHelpers.export(exports, "parseColor", ()=>parseColor);
parcelHelpers.export(exports, "normalizeColor", ()=>normalizeColor);
/** Returns a list of color channels for a given color space. */ parcelHelpers.export(exports, "getColorChannels", ()=>getColorChannels);
/**
 * Returns the hue value normalized to the range of 0 to 360.
 */ parcelHelpers.export(exports, "normalizeHue", ()=>normalizeHue);
var _utils = require("@react-stately/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _string = require("@internationalized/string");
var _number = require("@internationalized/number");
let dictionary = new (0, _string.LocalizedStringDictionary)((0, _jsonDefault.default));
function parseColor(value) {
    let res = RGBColor.parse(value) || HSBColor.parse(value) || HSLColor.parse(value);
    if (res) return res;
    throw new Error('Invalid color value: ' + value);
}
function normalizeColor(v) {
    if (typeof v === 'string') return parseColor(v);
    else return v;
}
function getColorChannels(colorSpace) {
    switch(colorSpace){
        case 'rgb':
            return RGBColor.colorChannels;
        case 'hsl':
            return HSLColor.colorChannels;
        case 'hsb':
            return HSBColor.colorChannels;
    }
}
function normalizeHue(hue) {
    if (hue === 360) return hue;
    return (hue % 360 + 360) % 360;
}
// Lightness threshold between orange and brown.
const ORANGE_LIGHTNESS_THRESHOLD = 0.68;
// Lightness threshold between pure yellow and "yellow green".
const YELLOW_GREEN_LIGHTNESS_THRESHOLD = 0.85;
// The maximum lightness considered to be "dark".
const MAX_DARK_LIGHTNESS = 0.55;
// The chroma threshold between gray and color.
const GRAY_THRESHOLD = 0.001;
const OKLCH_HUES = [
    [
        0,
        'pink'
    ],
    [
        15,
        'red'
    ],
    [
        48,
        'orange'
    ],
    [
        94,
        'yellow'
    ],
    [
        135,
        'green'
    ],
    [
        175,
        'cyan'
    ],
    [
        264,
        'blue'
    ],
    [
        284,
        'purple'
    ],
    [
        320,
        'magenta'
    ],
    [
        349,
        'pink'
    ]
];
class Color {
    toHexInt() {
        return this.toFormat('rgb').toHexInt();
    }
    getChannelValue(channel) {
        if (channel in this) return this[channel];
        throw new Error('Unsupported color channel: ' + channel);
    }
    withChannelValue(channel, value) {
        if (channel in this) {
            let x = this.clone();
            x[channel] = value;
            return x;
        }
        throw new Error('Unsupported color channel: ' + channel);
    }
    getChannelName(channel, locale) {
        let strings = (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || dictionary;
        return strings.getStringForLocale(channel, locale);
    }
    getColorSpaceAxes(xyChannels) {
        let { xChannel, yChannel } = xyChannels;
        let xCh = xChannel || this.getColorChannels().find((c)=>c !== yChannel);
        let yCh = yChannel || this.getColorChannels().find((c)=>c !== xCh);
        let zCh = this.getColorChannels().find((c)=>c !== xCh && c !== yCh);
        return {
            xChannel: xCh,
            yChannel: yCh,
            zChannel: zCh
        };
    }
    getColorName(locale) {
        // Convert to oklch color space, which has perceptually uniform lightness across all hues.
        let [l, c, h] = toOKLCH(this);
        let strings = (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || dictionary;
        if (l > 0.999) return strings.getStringForLocale('white', locale);
        if (l < 0.001) return strings.getStringForLocale('black', locale);
        let hue;
        [hue, l] = this.getOklchHue(l, c, h, locale);
        let lightness = '';
        let chroma = '';
        if (c <= 0.1 && c >= GRAY_THRESHOLD) {
            if (l >= 0.7) chroma = 'pale';
            else chroma = 'grayish';
        } else if (c >= 0.15) chroma = 'vibrant';
        if (l < 0.3) lightness = 'very dark';
        else if (l < MAX_DARK_LIGHTNESS) lightness = 'dark';
        else if (l < 0.7) ;
        else if (l < 0.85) lightness = 'light';
        else lightness = 'very light';
        if (chroma) chroma = strings.getStringForLocale(chroma, locale);
        if (lightness) lightness = strings.getStringForLocale(lightness, locale);
        let alpha = this.getChannelValue('alpha');
        let formatter = new (0, _string.LocalizedStringFormatter)(locale, strings);
        if (alpha < 1) {
            let percentTransparent = new (0, _number.NumberFormatter)(locale, {
                style: 'percent'
            }).format(1 - alpha);
            return formatter.format('transparentColorName', {
                lightness,
                chroma,
                hue,
                percentTransparent
            }).replace(/\s+/g, ' ').trim();
        } else return formatter.format('colorName', {
            lightness,
            chroma,
            hue
        }).replace(/\s+/g, ' ').trim();
    }
    getOklchHue(l, c, h, locale) {
        let strings = (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || dictionary;
        if (c < GRAY_THRESHOLD) return [
            strings.getStringForLocale('gray', locale),
            l
        ];
        for(let i = 0; i < OKLCH_HUES.length; i++){
            let [hue, hueName] = OKLCH_HUES[i];
            let [nextHue, nextHueName] = OKLCH_HUES[i + 1] || [
                360,
                'pink'
            ];
            if (h >= hue && h < nextHue) {
                // Split orange hue into brown/orange depending on lightness.
                if (hueName === 'orange') {
                    if (l < ORANGE_LIGHTNESS_THRESHOLD) hueName = 'brown';
                    else // Adjust lightness.
                    l = l - ORANGE_LIGHTNESS_THRESHOLD + MAX_DARK_LIGHTNESS;
                }
                // If the hue is at least halfway to the next hue, add the next hue name as well.
                if (h > hue + (nextHue - hue) / 2 && hueName !== nextHueName) hueName = `${hueName} ${nextHueName}`;
                else if (hueName === 'yellow' && l < YELLOW_GREEN_LIGHTNESS_THRESHOLD) // Yellow shifts toward green at lower lightnesses.
                hueName = 'yellow green';
                let name = strings.getStringForLocale(hueName, locale).toLocaleLowerCase(locale);
                return [
                    name,
                    l
                ];
            }
        }
        throw new Error('Unexpected hue');
    }
    getHueName(locale) {
        let [l, c, h] = toOKLCH(this);
        let [name] = this.getOklchHue(l, c, h, locale);
        return name;
    }
}
class RGBColor extends Color {
    constructor(red, green, blue, alpha){
        super(), this.red = red, this.green = green, this.blue = blue, this.alpha = alpha;
    }
    static parse(value) {
        let colors = [];
        // matching #rgb, #rgba, #rrggbb, #rrggbbaa
        if (/^#[\da-f]+$/i.test(value) && [
            4,
            5,
            7,
            9
        ].includes(value.length)) {
            const values = (value.length < 6 ? value.replace(/[^#]/gi, '$&$&') : value).slice(1).split('');
            while(values.length > 0)colors.push(parseInt(values.splice(0, 2).join(''), 16));
            colors[3] = colors[3] !== undefined ? colors[3] / 255 : undefined;
        }
        // matching rgb(rrr, ggg, bbb), rgba(rrr, ggg, bbb, 0.a)
        const match = value.match(/^rgba?\((.*)\)$/);
        if (match?.[1]) {
            colors = match[1].split(',').map((value)=>Number(value.trim()));
            colors = colors.map((num, i)=>{
                return (0, _utils.clamp)(num ?? 0, 0, i < 3 ? 255 : 1);
            });
        }
        if (colors[0] === undefined || colors[1] === undefined || colors[2] === undefined) return undefined;
        return colors.length < 3 ? undefined : new RGBColor(colors[0], colors[1], colors[2], colors[3] ?? 1);
    }
    toString(format = 'css') {
        switch(format){
            case 'hex':
                return '#' + (this.red.toString(16).padStart(2, '0') + this.green.toString(16).padStart(2, '0') + this.blue.toString(16).padStart(2, '0')).toUpperCase();
            case 'hexa':
                return '#' + (this.red.toString(16).padStart(2, '0') + this.green.toString(16).padStart(2, '0') + this.blue.toString(16).padStart(2, '0') + Math.round(this.alpha * 255).toString(16).padStart(2, '0')).toUpperCase();
            case 'rgb':
                return `rgb(${this.red}, ${this.green}, ${this.blue})`;
            case 'css':
            case 'rgba':
                return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hex':
            case 'hexa':
            case 'rgb':
            case 'rgba':
                return this;
            case 'hsb':
            case 'hsba':
                return this.toHSB();
            case 'hsl':
            case 'hsla':
                return this.toHSL();
            default:
                throw new Error('Unsupported color conversion: rgb -> ' + format);
        }
    }
    toHexInt() {
        return this.red << 16 | this.green << 8 | this.blue;
    }
    /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSBColor object.
   */ toHSB() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const brightness = Math.max(red, green, blue);
        const chroma = brightness - min;
        const saturation = brightness === 0 ? 0 : chroma / brightness;
        let hue = 0; // achromatic
        if (chroma !== 0) {
            switch(brightness){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new HSBColor((0, _utils.toFixedNumber)(hue * 360, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSLColor object.
   */ toHSL() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const max = Math.max(red, green, blue);
        const lightness = (max + min) / 2;
        const chroma = max - min;
        let hue;
        let saturation;
        if (chroma === 0) hue = saturation = 0; // achromatic
        else {
            saturation = chroma / (lightness < .5 ? max + min : 2 - max - min);
            switch(max){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                default:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new HSLColor((0, _utils.toFixedNumber)(hue * 360, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    clone() {
        return new RGBColor(this.red, this.green, this.blue, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'red':
            case 'green':
            case 'blue':
                return {
                    minValue: 0x0,
                    maxValue: 0xFF,
                    step: 0x1,
                    pageSize: 0x11
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'red':
            case 'green':
            case 'blue':
                return {
                    style: 'decimal'
                };
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'rgb';
    }
    static{
        this.colorChannels = [
            'red',
            'green',
            'blue'
        ];
    }
    getColorChannels() {
        return RGBColor.colorChannels;
    }
}
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsb(X, X%, X%)
// - hsba(X, X%, X%, X)
const HSB_REGEX = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class HSBColor extends Color {
    constructor(hue, saturation, brightness, alpha){
        super(), this.hue = hue, this.saturation = saturation, this.brightness = brightness, this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match(HSB_REGEX)) {
            const [h, s, b, a] = (m[1] ?? m[2]).split(',').map((n)=>Number(n.trim().replace('%', '')));
            return new HSBColor(normalizeHue(h), (0, _utils.clamp)(s, 0, 100), (0, _utils.clamp)(b, 0, 100), (0, _utils.clamp)(a ?? 1, 0, 1));
        }
    }
    toString(format = 'css') {
        switch(format){
            case 'css':
                return this.toHSL().toString('css');
            case 'hex':
                return this.toRGB().toString('hex');
            case 'hexa':
                return this.toRGB().toString('hexa');
            case 'hsb':
                return `hsb(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.brightness, 2)}%)`;
            case 'hsba':
                return `hsba(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.brightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hsb':
            case 'hsba':
                return this;
            case 'hsl':
            case 'hsla':
                return this.toHSL();
            case 'rgb':
            case 'rgba':
                return this.toRGB();
            default:
                throw new Error('Unsupported color conversion: hsb -> ' + format);
        }
    }
    /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   * @returns An HSLColor object.
   */ toHSL() {
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let lightness = brightness * (1 - saturation / 2);
        saturation = lightness === 0 || lightness === 1 ? 0 : (brightness - lightness) / Math.min(lightness, 1 - lightness);
        return new HSLColor((0, _utils.toFixedNumber)(this.hue, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSV color value to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let fn = (n, k = (n + hue / 60) % 6)=>brightness - saturation * brightness * Math.max(Math.min(k, 4 - k, 1), 0);
        return new RGBColor(Math.round(fn(5) * 255), Math.round(fn(3) * 255), Math.round(fn(1) * 255), this.alpha);
    }
    clone() {
        return new HSBColor(this.hue, this.saturation, this.brightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'hue':
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case 'saturation':
            case 'brightness':
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'hue':
                return {
                    style: 'unit',
                    unit: 'degree',
                    unitDisplay: 'narrow'
                };
            case 'saturation':
            case 'brightness':
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === 'saturation' || channel === 'brightness') value /= 100;
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'hsb';
    }
    static{
        this.colorChannels = [
            'hue',
            'saturation',
            'brightness'
        ];
    }
    getColorChannels() {
        return HSBColor.colorChannels;
    }
}
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsl(X, X%, X%)
// - hsla(X, X%, X%, X)
const HSL_REGEX = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class HSLColor extends Color {
    constructor(hue, saturation, lightness, alpha){
        super(), this.hue = hue, this.saturation = saturation, this.lightness = lightness, this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match(HSL_REGEX)) {
            const [h, s, l, a] = (m[1] ?? m[2]).split(',').map((n)=>Number(n.trim().replace('%', '')));
            return new HSLColor(normalizeHue(h), (0, _utils.clamp)(s, 0, 100), (0, _utils.clamp)(l, 0, 100), (0, _utils.clamp)(a ?? 1, 0, 1));
        }
    }
    toString(format = 'css') {
        switch(format){
            case 'hex':
                return this.toRGB().toString('hex');
            case 'hexa':
                return this.toRGB().toString('hexa');
            case 'hsl':
                return `hsl(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.lightness, 2)}%)`;
            case 'css':
            case 'hsla':
                return `hsla(${this.hue}, ${(0, _utils.toFixedNumber)(this.saturation, 2)}%, ${(0, _utils.toFixedNumber)(this.lightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hsl':
            case 'hsla':
                return this;
            case 'hsb':
            case 'hsba':
                return this.toHSB();
            case 'rgb':
            case 'rgba':
                return this.toRGB();
            default:
                throw new Error('Unsupported color conversion: hsl -> ' + format);
        }
    }
    /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   * @returns An HSBColor object.
   */ toHSB() {
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let brightness = lightness + saturation * Math.min(lightness, 1 - lightness);
        saturation = brightness === 0 ? 0 : 2 * (1 - lightness / brightness);
        return new HSBColor((0, _utils.toFixedNumber)(this.hue, 2), (0, _utils.toFixedNumber)(saturation * 100, 2), (0, _utils.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSL color to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let a = saturation * Math.min(lightness, 1 - lightness);
        let fn = (n, k = (n + hue / 30) % 12)=>lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return new RGBColor(Math.round(fn(0) * 255), Math.round(fn(8) * 255), Math.round(fn(4) * 255), this.alpha);
    }
    clone() {
        return new HSLColor(this.hue, this.saturation, this.lightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'hue':
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case 'saturation':
            case 'lightness':
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'hue':
                return {
                    style: 'unit',
                    unit: 'degree',
                    unitDisplay: 'narrow'
                };
            case 'saturation':
            case 'lightness':
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === 'saturation' || channel === 'lightness') value /= 100;
        return new (0, _number.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'hsl';
    }
    static{
        this.colorChannels = [
            'hue',
            'saturation',
            'lightness'
        ];
    }
    getColorChannels() {
        return HSLColor.colorChannels;
    }
}
// https://www.w3.org/TR/css-color-4/#color-conversion-code
function toOKLCH(color) {
    let rgb = color.toFormat('rgb');
    let red = rgb.getChannelValue('red') / 255;
    let green = rgb.getChannelValue('green') / 255;
    let blue = rgb.getChannelValue('blue') / 255;
    [red, green, blue] = lin_sRGB(red, green, blue);
    let [x, y, z] = lin_sRGB_to_XYZ(red, green, blue);
    let [l, a, b] = XYZ_to_OKLab(x, y, z);
    return OKLab_to_OKLCH(l, a, b);
}
function OKLab_to_OKLCH(l, a, b) {
    var hue = Math.atan2(b, a) * 180 / Math.PI;
    return [
        l,
        Math.sqrt(a ** 2 + b ** 2),
        hue >= 0 ? hue : hue + 360 // Hue, in degrees [0 to 360)
    ];
}
function lin_sRGB(r, g, b) {
    // convert an array of sRGB values
    // where in-gamut values are in the range [0 - 1]
    // to linear light (un-companded) form.
    // https://en.wikipedia.org/wiki/SRGB
    // Extended transfer function:
    // for negative values,  linear portion is extended on reflection of axis,
    // then reflected power function is used.
    return [
        lin_sRGB_component(r),
        lin_sRGB_component(g),
        lin_sRGB_component(b)
    ];
}
function lin_sRGB_component(val) {
    let sign = val < 0 ? -1 : 1;
    let abs = Math.abs(val);
    if (abs <= 0.04045) return val / 12.92;
    return sign * Math.pow((abs + 0.055) / 1.055, 2.4);
}
function lin_sRGB_to_XYZ(r, g, b) {
    // convert an array of linear-light sRGB values to CIE XYZ
    // using sRGB's own white, D65 (no chromatic adaptation)
    const M = [
        506752 / 1228815,
        87881 / 245763,
        12673 / 70218,
        87098 / 409605,
        175762 / 245763,
        12673 / 175545,
        7918 / 409605,
        87881 / 737289,
        1001167 / 1053270
    ];
    return multiplyMatrix(M, r, g, b);
}
function XYZ_to_OKLab(x, y, z) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        0.8190224379967030,
        0.3619062600528904,
        -0.1288737815209879,
        0.0329836539323885,
        0.9292868615863434,
        0.0361446663506424,
        0.0481771893596242,
        0.2642395317527308,
        0.6335478284694309
    ];
    const LMStoOKLab = [
        0.2104542683093140,
        0.7936177747023054,
        -0.0040720430116193,
        1.9779985324311684,
        -2.42859224204858,
        0.4505937096174110,
        0.0259040424655478,
        0.7827717124575296,
        -0.8086757549230774
    ];
    let [a, b, c] = multiplyMatrix(XYZtoLMS, x, y, z);
    return multiplyMatrix(LMStoOKLab, Math.cbrt(a), Math.cbrt(b), Math.cbrt(c));
}
function multiplyMatrix(m, x, y, z) {
    let a = m[0] * x + m[1] * y + m[2] * z;
    let b = m[3] * x + m[4] * y + m[5] * z;
    let c = m[6] * x + m[7] * y + m[8] * z;
    return [
        a,
        b,
        c
    ];
}

},{"@react-stately/utils":"kO94U","../intl/*.json":"jAvSj","@internationalized/string":[["LocalizedStringDictionary","4Bud6"],["LocalizedStringFormatter","kuVOY"]],"@internationalized/number":"2z0fS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jAvSj":[function(require,module,exports,__globalThis) {
const _temp0 = require("8261da12f2d796a0");
const _temp1 = require("e7f3cc295bd56c43");
const _temp2 = require("928b156311df314a");
const _temp3 = require("da11529b8a7c7264");
const _temp4 = require("2bd4fec20301a6e1");
const _temp5 = require("cb9e00ee1797bf96");
const _temp6 = require("df40c9f1e99342bc");
const _temp7 = require("2b741161a64c7f86");
const _temp8 = require("a0ab208d0c4d9bbc");
const _temp9 = require("6df59a33f8752594");
const _temp10 = require("95e83656be88a0b9");
const _temp11 = require("7b43c4f28c496178");
const _temp12 = require("ca7ab27d3dbdd701");
const _temp13 = require("9f280952ec6332d");
const _temp14 = require("a16fa84e8bec6f6d");
const _temp15 = require("87fa3c86dcff8488");
const _temp16 = require("7643407c7cc55124");
const _temp17 = require("8473098240aaa140");
const _temp18 = require("5a1160f9f8fea50a");
const _temp19 = require("2e5cb06bca7c3095");
const _temp20 = require("7888108d023a7b7f");
const _temp21 = require("61ff268bb8d1d4ac");
const _temp22 = require("3df506a2b962a66c");
const _temp23 = require("3c242200fe67447");
const _temp24 = require("50e3a59c589af3e6");
const _temp25 = require("d2499b131531a58f");
const _temp26 = require("e7105632fe9719e");
const _temp27 = require("1ab0cac6d4283cba");
const _temp28 = require("d0c6a9c4b1c1a945");
const _temp29 = require("9f55ffca6e1e6aee");
const _temp30 = require("ad7f8d39c3c9bbf1");
const _temp31 = require("9e2a03a6e3891821");
const _temp32 = require("84e9a5375c4b8dcf");
const _temp33 = require("3165da1482829949");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"8261da12f2d796a0":"ctpKo","e7f3cc295bd56c43":"ctpKo","928b156311df314a":"ctpKo","da11529b8a7c7264":"ctpKo","2bd4fec20301a6e1":"ctpKo","cb9e00ee1797bf96":"ctpKo","df40c9f1e99342bc":"7mleA","2b741161a64c7f86":"ctpKo","a0ab208d0c4d9bbc":"ctpKo","6df59a33f8752594":"ctpKo","95e83656be88a0b9":"ctpKo","7b43c4f28c496178":"ctpKo","ca7ab27d3dbdd701":"ctpKo","9f280952ec6332d":"ctpKo","a16fa84e8bec6f6d":"ctpKo","87fa3c86dcff8488":"ctpKo","7643407c7cc55124":"ctpKo","8473098240aaa140":"ctpKo","5a1160f9f8fea50a":"ctpKo","2e5cb06bca7c3095":"ctpKo","7888108d023a7b7f":"ctpKo","61ff268bb8d1d4ac":"ctpKo","3df506a2b962a66c":"ctpKo","3c242200fe67447":"ctpKo","50e3a59c589af3e6":"ctpKo","d2499b131531a58f":"ctpKo","e7105632fe9719e":"ctpKo","1ab0cac6d4283cba":"ctpKo","d0c6a9c4b1c1a945":"ctpKo","9f55ffca6e1e6aee":"ctpKo","ad7f8d39c3c9bbf1":"ctpKo","9e2a03a6e3891821":"ctpKo","84e9a5375c4b8dcf":"ctpKo","3165da1482829949":"ctpKo"}],"7mleA":[function(require,module,exports,__globalThis) {
module.exports = {
    "hue": `Hue`,
    "saturation": `Saturation`,
    "lightness": `Lightness`,
    "brightness": `Brightness`,
    "red": `Red`,
    "green": `Green`,
    "blue": `Blue`,
    "alpha": `Alpha`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparent`,
    "very dark": `very dark`,
    "dark": `dark`,
    "light": `light`,
    "very light": `very light`,
    "pale": `pale`,
    "grayish": `grayish`,
    "vibrant": `vibrant`,
    "black": `black`,
    "white": `white`,
    "gray": `gray`,
    "pink": `pink`,
    "pink red": `pink red`,
    "red orange": `red orange`,
    "brown": `brown`,
    "orange": `orange`,
    "orange yellow": `orange yellow`,
    "brown yellow": `brown yellow`,
    "yellow": `yellow`,
    "yellow green": `yellow green`,
    "green cyan": `green cyan`,
    "cyan": `cyan`,
    "cyan blue": `cyan blue`,
    "blue purple": `blue purple`,
    "purple": `purple`,
    "purple magenta": `purple magenta`,
    "magenta": `magenta`,
    "magenta pink": `magenta pink`
};

},{}],"6Hb2X":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lBmtU"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("6ftc0"),
    module.bundle.load("9f8mp"),
    module.bundle.load("dOFdr"),
    module.bundle.load("iCNtT"),
    module.bundle.load("jkk6G"),
    module.bundle.load("4UxgA")
]).then(()=>{
    let originalModule = module.bundle.root("i9ilt");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6ftc0")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("9f8mp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lBmtU"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dOFdr")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("iCNtT")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("jkk6G")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("4UxgA")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6mCg3":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("4UxgA"),
    module.bundle.load("jkk6G"),
    module.bundle.load("iCNtT"),
    module.bundle.load("dOFdr"),
    require("23dabd4616d8d087")(module.bundle.resolve("lBmtU")),
    module.bundle.load("9f8mp"),
    module.bundle.load("6ftc0")
]).then(()=>module.bundle.root('i9ilt'));

},{"23dabd4616d8d087":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"fiXwD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "TableColumn", ()=>TableColumn);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("../../../@react-spectrum/s2/style/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const table = " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xb12 _xa12 _Fd12 _FnuYUweb12 pt12 gX12 ob12 nb12 kb12 jb12 iq12 _kb12 hb12 mb12 lb12 _jf12 _Nc12 Pc12 __oe12 Za12";
const tableHeader = " gL12 ob12 nb12 sk12 snX20njb12";
const tableBody = " gX12";
const tableColumn = " Sf12 Rf12 _Wd12 xd12 _xa12 xX0cczbc12 _xX0cczba12 iq12 _ka12 hb12 ma12 la12 _jf12 Fx12 _oa12";
const tableCell = function anonymous(props) {
    let rules = " ";
    rules += ' Sf12';
    rules += ' Rf12';
    if (props.align === "center") rules += ' Fnv12';
    rules += ' Tp12';
    if (props.align === "bottom") rules += ' Tne12';
    else if (props.align === "center") rules += ' Tnd12';
    else if (props.align === "top") rules += ' Tnp12';
    if (props.align === "bottom") rules += ' Qd12';
    else rules += ' Qkp12';
    if (props.align === "bottom") rules += ' Qnd12';
    else if (props.align === "center") rules += ' Qnd12';
    else if (props.align === "top") rules += ' Qne12';
    rules += ' _ka12';
    if (props.isBorderHidden) rules += ' ha12';
    else {
        rules += ' ha12';
        rules += ' hkb12';
        rules += ' hnb12';
        rules += ' hEbDz5a12';
    }
    rules += ' ma12';
    rules += ' la12';
    rules += ' _jf12';
    rules += ' iq12';
    rules += ' _oa12';
    rules += ' sb12';
    rules += ' snmv8xi12';
    return rules;
};
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        ...props,
        className: table
    });
}
function TableHeader(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
        ...props,
        className: tableHeader
    });
}
function TableColumn(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
        ...props,
        className: tableColumn
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
        ...props,
        className: tableBody
    });
}
function TableRow(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
        ...props
    });
}
function TableCell({ hideBorder, styles, ...props }) {
    let align = 'center';
    if (hideBorder) align = 'bottom';
    else if (props.colSpan) align = 'top';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        ...props,
        className: (0, _runtime.mergeStyles)(tableCell({
            isBorderHidden: hideBorder,
            align
        }), styles)
    });
}

},{"0":"hDsP8","1":"hWyIx","2":"65rv1","3":"ailAX","4":"4bn6I","react/jsx-runtime":"2Is6Z","../../../@react-spectrum/s2/style/runtime":"8g9no","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hDsP8":[function() {},{}],"hWyIx":[function() {},{}],"65rv1":[function() {},{}],"ailAX":[function() {},{}],"4bn6I":[function() {},{}],"9lkLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Displays a link with a popover to browse a TypeScript type definition.
 */ parcelHelpers.export(exports, "TypePopover", ()=>TypePopover);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _link = require("./Link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const TypeLinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TypePopover({ name, children }) {
    let [breadcrumbs, setBreadcrumbs] = (0, _react.useState)([
        {
            id: 0,
            name,
            children
        }
    ]);
    let ctx = (0, _react.useContext)(TypeLinkContext);
    // If already inside a parent TypeLink, push onto the stack within the same popover.
    if (ctx) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ColorLink), {
        onPress: ()=>ctx.push(name, children),
        children: name
    });
    // Otherwise render the root popover with breadcrumbs for the stack of visited links.
    let cur = breadcrumbs.at(-1);
    let push = (name, children)=>{
        setBreadcrumbs((breadcrumbs)=>[
                ...breadcrumbs,
                {
                    id: breadcrumbs.length,
                    name,
                    children
                }
            ]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ColorLink), {
                className: " p37ZLpd12",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                styles: " L6kvVdc12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " Te12 Qe12 Se12 Re12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumbs), {
                            size: "L",
                            onAction: (id)=>setBreadcrumbs(breadcrumbs.slice(0, Number(id) + 1)),
                            styles: " GC12",
                            children: breadcrumbs.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumb), {
                                    id: item.id,
                                    children: item.name
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypeLinkContext.Provider, {
                            value: {
                                push
                            },
                            children: cur.children
                        })
                    ]
                })
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Breadcrumb","7swdD"],["Breadcrumbs","7swdD"],["DialogTrigger","eu4Kx"],["Popover","62puW"]],"./Link":"el6b6","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7swdD":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreadcrumbsContext", ()=>BreadcrumbsContext);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
parcelHelpers.export(exports, "Breadcrumb", ()=>Breadcrumb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _s2IconFolderBreadcrumb20NSvg = require("../s2wf-icons/S2_Icon_FolderBreadcrumb_20_N.svg");
var _s2IconFolderBreadcrumb20NSvgDefault = parcelHelpers.interopDefault(_s2IconFolderBreadcrumb20NSvg);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MIN_VISIBLE_ITEMS = 1;
const MAX_VISIBLE_ITEMS = 4;
const BreadcrumbsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexGrow = false;
    let flexShrink = false;
    let flexBasis = false;
    let marginTop = false;
    let marginBottom = false;
    let marginInlineStart = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_s") flexBasis = true;
        if (p[1] === "J") marginTop = true;
        if (p[1] === "G") marginBottom = true;
        if (p[1] === "I") marginInlineStart = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc12';
    rules += ' sd12';
    rules += ' _Cg12';
    rules += ' _Gc12';
    rules += ' _wa12';
    if (!flexGrow) rules += ' _ub12';
    if (!flexShrink) rules += ' _va12';
    if (!flexBasis) rules += ' _sb12';
    if (props.size === "L") rules += ' Urun3rd12';
    else if (props.size === "M") rules += ' UssxDec12';
    if (props.size === "L") rules += ' qrun3rd12';
    else if (props.size === "M") rules += ' qssxDec12';
    rules += ' Td12';
    rules += ' Qd12';
    rules += ' Sd12';
    rules += ' Rd12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (!marginTop) rules += ' Jy12';
    if (!marginBottom) rules += ' Gy12';
    if (props.size === "L") {
        if (!marginInlineStart) rules += ' Irun3rd12';
    } else if (props.size === "M") {
        if (!marginInlineStart) rules += ' IssxDec12';
    }
    return rules;
};
const InternalBreadcrumbsContext = /*#__PURE__*/ (0, _react.createContext)({});
const Breadcrumbs = /*#__PURE__*/ (0, _react.forwardRef)(function Breadcrumbs(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, BreadcrumbsContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, size = 'M', children, isDisabled, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                InternalBreadcrumbsContext,
                {
                    size,
                    isDisabled
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsingCollection, {
            containerRef: domRef,
            onAction: props.onAction,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Breadcrumbs), {
                ...otherProps,
                isDisabled: isDisabled,
                ref: domRef,
                style: UNSAFE_style,
                className: UNSAFE_className + wrapper({
                    size
                }, styles),
                children: children
            })
        })
    });
});
let BreadcrumbMenu = (props)=>{
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { items, onAction } = props;
    let { direction } = (0, _reactAria.useLocale)();
    let { size, isDisabled } = (0, _react.useContext)(InternalBreadcrumbsContext);
    let label = stringFormatter.format('breadcrumbs.more');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CollectionRendererContext).Provider, {
        value: (0, _reactAriaComponents.DefaultCollectionRenderer),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            className: breadcrumbStyles({
                size,
                isDisabled,
                isMenu: true
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                            isDisabled: isDisabled,
                            isQuiet: true,
                            "aria-label": label,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconFolderBreadcrumb20NSvgDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                            items: items,
                            onAction: onAction,
                            children: (item)=>/*#__PURE__*/ (0, _react.createElement)((0, _menu.MenuItem), {
                                    ...item.props.originalProps,
                                    key: item.key
                                }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                                    slot: "label",
                                    children: item.props.children({
                                        size,
                                        isCurrent: false,
                                        isMenu: true
                                    })
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                    size: size,
                    className: chevronStyles({
                        direction,
                        isMenu: true
                    })
                })
            ]
        })
    });
};
let HiddenBreadcrumbs = function(props) {
    let { listRef, items, size } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        // @ts-ignore
        inert: (0, _utils.inertValue)(true),
        ref: listRef,
        className: " s40ub4c12 U40ub4c12 q40ub4c12 _w40ub4c12 _Pa12 Wr12 _lr12 _6b12 _Nc12 Pc12 _Ia12",
        children: [
            items.map((item, idx)=>{
                // pull off individual props as an allow list, don't want refs or other props getting through
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-hidden-breadcrumb": true,
                    style: item.props.UNSAFE_style,
                    className: item.props.className({
                        size,
                        isCurrent: idx === items.length - 1
                    }),
                    children: item.props.children({
                        size,
                        isCurrent: idx === items.length - 1
                    })
                }, item.key);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                "data-hidden-button": true,
                isQuiet: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconFolderBreadcrumb20NSvgDefault.default), {})
            })
        ]
    });
};
const breadcrumbStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sd12';
    rules += ' eb12';
    rules += ' _Cg12';
    if (props.size === "XL") rules += ' Fz12';
    else if (props.size === "L") rules += ' Fv12';
    else if (props.size === "S") rules += ' Fp12';
    else if (props.size === "XS") rules += ' Fn12';
    else rules += ' Fx12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _Pc12';
    rules += ' _va12';
    if (props.isDisabled) rules += ' pp12';
    else rules += ' pt12';
    if (props.isDisabled) rules += ' plc12';
    else rules += ' plb12';
    rules += ' _je12';
    if (props.isMenu) rules += ' I34mdr12';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.direction === "rtl") {
        rules += ' -Z4Pn4c-a12';
        rules += ' __Ha12';
    }
    if (props.direction === "rtl") {
        rules += ' -_04Pn4c-a12';
        rules += ' __Ha12';
    }
    if (props.isMenu) rules += ' Iy12';
    else {
        rules += ' It12';
        rules += ' Isu12';
    }
    rules += ' pt12';
    rules += ' plf12';
    rules += ' -_8sjo0b-t5ZbAob12';
    return rules;
};
const linkStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' Olc12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.isCurrent) {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    } else if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' pt12';
        else if (props.isFocusVisible) rules += ' pt12';
        else if (props.isHovered) rules += ' pt12';
        else rules += ' pv12';
    }
    if (props.isCurrent) rules += ' plc12';
    else if (props.isDisabled) rules += ' plc12';
    else rules += ' plf12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isDisabled) rules += ' _Xa12';
    else if (props.isFocusVisible) {
        rules += ' _Xb12';
        rules += ' __Va12';
    } else if (props.isHovered) {
        rules += ' _Xb12';
        rules += ' __Va12';
    } else rules += ' _Xa12';
    if (props.isDisabled) rules += ' ri12';
    else rules += ' ry12';
    rules += ' __ca12';
    return rules;
};
const currentStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' ucJ9TBTb12';
        rules += ' ud3Euai12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FnuYUweb12';
    }
    if (props.size === "XL") rules += ' pt12';
    else if (props.size === "L") rules += ' pt12';
    else if (props.size === "S") rules += ' pt12';
    else if (props.size === "XS") rules += ' pt12';
    else rules += ' pt12';
    return rules;
};
// TODO: support user heading size customization, for now just set it to large
const heading = " Jy12 Gy12 Iy12 Hy12 uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-h12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 _Fd12 _FnuYUweb12 po12";
const Breadcrumb = /*#__PURE__*/ (0, _react.forwardRef)(function Breadcrumb({ children, ...props }, ref) {
    let { href, target, rel, download, ping, referrerPolicy } = props;
    let { size = 'M' } = (0, _react.useContext)(InternalBreadcrumbsContext) ?? {};
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Breadcrumb), {
        ...props,
        ref: domRef,
        // @ts-ignore
        originalProps: props,
        className: ({ isCurrent, isDisabled })=>breadcrumbStyles({
                size,
                isCurrent,
                isDisabled
            }),
        children: ({ isCurrent, isDisabled, // @ts-ignore
        isMenu })=>{
            if (isMenu) return children;
            return isCurrent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: currentStyles({
                    size
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                    values: [
                        [
                            (0, _reactAriaComponents.HeadingContext),
                            {
                                className: heading
                            }
                        ]
                    ],
                    children: children
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                        style: ({ isFocusVisible })=>({
                                clipPath: isFocusVisible ? 'none' : 'margin-box'
                            }),
                        href: href,
                        target: target,
                        rel: rel,
                        download: download,
                        ping: ping,
                        referrerPolicy: referrerPolicy,
                        isDisabled: isDisabled || isCurrent,
                        className: ({ isFocused, isFocusVisible, isHovered, isDisabled, isPressed })=>linkStyles({
                                isFocused,
                                isFocusVisible,
                                isHovered,
                                isDisabled,
                                size,
                                isPressed,
                                isCurrent
                            }),
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                        size: "M",
                        className: chevronStyles({
                            direction
                        })
                    })
                ]
            });
        }
    });
});
// Context for passing the count for the custom renderer
let CollapseContext = /*#__PURE__*/ (0, _react.createContext)(null);
function CollapsingCollection({ children, containerRef, onAction }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseContext.Provider, {
        value: {
            containerRef,
            onAction
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CollectionRendererContext).Provider, {
            value: CollapsingCollectionRenderer,
            children: children
        })
    });
}
let CollapsingCollectionRenderer = {
    CollectionRoot ({ collection }) {
        return useCollectionRender(collection);
    },
    CollectionBranch ({ collection }) {
        return useCollectionRender(collection);
    }
};
let useCollectionRender = (collection)=>{
    let { containerRef, onAction } = (0, _react.useContext)(CollapseContext) ?? {};
    let [visibleItems, setVisibleItems] = (0, _react.useState)(collection.size);
    let { size = 'M' } = (0, _react.useContext)(InternalBreadcrumbsContext);
    let children = (0, _react.useMemo)(()=>{
        let result = [];
        for (let key of collection.getKeys())result.push(collection.getItem(key));
        return result;
    }, [
        collection
    ]);
    let listRef = (0, _react.useRef)(null);
    let updateOverflow = (0, _react.useCallback)(()=>{
        let currListRef = listRef.current;
        if (!currListRef) {
            setVisibleItems(collection.size);
            return;
        }
        let container = currListRef.parentElement;
        if (!container) {
            setVisibleItems(collection.size);
            return;
        }
        let listItems = Array.from(currListRef.querySelectorAll('[data-hidden-breadcrumb]'));
        let folder = currListRef.querySelector('button');
        if (listItems.length <= 0) {
            setVisibleItems(collection.size);
            return;
        }
        let containerWidth = container.offsetWidth;
        let containerGap = parseInt(getComputedStyle(container).gap, 10);
        let folderGap = parseInt(getComputedStyle(folder).marginInlineStart, 10);
        let newVisibleItems = 0;
        let maxVisibleItems = MAX_VISIBLE_ITEMS;
        let widths = [];
        let totalWidth = 0;
        for (let breadcrumb of listItems){
            let width = breadcrumb.offsetWidth + 1; // offsetWidth is rounded down
            widths.push(width);
            totalWidth += width;
        }
        // can we fit all the items without collapsing
        if (totalWidth <= containerWidth - collection.size * containerGap && collection.size <= MAX_VISIBLE_ITEMS) {
            setVisibleItems(collection.size);
            return;
        }
        // we know there is always at least one item because of the listItems.length check up above
        let widthOfFirst = widths.shift();
        let availableWidth = containerWidth - widthOfFirst - folderGap - folder.offsetWidth - containerGap;
        maxVisibleItems -= 2; // account for the first item and folder
        for (let width of widths.reverse()){
            availableWidth -= width;
            if (availableWidth <= 0) break;
            availableWidth -= containerGap;
            newVisibleItems++;
        }
        setVisibleItems(Math.max(MIN_VISIBLE_ITEMS, Math.min(maxVisibleItems, newVisibleItems)));
    }, [
        collection.size,
        setVisibleItems
    ]);
    // making bad assumption that i can listen to containerRef when it's declared in the parent?
    (0, _utils1.useResizeObserver)({
        ref: containerRef,
        onResize: updateOverflow
    });
    (0, _utils.useLayoutEffect)(()=>{
        if (collection.size > 0) queueMicrotask(updateOverflow);
    }, [
        collection.size,
        updateOverflow
    ]);
    (0, _react.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateOverflow());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let sliceIndex = collection.size - visibleItems;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenBreadcrumbs, {
                items: children,
                size: size,
                listRef: listRef
            }),
            visibleItems < collection.size && collection.size > 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children[0].render?.(children[0]),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbMenu, {
                        items: children.slice(1, sliceIndex),
                        onAction: onAction
                    }),
                    children.slice(sliceIndex).map((node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                            children: node.render?.(node)
                        }, node.key))
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: children.map((node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                        children: node.render?.(node)
                    }, node.key))
            })
        ]
    });
};

},{"0":"mX7CO","1":"11eHq","2":"1EeqD","3":"02hEQ","4":"gKkus","5":"4D7dO","6":"6OIau","react/jsx-runtime":"2Is6Z","react":"a1TxN","./ActionButton":"lNDRs","react-aria-components":[["Breadcrumb","75ZnM"],["Breadcrumbs","75ZnM"],["CollectionRendererContext","7QyMy"],["DefaultCollectionRenderer","7QyMy"],["HeadingContext","lIerG"],["Link","fOCdV"],["Provider","bA6Cz"]],"../ui-icons/Chevron":"1904U","../s2wf-icons/S2_Icon_FolderBreadcrumb_20_N.svg":"eTHST","@react-aria/utils":[["inertValue","aL0AK"],["useLayoutEffect","2ViQu"]],"../intl/*.json":"gDH3q","./Menu":"1F0Yz","./Content":"10r6w","@react-spectrum/utils":[["useDOMRef","jqfrX"],["useResizeObserver","7OAb4"]],"react-aria":"4k4z8","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"mX7CO":[function() {},{}],"11eHq":[function() {},{}],"1EeqD":[function() {},{}],"02hEQ":[function() {},{}],"gKkus":[function() {},{}],"4D7dO":[function() {},{}],"6OIau":[function() {},{}],"75ZnM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreadcrumbsContext", ()=>BreadcrumbsContext);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
parcelHelpers.export(exports, "Breadcrumb", ()=>Breadcrumb);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _collection = require("./Collection");
var _utils1 = require("@react-aria/utils");
var _link = require("./Link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BreadcrumbsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Breadcrumbs = /*#__PURE__*/ (0, _react.forwardRef)(function Breadcrumbs(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, BreadcrumbsContext);
    let { CollectionRoot } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let { navProps } = (0, _reactAria.useBreadcrumbs)(props);
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.CollectionBuilder), {
        content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Collection), props)
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("ol", {
            ref: ref,
            ...(0, _utils1.mergeProps)(DOMProps, navProps),
            slot: props.slot || undefined,
            style: props.style,
            className: props.className ?? 'react-aria-Breadcrumbs'
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(BreadcrumbsContext.Provider, {
            value: props
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRoot, {
            collection: collection
        }))));
});
class BreadcrumbNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'item';
    }
}
const Breadcrumb = /*#__PURE__*/ (0, _collections.createLeafComponent)(BreadcrumbNode, function Breadcrumb(props, ref, node) {
    // Recreating useBreadcrumbItem because we want to use composition instead of having the link builtin.
    let isCurrent = node.nextKey == null;
    let { isDisabled, onAction } = (0, _utils.useSlottedContext)(BreadcrumbsContext);
    let linkProps = {
        'aria-current': isCurrent ? 'page' : null,
        isDisabled: isDisabled || isCurrent,
        onPress: ()=>onAction?.(node.key)
    };
    let renderProps = (0, _utils.useRenderProps)({
        ...node.props,
        children: node.rendered,
        values: {
            isDisabled: isDisabled || isCurrent,
            isCurrent
        },
        defaultClassName: 'react-aria-Breadcrumb'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        "data-disabled": isDisabled || isCurrent || undefined,
        "data-current": isCurrent || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _link.LinkContext).Provider, {
        value: linkProps
    }, renderProps.children));
});

},{"react-aria":"aTC40","./utils":"bA6Cz","@react-aria/collections":[["Collection","2Jd0Q"],["CollectionBuilder","2Jd0Q"],["createLeafComponent","2Jd0Q"],["CollectionNode","ab6Rh"]],"./Collection":"7QyMy","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"./Link":"fOCdV","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aTC40":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a breadcrumbs component.
 * Breadcrumbs display a hierarchy of links to the current page or resource in an application.
 */ parcelHelpers.export(exports, "useBreadcrumbs", ()=>useBreadcrumbs);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
function useBreadcrumbs(props) {
    let { 'aria-label': ariaLabel, ...otherProps } = props;
    let strings = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/breadcrumbs');
    return {
        navProps: {
            ...(0, _utils.filterDOMProps)(otherProps, {
                labelable: true
            }),
            'aria-label': ariaLabel || strings.format('breadcrumbs')
        }
    };
}

},{"@react-aria/utils":"3upVm","../intl/*.json":"3mxvV","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3mxvV":[function(require,module,exports,__globalThis) {
const _temp0 = require("6a38761146b6fe2e");
const _temp1 = require("f6b69d03e449ab21");
const _temp2 = require("af85e2bc3e34c1d6");
const _temp3 = require("5e32c2de9204e278");
const _temp4 = require("5b11147d5bfedd72");
const _temp5 = require("7c3146921ce52309");
const _temp6 = require("1e79bd5d961c6452");
const _temp7 = require("49e50a05c7963e29");
const _temp8 = require("1373b5c9a222813d");
const _temp9 = require("e11ca0be0ce69fc");
const _temp10 = require("a6f34b0d8c8ad951");
const _temp11 = require("4db20e48e4925567");
const _temp12 = require("b4f2b3bdc84b0026");
const _temp13 = require("18d72bc7e2eacf86");
const _temp14 = require("dce25e6362366691");
const _temp15 = require("23f1fd9676ab8b95");
const _temp16 = require("fa9b35c3cfa226e4");
const _temp17 = require("682acae4c1705d87");
const _temp18 = require("fdce9782f6e0c241");
const _temp19 = require("a70ab25a76745459");
const _temp20 = require("fc9d3bf6a17a9db2");
const _temp21 = require("ce90a8e9c8700853");
const _temp22 = require("2d2a634e6fdc7c2f");
const _temp23 = require("ceb2520a86f131b7");
const _temp24 = require("d9dd24235c7defee");
const _temp25 = require("a6338e819dedcced");
const _temp26 = require("6677c20ef8ad4e3a");
const _temp27 = require("5ed83f537c396fb5");
const _temp28 = require("b46950c97094556d");
const _temp29 = require("6957ceb9bd94292e");
const _temp30 = require("b71d4e4a6b126cb6");
const _temp31 = require("d0e5289e4e461332");
const _temp32 = require("c454a88bb5ffd503");
const _temp33 = require("99f443041faa1e37");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"6a38761146b6fe2e":"ctpKo","f6b69d03e449ab21":"ctpKo","af85e2bc3e34c1d6":"ctpKo","5e32c2de9204e278":"ctpKo","5b11147d5bfedd72":"ctpKo","7c3146921ce52309":"ctpKo","1e79bd5d961c6452":"edtk3","49e50a05c7963e29":"ctpKo","1373b5c9a222813d":"ctpKo","e11ca0be0ce69fc":"ctpKo","a6f34b0d8c8ad951":"ctpKo","4db20e48e4925567":"ctpKo","b4f2b3bdc84b0026":"ctpKo","18d72bc7e2eacf86":"ctpKo","dce25e6362366691":"ctpKo","23f1fd9676ab8b95":"ctpKo","fa9b35c3cfa226e4":"ctpKo","682acae4c1705d87":"ctpKo","fdce9782f6e0c241":"ctpKo","a70ab25a76745459":"ctpKo","fc9d3bf6a17a9db2":"ctpKo","ce90a8e9c8700853":"ctpKo","2d2a634e6fdc7c2f":"ctpKo","ceb2520a86f131b7":"ctpKo","d9dd24235c7defee":"ctpKo","a6338e819dedcced":"ctpKo","6677c20ef8ad4e3a":"ctpKo","5ed83f537c396fb5":"ctpKo","b46950c97094556d":"ctpKo","6957ceb9bd94292e":"ctpKo","b71d4e4a6b126cb6":"ctpKo","d0e5289e4e461332":"ctpKo","c454a88bb5ffd503":"ctpKo","99f443041faa1e37":"ctpKo"}],"edtk3":[function(require,module,exports,__globalThis) {
module.exports = {
    "breadcrumbs": `Breadcrumbs`
};

},{}],"1oOMo":[function(require,module,exports,__globalThis) {
const _temp0 = require("b5521ab5771dbcc5");
const _temp1 = require("16b0c87fb6f0afb5");
const _temp2 = require("4b88b113ce05544f");
const _temp3 = require("5c93d768f9f3f766");
const _temp4 = require("3e9d5012af0fcd26");
const _temp5 = require("b0a8106cf4d57499");
const _temp6 = require("7c164cece50a4681");
const _temp7 = require("a6e49461c746c8b5");
const _temp8 = require("6049a15dbd7061d4");
const _temp9 = require("2384d272a43fd275");
const _temp10 = require("7520a51ca1dd89f3");
const _temp11 = require("43131ed583dad9d5");
const _temp12 = require("dfdc728402eba1f7");
const _temp13 = require("4cafe01370a1741b");
const _temp14 = require("38266c494ca5d4a6");
const _temp15 = require("8e97716852873df5");
const _temp16 = require("bab30bd0883e0653");
const _temp17 = require("dfe02feddc4a133c");
const _temp18 = require("1788f136175a6c9");
const _temp19 = require("1c3e424e882698b3");
const _temp20 = require("b337b827b1afcf27");
const _temp21 = require("b5bd2bea21af5a6f");
const _temp22 = require("3b4dec6d46d6807d");
const _temp23 = require("50e48aec390da4e2");
const _temp24 = require("1672b97cab966e86");
const _temp25 = require("c812172713b96534");
const _temp26 = require("c5f457161baebf16");
const _temp27 = require("763a23bba42bf5eb");
const _temp28 = require("190f3e44a39592e1");
const _temp29 = require("67ac7a8f9e1a128a");
const _temp30 = require("bc671a05841e6fa");
const _temp31 = require("f48715f5be4e5846");
const _temp32 = require("eb3b701b28bec7bc");
const _temp33 = require("3e5371c147d7adfd");
const _temp34 = require("d99f3262a83ae0cd");
const _temp35 = require("474ba4f607a60147");
const _temp36 = require("c6b79691ff227280");
const _temp37 = require("c037e72a2d0bd748");
const _temp38 = require("4c22f2ba5565bb4");
module.exports = {
    "react-aria": {
        "assets": {
            "datepicker-rtl": {
                "png": _temp0
            }
        },
        "examples": {
            "crud-dark": {
                "png": _temp1
            },
            "crud": {
                "png": _temp2
            },
            "emoji-picker-dark": {
                "png": _temp3
            },
            "emoji-picker": {
                "png": _temp4
            },
            "ios-list-dark": {
                "png": _temp5
            },
            "kanban-dark": {
                "png": _temp6
            },
            "kanban": {
                "png": _temp7
            },
            "photos-dark": {
                "png": _temp8
            },
            "photos": {
                "png": _temp9
            },
            "sheet-dark": {
                "png": _temp10
            },
            "sheet": {
                "png": _temp11
            },
            "swipeable-tabs-dark": {
                "png": _temp12
            },
            "swipeable-tabs": {
                "png": _temp13
            },
            "plants": {
                "plants": {
                    "agapanthus": {
                        "jpg": _temp14
                    },
                    "aloe": {
                        "jpg": _temp15
                    },
                    "dracaena": {
                        "jpg": _temp16
                    },
                    "fern": {
                        "jpg": _temp17
                    },
                    "fig": {
                        "jpg": _temp18
                    },
                    "gardenia": {
                        "jpg": _temp19
                    },
                    "ivy": {
                        "jpg": _temp20
                    },
                    "jacaranda": {
                        "jpg": _temp21
                    },
                    "maidenhair": {
                        "jpg": _temp22
                    },
                    "money": {
                        "jpg": _temp23
                    },
                    "monstera": {
                        "jpg": _temp24
                    },
                    "morning": {
                        "jpg": _temp25
                    },
                    "nasturtium": {
                        "jpg": _temp26
                    },
                    "oleander": {
                        "jpg": _temp27
                    },
                    "poplar": {
                        "jpg": _temp28
                    },
                    "spider": {
                        "jpg": _temp29
                    },
                    "star": {
                        "jpg": _temp30
                    },
                    "tree_fern": {
                        "jpg": _temp31
                    },
                    "xmas": {
                        "jpg": _temp32
                    },
                    "zz": {
                        "jpg": _temp33
                    }
                }
            }
        }
    },
    "s2": {
        "assets": {
            "logo": {
                "svg": _temp34
            },
            "multiply": {
                "png": _temp35
            },
            "normal": {
                "png": _temp36
            },
            "preview": {
                "png": _temp37
            },
            "screen": {
                "png": _temp38
            }
        }
    }
};

},{"b5521ab5771dbcc5":"33n7F","16b0c87fb6f0afb5":"lzjFF","4b88b113ce05544f":"2smAH","5c93d768f9f3f766":"c18aK","3e9d5012af0fcd26":"8YCgT","b0a8106cf4d57499":"bk4yh","7c164cece50a4681":"vjlUD","a6e49461c746c8b5":"iLi8Y","6049a15dbd7061d4":"lSXrg","2384d272a43fd275":"gaMb5","7520a51ca1dd89f3":"kyBLL","43131ed583dad9d5":"guc3G","dfdc728402eba1f7":"91lqj","4cafe01370a1741b":"2UiVe","38266c494ca5d4a6":"9YfkL","8e97716852873df5":"99nMi","bab30bd0883e0653":"5ntJ6","dfe02feddc4a133c":"9G1Yy","1788f136175a6c9":"1ts1t","1c3e424e882698b3":"8p6ES","b337b827b1afcf27":"WhBxT","b5bd2bea21af5a6f":"39NTq","3b4dec6d46d6807d":"4BDiK","50e48aec390da4e2":"bQtEi","1672b97cab966e86":"kzslC","c812172713b96534":"1Y9uq","c5f457161baebf16":"cy1Tn","763a23bba42bf5eb":"8EUfG","190f3e44a39592e1":"7dncL","67ac7a8f9e1a128a":"3zhbA","bc671a05841e6fa":"duES8","f48715f5be4e5846":"7gwLw","eb3b701b28bec7bc":"iUx62","3e5371c147d7adfd":"2OnO0","d99f3262a83ae0cd":"lm81l","474ba4f607a60147":"czCxR","c6b79691ff227280":"bHAV9","c037e72a2d0bd748":"f3RUu","4c22f2ba5565bb4":"2Wutx"}],"33n7F":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6zqTD");

},{}],"lzjFF":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5BqrR");

},{}],"2smAH":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aeJCk");

},{}],"c18aK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cV9iZ");

},{}],"8YCgT":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gsBhw");

},{}],"bk4yh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5cipT");

},{}],"vjlUD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("96Yok");

},{}],"iLi8Y":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7uoTh");

},{}],"lSXrg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bKKfw");

},{}],"gaMb5":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jDbeZ");

},{}],"kyBLL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("d9Oph");

},{}],"guc3G":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kKbHj");

},{}],"91lqj":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1TKak");

},{}],"2UiVe":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("l5zV9");

},{}],"9YfkL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("23T9U");

},{}],"99nMi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7DhUR");

},{}],"5ntJ6":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("13AxL");

},{}],"9G1Yy":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kOjWr");

},{}],"1ts1t":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("17tYV");

},{}],"8p6ES":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7wu64");

},{}],"WhBxT":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8H5Vj");

},{}],"39NTq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("evP0U");

},{}],"4BDiK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cwkB5");

},{}],"bQtEi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3YajE");

},{}],"kzslC":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("XZ4On");

},{}],"1Y9uq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("OIxRS");

},{}],"cy1Tn":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3cgqa");

},{}],"8EUfG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("d6Xjf");

},{}],"7dncL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kpwkm");

},{}],"3zhbA":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8jlPY");

},{}],"duES8":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3zoab");

},{}],"7gwLw":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2THLY");

},{}],"iUx62":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("9ssN2");

},{}],"2OnO0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4XdAR");

},{}],"lm81l":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8WQtT");

},{}],"czCxR":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5NdkH");

},{}],"bHAV9":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("ld31y");

},{}],"f3RUu":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eXbiS");

},{}],"2Wutx":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5M3m2");

},{}],"gQsl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandableCode", ()=>ExpandableCode);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const example = function anonymous(props) {
    let rules = " ";
    rules += ' uj12';
    rules += ' -_6BNtrc-e12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fb12';
    rules += ' _FnuYUwec12';
    rules += ' pt12';
    if (props.isExpanded) rules += ' KEmhfb12';
    else rules += ' KDBOfn12';
    if (props.isExpanded) rules += ' _Na12';
    else rules += ' _Nb12';
    if (props.isExpanded) rules += ' Pa12';
    else rules += ' Pb12';
    rules += ' _Pc12';
    rules += ' Za12';
    rules += ' ke12';
    rules += ' je12';
    if (props.isExpanded) rules += ' -T8cqC-sf12';
    else rules += ' -T8cqC-sk12';
    if (props.isExpanded) rules += ' -kAdake-Rr12';
    else rules += ' -kAdake-Rf12';
    return rules;
};
const expandWrapper = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Pd12';
    else rules += ' _Pa12';
    rules += ' _lr12';
    rules += ' _Ar12';
    rules += ' _zr12';
    rules += ' sd12';
    rules += ' _Ca12';
    rules += ' Tt12';
    rules += ' Qt12';
    return rules;
};
function ExpandableCode({ children, hasHighlightedLine }) {
    let [isExpanded, setExpanded] = (0, _react.useState)(false);
    let ref = (0, _react.useRef)(null);
    let mask;
    let padding;
    if (!isExpanded) {
        if (hasHighlightedLine) {
            // mask the top, bottom, and right sides
            mask = 'linear-gradient(transparent, white 25% 50%, transparent), linear-gradient(to right, white 0% 85%, transparent)';
            padding = '0px';
        } else // only mask the bottom and right
        mask = 'linear-gradient(white 0% 50%, transparent), linear-gradient(to right, white 0% 85%, transparent)';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: example({
            isExpanded
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    maskImage: mask,
                    maskComposite: 'intersect',
                    maxHeight: isExpanded ? undefined : 'inherit',
                    '--code-padding-y': padding
                },
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: expandWrapper({
                    isExpanded
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                    onPress: ()=>{
                        viewTransition(()=>{
                            setExpanded(!isExpanded);
                            ref.current?.scrollTo(0, 0);
                        });
                    },
                    children: isExpanded ? 'Collapse code' : 'Expand code'
                })
            })
        ]
    });
}
function viewTransition(cb) {
    if ('startViewTransition' in document) // @ts-ignore
    document.startViewTransition(()=>(0, _reactDom.flushSync)(()=>cb()));
    else cb();
}

},{"0":"4oKuc","1":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"lNDRs","react-dom":"gC2PC","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ig7bW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsContext", ()=>TabsContext);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabList", ()=>TabList);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "TabPanel", ()=>TabPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _collections = require("@react-aria/collections");
var _icon = require("./Icon");
var _utils = require("@react-aria/utils");
var _tabsPicker = require("./TabsPicker");
var _content = require("./Content");
var _utils1 = require("@react-stately/utils");
var _utils2 = require("@react-spectrum/utils");
var _focus = require("@react-aria/focus");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TabsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalTabsContext = /*#__PURE__*/ (0, _react.createContext)({});
const CollapseContext = /*#__PURE__*/ (0, _react.createContext)({
    showTabs: true,
    menuId: '',
    valueId: '',
    tabs: []
});
const tabs = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexShrink = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_v") flexShrink = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc12';
    rules += ' sd12';
    if (!flexShrink) rules += ' _va12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    rules += ' pt12';
    if (props.orientation === "horizontal") rules += ' _ta12';
    return rules;
};
const Tabs = /*#__PURE__*/ (0, _react.forwardRef)(function Tabs(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TabsContext);
    let { density = 'regular', isDisabled, disabledKeys, orientation = 'horizontal', labelBehavior = 'show' } = props;
    let domRef = (0, _utils2.useDOMRef)(ref);
    let [value, setValue] = (0, _utils1.useControlledState)(props.selectedKey, props.defaultSelectedKey ?? null, props.onSelectionChange);
    if (!props['aria-label'] && !props['aria-labelledby']) throw new Error('An aria-label or aria-labelledby prop is required on Tabs for accessibility.');
    let tablistRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                InternalTabsContext,
                {
                    density,
                    isDisabled,
                    orientation,
                    disabledKeys,
                    selectedKey: value,
                    tablistRef,
                    onSelectionChange: setValue,
                    labelBehavior,
                    'aria-label': props['aria-label'],
                    'aria-labelledby': props['aria-labelledby']
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collections.CollectionBuilder), {
            content: props.children,
            children: (collection)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsingTabs, {
                    ...props,
                    selectedKey: value,
                    onSelectionChange: setValue,
                    collection: collection,
                    containerRef: domRef
                })
        })
    });
});
const tablist = function anonymous(props) {
    let rules = " ";
    rules += ' sd12';
    if (props.orientation === "horizontal") {
        if (props.labelBehavior === "hide") {
            if (props.density === "regular") rules += ' Uj12';
            else if (props.density === "compact") rules += ' Ul12';
        } else if (props.density === "regular") rules += ' Up12';
        else if (props.density === "compact") rules += ' Uj12';
    }
    if (props.orientation === "horizontal") {
        if (props.labelBehavior === "hide") {
            if (props.density === "regular") rules += ' qj12';
            else if (props.density === "compact") rules += ' ql12';
        } else if (props.density === "regular") rules += ' qp12';
        else if (props.density === "compact") rules += ' qj12';
    }
    if (props.orientation === "vertical") rules += ' _ta12';
    if (props.orientation === "vertical") rules += ' Hz12';
    if (props.orientation === "vertical") rules += ' Ix12';
    rules += ' Nq12';
    return rules;
};
const tablistWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let minWidth = false;
    let flexShrink = false;
    let flexGrow = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_u") flexGrow = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc12';
    if (!minWidth) rules += ' Na12';
    if (!flexShrink) rules += ' _va12';
    if (!flexGrow) rules += ' _ua12';
    return rules;
};
function TabList(props) {
    let { showTabs, menuId, valueId, tabs, listRef, onSelectionChange, ariaLabel, ariaDescribedBy } = (0, _react.useContext)(CollapseContext) ?? {};
    let { density, orientation, labelBehavior } = (0, _react.useContext)(InternalTabsContext);
    if (showTabs) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabListInner, {
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: tablistWrapper(null, props.styles),
        children: [
            listRef && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: tablist({
                    orientation,
                    labelBehavior,
                    density
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenTabs, {
                    items: tabs,
                    density: density,
                    listRef: listRef
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsMenu, {
                id: menuId,
                valueId: valueId,
                items: tabs,
                onSelectionChange: onSelectionChange,
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedBy
            })
        ]
    });
}
function TabListInner(props) {
    let { tablistRef, orientation, density, labelBehavior, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = (0, _react.useContext)(InternalTabsContext) ?? {};
    let { tabs, listRef } = (0, _react.useContext)(CollapseContext) ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + tablistWrapper(null, props.styles),
        children: [
            listRef && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: tablist({
                    orientation,
                    labelBehavior,
                    density
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenTabs, {
                    items: tabs,
                    density: density,
                    listRef: listRef
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabList), {
                ...props,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                ref: tablistRef,
                className: (renderProps)=>tablist({
                        ...renderProps,
                        labelBehavior,
                        density
                    })
            })
        ]
    });
}
const selectedIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa12';
    if (props.isDisabled) rules += ' gH12';
    else rules += ' g012';
    if (props.isDisabled) rules += ' gld12';
    else rules += ' gle12';
    if (props.orientation === "horizontal") rules += ' FLvNfn12';
    else rules += ' Fb12';
    if (props.orientation === "vertical") rules += ' ZLvNfn12';
    else rules += ' Za12';
    rules += ' _qg12';
    rules += ' YIRyJjb12';
    rules += ' Ydklsgce12';
    rules += ' Xc12';
    rules += ' _2a12';
    rules += ' _lr12';
    if (props.orientation === "vertical") rules += ' Wr12';
    if (props.orientation === "horizontal") rules += ' _Er12';
    if (props.orientation === "vertical") rules += ' _Aa12';
    rules += ' _je12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    return rules;
};
const tab = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexShrink = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_v") flexShrink = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' sd12';
    if (props.isDisabled) rules += ' pp12';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    } else {
        if (props.isPressed) rules += ' pt12';
        else if (props.isFocusVisible) rules += ' pt12';
        else if (props.isHovered) rules += ' pt12';
        else rules += ' pv12';
    }
    if (props.isDisabled) rules += ' plc12';
    else if (props.isSelected) rules += ' pld12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    rules += ' Uc12';
    rules += ' Usd12';
    rules += ' qc12';
    rules += ' qsd12';
    if (props.orientation === "horizontal") {
        if (props.density === "regular") rules += ' Fz12';
        else if (props.density === "compact") rules += ' Fx12';
    }
    if (props.orientation === "vertical") {
        if (props.density === "regular") rules += ' Mk12';
        else if (props.density === "compact") rules += ' Mi12';
    }
    rules += ' eb12';
    if (!position) rules += ' _Pc12';
    rules += ' ri12';
    rules += ' _Xa12';
    if (!flexShrink) rules += ' _va12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.labelBehavior === "hide") rules += ' SssxDec12';
    if (props.labelBehavior === "hide") rules += ' RssxDec12';
    rules += ' __ca12';
    return rules;
};
const icon = " sb12 _va12 -_8sjo0b-t5ZbAob12";
function Tab(props1) {
    let { density, orientation, labelBehavior } = (0, _react.useContext)(InternalTabsContext) ?? {};
    let contentId = (0, _utils.useId)();
    let ariaLabelledBy = props1['aria-labelledby'] || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tab), {
        ...props1,
        // @ts-ignore
        originalProps: props1,
        "aria-labelledby": `${labelBehavior === 'hide' ? contentId : ''} ${ariaLabelledBy}`,
        style: props1.UNSAFE_style,
        className: (renderProps)=>(props1.UNSAFE_className || '') + tab({
                ...renderProps,
                density,
                labelBehavior,
                orientation
            }, props1.styles),
        children: ({ // @ts-ignore
        isMenu, isDisabled })=>{
            if (isMenu) return props1.children;
            else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _content.TextContext),
                        {
                            id: contentId,
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' _Jb12';
                                if (props.labelBehavior === "hide") rules += ' sk12';
                                return rules;
                            }({
                                labelBehavior
                            })
                        }
                    ],
                    [
                        (0, _icon.IconContext),
                        {
                            render: (0, _centerBaseline.centerBaseline)({
                                slot: 'icon',
                                styles: " _Ja12"
                            }),
                            styles: icon
                        }
                    ]
                ],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabInner, {
                    orientation: orientation,
                    isDisabled: isDisabled,
                    children: typeof props1.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        children: props1.children
                    }) : props1.children
                })
            });
        }
    });
}
function TabInner({ isDisabled, orientation, children }) {
    let ref = (0, _react.useRef)(null);
    let isHidden = (0, _react.useContext)(HiddenTabsContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !isHidden && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectionIndicator), {
                ref: ref,
                className: selectedIndicator({
                    isDisabled,
                    orientation
                })
            }),
            children
        ]
    });
}
const tabPanel = function anonymous(props, overrides) {
    let rules = " ";
    let marginTop = false;
    let flexGrow = false;
    let minHeight = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "J") marginTop = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "M") minHeight = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    if (!marginTop) rules += ' Js12';
    rules += ' pt12';
    if (!flexGrow) rules += ' _ub12';
    if (!minHeight) rules += ' Ma12';
    if (props.isInert) rules += ' sk12';
    else rules += ' sb12';
    return rules;
};
function TabPanel(props) {
    let { showTabs } = (0, _react.useContext)(CollapseContext);
    let { selectedKey } = (0, _react.useContext)(InternalTabsContext);
    if (showTabs) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabPanel), {
        ...props,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className ?? '') + tabPanel(renderProps, props.styles)
    });
    if (props.id !== selectedKey) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsedTabPanel, {
        ...props
    });
}
function CollapsedTabPanel(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { UNSAFE_style, UNSAFE_className = '', id, ...otherProps } = props;
    let { menuId, valueId } = (0, _react.useContext)(CollapseContext);
    let ref = (0, _react.useRef)(null);
    let tabIndex = (0, _focus.useHasTabbableChild)(ref) ? undefined : 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ...otherProps,
        ref: ref,
        "aria-labelledby": menuId + ' ' + valueId,
        tabIndex: tabIndex,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + tabPanel(renderProps, props.styles)
    });
}
function isEveryTabDisabled(collection, disabledKeys) {
    let testKey = null;
    if (collection && collection.size > 0) {
        testKey = collection.getFirstKey();
        let index = 0;
        while(testKey && index < collection.size){
            // We have to check if the item in the collection has a key in disabledKeys or has the isDisabled prop set directly on it
            if (!disabledKeys.has(testKey) && !collection.getItem(testKey)?.props?.isDisabled) return false;
            testKey = collection.getKeyAfter(testKey);
            index++;
        }
        return true;
    }
    return false;
}
const HiddenTabsContext = /*#__PURE__*/ (0, _react.createContext)(false);
let HiddenTabs = function(props) {
    let { listRef, items = [], size, density } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        // @ts-ignore
        inert: (0, _utils.inertValue)(true),
        ref: listRef,
        className: " s40ub4c12 _t40ub4c12 U40ub4c12 q40ub4c12 _w40ub4c12 _Pa12 Wr12 _lr12 _Ar12 _zr12 _6b12 _Nc12 Pc12 _Ia12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenTabsContext.Provider, {
            value: true,
            children: items.map((item)=>{
                // pull off individual props as an allow list, don't want refs or other props getting through
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-hidden-tab": true,
                    style: item.props.UNSAFE_style,
                    className: item.props.className({
                        size,
                        density
                    }),
                    children: item.props.children({
                        size,
                        density
                    })
                }, item.key);
            })
        })
    });
};
let TabsMenu = (props1)=>{
    let { id, items, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, valueId } = props1;
    let { density, onSelectionChange: _onSelectionChange, selectedKey, isDisabled, disabledKeys, labelBehavior } = (0, _react.useContext)(InternalTabsContext);
    let onSelectionChange = (0, _react.useCallback)((key)=>{
        if (key != null) _onSelectionChange?.(key);
    }, [
        _onSelectionChange
    ]);
    let state = (0, _react.useContext)((0, _reactAriaComponents.TabListStateContext));
    let allKeysDisabled = (0, _react.useMemo)(()=>{
        return isEveryTabDisabled(state?.collection, disabledKeys ? new Set(disabledKeys) : new Set());
    }, [
        state?.collection,
        disabledKeys
    ]);
    let labelProps = (0, _utils.useLabels)({
        id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd12';
            rules += ' _va12';
            rules += ' eb12';
            if (props.density === "regular") rules += ' Fz12';
            else if (props.density === "compact") rules += ' Fx12';
            return rules;
        }({
            density
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsPicker.Picker), {
            id: id,
            valueId: valueId,
            ...labelProps,
            "aria-describedby": props1['aria-describedby'],
            "aria-details": props1['aria-details'],
            isDisabled: isDisabled || allKeysDisabled,
            density: density,
            labelBehavior: labelBehavior,
            items: items,
            disabledKeys: disabledKeys,
            selectedKey: selectedKey,
            onSelectionChange: onSelectionChange,
            children: (item)=>{
                return /*#__PURE__*/ (0, _react.createElement)((0, _tabsPicker.PickerItem), {
                    ...item.props.originalProps,
                    isDisabled: isDisabled || allKeysDisabled,
                    key: item.key
                }, item.props.children({
                    density,
                    isMenu: true
                }));
            }
        })
    });
};
let CollapsingTabs = ({ collection, containerRef, ...props })=>{
    let { orientation = 'horizontal', onSelectionChange } = props;
    let [showItems, _setShowItems] = (0, _react.useState)(true);
    showItems = orientation === 'vertical' ? true : showItems;
    let setShowItems = (0, _react.useCallback)((value)=>{
        if (orientation === 'vertical') // if orientation is vertical, we always show the items
        _setShowItems(true);
        else _setShowItems(value);
    }, [
        orientation
    ]);
    let { direction } = (0, _i18N.useLocale)();
    let children = (0, _react.useMemo)(()=>[
            ...collection
        ], [
        collection
    ]);
    let listRef = (0, _react.useRef)(null);
    let updateOverflow = ()=>{
        if (orientation === 'vertical' || !listRef.current || !containerRef?.current) return;
        let container = listRef.current;
        let containerRect = container.getBoundingClientRect();
        let tabs = container.querySelectorAll('[data-hidden-tab]');
        let lastTab = tabs[tabs.length - 1];
        let lastTabRect = lastTab.getBoundingClientRect();
        if (direction === 'ltr') setShowItems?.(lastTabRect.right <= containerRect.right);
        else setShowItems?.(lastTabRect.left >= containerRect.left);
    };
    let updateOverflowEffect = (0, _utils.useEffectEvent)(updateOverflow);
    (0, _utils.useResizeObserver)({
        ref: containerRef,
        onResize: updateOverflow
    });
    (0, _utils.useLayoutEffect)(()=>{
        if (collection.size > 0) queueMicrotask(updateOverflowEffect);
    }, [
        collection.size
    ]);
    // start with null so that the first render won't have a flicker
    let prevOrientation = (0, _react.useRef)(null);
    (0, _utils.useLayoutEffect)(()=>{
        if (collection.size > 0 && prevOrientation.current !== orientation) updateOverflowEffect();
        prevOrientation.current = orientation;
    }, [
        collection.size,
        orientation
    ]);
    (0, _react.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateOverflowEffect());
    }, []);
    let menuId = (0, _utils.useId)();
    let valueId = (0, _utils.useId)();
    let contents;
    if (showItems) contents = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tabs), {
        ...props,
        style: {
            display: 'contents'
        },
        children: props.children
    });
    else contents = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseContext.Provider, {
            value: {
                showTabs: false,
                tabs: children,
                menuId,
                valueId,
                listRef: listRef,
                onSelectionChange,
                ariaLabel: props['aria-label'],
                ariaDescribedBy: props['aria-labelledby']
            },
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + tabs({
            orientation
        }, props.styles),
        ref: containerRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseContext.Provider, {
            value: {
                showTabs: true,
                menuId,
                valueId,
                tabs: children,
                listRef: listRef
            },
            children: contents
        })
    });
};

},{"0":"izZJF","1":"bgSAj","2":"bsb6H","3":"lQ0Mj","4":"17Exf","5":"g2LQ9","6":"kemwp","7":"fCgS4","8":"i1Czv","9":"ecU8A","10":"lGaBQ","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Group","6UspO"],["Provider","bA6Cz"],["SelectionIndicator","dgQU7"],["Tab","ahti0"],["TabList","ahti0"],["TabListStateContext","ahti0"],["TabPanel","ahti0"],["Tabs","ahti0"]],"./CenterBaseline":"1vpL9","@react-aria/collections":"2Jd0Q","./Icon":"jQAJE","@react-aria/utils":[["inertValue","aL0AK"],["useEffectEvent","eg4dC"],["useId","jbI4Y"],["useLabels","7Uhyw"],["useLayoutEffect","2ViQu"],["useResizeObserver","7OAb4"]],"./TabsPicker":"lNaKi","./Content":"10r6w","@react-stately/utils":"4Nj6T","@react-spectrum/utils":"jqfrX","@react-aria/focus":"eSQu0","@react-aria/i18n":"4k4z8","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"izZJF":[function() {},{}],"bgSAj":[function() {},{}],"bsb6H":[function() {},{}],"lQ0Mj":[function() {},{}],"17Exf":[function() {},{}],"g2LQ9":[function() {},{}],"kemwp":[function() {},{}],"fCgS4":[function() {},{}],"i1Czv":[function() {},{}],"ecU8A":[function() {},{}],"lGaBQ":[function() {},{}],"lNaKi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerContext", ()=>PickerContext);
parcelHelpers.export(exports, "menu", ()=>menu);
parcelHelpers.export(exports, "Picker", ()=>_Picker);
parcelHelpers.export(exports, "PickerItem", ()=>PickerItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _menu = require("./Menu");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _field = require("./Field");
var _content = require("./Content");
var _icon = require("./Icon");
var _reactAria = require("react-aria");
var _popover = require("./Popover");
var _pressScale = require("./pressScale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const PickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' zXcEWr12';
    rules += ' yXcEWr12';
    rules += ' BXcEWr12';
    rules += ' AXcEWr12';
    if (props.size === "XL") rules += ' Nl12';
    else if (props.size === "L") rules += ' Nj12';
    else if (props.size === "S") rules += ' Nf12';
    else if (props.size === "XS") rules += ' Ne12';
    else rules += ' Nk12';
    if (props.isQuiet) rules += ' _qd12';
    else rules += ' _qtb12';
    if (props.size === "XL") rules += ' -Anxdcc-Zt12';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne12';
    else if (props.size === "S") rules += ' -Anxdcc-Zr12';
    else rules += ' -Anxdcc-Z3fn9H12';
    rules += ' __v6TNLWb12';
    rules += ' _Pc12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FnuYUweb12';
    if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' sd12';
    rules += ' _Wd12';
    rules += ' _je12';
    rules += ' oa12';
    rules += ' na12';
    rules += ' ka12';
    rules += ' ja12';
    rules += ' eb12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' qc12';
    rules += ' qsd12';
    rules += ' SMBFGYc12';
    rules += ' RfBFGYc12';
    rules += ' g912';
    if (props.isQuiet) rules += ' Ln12';
    rules += ' __ca12';
    if (props.density === "compact") rules += ' Fx12';
    else rules += ' Fz12';
    rules += ' _oa12';
    rules += ' -S_-Sd12';
    rules += ' -R_-Rd12';
    return rules;
};
let menu = function anonymous(props) {
    let rules = " ";
    rules += ' _Le12';
    rules += ' se12';
    rules += ' Deb5jcb12';
    rules += ' _oa12';
    rules += ' Za12';
    rules += ' K40ub4c12';
    rules += ' _Na12';
    rules += ' Pa12';
    rules += ' Tt12';
    rules += ' Qt12';
    rules += ' St12';
    rules += ' Rt12';
    rules += ' uk12';
    rules += ' ucJ9TBTb12';
    rules += ' ud3Euai12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    return rules;
};
const valueStyles = " _ua12 _Nc12 Pc12 _Yb12 _7c12 sd12 eb12 Fb12";
const iconStyles = " _va12 _Sd12 -_8sjo0b-t5ZbAob12";
const iconCenterWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' sd12';
    rules += ' z2U5Crc12';
    rules += ' y2U5Crc12';
    rules += ' B2U5Crc12';
    rules += ' A2U5Crc12';
    if (props.labelBehavior === "hide") rules += ' SssxDec12';
    return rules;
};
let InsideSelectValueContext = /*#__PURE__*/ (0, _react.createContext)(false);
function Picker(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, PickerContext);
    let domRef = (0, _utils.useFocusableRef)(ref);
    props1 = (0, _form.useFormProps)(props1);
    let { direction = 'bottom', align = 'start', shouldFlip = true, children, items, density, labelBehavior = 'show', valueId, ...pickerProps } = props1;
    let isQuiet = true;
    const menuOffset = 6;
    const size = 'M';
    let ariaLabelledby = props1['aria-labelledby'] ?? '';
    let { direction: dir } = (0, _reactAria.useLocale)();
    let RTLFlipOffset = dir === 'rtl' ? -1 : 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Select), {
                ...pickerProps,
                "aria-labelledby": `${labelBehavior === 'hide' ? valueId : ''} ${ariaLabelledby}`,
                children: ({ isOpen })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                                isQuiet: isQuiet
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                                ref: domRef,
                                style: (renderProps)=>(0, _pressScale.pressScale)(domRef)(renderProps),
                                // Prevent press scale from sticking while Picker is open.
                                // @ts-ignore
                                isPressed: false,
                                className: (renderProps)=>inputButton({
                                        ...renderProps,
                                        size: 'M',
                                        isOpen,
                                        isQuiet,
                                        density
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectValue), {
                                        className: valueStyles + ' ' + "WzII9b",
                                        children: ({ defaultChildren })=>{
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                                values: [
                                                    [
                                                        (0, _icon.IconContext),
                                                        {
                                                            slots: {
                                                                icon: {
                                                                    render: (0, _centerBaseline.centerBaseline)({
                                                                        slot: 'icon',
                                                                        styles: iconCenterWrapper({
                                                                            labelBehavior
                                                                        })
                                                                    }),
                                                                    styles: (0, _menu.icon)
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    [
                                                        (0, _content.TextContext),
                                                        {
                                                            slots: {
                                                                // Default slot is useful when converting other collections to PickerItems.
                                                                [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                                                    id: valueId,
                                                                    styles: function anonymous(props) {
                                                                        let rules = " ";
                                                                        if (props.labelBehavior === "hide") rules += ' sk12';
                                                                        else rules += ' sb12';
                                                                        rules += ' _ub12';
                                                                        rules += ' _Nc12';
                                                                        rules += ' Pc12';
                                                                        rules += ' _Yb12';
                                                                        rules += ' _7c12';
                                                                        return rules;
                                                                    }({
                                                                        labelBehavior
                                                                    })
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    [
                                                        InsideSelectValueContext,
                                                        true
                                                    ]
                                                ],
                                                children: defaultChildren
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                        size: size,
                                        className: iconStyles
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                                hideArrow: true,
                                offset: menuOffset,
                                crossOffset: RTLFlipOffset * -12,
                                placement: `${direction} ${align}`,
                                shouldFlip: shouldFlip,
                                styles: " Nh12 ZbWuche12",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sd12 Za12 Fb12",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                        values: [
                                            [
                                                (0, _content.HeaderContext),
                                                {
                                                    styles: (0, _menu.sectionHeader)({
                                                        size
                                                    })
                                                }
                                            ],
                                            [
                                                (0, _content.HeadingContext),
                                                {
                                                    // @ts-ignore
                                                    role: 'presentation',
                                                    styles: (0, _menu.sectionHeading)
                                                }
                                            ],
                                            [
                                                (0, _content.TextContext),
                                                {
                                                    slots: {
                                                        description: {
                                                            styles: (0, _menu.description)({
                                                                size
                                                            })
                                                        }
                                                    }
                                                }
                                            ]
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                                            items: items,
                                            className: menu,
                                            children: children
                                        })
                                    })
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabLine, {
                isDisabled: props1.isDisabled
            })
        ]
    });
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */ let _Picker = /*#__PURE__*/ (0, _react.forwardRef)(Picker);
const selectedIndicator = function anonymous(props) {
    let rules = " ";
    if (props.isDisabled) rules += ' gH12';
    else rules += ' g012';
    if (props.isDisabled) rules += ' gld12';
    else rules += ' gle12';
    rules += ' FLvNfn12';
    rules += ' _je12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    rules += ' Jk7Otrc12';
    rules += ' Xa12';
    rules += ' _2b12';
    return rules;
};
function TabLine(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: selectedIndicator(props)
    });
}
function PickerItem(props) {
    let ref = (0, _react.useRef)(null);
    let isLink = props.href != null;
    const size = 'M';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, _pressScale.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, _menu.menuitem)({
                ...renderProps,
                size,
                isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children } = props;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultProvider, {
                context: (0, _icon.IconContext),
                value: {
                    slots: {
                        icon: {
                            render: (0, _centerBaseline.centerBaseline)({
                                slot: 'icon',
                                styles: iconCenterWrapper({})
                            }),
                            styles: (0, _menu.icon)
                        }
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DefaultProvider, {
                    context: (0, _content.TextContext),
                    value: {
                        slots: {
                            [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                styles: (0, _menu.label)({
                                    size
                                })
                            }
                        }
                    },
                    children: [
                        !isLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                            size: size,
                            className: (0, _menu.checkmark)({
                                ...renderProps,
                                size
                            })
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
}
// A Context.Provider that only sets a value if not inside SelectValue.
function DefaultProvider({ context, value, children }) {
    let inSelectValue = (0, _react.useContext)(InsideSelectValueContext);
    if (inSelectValue) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(context.Provider, {
        value: value,
        children: children
    });
}

},{"0":"eKXgR","1":"5bLyZ","2":"hWuIK","3":"cDC0t","4":"jMB14","5":"bYjdB","6":"04NEW","7":"3OL6a","8":"5ZqMJ","9":"jQ7pv","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["Select","f92ET"],["SelectValue","f92ET"]],"./CenterBaseline":"1vpL9","./Menu":"1F0Yz","../ui-icons/Checkmark":"gK3Wp","../ui-icons/Chevron":"1904U","./Field":"eI7CE","./Content":"10r6w","./Icon":"jQAJE","react-aria":"4k4z8","./Popover":"62puW","./pressScale":"8Ufux","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Form":"cHqN4","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eKXgR":[function() {},{}],"5bLyZ":[function() {},{}],"hWuIK":[function() {},{}],"cDC0t":[function() {},{}],"jMB14":[function() {},{}],"bYjdB":[function() {},{}],"04NEW":[function() {},{}],"3OL6a":[function() {},{}],"5ZqMJ":[function() {},{}],"jQ7pv":[function() {},{}],"kwXgr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preloadSearchMenu", ()=>preloadSearchMenu);
parcelHelpers.export(exports, "default", ()=>SearchMenuTrigger);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _library = require("./library");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _search = require("@react-spectrum/s2/icons/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
'use client';
let SearchMenu = /*#__PURE__*/ (0, _react.lazy)(()=>require("c30a222dd1a9b6b1").then(({ SearchMenu })=>({
            default: SearchMenu
        })));
async function preloadSearchMenu() {
    try {
        SearchMenu = (await require("c30a222dd1a9b6b1")).SearchMenu;
    } catch  {
    // ignore.
    }
}
let underlayStyle = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa12';
    rules += ' Wr12';
    rules += ' _Er12';
    rules += ' Za12';
    rules += ' FKem6Ob12';
    rules += ' _Bb12';
    rules += ' g812';
    if (props.isExiting) rules += ' _Ia12';
    else if (props.isEntering) rules += ' _Ia12';
    rules += ' Yf12';
    if (props.isExiting) rules += ' Xa12';
    else rules += ' Xd12';
    rules += ' _2b12';
    return rules;
};
let modalStyle = " _Pa12 WJ12 Za12 LykyMMb12 g_g12 Sf12 Rf12 Tt12 Qt12 _9G1Ky12 _kb12 hb12 mb12 lb12 iq12 _jf12 oe12 ne12 ke12 je12 _nLeasBb12 _Er12 _Rr12 JM12 GM12 IM12 HM12 FGMCvrc12";
function SearchMenuTrigger({ onOpen, onClose, isSearchOpen, overlayId, ...props1 }) {
    let [initialSearchValue, setInitialSearchValue] = (0, _react.useState)('');
    let open = (0, _react.useCallback)((value)=>{
        setInitialSearchValue(value);
        onOpen();
    }, [
        onOpen
    ]);
    // Type to search handler
    let onKeyDown = (0, _react.useCallback)((e)=>{
        // Ignore modifier keys, navigation keys, Enter, Escape, etc.
        if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey && e.key !== ' ') {
            e.preventDefault();
            open(e.key);
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            open('');
        }
    }, [
        open
    ]);
    (0, _react.useEffect)(()=>{
        let isMac = /Mac/.test(navigator.platform);
        const isTextInputLike = (el)=>{
            if (!el) return false;
            let h = el;
            return h.isContentEditable || !!el.closest('input, textarea, [contenteditable], [role="textbox"]');
        };
        const handleKeyDown = (e)=>{
            if (e.isComposing) // avoid intercepting IME input
            return;
            if (e.key === 'Escape' && isSearchOpen) {
                e.preventDefault();
                onClose();
            } else if (e.key === 'k' && (isMac ? e.metaKey : e.ctrlKey)) {
                e.preventDefault();
                open('');
            } else if (e.key === '/' && !(isTextInputLike(e.target) || isTextInputLike(document.activeElement))) {
                e.preventDefault();
                open('');
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        isSearchOpen,
        onClose,
        open
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " se12 DPlN5qb12 eb12 Ul12 ql12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                ...props1,
                "aria-label": "Open search and menu",
                "aria-expanded": isSearchOpen,
                "aria-controls": isSearchOpen ? overlayId : undefined,
                onPress: ()=>open(''),
                onHoverStart: ()=>preloadSearchMenu(),
                onKeyDown: onKeyDown,
                className: ({ isHovered, isFocusVisible })=>(function anonymous(props) {
                        let rules = " ";
                        rules += ' FRuFGYc12';
                        rules += ' _oa12';
                        rules += ' Sw12';
                        rules += ' Rt12';
                        rules += ' -_6BNtrc-d12';
                        rules += ' vx12';
                        rules += ' og12';
                        rules += ' ng12';
                        rules += ' kg12';
                        rules += ' jg12';
                        rules += ' _kc12';
                        rules += ' hc12';
                        rules += ' mc12';
                        rules += ' lc12';
                        rules += ' _jf12';
                        rules += ' Yd12';
                        rules += ' Xb12';
                        rules += ' _2b12';
                        if (props.isFocusVisible) rules += ' in12';
                        else if (props.isHovered) rules += ' io12';
                        else rules += ' iq12';
                        rules += ' gX12';
                        rules += ' pv12';
                        rules += ' rD12';
                        rules += ' ZOLfCn12';
                        rules += ' sd12';
                        rules += ' eb12';
                        rules += ' Uc12';
                        rules += ' Usd12';
                        rules += ' qc12';
                        rules += ' qsd12';
                        if (props.isFocusVisible) rules += ' _Lf12';
                        else rules += ' _Le12';
                        rules += ' _Kd12';
                        if (props.isFocusVisible) rules += ' Oh12';
                        else rules += ' Oj12';
                        if (props.isFocusVisible) rules += ' _Mc12';
                        else rules += ' _Ma12';
                        rules += ' -F_-Fv12';
                        return rules;
                    })({
                        isHovered,
                        isFocusVisible
                    }),
                style: {
                    viewTransitionName: !isSearchOpen ? 'search-menu-search-field' : 'none',
                    visibility: isSearchOpen ? 'hidden' : 'visible'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
                        UNSAFE_className: String(" ZuUmpre12 FuUmpre12 -_8sjo0b-t5ZbAob12 _va12")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-d12 vx12 xb12 _xa12 _Fd12 _FnuYUweb12 pn12",
                        children: [
                            "Search ",
                            (0, _library.getLibraryLabel)((0, _library.getLibraryFromPage)(props1.currentPage))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("kbd", {
                        className: " IM12 uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xc12 _xa12 xfd12 _xfa12 xfX0cczbc12 _xfX0cczba12 _Fd12 _FnuYUweb12 pn12 gqlRAZb12 Tj12 Qj12 St12 Rt12 oe12 ne12 ke12 je12 _kb12 hb12 mb12 lb12 iq12 _jf12 _Ob12 _dc12",
                        children: "\u2318K"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
                isDismissable: true,
                isOpen: isSearchOpen,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) onClose();
                },
                className: underlayStyle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                    className: modalStyle,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchMenu, {
                        pages: props1.pages,
                        currentPage: props1.currentPage,
                        onClose: onClose,
                        overlayId: overlayId,
                        initialSearchValue: initialSearchValue,
                        isSearchOpen: isSearchOpen
                    })
                })
            })
        ]
    });
}

},{"0":"j4VhJ","1":"h3x9T","2":"eNnA7","3":"dU9nM","4":"6Hhkw","5":"781QM","6":"fjK9s","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Modal","29rOq"],["ModalOverlay","29rOq"]],"./library":"a5H2j","react":"a1TxN","@react-spectrum/s2/icons/Search":"cSREm","c30a222dd1a9b6b1":"enb3m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j4VhJ":[function() {},{}],"h3x9T":[function() {},{}],"eNnA7":[function() {},{}],"dU9nM":[function() {},{}],"6Hhkw":[function() {},{}],"781QM":[function() {},{}],"fjK9s":[function() {},{}],"enb3m":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lBmtU"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("aPVyw"),
    module.bundle.load("9f8mp"),
    module.bundle.load("dOFdr"),
    module.bundle.load("i6te6"),
    module.bundle.load("jkk6G"),
    module.bundle.load("4UxgA"),
    module.bundle.load("dZMz1"),
    module.bundle.load("c0VSK"),
    module.bundle.load("lfyA4")
]).then(()=>{
    let originalModule = module.bundle.root("7ohac");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("aPVyw")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("9f8mp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lBmtU"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dOFdr")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("i6te6")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("jkk6G")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("4UxgA")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dZMz1")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("c0VSK")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lfyA4")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"lFJdG":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("lfyA4"),
    module.bundle.load("c0VSK"),
    module.bundle.load("dZMz1"),
    module.bundle.load("4UxgA"),
    module.bundle.load("jkk6G"),
    module.bundle.load("i6te6"),
    module.bundle.load("dOFdr"),
    require("9547008005237477")(module.bundle.resolve("lBmtU")),
    module.bundle.load("9f8mp"),
    module.bundle.load("aPVyw")
]).then(()=>module.bundle.root('7ohac'));

},{"9547008005237477":"819rl"}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/c76ce6fa90ccc44b1f5afff35e34b408a453ee9d/s2-docs/")

//# sourceMappingURL=error.d7c4f880.js.map
